/* eslint-disable prettier */
/* eslint-disable max-len */
/**
 * FR CA resource file
 */

import {
    ArcTimeLineValidationTypes,
    ArcTimelineGroups,
    Entity,
    GAComponentDocumentStatus,
    GALinkStatus,
    GARoleTypeId,
    TaskListTypes,
    actionTypes,
    activityType,
    assignmentTypes,
    bulkAssignment,
    bulkAssignmentConstants,
    clientRequestNoteTab,
    confidentialityTypes,
    filters,
    financialStatementType,
    gaRecommendationType,
    gaScopes,
    groupSummaryTabs,
    independenceActionIds,
    instructionStatus,
    instructionType,
    ipFilterType,
    ipInputType,
    linkType,
    milestoneBuildTaskIds,
    notesFilter,
    reviewNoteRoutes,
    rnhFilterTypeQuery,
    rnhQuickFilter,
    snapshotComparisonIds,
    syncStatus,
    todoListTimeframeOptions,
    trialBalanceType,
    uiViews,
    receiveInstructionSwitcherIds
} from "../util/uiconstants";

export const labels = {

    //Review notes tile 2

    reviewNoteTileGraphHeader: "Notes de revue ouvertes par date d’échéance",
    reviewNoteTileGraphHeaderAssignedToMe: "Notes de revue ouvertes qui me sont attribuées, par date d’échéance",
    reviewNoteTileGraphHeaderAuthoredByMe: 'Authored open notes, by due date',
    reviewNoteYAxisLabel: "Notes de revue",
    overDueCatFirst: "Plus de 90 jours de retard",
    overDueCatSecond: "De 31 à 90 jours de retard",
    overDueCatThird: "De 10 à 30 jours de retard",
    overDueCatFourth: "Moins de 10 jours de retard",
    catFifth: '<10',
    catSixth: '10-30',
    catSeventh: '31-90',
    catEighth: '>90',
    noNotesAvailable: "Aucune note disponible",


    //ReviewNoteTiles
    totalOpen: "Ouvertes au total",
    totalCleared: "Réglées au total",
    changeDueDate: "Modifier la date d’échéance",
    reviewNoteHashValue: '#',

    //Rejected PSPs
    rejectedPSPsTitle: 'Rejected PSPs',
    noRejectedPSPs: 'No rejected PSPs',
    updateRejectedPSPs: 'Update rejected PSPs',


    //CRA Build Step 2 Labels
    inherentRiskTypeId: "Évaluation du risque inhérent",
    controlRiskTypeId: "Évaluation du risque lié au contrôle",
    viewUnRelatedWCGWs: "Afficher les erreurs possibles non associées",
    unrelatedWCGWsInstruction: "Les erreurs possibles figurant dans la liste ci-dessous ne sont associées à aucune assertion. Elles doivent être associées à au moins une assertion ou être supprimées. Pour trouver facilement ces erreurs possibles dans la fenêtre modale « Associer les erreurs possibles aux assertions », sélectionnez \'Erreurs possibles non associées'\ dans le menu déroulant Catégories d’opérations importantes. Si l’erreur possible n’est plus pertinente ou doit être modifiée, cliquez sur le lien \'Identifier les erreurs possibles et les contrôles'\ figurant dans la page sous-jacente pour effectuer ces changements.",
    relatedWCGWsInstruction: "Associer les erreurs possibles à l’assertion sélectionnée. Sélectionner une catégorie d’opérations importante pour associer les erreurs possibles à celle-ci, ou sélectionner une option dans Toutes les catégories d’opérations importantes. Pour la liste des erreurs possibles devant être associées à une assertion, sélectionner \'Erreurs possibles non associées'\.",
    allScots: "Toutes les catégories d’opérations importantes",
    allWCGWs: "Toutes les erreurs possibles",
    unRelatedWCGWs: "Erreurs possibles non associées",
    //CRA Build Step 4 Header Label
    craValue: "EGR",
    incompleteCraValue: "EGR incomplète",
    // Panel Headers
    taskCategories: "Navigation dans les tâches",
    taskCategoryExecution: "Exécution",
    taskList: "Liste des tâches",
    taskDetails: "Détails de la tâche",
    fullScreen: "Plein écran",
    exitFullScreen: "Quitter le mode Plein écran",
    defaultDropdown: "Menu déroulant",
    status: "État",
    language: "Langue",
    channel: "Édition",
    header: "En-tête",
    headerName: "Nom de l'en-tête",
    sectionCustomLabelLabel: "Étiquette personnalisée",
    sectionNamePlaceHolder: "Entrer le titre de la section",
    showRelatedObjectLabel: "Afficher les objets associés",
    errorBanner: "{0} erreur(s)",
    customize: "Personnaliser",
    customized: "Personnalisé",
    custom: "Personnalisé",
    description: "Description",
    seeDescription: "Voir la description",
    section: "Section",
    entities: "Entités",
    edit: "Modifier",
    delete: "Supprimer",
    collapse: "Réduire",
    collapseAll: "Tout réduire",
    expand: "Développer",
    expandAll: "Tout développer",
    incompleteResponse: "Réponse incomplète",
    unresolvedComments: "Commentaires non résolus",
    saving: "Enregistrement en cours",
    tasks: "tâches",
    requests: "demandes",

    //BodyType Placeholder
    numericValuePlaceholder: "Entrer le montant",

    //Modal
    addButton: "Bouton Ajouter",
    evidence: "Éléments probants",
    temporary: "Temporaire",
    temporaryFiles: "Fichiers temporaires",
    priorPeriod: "Période précédente",
    externaldocuments: "Documents externes",
    eydocuments: "Documents EY",
    clientRequestClientAnalytics: "Nom de l’analyse",
    groupdocuments: " Documents du groupe",
    name: "Nom",
    reason: "Explication",
    browse: "parcourir",
    uploadFile: "Télécharger les fichiers",
    uploadDocument: "Télécharger le document",
    duplicateDocumentHeader: "Un ou plusieurs documents du même nom existent déjà dans cette mission (dans les éléments probants ou les fichiers temporaires).",
    duplicateDocumentInstruction: "Cliquez sur «Écraser» pour remplacer le fichier existant par le nouveau document ou sur Supprimer pour annuler. Si le fichier existant se trouve dans les éléments probants, le nouveau document sera téléchargé dans le même dossier. Si le fichier existant se trouve dans les fichiers temporaires, le nouveau document sera téléchargé dans le même dossier.",
    overwriteLabel: "Écraser",
    discardLabel: "Supprimer",
    discardChangesLabel: "Ignorer les modifications",
    note: "Note",
    notes: "Notes",
    signOffs: "Approbations",
    related: "Associé",
    attributes: " Attributs",
    approveChanges: "Approuver les modifications",
    nodocumentsAdded: "Aucun document disponible",
    noEntitiesAvailable: "Aucune entité disponible",
    noDocumentsUpload: "Aucun document n’est en cours de téléchargement.",
    noSections: "Aucune section disponible",
    noRequestMessage: "Aucune tâche ou demande n'a été attribuée à cette mission",
    noResultFound: "Aucun résultat trouvé.",
    noRequestsFound: "Aucune demande trouvée",
    noTimePhasesFound: "Aucune période disponible",
    noEntitiesFound: "Aucun résultat",
    relatedEntities: "Entités associées",
    noClickableRelatedEntities: "Les entités associées ne peuvent pas être modifiées pour cette tâche",
    taskByEntityLabel: "Tâches par entité",
    relEntityLabel: "Entité",
    singleEntity: "{0} entité",
    multipleEntity: "{0} entités",
    engagementDeliveryLabel: "Tâches par mission",
    onlyShowRelEntities: "Afficher seulement les entités associées",
    engDeliveryDescription: "Cette tâche est associée à toutes les entités de la mission.",
    relEntitiesDescription: "Afficher les entités associées à la tâche. Les entités associées ne peuvent être modifiées que pour les tâches APC et ATS.",
    relEntitiesPSTorPSPDesc: "Afficher les entités associées à la tâche. Les entités associées ne peuvent pas être modifiées pour les tâches TSB et les PCB.",
    warningRelMsg: "La tâche doit être associée à au moins une entité. Pour que la tâche s’applique à l’ensemble de la mission, cliquez sur le bouton Tâches par entité.",
    reldetailDescription: "Les tâches Autre procédure de corroboration et Autre tâche standard s’appliquent par défaut à l’ensemble de la mission et sont associées à toutes les entités. Les tâches peuvent être associées à une ou plusieurs entités en sélectionnant Tâches par entité.",
    results: "résultats",
    searchPlaceholder: "Rechercher",
    searchDocPlaceholder: "Rechercher un document",
    searchCanvasForms: "Rechercher des formulaires Canvas",
    searchControlForms: "Rechercher des catégories d’opérations importantes",
    canvasFormListDescription: "Sélectionner un formulaire Canvas dans la liste ci-dessous pour afficher les rapports connexes.",
    controlFormListDescription: "Sélectionner une catégorie d’opérations importante pour afficher les formulaires sur les contrôles qui y sont associés.",
    object: "Objet",
    relateCollaboration: "Associer les collaborations",
    reviewNote: "Notes de revue ",
    reviewNoteSingle: "Note de revue",
    documentReviewNotes: "Notes de document",
    noEvidenceFilesAssociated: "Aucun dossier contenant des éléments probants n'est associé à cette tâche",
    taskReviewNoteWithParenthesess: "Note(s) relative(s) à la ou aux tâches",
    taskNotes: "Notes de tâche",
    documentsNotes: "Notes de document",
    addNewDocumentNote: "Ajouter une note de document",
    selectDocument: "Sélectionner un document",
    taskReviewNotes: "Note de tâche",
    showCleared: "Afficher les éléments réglés",
    Replied: "Réponse :",
    showClosed: "Afficher les éléments fermés",
    allNotes: "Toutes les notes",
    myNotes: "Mes notes",
    noTasksAvailable: "Aucune tâche disponible",
    noWCGWAvailableForTask: "Aucun risque d’anomalie significative n’est disponible.",
    noSubstantiveTasksAvailable: "Aucune tâche Corroboration associée",
    noNotesAssociatedWithDocument: "Aucune note n’est associée à ce document",
    noNotesAssociatedWithTak: "Aucune note n’est associée à cette tâche",
    otherEngagementNotes: "Autres notes relatives à la mission",
    to: "à",
    deleteReviewNote: "Supprimer",
    missingToUserError: "Requis",
    missingReviewNoteTextError: "La note de revue doit contenir du texte",
    invalidReviewNoteTextError: "Le texte saisi dépasse la limite de caractères maximale permise",
    dueDateRequiredTextError: "La date d’échéance est requise",
    saveNoteTextError: "Enregistrer ou Annuler pour continuer",
    engagementName: "Nom de la mission :",
    assignmentsCountLabel: "Affectations",
    AssignmentsDays: "Jours",
    closedOnTime: "Fermées à temps",
    daysToPrepare: "Nombre de jours pour la préparation",
    daysToReview: "Nombre de jours pour la revue",
    totalAssignments: "Total des <br>affectations",
    currentlyAssigned: "Actuellement <br>attribuées",
    UpcomingAssignments: "À venir",
    authoredByMe: "Rédigés par moi",
    commentsLabel: "Notes de revue",
    clearedOnTime: "Réglés à temps",
    daysToClear: "Nombre de jours pour le règlement",
    daysToClose: "Nombre de jours pour la fermeture",
    totalLabel: "Notes totales",

    criticalAndHighRn: "Notes de priorité critique et élevée",
    criticalAndHighComments: "Notes de priorité critique et élevée",
    lowAndMediumComments: "Notes de priorité modérée et faible",
    metricsInstructionalText: "Affichez les mesures de la performance pour vos affectations et vos notes ci-après. <br>Sélectionnez un membre de l’équipe pour voir les mesures qui le concernent ou sélectionnez <b> Vue de la mission</b> pour un résumé général.",
    metricsNewInstructionalText: "Sélectionner un membre de l’équipe pour voir les notes de revue et les affectations qui le concernent ou sélectionner <b>Vue de la mission</b> pour un résumé général.",
    switchToViewPlaceholder: "Aucune donnée à afficher.<br>Sélectionnez un autre membre de l’équipe ou passez à la <b>vue de la mission.</b>",
    tasksClosedOnTime: "Tâches fermées à temps",
    daysDetailReview: "Nombre de jours pour la revue détaillée",
    daysGeneralReview: "Nombre de jours pour la revue générale",
    totalDaysReview: "Nombre de jours total pour réaliser la revue",
    metricsInstructionalTextconfiguration: "Afficher un résumé général des mesures de la performance pour les affectations et les notes ci-après.",

    //document download
    docSizeMB: "Mo",
    docSizeKB: "Ko",
    labelForExpiredPackage: "Le paquet de données est échu.",
    headerForDocumentDownload: "Cliquer sur le nom du fichier pour le télécharger",
    labelForNoFiles: "Il n’y avait aucun fichier dans les catégories sélectionnées.",
    labelForProcessing: "Les dossiers sont en cours de traitement.",

    //create dropdown texts
    create: "Créer",
    addRequestText: "Demande",
    addExternalTaskText: "Tâche externe",
    addFindingText: "Constatation",
    show: "Afficher:",
    riskTypeHeader: "Type de risque",
    wcgwHeader: "Erreur possible",
    hasNotes: "notes ouvertes",
    hasNote: "note ouverte",
    noNotes: "(0 note(s) ouverte(s))",
    addTemporaryFiles: "Ajouter des fichiers temporaires",
    addPriorPeriodEvidence: "Ajouter une période précédente",
    addExternalDocuments: "Ajouter des documents externes",
    //Nav
    navHeaderTasks: "Tâches",
    quickFilterAllCompletedTasks: "Toutes les tâches terminées",
    quickFilterMyCompletedAssignmnets: "Mes affectations terminées",
    quickFilterMyUpcomingAssignments: "Mes affectations à venir",
    navHeaderTaskCategory: "Catégories de tâches",
    navFilterBy: "Options de filtre",
    navHeaderDocuments: "Documents",
    navHeaderCollaboration: "Collaboration",
    navHeaderAssignments: "Affectations",
    navHeaderAutomation: "Automatisation",
    navHeaderMore: "Plus",
    navDashboard: "Tableau de bord",
    navReviewnotes: "Notes de revue",
    navHeaderManageteam: "Gérer l’équipe",
    navHeaderMangeteamNew: "Gérer l’équipe - Nouveau",
    mangeteam: "Gérer l’équipe",
    postArchive: "Envoyer l’archive",
    addmember: "Ajouter un membre",
    addnewmember: "Ajouter un nouveau membre",
    addPriorPeriodMembers: "Ajouter des membres inactifs",
    addPriorPeriodUsers: "Ajouter des membres inactifs",
    createPackage: "Créer un paquet",
    engagementrole: "Rôle dans la mission",
    noPendingPriorPeriodUsers: "Aucun membre inactif à inviter",
    sendPriorPeriodUserInvitesWithCount: "Envoyer ({0}) invitations",
    sendPriorPeriodUserInvitesWithoutCount: "Envoyer les invitations",
    priorPeriodMembersModalHeaderMessage: "Sélectionnez les membres inactifs que vous souhaitez ajouter à votre mission. Au moment de la réactivation, les membres se verront attribuer les mêmes autorisations dont ils disposaient auparavant dans le cadre de la mission.",
    priorPeriodIndependenceModalHeaderMessage: "Sélectionnez les utilisateurs inactifs faisant l’objet de la restriction Indépendance seulement que vous souhaitez ajouter à votre mission.",
    disabledPriorPeriodMembersButtonToolTip: "Vous ne disposez pas des droits requis pour ajouter d’anciens membres. Veuillez communiquer avec un membre de l’équipe de mission disposant des droits appropriés pour effectuer cette action.",
    disabledNewMembersButtonToolTip: "Vous ne disposez pas des droits requis pour ajouter de nouveaux membres. Veuillez communiquer avec un membre de l’équipe de mission disposant des droits appropriés pour effectuer cette action.",
    disabledNewMembersButtonToolTipThirdpartyuser: "Vous ne disposez pas des droits requis pour ajouter de nouveaux membres tiers. Veuillez communiquer avec un membre de l’équipe de mission disposant des droits appropriés pour effectuer cette action.",
    rbacNoRightsForContentUpdateToolTip: "Vous ne disposez pas des autorisations requises pour effectuer la mise à jour du contenu. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation de lancer la mise à jour de contenu.",
    deactivateInternalUsersWithCount: "{0} membres sélectionnés",
    canvasFormSelectionMessageSingular: "{0} formulaire Canvas sélectionné",
    canvasFormSelectionMessagePlural: "{0} formulaires Canvas sélectionnés",
    pspAccountSelectionMessageSingular: "{0} compte sélectionné",
    pspAccountSelectionMessagePlural: "{0} comptes sélectionnés",
    manageTeamGroupLabel: " groupe",
    manageTeamGroupsLabel: " groupes",
    allAccessGroups: "tous les groupes d’accès",
    reactivate: "Réactiver",
    deactivate: "Désactiver",
    unselect: "Tout désélectionner",
    deactivateInternalModalTitle: "Désactiver les membres internes",
    deactivateInternalModalMessage: "Voulez-vous vraiment désactiver les membres de l’équipe suivants?",
    deactivateInternalUsersSuccessMessage: "{0} membres ont été déactivés.",
    deactivateExternalModalTitle: "Désactiver les membres externes",
    deactivateExternalModalMessage: "Voulez-vous vraiment désactiver les membres de l’équipe suivants de {0}? Les éléments attribués seront réaffectés aux groupes d’accès respectifs.",
    deactivateExternalSuccessMessage: "Les membres ont bien été désactivés.",
    internalMember: "Membres internes",
    addinternalmember: "Ajouter un membre interne",
    addThirdPartymember: "Ajouter un membre tiers",
    missingResponsiblePerson: "Personne responsable manquante",
    sentRequests: "Envoyé",
    receivedRequests: "Reçu",
    syncProfileNotAllowed: "Synchronisation du profil non autorisée",
    allSyncProfileNotAllowedMessage: "La synchronisation du profil n’est pas autorisée. Aucun formulaire disponible pour ce profil.",
    allCanvasFormsContentUpdateMessage: "Le contenu ne peut pas être envoyé pour les activités de l’outil FIT d’EY Canvas qui sont partagées. Veuillez dissocier ces activités pour continuer de mettre à jour le contenu.",
    someFormContentUpdateMessage: "Certains des formulaires ne peuvent pas être synchronisés avec le profil de la mission, car il n’y a pas de contenu. ",
    linkedFormContentUpdateMessage: "Le contenu ne sera pas envoyé pour les activités de l’outil FIT d’EY Canvas qui sont partagées. Pour mettre à jour le contenu pour ces activités, veuillez les dissocier.",
    leaveUsFeedback: "Faites-nous part de vos commentaires",

    notApplicableLabel: "S. O.",
    addThirdPartyMemberDescription: "Cette fonction ne doit être utilisée que pour donner accès à cette mission EY Canvas à des réviseurs tiers. Les approbations et les autorisations appropriées doivent être obtenues auprès des Services professionnels.",
    hasOverallResponsibilityDescription: "Un membre de l’équipe d’audit ou de l’équipe de mission qui assume la responsabilité globale de la direction, la supervision et la mise en œuvre de l’audit ou de la mission et du caractère approprié du rapport et/ou de la conclusion interbureaux dans les circonstances. ",
    partnerInChargeHeader: "Associé / cadre responsable de la mission ",
    picFlag: "PIC",
    CannotUpdatePicInArchivedEngagement: "Les modifications apportées aux champs restreints ne peuvent pas être traitées. Actualisez la page et réessayez.",

    noGroupFound: "Aucun groupe d’accès n’a été créé dans cette mission. Sélectionnez \'Ajouter un groupe d’accès\'pour créer un nouveau groupe externe.",
    addGroup: "Ajouter un groupe",
    deleteGroup: "Supprimer le groupe d’accès",
    deleteGroupMessage: "Voulez-vous vraiment supprimer le groupe d’accès {0}?",
    addAccessGroup: "Ajouter un groupe d’accès",
    accessGroupCreated: "Le nouveau groupe d’accès {0} a bien été créé.",
    accessGroupUpdated: "Les modifications apportées au groupe d’accès {0} ont bien été enregistrées.",
    editAccessGroup: "Modifier le groupe d’accès",
    sharedGroupwarning: "Il s’agit d’un groupe d’accès partagé et les modifications qui y sont apportées seront prises en compte dans toutes les missions associées.",
    groups: "Groupes",
    addExternalMembers: "Tous les membres externes",
    members: "Membres",
    externalMember: "Membres externes",
    member: "Membre",
    role: "Rôle",
    actions: "Actions",
    internalUserEdit: "Modifier",
    internalUserDeactivate: "Désactiver",
    usersFilter: "Filtrer",
    externalUserEdit: "Modifier",
    externalUserDeactivate: "Désactiver",
    externalUserGroupLabel: "groupes",
    externalNoUserInGroup: "Aucun membre n’a été ajouté à ce groupe d’accès.",
    externalNoUserInAllGroup: "Aucun membre n’a été ajouté à cette mission.",
    alias: "Pseudonyme",
    independence: "Indépendance",
    navManagegroup: "Gérer le groupe",
    navCRAsummary: "Synthèse de l’EGR",
    navAuditplan: "Plan de mission",
    navWorkplan: "Plan de travail",
    navSEM: "Matrice d’évaluation des procédures de corroboration",
    nav440GL: "Des changements ont été apportés après la date du rapport.",
    navFindings: "Constatations",
    navCanvasformupdates: "Mises à jour des formulaires Canvas ",
    navPSPContentUpdates: "Mises à jour du contenu des PCB",
    navCopyhubNew: "Centre de copie – NOUVEAU",
    navCopyhub: "Centre de copie",
    navArchiveChecklist: "Liste de contrôle de l’archivage",
    navExporthub: "Centre d’exportation",
    navReporting: "Rapports",
    navAccountSummary: "Synthèse des comptes",
    navScotSummary: "Synthèse des catégories importantes d’opérations",
    navItSummary: "Synthèse TI",
    navGroupInstructionSummary: "Instructions relatives à l’audit de groupe",
    navGroupInvolvement: "Participation à l’audit de groupe",
    navHelixProjects: "Connexions EY Helix",
    navContentUpdates: "Mise à jour du contenu",
    contentUpdateErrorMsg: "Vous ne disposez pas des autorisations requises pour enregistrer les modifications. Veuillez communiquer avec les autres membres de l’équipe disposant de ces autorisations pour apporter les modifications.",
    contentUpdateTitleTip: "Vous ne disposez pas des autorisations requises pour effectuer la mise à jour du contenu. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation de lancer la mise à jour de contenu.",
    noPreviousUpdates: "Aucune mise à jour précédente",
    noContentUpdateResults: "Aucun résultat trouvé",
    noPSPAccountsToUpdate: "Aucun compte à mettre à jour",
    rbcaUnavailableMsg: "Les modifications n’ont pas pu être enregistrées dans EY Canvas pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    showErrInProgressMsg: "29007 - Vous ne pouvez pas lancer de mises à jour de contenu pendant que d’autres mises à jour sont en cours. Attendez que la mise à jour de contenu actuelle soit terminée, ou actualisez la page et réessayez.",
    navHelp: "Aide générale",
    validationNavHelp: "Aide relative à la validation",
    searchUserText: "Rechercher un utilisateur",
    superModelTitle: "Objets de la mission",
    superModelText: "Fenêtre modale",
    independenceOnlyMembers: "Membres faisant l’objet de la restriction Indépendance seulement",
    noIndependenceOnlyPriorPeriodUsers: "Aucun membre inactif faisant l’objet de la restriction Indépendance seulement à inviter",

    //Copyright
    copyRight: "© <year> Tous droits réservés.",

    //Copyhub List labels
    moreRecipient: "plus",
    copyHubPackageName: "Nom du paquet",
    copyHubSentBy: "Envoyé par",
    copyHubSentTo: "Envoyé à",
    copyHubReceivedBy: "Reçu par",
    copyHubDate: "Date",
    copyHubRemainingTime: "Délai restant",
    copyHubAvailableFor: "Disponible pour",
    copyHubStatus: "État",
    noCopyHubSentPackages: "Aucun paquet de données pour copie n’a été créé. Sélectionnez « Créer un paquet » pour créer un nouveau paquet de données",
    noCopyHubReceivedPackages: "Aucun paquet de données pour copie n’est disponible dans cette mission.",
    remainingTimeTooltip: "Les éléments seront éliminés de façon permanente au moment de l’archivage ou 10 jours après leur création",
    copyHubDeleteText: "Supprimer",
    appendDays: " jours",
    generalInformation: "Renseignements généraux",
    copyDocuments: "Documents",
    copyFiles: "Fichiers",
    scots: "Catégories importantes d’opérations",
    accounts: "Comptes",
    copyHubImport: "Importer",
    copyHubPackageType: "Type de paquet : ",
    copyHubCreatedModal: "Créé le :",
    copyHubRemainingTimeModal: "Délai restant :",
    copyHubAvailableForModal: "Disponible pour :",
    copyHubInstructionModal: "Instructions :",
    copyHubCategories: "Catégories",
    copyHubPendingDeletion: "Suppression en attente",
    copyHubVersionMismatchCat: "Les catégories ne peuvent pas être affichées en raison de versions de paquet incompatibles.",
    copyHubVersionMismatchPersonInfo: "Les renseignements de l’expéditeur et du destinataire ne peuvent pas être affichés en raison de versions de paquet incompatibles.",
    copyHubViewLegacyPacakgeDetails: "Les renseignements détaillés de ce paquet de données pour copie ne sont pas disponibles.",
    associateTasks: "Associer des tâches",
    backToForms: "Retour aux formulaires",
    noTaskSelected: "Sélectionnez au moins une tâche",
    taskLabel: "Tâche :",
    taskMessage: "Vous devez associer une tâche à ces formulaires d’importation.",
    importSuccessMessage: "La demande d’importation a été ajoutée à la file d’attente.",
    taskSelectedText: "Tâche sélectionnée",
    insufficientPermissionsToImport: "Vous ne disposez pas des autorisations requises pour importer un paquet de données pour copie. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation d’importer un paquet de données pour copie.",
    cannotImportExpiredPackage: "Impossible d’importer un paquet de données pour copie échu.",
    cannotImportWhileInProgress: "Impossible d’importer un paquet de données pour copie déjà en cours.",
    deletePackageHeader: "Supprimer le paquet de données",
    copyPackageDeleted: "Le paquet de données a été supprimé.",
    copyPackageDeleteConfirmation: "Voulez-vous vraiment supprimer ce paquet de données?",
    insufficientPermissionsToDelete: "Vous ne disposez pas des autorisations requises pour supprimer un paquet de données pour copie. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation de supprimer un paquet de données pour copie.",
    insufficientPermissions: "Vous ne disposez pas des autorisations requises",
    GuidedWorkflowsPackageDisplayText: "Cliquer sur Importer pour mettre à jour les flux de travail guidés correspondants à partir de la copie de cette mission. Les flux de travail guidés sans correspondance ne seront pas importés.",
    copyRequestStatusInQueue: "Dans la file d’attente",
    GuidedWorkflowImportError: "La fonction d’importation des flux de travail guidés n’est pas disponible pour les missions entités multiples.",

    //TopHeaderLayout.js
    topHeaderLayoutMilestoneText: "Jalon. Vérifier la concordance ou faire le rapprochement des informations financières avec les documents comptables sous-jacents. Obtenir des éléments probants attestant que les informations financières intermédiaires concordent ou ont fait l’objet d’un rapprochement avec les documents comptables sous-jacents.",
    //TaskLayoutHeader
    taskLayoutHeaderSearchPlaceholder: "Rechercher des tâches",
    taskLayoutHeaderAssignments: "Affectations",
    taskLayoutHeaderAddTask: "Nouvelle tâche",
    wcgwSearchPlaceholder: "Chercher l’erreur possible",
    //TaskListHeader
    taskTypeHeader: "Type",
    taskNameHeader: "Nom",
    taskDueDateHeader: "Date d’échéance",
    reviewNoteChangeDueDate: "Modifier la date d’échéance",
    taskListHeaderSortByDueDate: "Date d’échéance",
    taskListHeaderSortByTaskName: "Nom de la tâche",
    sortBy: "Trier par :",
    ascending: "Ordre croissant",
    descending: "Ordre décroissant",
    taskListHeaderSortByKnowledge: "Plan de mission",
    taskListHeaderDeleteWarning: "Voulez-vous vraiment supprimer les tâches sélectionnées?",
    taskListHeaderSortText: "Trier",
    taskListHeaderSortOrderText: "Ordre de tri",
    taskListHeaderTimePhaseText: "Définir la période",
    taskListHeaderBookMarkText: "Signet",
    taskListHeaderFavoriteText: "Favori",
    taskListHeaderEditText: "Modifier le titre de la tâche",
    moreMenu: "Plus",
    taskListHeaderMoveTaskText: "Modifier le groupe de tâches",
    taskGroupIconHoverText: "Modifier le groupe de tâches",
    taskGroupLabel: "Modifier le groupe",
    task: "Tâche",
    toc: "TDC",
    tenNotes: "10 notes",
    source: "Source",
    nature: "Nature",
    assertion: "Assertions",
    relatedAccounts: "Comptes connexes",
    testOfDetail: "Tests de détail",
    testOfControl: "Test du contrôle",
    substantiveAnalyticalProcedure: "Procédure analytique de corroboration",
    tod: "TDD",
    sap: "PAC",
    int: "INT",
    ext: "EXT",
    notSel: "NON SÉLECTIONNÉE",
    internal: "Interne",
    external: "Externe",
    notSelected: "Non sélectionnée",
    documentCannotOpen: "Ce document ne peut pas être ouvert à partir des détails de la tâche. Pour ouvrir le document, cliquez sur la liste des documents.",
    //TaskPanelLayout
    emptyTaskDetailsMessage: "Sélectionnez une tâche pour afficher les détails.",
    multiTaskSelectedMessage: "Pour activer les contrôles en bloc, appuyez sur la touche Contrôle (Ctrl) et sélectionnez plusieurs tâches. \n Si vous souhaitez travailler sur une seule tâche, vous devez la sélectionner dans la liste des tâches.",
    emptyAndMultiSelectedMessage: "To enable bulk controls, use the checkbox to select one or more tasks. Use the shift key to select several tasks at once. If you would like to work on an individual task, then select that task from the list.",
    //Evidence
    evidenceDragAndDrop: "Glisser-déposer ou",
    //Timephases
    noResultTimePhase: "Aucun résultat.",
    //handoff
    handoff: "Transmettre",
    handoffConfirmButtonText: "Transmettre",
    handoffModalTitle: "Transmettre la tâche",
    handoffTitle: "Transmettre au prochain membre de l’équipe",
    handoffTextLine2: "Pour approuver un élément probant, sélectionnez une option parmi les suivantes.",
    return: "Précédent",
    returnDisabledMessage: "Cette tâche n’a pas pu être retournée, car 1) la tâche Préparateur vous a été attribuée; 2) l’état de la tâche n’est pas réglé à «En cours de revue» ou à «Terminé» ou 3) la tâche n’a pas été attribuée à un préparateur.",
    handOffTitleTip: "Transmettre pour revue",
    //Mark Complete
    markCompleteTitleTip: "Terminer",
    markCompleteTitle: "Inscrire la tâche comme terminée",
    markCompleteText: "Votre approbation sera appliquée aux éléments probants associés à cette tâche, tel qu'il est indiqué ci-après. La tâche sera inscrite comme terminée.",
    markCompleteTextLine1: "Transmettre cette tâche au prochain membre de l’équipe.",
    markCompleteTextLine2: "Pour approuver un élément probant, sélectionnez une option parmi les suivantes. Si vous avez terminé la tâche qui vous a été attribuée, cliquez sur <b>Oui</b> pour la fermer. Si cette tâche nécessite l’approbation de l’associé responsable ou du responsable de la revue de la qualité de la mission, sélectionnez l’une des options suivantes.",
    markCompleteConfirm: "Terminer",
    signOffAs: "Tout approuver à titre de :",
    additionalSignOff: "Autres approbations requises",
    additionalTaskStatus: "Fermer mon affectation",
    markCompleteModalHeaderTextPart1: "La tâche sera inscrite comme terminée.",
    markCompleteModalHeaderTextPart2: "Pour approuver un élément probant, sélectionnez une option parmi les suivantes. Si vous avez terminé la tâche qui vous a été attribuée, cliquez sur <b>Oui</b> pour la fermer. Si cette tâche nécessite l’approbation de l’associé responsable ou du responsable de la revue de la qualité de la mission, sélectionnez l’une des options suivantes.",
    ep: "PIC",
    eqr: "RRQM",
    closeMyAssignment: "Fermer mon affectation",
    tempMarkCompleteMessage: "La tâche ne peut pas être marquée comme étant terminée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    tempMarkCompleteEnable: "Marquer comme étant terminée-activé",
    tempMarkCompleteDisable: "Marquer comme étant terminée-désactivé",
    //TaskDetails
    seeTask: "Afficher les tâches",
    NoTasksFound: "Aucune tâche trouvée",
    taskDetailsAddRelate: "Ajouter/Associer",
    taskDetailsDocument: "Document",
    taskDetailsAutomationRequest: "Demande d'automatisation",
    taskDetailsExternalTask: "Tâche externe",
    taskDetailsFinding: "Constatation",
    taskDetailsRequest: "Demande",
    taskDetailsNotes: "Notes",
    taskDetailsRelatedTask: "Tâche associée",
    epeqr: "PIC/RRQM",
    epeqrsignoffheader: "Approbation requise",
    addTaskGroupLabel: "Ajouter un groupe de tâches",
    itgcTaskDescription: "Mettre en œuvre les tests des CGI que nous avons conçus de manière à obtenir des éléments probants suffisants et appropriés sur l’efficacité de leur fonctionnement pour toute la période d’appui.",
    //create assignment
    createassignmentheaderLine1: "La tâche n’a pas été attribuée au membre de l’équipe sélectionné.",
    createassignmentheaderLine2: "Créer une affectation ici. Si un autre membre de l’équipe a déjà une affectation inachevée du même type,",
    createassignmentheaderLine3: "sélectionnez ",
    createassignmentheaderLine4: "pour la remplacer par cette affectation.",
    overwriteIncompleAssignments: "Écraser les affectations inachevées",
    //Create Assignment
    createassignmentheader1: "Cette tâche n’a pas été attribuée au membre de l’équipe sélectionné.",
    createassignmentheader2: "Créer une affectation ici.",
    //Guidance
    atlasLink: "Lien vers Atlas",
    automationLink: "Lien vers la fonction d’automatisation intelligente",
    otherLink: "Autre lien",
    helixLink: "Lien Helix",
    relatedAutomations: "Automatisations associées",
    noSuggestedAutomationLabel: "Aucune automatisation n’est proposée pour cette tâche.",
    noSuggestedItemLabel: "Aucun élément n’est proposé pour cette tâche.",
    noAutomationRequestLabel: "Cette tâche n’est associée à aucune automatisation. Pour commencer, créez une nouvelle automatisation ou associez-y une automatisation existante.",
    relateAutomation: "Associer",
    relateAutomationModelHeader: "Associer les automatisations intelligentes",
    automationSolution: "Solution",
    automationName: "Nom de l’automatisation",
    relateAutomationTextLine1: "Associez une automatisation intelligente à cette tâche.",
    relateAutomationTextLine2: "Une fois qu’elle associée, vous pouvez l’ouvrir en cliquant dessus à partir de la description des tâches.",
    noSamrtAutomationForEngagement: "Aucune automatisation intelligente n’a été créée dans votre mission.",
    searchAutomationLabel: "Rechercher des automatisations",

    //RelatedItemHeader
    relatedItemsHeader: "Éléments associés",
    relateButtonText: "Associer",
    createButtonText: "Créer",
    relatedItemREQ: "Demande",
    relatedItemET: "Tâche externe",
    relatedItemATM: "Automatisation",
    relatedItemRelatedTask: "Tâche associée ",
    relateObjectsToTaskTitle: " Associer les objets à cette tâche",
    relateObjectsToTaskSubTitle: "Associer un ou plusieurs objets à cette tâche. Ces objets s’afficheront à la section Éléments associés dans les détails de la tâche.",
    relateObjectOptionsHeaderPSPOSP: "Comptes, assertions et comptes présentant un risque limité",
    relateObjectOptionsHeaderITWalkthrough: "Processus informatiques",
    relateObjectOptionsHeaderITControl: " Contrôles informatiques (CGI et procédures de corroboration liés aux TI)",
    // SDM Nextwave services
    scheduledServicesText: "Services connexes",
    suggestedServicesText: "Services suggérés",
    suggestedServicesDefaultMessage: "Il existe des services NextWave suggérés pour cette tâche. Cliquez sur ",
    suggestedServicesDefaultMessage1: '+',
    suggestedServicesDefaultMessage2: "pour commencer.",
    suggestedServicesPlaceholderMessage: "Aucun service n'est proposé pour cette tâche.",
    nextWaveServiceOfferingLabel: "Service",
    nextWaveServiceStatusLabel: "État",
    nextWaveServiceStartDateLabel: "Début",
    nextWaveServiceDueDateLabel: "Date limite",
    nextWaveServiceRequestCreate: "Créer une demande",
    nextWaveServiceRequests: "Demandes de services centralisés",
    nextWaveServiceGatewayRequests: "Requêtes de Service Gateway",
    onlyShowSelectedTask: "N’afficher que les tâches sélectionnées",
    sdmRestrictAddTaskLabel: "Cliquez sur Continuer pour passer à l’étape suivante. La sélection de tâches ne peut avoir lieu qu’après l’acceptation des services et la tenue d’une discussion avec le chef de l’équipe responsable des processus du groupe PSM à propos des travaux à réaliser.",
    //Links
    linksText: "Liens",
    //Forms
    formsText: "Formulaires",
    /*Accounts*/
    associatedTasks: "Tâches associées à une erreur possible ",
    noAssertionsChecked: "Sélectionner une assertion pour afficher l’erreur possible correspondante",
    noAccountsCreated: "Aucun compte n’a été créé",
    noDesignationSelected: "Aucune désignation sélectionnée",
    noRelatedAccounts: "Aucun compte connexe",
    manageAccount: "Gérer les comptes et les informations à fournir",
    /*Risks*/
    risk: "Risque",
    risks: "Risques",
    wcgw: "Erreur possible",
    riskWcgw: "Relation risque-erreur possible",
    wcgwTasks: "Erreur possible : tâche",
    riskWcgwLabel: "Associer les risques aux erreurs possibles",
    wcgwTasksLabel: "Associer l'erreur possible à la tâche",
    noRiskTypes: "Aucun type de risque relevé",
    saveRisk: "Enregistrer",
    noRisksFound: "Aucun risque trouvé",
    haveBeenIdentified: "a été identifié",
    noAssertionFound: "Aucune assertion associée ne s’applique à cette mission",
    noAssertionApplicable: "Aucune assertion applicable à cette mission n’a été associée",
    noWCGWFound: "Aucune erreur possible n’est associée à ce risque. Cliquez sur Modifier les éléments associés pour associer une ou plusieurs erreurs possibles.",
    noRelatedWCGWs: "Aucune erreur possible associée",
    noRelatedControls: "Aucun contrôle associé",
    noRelatedRisks: "Aucun risque lié aux TI associé",
    noRelatedITGCs: "Aucun CGI associé",
    iTriskVal: "Risque lié aux TI",
    iTrisksVal: "Risques liés aux TI",
    iTGCVal: "CGI",
    iTGCsVal: "CGI",
    iTSPVal: "Procédure de corroboration liée aux TI",
    iTSPsVal: "Procédures de corroboration liées aux TI",
    iTGCname: "Nom du CGI",
    iTSPname: "Nom de la procédure de corroboration liée aux TI",
    noWCGWAvailable: "Aucun risque d’anomalie significative n’est disponible pour l’assertion sélectionnée.",
    relevantWcgwCountHint: "Le nombre figurant à côté du nom de compte correspond au nombre d’erreurs possibles associées à des assertions avec un risque lié au contrôle de niveau «Pas d’appui» ou à des assertions liées à des estimations présentant un risque élevé, ayant été associées à une procédure de corroboration, par rapport au nombre total d’erreurs possibles.",
    noAccountsFound: "Aucun enregistrement trouvé",
    selectAssertionToRelateWCGW: "Sélectionner une assertion pour associer un risque à une erreur possible",
    significantAccounts: "Comptes importants",
    riskName: "Risque : ",
    accountName: "Compte :",
    noScotsFound: "Aucune catégorie importante d’opérations associée",
    relatedwcgw: "Erreurs possibles associées",
    relatedRisks: "Risques associés",
    noRelatedAssertionsLabel: "Aucune assertion sélectionnée pour le compte",
    boltIconTitle: "Risque associé",
    instructions: "Instructions",
    expandRisk: "1. Développer le risque",
    selectAssertion: "2. Sélectionner une assertion",
    identifyRelatedWCGW: "3. Identifier les erreurs possibles associées au risque",
    clickAccount: "1. Cliquer sur un compte",
    selectWCGW: "2. Sélectionner une erreur possible",
    identifyRelatedTask: "3. Identifier les tâches qui répondent à l’erreur possible",
    information: "Information",
    requiredAssertions: "Assertions requises",
    wcgwWithoutTasks: "Erreur possible sans tâches",
    found: "trouvé",
    editAssociations: "Modifier les éléments associés ",
    riskWCGW: "Relation risque-erreur possible",
    wcgwTask: "Relation erreur possible-tâche",
    requireTaskToBeRelated: "Une tâche doit être associée.",
    expandCollapse: "Cliquez ici pour développer/réduire",
    requiredAssertionsInfo: "Afficher uniquement les assertions avec un risque lié au contrôle de niveau «Pas d’appui» et les assertions liées à des estimations présentant un risque élevé.",
    wCGWwithoutTasksInfo: "Afficher uniquement les erreurs possibles liées à une assertion avec un risque lié au contrôle de niveau «Pas d’appui» et à des assertions liées à des estimations présentant un risque élevé, pour lesquelles n’a été associée aucune procédure de corroboration.",
    noBuildStepsAvailable: "Aucune étape de production à présenter.",
    accountRiskAssessmentSummary: "Comptes et informations à fournir",
    manageRisk: "Gérer les risques",
    addResponsivePSPOSP: "Ajouter une PCB/APB en réponse aux risques",
    assertionlbl: "Assertion",
    addResponsiveControl: "Ajouter un contrôle en réponse aux risques",
    addResponsiveTOC: "Ajouter un TDC en réponse aux risques",
    showOnlyRelatedItems: "Afficher seulement les éléments associés",
    relatedControlCounter: "{0} contrôle",
    relatedControlsCounter: "{0} contrôles",
    noControlsAvailableForRelateItem: "Aucun contrôle disponible",
    relateControlName: "Contrôles",
    relateContolsAPIErrorMessage: "Le contrôle ne peut pas être associé à l’assertion. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    relateTasksAPIErrorMessage: "La tâche ne peut pas être associée à l’assertion. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    toggleFilterWarningMessage: "Afficher seulement les comptes et informations à fournir auxquels aucune procédure de corroboration n’est associée",
    toggleFilterWarningMessageForRisk: "Afficher seulement les risques auxquels ne répondent aucune procédure de corroboration ni aucun contrôle/TDC",
    warningIconHoverText: "Risque auquel ne répondent aucune procédure de corroboration ni aucun contrôle/TDC",
    filterYes: "Oui",
    filterNo: "Non",

    /*OrphanedControls*/
    orphanedControls: 'View unrelated controls',
    unRelatedOrphanControls: 'Unrelated controls',
    noOrphanedControlsDataLabel: "No unrelated controls available",
    noOrphanedControlsResultLabel: "No unrelated controls available",
    noControlSelected: 'At least one control must be selected for deletion.',
    controlsDeleteConformation: 'Are you sure that you want to delete the selected controls?',
    controlDeleteConformation: 'Are you sure that you want to delete the selected control?',
    deleteControlModalHeader: 'Confirm deletion of selected control',
    deleteControlsModalHeader: 'Confirm deletion of selected controls',

    /*SEM*/
    select: "Sélectionner",
    selectAnAccountFromTheDropDown: "1. Sélectionner un compte dans le menu déroulant",
    applyAsertionsFilters: "2. Appliquer les filtres pour les assertions",
    reviewTheTasksThatRespondToTheRisks: "3. Passer en revue les tâches qui répondent aux risques",
    riskOfMaterialMisstatement: "Risque d’anomalie significative",
    expandScot: "1. Développer la catégorie importante d’opérations",
    selectWCGWToDisplayTheResponsiveTask: "2. Sélectionner le risque d’anomalies significatives pour afficher dans les tâches qui y répondent",
    tasksWithNoRelatedWCGW: "Tâches sans risque d’anomalies significatives associé",
    selected: "sélectionnée",
    clearSelections: "Tout désélectionner",
    romm: "Risque d’anomalies significatives",
    selectAccount: "Compte",
    selectHeader: "Sélectionner l’en-tête",
    riskOfMaterialMisstatementsWithoutRelatedTask: "Risques d’anomalies significatives sans tâche associée",
    selectOneOrMoreTasksToSeeTheRelatedROMM: "Sélectionner une ou plusieurs tâches pour afficher les risques d’anomalies significatives correspondants",
    invalidRelatedEntity: "Compte associé introuvable. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    scrollUp: "Défiler vers le haut",
    scrollDown: "Défiler vers le bas",
    duplicate: "Dupliquer",
    showIndex: "Afficher la référence",
    noContentAvailable: "Aucun contenu disponible",
    navigateTo: "Allez à l’adresse",
    /*validations */
    semValidation: "Validation de la grille d'évaluation des procédures de corroboration",
    riskWCGWValidation: "Validation de l'erreur possible associée au risque",
    showValidation: "Validations",
    wcgwWithNoRelatedTask: "Erreur possible sans tâche Corroboration associée",
    riskWithNoRelatedWCGW: "Risque sans erreur possible associée",
    noValidationIdentified: "Aucune validation identifiée",
    onlyShowScotWithNoControlNoWCGW: "Afficher seulement les catégories d’opérations importantes auxquelles aucune erreur possible ou aucun contrôle ne sont associés",
    /*CRA Badge*/
    ir: "Risque inhérent",
    cr: "Risque lié au contrôle",
    cra: "EGR",
    selectToEdit: "Sélectionner pour modifier",
    both: "Les deux",
    prefix: "Préfixe",
    suffix: "Suffixe",
    optional: "(facultatif)",
    title: "Titre",
    charLimitExceeded: "La limite de caractère est dépassée",
    requiredField: "Champ obligatoire",
    Lastmodifiedby: "Dernière modification par",
    fileSize: " | {1} Ko",
    fileSizeInKB: "{1} Ko",
    fileSizeHeader: "Taille des fichiers",
    daysAgo: "il y a {0} jours",
    weekAgo: "Il y a {0} semaine",
    weeksAgo: "Il y a {0} semaines",
    monthAgo: "Il y a {0} mois",
    monthsAgo: "Il y a {0} mois",
    yearAgo: "Il y a {0} année",
    yearsAgo: "Il y a {0} années",
    currentlyBeingModifiedBy: "En cours de modification par",
    beingEditedInCoeditModeError: 'Being edited in multi-user edit',
    beingEditedInCoeditMode: 'Being edited in multi-user edit. Edit started by {0} ',
    beingEditedInCoeditModeOn: 'on {0}.',
    coEditModeAutomaticallyEnds: 'Multi-user editing. {0} days until multi-user editing automatically ends.',
    coEditModeIsEnding: "Fin du mode édition multiutilisateur",
    coEditMode: "Mode édition multiutilisateur",
    checkInInProgressMessage: "Archivage en cours. Le processus peut prendre jusqu’à 20 minutes. Veuillez actualiser la page pour voir les mises à jour.",
    checkOutInProgressMessage: "Extraction en cours. Le processus peut prendre jusqu’à 20 minutes. Veuillez actualiser la page pour voir les mises à jour.",
    daasErrorMessage: "L’opération ne peut pas être traitée pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    coEditModeIsStarting: "Début du mode édition multiutilisateur",
    daasOpenDocumentWarning: 'Multi-user editing may have been ended by another user. Refresh the page and try again.',
    daasStartCollaborationModeWarning: 'Collaboration mode may have been started by another user. Refresh the page and try again.',
    documentCurrentlyBeingModifiedTitle: 'Document currently being modified',
    documentCurrentlyBeingModifiedHeader: 'This document is currently being modified by {0}. This user opened the document',
    documentCurrentlyBeingModifiedBody: 'Starting multi-user edit mode could cause conflicts, so we recommend discussing with {0} before proceeding. Select {1} to start the multi-user edit mode or {2} to return without starting multi-user edit mode.',
    documentEndMultiUserEditingTitle: 'Confirm you want to end multi-user editing',
    documentEndMultiUserEditingHeader: 'Warning: Other users may be actively editing this document.  This can be checked by opening the document and seeing if other users are currently in the file. Please confirm that all changes are complete before ending multi-user mode. File changes in multi-user mode may take up to 1 minute to be processed. Therefore, please wait at least 1 minute after exiting the file before ending multi-user mode.',
    documentEndMultiUserEditingBody: 'Select {0} to end the multi-user edit mode or {1} to return without ending multi-user edit mode.',
    startMultiuserEditing: 'Start',
    continue: "Continuer",
    openReadOnly: "Ouvrir en lecture seule",
    takeControlFromTeam: "Prendre la relève du membre de l’équipe actuel",
    itapplication: "Application informatique",
    aggregateITevaluation: "Évaluation globale des TI :",
    control: "Contrôle",
    itgcitsp: "CGI / procédures de corroboration liés aux TI",
    limitedRisk: "Compte présentant un risque limité",
    so: "SS",
    itApp: "Application informatique",
    itAppType: "Application informatique ",
    deleteTaskModalHeader: "Confirmer la suppression de la tâche sélectionnée",
    deleteTasksModalHeader: "Confirmer la suppression des tâches sélectionnées",
    deleteTaskModalMessage: "Voulez-vous vraiment supprimer la tâche sélectionnée? ",
    deleteTaskModalMessage1: "Les éléments probants correspondants qui ne sont associés à aucune autre tâche de cette mission seront déplacés dans les fichiers temporaires. Les constatations et tâches Réponse qui ne sont associées à aucun autre élément probant seront supprimées.",
    deleteTasksModalMessage: "Voulez-vous vraiment supprimer les tâches sélectionnées? ",
    someTasksCannotBeDeleted: "Certaines tâches ne peuvent pas être supprimées",
    onlySomeTasksCanBeDeleted: "Seulement certaines des tâches que vous avez sélectionnées peuvent être supprimées.",
    tasksThatCanBeDeleted: "Si vous choisissez de continuer, <b>les tâches figurant dans la liste ci-dessous seront supprimées</b> de votre mission. Les éléments probants qui ne sont associés à aucune autre tâche de votre mission seront déplacés dans les fichiers temporaires. Les constatations et les tâches Réponse qui ne sont pas associées à un autre élément probant seront aussi surpprimées. ",
    tasksThatCannnotBeDeleted: "<b>Les tâches figurant dans la liste ci-dessous ne peuvent pas être supprimées</b> de votre mission, mais elles peuvent être rejetées du plan de mission s’il y a lieu.",
    accountHeader: "Comptes",
    noAccountsIdentified: "Aucun compte n'a été identifié.",
    noRisksIdentified: "Aucun risque n'a été identifié",
    noAssertionsIdentified: "Aucune assertion n'a été identifiée",
    noWcgwsIdentified: "Aucune erreur possible n'a été identifiée",
    // Tasks/TaskDetails/Evidence
    addEvidence: "Ajouter des éléments probants",
    relateEvidence: "Associer les éléments probants",
    relateTemporary: "Associer les fichiers temporaires",
    relatePriorPeriod: "Associer les éléments probants de la période précédente",
    relateExtDoc: "Associer les documents externes",
    relateFile: "Associer les fichiers",
    relateAnalytics: "Associer les analyses",
    quickAddButton: "Ajout rapide",
    createPaperProfile: "Créer un profil papier",
    paperProfileInformationMessage: "Toute notre documentation est en format électronique, y compris les documents de préparation et les approbations des réviseurs. Les seuls documents papier acceptés dans nos dossiers de travail sont les documents que la direction ou un tiers nous a fournis sur support papier et qui ne sont pas disponibles sur support électronique (p. ex., la copie d’un contrat signé entre l’entité et un tiers).",
    paperProfileName: "Nom du profil papier",
    paperProfileAdd: "Ajouter",
    paperProfileError: "Veuillez entrer un nom de profil papier valide.",
    otherEngagementsInWorkspace: "Autres missions dans cet espace de travail",
    relateDescription: "Associer un document de cette mission ou d’une autre mission à cet espace de travail",
    onlyShowRelatedDocuments: "Afficher seulement les documents associés",
    relateDescriptionTemp: "Associer un document de cette mission",
    added: "Ajouté",
    documentLocation: "Emplacement du document",
    documentIneligibleForSharingMessage: "Les documents confidentiels ne peuvent pas être partagés. ",
    confidentialityNotAppropiateForSharing: "Vous ne disposez pas du niveau de confidentialité requis pour envoyer ce document.",
    documentIsCheckedOut: "Le document est en mode coédition et ne peut pas être partagé. Veuillez quitter le mode coédition pour partager le document.",
    addCanvasFormNew: "Ajouter un formulaire Canvas NOUVEAU",
    documentCount: "{0} document",
    documentsCount: "{0} documents",
    fitDocumentCannotbeSelected: "Les documents FIT ne peuvent pas être partagés entre les missions.",
    // Task/TaskDetail/Description
    noDescriptionAvailable: "Aucune description disponible.",
    knowledge: "Connaissances",
    knowledgeDescription: "Description des connaissances",
    descriptionInstructions: "Description des instructions",
    fromInstructions: "À partir des instructions",
    customizeDescription: "Description personnalisée",
    custimizeTaskDescription: "Personnaliser la description de la tâche",
    editTaskDescription: "Modifier la description de la tâche",
    saveLabel: "Enregistrer",
    okLabel: "OK",
    cancelLabel: "Annuler",
    leaveCommentLabel: "Laisser un commentaire",
    addLabel: "Ajouter",
    closeLabel: "Fermer",
    editText: "Modifier",
    enterReply: "Saisir la réponse",
    reply: "Répondre",
    deleteTagDesc: "La suppression d’une balise ne peut pas être annulée, voulez-vous vraiment continuer?",
    requiredText: "Texte requis",
    descriptionEmptyError: "Une description est requise",
    descriptionMaxLengthError: "La longueur de la description dépasse la longueur maximale permise",
    assignmentDueDate: "Date d’échéance de l’affectation ",
    navigateToGuidedWorkflow: "Accéder à l’outil FIT d’EY Canvas",
    openInTasksPage: "Ouvrir dans les Tâches",
    copyTaskLink: "Copier le lien vers la tâche",
    copyReviewNoteLink: "Copier le lien vers la note de revue",
    urlCopiedLabel: "Lien copié avec succès",
    //Related Tasks
    showOnlyRelatedTask: "Afficher seulement les tâches associées",
    noTaskAvailable: "Aucune tâche disponible",

    // Client Request / Client Request Detail /  Client Request Drawer
    openInCollaborationPage: "Ouvrir dans Collaboration",
    copyRequestLink: "Copier le lien vers la demande",
    requestType2MessageTitleDrawer: "D’autres fonctionnalités sont disponibles pour cette demande.",
    requestType2MessageSubtitleDrawer1: "Veuillez",
    requestType2MessageSubtitleDrawer2: "cliquer ici",
    requestType2MessageSubtitleDrawer3: "pour y accéder.",

    // SeeMore component
    showMore: "Afficher plus",
    showLess: "Afficher moins",
    showMoreEllipsis: "Afficher plus...",
    showLessEllipsis: "Afficher moins...",

    // Request Description
    saveAndCloseButtonLabel: "Enregistrer et fermer",
    saveButtonLabel: "Enregistrer",
    cancelButtonLabel: "Fermer",

    // Request Description Modal labels
    discardChangesModalText: "Ignorer les modifications",
    inlineSaveUnsavedChanges: "Des modifications n’ont pas été enregistrées, voulez-vous continuer?",

    // RelateWCGWModal labels
    wcgwName: "Nom de l’erreur possible",
    wcgwByScot: "Erreurs possibles par catégorie d’opérations importante ",
    unrelatedSCOTsHeader: "Catégories d’opérations importantes non associées",
    unrelatedSCOTPlaceholder: "Aucune catégorie d’opérations importante non associée",
    noWcgwPlaceholder: "Aucune erreur possible n’a été créée",
    showOnlyUnrelatedWCGW: "Afficher seulement les erreurs possibles non associées",

    // CharCount component.
    of: "de ",
    characters: "caractères",
    fromUserLabel: "De",
    toUserLabel: "À",
    handoffto: "Transmettre à",
    priorityLabel: "Priorité",
    addNoteLabel: "Ajouter",
    replyNoteLabel: "Répondre",
    characterCountLabel: "de  4 000 caractères",
    taskNotePlacehodler: "Entrer une note pour la tâche",
    documentNotePlacehodler: "Entrer une note pour le document",
    taskNoteStatusBy: "par :",
    addNewReviewNoteButtonText: "Nouvelle note",
    fromKnowledge: "de la base de connaissances",
    /*day labels*/
    mon: "Lun",
    tues: "Mar",
    wed: "Mer",
    thurs: "Jeu",
    fri: "Ven",
    sat: "Sam",
    sun: "Dim",
    /*month labels*/
    jan: "Janvier",
    feb: "Février",
    march: "Mars",
    april: "Avril",
    may: "Mai",
    june: "Juin",
    july: "Juillet",
    august: "Août",
    sept: "Septembre",
    oct: "Octobre",
    nov: "Novembre",
    dec: "Décembre",
    /*Rename*/
    documentDropdown: "Menu Document",
    fileNameRequired: "Le nom du fichier est requis",
	invalidCharacters: 'Le nom du fichier ne peut pas contenir les caractères suivants : */:<>\\?|\"',
    existingFileName: "Le nom du fichier n'est pas unique. Actualisez la page ou renommez le fichier pour supprimer ce message.",
    unknowError: "Une erreur inattendue s’est produite. Actualisez la page pour supprimer ce message.",
    maxLengthExceeded: "Le nom du document ne doit pas dépasser la limite de 115 caractères.",
    documentNameSyncErrorMessage: "Le nom du document n’a pas pu être synchronisé avec le portail client d’EY Canvas. Veuillez actualiser la page et réessayer.",
    /*Delete*/
    deleteFileTitle: "Supprimer le document",
    deleteFileCloseBtnTitle: "Annuler",
    deleteFileConfirmBtnTitle: "Supprimer",
    deleteFileCloseTitle: "Fermer",
    deleteFileModalMessage: "Voulez-vous vraiment supprimer le document sélectionné?",
    none: "Aucun",
    /*Unlink*/
    unlinkFileTitle: "Dissocier les éléments probants partagés",
    unlinkSource: "Source",
    unlinkTarget: "Cible",
    unlinkFileCloseBtnTitle: "Annuler",
    unlinkFileConfirmBtnTitle: "Confirmer",
    unlinkFileCloseTitle: "Fermer",
    unlinkFileModalMessage: "Voulez-vous vraiment détacher ce dossier d’éléments probants partagés?",
    /*Relate Tasks*/
    relateTasksTitle: "Associer les tâches",
    relateTaskSearchPlaceholder: "Entrer pour rechercher",
    relateTaskInstructionalText: "Ajoutez ou supprimez les tâches auxquelles le document doit être associé. Si le document fait partie des éléments probants et que vous le supprimez de la dernière tâche, il sera déplacé dans les fichiers temporaires.",
    relatedTaskInstructionalText: "Le document est associé aux tâches suivantes dans cette mission. Cliquez sur le nom de la tâche pour y accéder.",
    relateTaskName: "Nom de la tâche",
    relateTaskType: "Type",
    relatedTaskCounter: "{0} tâche",
    relatedTasksCounter: "{0} tâches",
    /*Relate Entities*/
    relateEntitiesTitle: "Associer des entités",
    relateEntitiesSearchPlaceholder: "Appuyez sur Entrée pour rechercher par nom",
    relateEntitiesName: "Nom de l’entité",
    relateEntitiesIndex: "Référence standard de l’entité",
    relatedEntitiesCounter: "{0} entités",
    relatedEntityCounter: "{0} entités",
    onlyShowRelatedEntities: "Afficher seulement les entités associées",
    unableToRemoveSystemAssociatedRelatedEntity: "Impossible de supprimer les relations entre les documents et les entités dans le système",
    /* Finalize document */
    document: "Document",
    finalize: "Finaliser",
    finalizeDocument: "Finaliser le document",
    finalizeDocumentTitle: "Voulez-vous vraiment aviser l’équipe principale que le document est finalisé?",
    finalizeDocumentSubtitle: "En finalisant un document, vous informez l’équipe principale que vous ne pensez pas envoyer d’autres versions du document et l’état du document passe à <b>Version finale envoyée</b>. Si vous effectuez des changements à un document finalisé, vous pouvez quand même envoyer une nouvelle version à l’équipe principale. ",
    /* Remove From Task */
    removeEvidenceModalTitle: "Retirer de la tâche",
    remove: "Retirer",
    removeFromTaskModalContent: "Voulez-vous vraiment supprimer le document sélectionné de cette tâche? Ce document n’est associé à aucune autre tâche de cette mission et sera donc déplacé dans les fichiers temporaires.",
    sharedEvidenceRemoveFromTaskModalContent: "Voulez-vous vraiment supprimer le document sélectionné de cette tâche? Ce document est partagé et n’est associé à aucune autre tâche de cette mission. Si vous supprimez le document, il ne sera plus disponible dans votre mission.",
    /*AddDocumentToTasksModal*/
    modalCheckboxHeading: "Ajouter aux éléments probants d'une ou plusieurs tâches",
    modalRadioHeading: "Associer le document à une ou plusieurs tâches",
    confirm: "Confirmer",
    proceed: "Continuer",
    modalCheckboxMessage: "Sélectionnez les tâches pertinentes pour ajouter le présent document à ",
    selectedDocument: "document sélectionné",
    modalRadioMessage: "Ce document a déjà été ajouté aux éléments probants ou aux fichiers temporaires.",
    modalRadioMessage1: "Si vous ajoutez ce document, vous créerez un doublon. Indiquez si vous voulez associer une copie existante de ce document ou créer une nouvelle copie de ce document.",
    option: "Option",
    option1Message: "Associer un document existant à cette tâche",
    option2Message: "Créer une nouvelle copie de ce document",
    addToEvidenceSelectAll: "Tout sélectionner",
    currentTask: "Tâche en cours :",
    createNewCopy: "Créer une nouvelle copie",
	fileNameMaxLenError: (maxFileLen) => ` Le nom du fichier ne peut pas dépasser ${maxFileLen} caractères.`,
    /* Confidentiality */
    confidentiality: "Confidentialité",
    confidentialityType: "Confidentialité (facultatif)",
    confidentialityTitle: "Confidentialité des documents",
    confidentialityPlaceholder: "Sélectionner le niveau de confidentialité",
    confidentialityText: "Établir le niveau d’accès requis pour ouvrir ce document. Les niveaux d’accès sont établis par les administrateurs de missions à partir de la page Gérer l’équipe. Si le niveau de confidentialité a déjà été établi pour ce document, seules les personnes autorisées à ouvrir le document peuvent en changer le niveau de confidentialité. ",
    confidentialityNotOpenable: "Impossible d’ouvrir le document, car vous ne disposez pas des droits requis. Les niveaux d’accès sont établis par les administrateurs de missions à partir de la page Gérer l’équipe.",
    confidentialityTargetNotOpenable: "Les documents confidentiels ne peuvent être ouverts qu’à partir de la mission source. ",
    /*Sign-off requirements*/
    signOffRequirements: "Exigences d’approbation",
    signoffRequirementsModalTitle: "Exigences d’approbation",
    signoffRequirementsModalDescription1: "Ajuster les exigences d’approbation par un cadre ci-après pour ce document.",
    signoffRequirementsModalDescription2: "Certaines exigences d’approbations ne peuvent pas être ajustées, car ce sont des exigences par défaut d’EY Canvas. ",
    signoffRequirementsModalSaveLabel: "Enregistrer",
    signoffRequirementsModalCancelLabel: "Annuler",
    signoffRequirementsModalCloseLabel: "Fermer",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "RRQM",
    /*SEM summary*/
    nextAccount: '>',
    prevAccount: "<",
    reviewedBy: "Revu par",
    displaytoc: "Afficher le TDC",
    viewBy: "Afficher par",
    substantiveEvaluation: "Matrice d’évaluation des procédures de corroboration",
    reviewed: "Revu",
    estimate: "Estimation",
    /*440GL*/
    FourFortyTitle: "Éléments probants modifiés après la date du rapport ({0})",
    LeftContainerTitle440GL: "Raisons du changement",
    approvals: "Approbations",
    approveChangesColumnTitle: "Approuver les modifications",
    approveChangesButton: "Approuver les modifications",
    deleteApproval: "Retirer l’approbation",
    unauthorizedAction: "Cette action ne peut être mise en œuvre que par les cadres de la mission.",
    reasonColumnTitle: "Raison",
    approvedBy: "Approuvées par",
    approvedByPeople: "gens",
    noChangeReasonCommentAvailable: "Cliquez sur Modifier la raison dans les options de la roue dentée du document pour saisir la raison du changement.",
    changeReasonModalTitle: "Modifier la raison du changement",
    changeReasonModalText: "Sélectionnez la raison des modifications apportées au document après la date du rapport. Si plusieurs modifications de nature administrative ont été apportées, sélectionnez la modification la plus importante dans le menu déroulant ci-dessous. Si des modifications de nature administrative et autres que de nature administrative ont été apportées, sélectionnez l’option « autre que de nature administrative » ci-dessous.",
    changeReasonUploadModalTitle: "Raison pour laquelle le document a été téléchargé",
    changeReasonUploadModalText: "Sélectionnez la raison des modifications apportées au document après la date du rapport. Si plusieurs modifications de nature administrative ont été apportées, sélectionnez la modification la plus importante dans le menu déroulant ci-dessous. Si des modifications de nature administrative et autres que de nature administrative ont été apportées, sélectionnez l’option « autre que de nature administrative » ci-dessous.",
    changeReasonModalComboPlaceholder: "Sélectionner",
    changeReasonModalAnnotationText: "Consignez les circonstances particulières et les raisons de l’ajout de l’information, les procédures d’audit nouvelles ou supplémentaires mises en œuvre, les éléments probants obtenus et les conclusions tirées, ainsi que l’incidence sur notre rapport.",
    changeReasonUploadModalAnnotationText: "Consignez les circonstances particulières et les raisons de l’ajout de l’information, les procédures d’audit nouvelles ou supplémentaires mises en œuvre, les éléments probants obtenus et les conclusions tirées, ainsi que l’incidence sur notre rapport.",
    changeReasonModalAnnotationPlaceHolder: "Indiquer la raison du changement",
    changeReasonModalChangeReasonRequired: "Raison du changement à enregistrer",
    noDocumentsModifiedAfterReportDate: "Aucun document n’a été modifié après la date du rapport.",
    noReasonSelected: "Aucune raison justifiant la modification n’a été sélectionnée",
    fileSizeColumn: "Taille du fichier",
    changePercent: "% de variation",
    toolTipChangePercent: "Le changement de taille du fichier est calculé en comparant la taille du fichier à la date du rapport à la taille actuelle du fichier.",
    /*Account Conclusion*/
    AccountConclusion: "Conclusion sur le compte",
    AccountDetails: "Détails",
    Conclusions: "Conclusions",
    accountDetailsTab: "détails",
    conclusionsTab: "conclusions",
    accountConclusionNoContentText: "Le contenu de ce formulaire n’a pas été livré. À partir du menu Plus dans la barre de navigation générale, cliquez sur Mises à jour de contenu des formulaires dans Canvas et mettez à jour manuellement le contenu.",
    validations: "Validations",
    /*RelatedFindings*/
    deficiency: "{0} déficiences associées",
    misstatement: "{0} anomalies associées",
    relatedDeficiency: "{0} déficience associée",
    relatedMisstatement: "{0} anomalie associée",
    deficiencies: "Déficiences",
    misstatements: "Anomalies",
    pagingShowtext: "Afficher",
    documentOpenModelLabel: "Le document est en cours de modification.",
    openedLabelText: "Ouvert",
    modelDocumentOpenedText: "Ce document est en cours de modification par",
    modelUserOpenedTheDocumentText: "Cet utilisateur a ouvert le document",
    modelOpenedDocumentConflictText: "L’ouverture du document pourrait entraîner des conflits, il est donc recommandé de l’ouvrir en lecture seule. Si vous souhaitez devenir l’éditeur du document,",
    clickHereEnabledText: "cliquez ici.",
    reviewNotesTemporeryFilesTitle: "Notes de revue dans les fichiers temporaires",
    addNewReviewNoteTitle: "Notes relatives aux tâches",
    /*Assignments*/
    assignedTo: "Attribuée à",
    createAssignment: "Créer une affectation",
    createAssignments: "Créer des affectations",
    editAssignments: "Modifier les affectations",
    deleteAssignments: "Supprimer les affectations",
    removeAssignments: "Retirer les affectations",
    noTimephaseSelected: "Non sélectionnée",
    unassigned: "non attribuée",
    unassignedCapitalized: "Non attribuée",
    dueDateBlank: "échéance",
    reviewerAssignment: "Affectations du responsable de la revue",
    manageAssignments: "Gérer les affectations de tâches",
    manageTaskAssignments: "Créer des affectations",
    selectedTasks: "tâches sélectionnées",
    someTasksCannotBeMoved: "Certaines tâches ne peuvent pas être déplacées",
    onlySomeTaskCanMoveToOtherGroup: "Seulement certaines des tâches que vous avez sélectionnées peuvent être déplacées vers un autre groupe de tâches.",
    taskThatCanBeMovedToOtherGroup: "Si vous choisissez de continuer, <b>les tâches figurant dans la liste ci-dessous seront déplacées</b> vers le groupe de tâches que vous avez sélectionné.",
    tasksThatCannotBeMovedToOtherGroup: "<b>Les tâches figurant dans la liste ci-dessous ne peuvent pas être déplacées</b> vers un autre groupe de tâches.",
    taskGroupSectionNotFound: "Aucun résultat trouvé",
    placeholderForSearch: "Rechercher",
    taskFilter: "Filtrer",
    noResultsAvavilable: "Aucun résultat trouvé",
    noTasksAvavilable: "Aucune tâche disponible",
    clearAll: "Tout effacer",
    engagementPhase: "Phase de l’audit",
    noOptionAvailable: "Aucune option disponible",
    noTimePhase: "Aucune période attribuée",
    roles: "Rôles",
    users: "Membres de l’équipe",
    rommAssociatedWNotRelyAssertion: "Le risque d’anomalies significatives est associé à une assertion avec «Pas d’appui» comme niveau de risque lié au contrôle, ou bien à une assertion avec un risque inhérent plus élevé lorsqu’une estimation est associée à ce compte.",
    hasRiskAssociated: "Risque associé",
    canvas: "Canvas",
    workingoffline: "Travailler hors ligne",
    syncinprogress: "Synchronisation en cours",
    prepareoffline: "Préparation des données pour le travail hors ligne",
    connectionavilable: "Connexion disponible",
    createAnAssignment: "Créez une affectation",
    createAssignmentEnd: "à associer à cette tâche pour commencer.",
    // Manage Assignments
    step01: "Étape 01",
    step02: "Étape 02",
    step03: "Étape 03",
    step04: "Étape 04",
    step05: "Étape 05",
    manageAssigmentsStep1: "Sélectionner une action.",
    manageAssigmentsStep2: "Modifier la tâche attribuée",
    editAssignment: "Modifier une affectation",
    deleteAssignment: "Supprimer une affectation",
    manageAssigmentsStep3: "Terminer la tâche ",
    taskAssigmentStatusHeader: "État de l’affectation",
    taskAssigmentStatusTileHeader: "État de la tâche et de l’affectation",
    taskAssignmentName: "Affectation",
    dueDateAssigment: "Échéance",
    editDueDate: " Facultatif : Modifier le nombre de jours avant la date de fin",
    teamMemberAssigmentLabel: "Membre de l’équipe",
    currentAssigmentLabel: "En cours",
    handOffToAssigmentLabel: "Remis à :",
    priorToEndDateLabel: "avant la date de fin",
    noTimePhaseAssigmentLabel: "Aucune période attribuée",
    closedByAssigmentLabel: "Fermée par",
    onAssingmentLabel: "le",
    preparerAssigmentOpenTitleTip: "Transmettre cette tâche pour fermer la tâche attribuée",
    reviewerAssigmentOpenTitleTip: "Inscrire la tâche attribuée comme étant fermée",
    reviewerAssigmentClosedTitleTip: "Inscrire la tâche attribuée comme étant ouverte",
    AssigmentLabel: "Transmettre cette tâche pour fermer la tâche qui vous a été attribuée",
    noEvidenceReviewerAssigmentTitleTip: "Ajouter des éléments probants pour inscrire la tâche attribuée comme étant fermée",
    noTaskEvidencesHandoffModal: "Aucun élément probant n’est associé à cette tâche.",
    back: "Retour",
    savecontinue: "Enregistrer et continuer",
    finish: "Terminer",
    save: "Enregistrer",
    emptyManageAssignmentStep: "...",
    selectAssignmentActionToContinue: "Sélectionner une action pour continuer",
    createNewTaskAssingment: "Créer une nouvelle tâche à attribuer",
    deleteTaskAssingment: "Supprimer une affectation de tâche",
    createTaskAssingment: "Créer une tâche à attribuer",
    editExistingTaskAssingment: "Modifier une tâche attribuée existante",
    editTaskAssingment: "Modifier la tâche attribuée",
    removeExistingTaskAssingment: "Supprimer une tâche attribuée existante",
    warningPopUpPreparerAssignmentTitle: "Écraser l’affectation du préparateur existante",
    warningPopUpPreparerAssignmentText: "Un préparateur a déjà été assigné à cette tâche. Voulez-vous vraiment écraser cette affectation?",
    warningPopUpPreparerAssignmentConfirm: "Confirmer",
    warningPopUpPreparerAssignmentCancel: "Annuler",
    selectTaskAssingment: "Sélectionner la tâche attribuée",
    viewHistoryAndConflicts: "Afficher l’historique",
    noHistoryAvailable: "Aucun historique disponible",
    teamMember: "Membre de l’équipe",
    dateEdited: "Dernière modification",
    viewHistoryHeader: "L’historique de cette version de document est affiché ci-dessous.",
    viewHistorySubHeader: "Cliquez sur le nom d’un membre de l’équipe pour ouvrir l’ancienne version de ce document en lecture seule. Les changements apportés à l’ancienne version ne seront pas enregistrés dans EY Canvas.",
    docConflictedMessage: "Des conflits sont associés à ce document. Pour les résoudre, cliquez sur l’onglet Conflits dans la liste de documents.",
    removeTaskAssingment: "Supprimer la tâche attribuée",
    addAssignmentInstructionalText: "Entrer le nom de la nouvelle tâche à attribuer ici (p. ex., Responsable de la revue détaillée, Responsable de la revue générale)",
    addNewAssingmentName: "Ajouter le nom de la nouvelle affectation",
    addTaskAssignmentName: "Ajouter le nom de la tâche attribuée",
    assignmentName: "Nom de l’affectation",
    selectedTask: "tâches sélectionnées",
    createTaskAssignmentHeading: "Créer une nouvelle affectation ici.",
    createTaskAssignmentHeading1: "Entrez les détails relatifs à l’affectation ci-dessous et sélectionnez <b>Enregistrer et fermer</b> pour terminer. Pour créer une autre affectation, sélectionnez <b>Enregister et ajouter</b>.",
    saveDelete: "Enregistrer et supprimer",
    createTaskAssignmentFinishLabel: "Enregistrer et fermer",
    createTaskAssignment: " Enregistrer et ajouter",
    editTaskAssignment: "Enregistrer et passer à une autre tâche",
    createTaskAssignmentSaveAndContinueLabel: "Enregistrer et passer à une autre tâche",
    daysPriorToEndDate: "Nombre de jours avant la date de fin",
    daysdue: "jours avant l’échéance",
    daysPriorToEndDateOptional: "Nombre de jours avant la date de fin (facultatif)",
    timephase: "Période",
    timephasesLabel: "Périodes",
    manageTimePhase: "Gérer les périodes",
    removeTaskAssingmentSingleTaskHeading: "Sélectionnez la tâche attribuée que vous souhaitez supprimer.",
    removeTaskAssingmentSingleTaskHeading2: "Cliquez sur Enregistrer et fermer lorsque vous avez terminé ou sur Enregistrer et passer à une autre tâche si vous souhaitez passer à une autre tâche attribuée.",
    removeTaskAssingmentMultipleTaskHeading: "Si la combinaison affectation/membre de l’équipe existe déjà pour la tâche sélectionnée, l’affectation sera supprimée. Faites votre sélection et cliquez sur <b>Enregistrer et fermer</b> pour terminer. Pour supprimer une autre affectation, cliquez sur <b>Enregistrer et supprimer</b>.",
    editTaskAssingnmentStep2Heading: "Sélectionnez la tâche attribuée que vous souhaitez modifier.",
    selectedAssignment: "Affectation sélectionnée :",
    editTaskAssingmentBulkHeading: "Sélectionnez l’affectation que vous souhaitez modifier",
    editTaskAssingmentBulkSubHeading1: "Si la combinaison affectation/membre de l’équipe existe déjà pour la tâche sélectionnée, la tâche sera réattribuée. Vous avez la possibilité de modifier le <b>nombre de jours avant la date de fin</b>. Si vous modifiez cette valeur, celle-ci sera mise à jour dans toutes les tâches réattribuées. Apportez vos modifications et cliquez sur <b>Enregistrer et fermer</b> pour terminer. Pour modifier une autre affectation, cliquez sur <b>Enregistrer et modifier une autre </b>.",
    noResultInCategory: "Aucun résultat trouvé dans la catégorie de tâches",
    searchTaskList: "Rechercher dans la liste de tâches",
    searchCanvasFormList: "Rechercher",
    clearHoverText: "Effacer",
    filtersWarningMessage: "Le nombre maximal de filtres est dépassé. Vous ne pouvez appliquer que 25 filtres à la fois.",
    reviewNotesWarningMessage: "Une erreur s’est produite lors de la récupération des données. Essayez à nouveau et si le problème persiste, communiquez avec le Service de dépannage.",
    editTaskAssingmentSept3Header: "Modifier l'affectation sélectionnée",
    editTaskAssingmentSept3Header2: "Cliquez sur Enregistrer et fermer lorsque vous avez terminé ou sur Enregistrer et passer à une autre tâche si vous souhaitez passer à une autre tâche attribuée.",
    editTaskAssignmentHeaderPart1: "Modifier les détails relatifs à l’affectation ci-dessous et sélectionner <b>Enregistrer les modifications</b>.",
    calculatedDate: "Date calculée",
    saveAndAddbtn: "Enregistrer et ajouter",

    //Calendar Toggle Labels
    daysPriorToEndDateRequired: "Nombre de jours avant la date de fin (obligatoire)",
    dueDateRequired: "Date d’échéance (obligatoire)",
    selectDate: "Sélectionner la date",
    calculateDate: "Calculer la date",

    /* Bulk TimePhase*/
    taskText: "Tâche",
    timephasesetsuccess: "La période {0} a été définie avec succès.",
    timephasessetsuccess: "Les périodes {0} ont été définies avec succès.",
    addTimephaseLabel: "Ajouter une période",
    infoSetTimePhase: "<h3>Définir les périodes</h3><p>Glissez et déposez les éléments sélectionnés sur une période pour les associer à cette période.</p>",
    infoEditTimePhase: "<h3>Modifier la période</h3><p>Cliquez sur le menu de débordement (trois points) et sélectionnez Modifier pour modifier les propriétés de la période.</p>",
    infoAddTimePhase: "<h3>Ajouter une période</h3><p>Cliquez sur Ajouter une période pour créer une nouvelle période.</p>",
    infoDeleteTimePhase: "<h3>Supprimer la période</h3><p>Cliquez sur le menu de débordement (trois points) et sélectionnez Supprimer pour supprimer la période.</p>",
    deletedTimePhaseFilterWarningMessage: "La période a été supprimée par un utilisateur différent.",

    //Set assignment dates modal labels
    setAssignmentTitle: "Établir la date d’échéance des affectations",
    setAssignmentDesc: "Vous n’avez pas établi la date d’échéance des affectations. Sélectionnez ci-dessous la date d’échéance des affectations pour continuer.",
    setAssignmentDesc2: "La date de fin de période pour une ou plusieurs tâches est antérieure à la date d’échéance sélectionnée, le {0}. Veuillez ajuster les dates d’échéance des tâches ou de la période pour continuer.",
    timePhaseNameLabel: "Période",
    timephaseEndDate: "Date de fin de période",
	tasksLabel: "Nbre de tâches",
    assignmentDateLabel: "Affectation",
    noAssignedTimePhase: "Aucune période attribuée",
    endDate: "Date de fin",
    calendarDateError: "La date d’échéance devrait être antérieure à la date de fin de période.",

    /* Events*/
    addEventLabel: "Ajouter un événement",
    sharedWithClient: "Partagé",
    noEventsMessage: "Aucun événement n’a été identifié.",
    naLabel: "s. o.",
    deleteEventModalTitle: "Effacer l’événement",
    deleteEventDescription: "Voulez-vous vraiment supprimer cet événement?",
    showEventeName: "Événement",
    eventDateLabel: "Date",
    eventDatesLabel: "Dates",
    showEventStartDate: "Date de début",
    showEventEndDate: "Date de fin ",
    deleteEventSuccessMessage: "Événement supprimé avec succès.",
    eventTypeLabel: "Type d’événement",
    singleDayEventLabel: "Un seul jour",
    multiDayEventLabel: "Plusieurs jours",
    dateRangeEventLabel: "Plage de dates",
    eventSharedWithClientLabel: "Partagé avec le client",
    editEventLabel: "Modifier l’événement",
    eventUpdateSuccessMessage: "Événement mis à jour avec succès.",
    noTimephasesMessage: "Aucune période n’a été identifiée. ",

    /* Review Notes */
    showAll: "Tout",
    reviewNotesLabel: "Notes de revue",
    athoredByMeLabel: "Rédigées par moi",
    assignedToMe: "Attribués à moi",
    assignedToOpen: "Attribuées à (Ouvertes)",
    authoredByCleared: "Rédigées par (Réglées)",
    totalOpenReviewLabel: "Nombre total de notes de revue ouvertes",
    totalClearedReviewLabel: "Nombre total de notes de revue réglées",
    agingLabel: "Organisation",
    openLabel: "Ouvertes",
    clearedLabel: "Réglées",
    noUsersFoundLabel: "Aucun résultat",
    chartDataLabel: "Aucune donnée disponible.",
    noClientDataAvailable: "Aucune donnée disponible",
    DaysLessThan10: "< 10 jours",
    Days11To30: "< 30 jours",
    Days31To60: "< 60 jours",
    Days61To90: "< 90 jours",
    DaysMoreThan90: "> 90 jours",
    noReviewNotesFound: "Aucune note de revue trouvée",

    formMaxLength: "Le texte ne doit pas dépasser {number} caractères.",
    voiceNote: "Note vocale",
    microphoneBlockedMessage: "Autorisez le navigateur à accéder à votre microphone afin d’utiliser les notes vocales. Si vous l’avez déjà fait, veuillez actualiser la page et réessayer.",
    microphoneBlockedOnVideoMessage: "Autorisez le navigateur à accéder à votre microphone afin d’ajouter la voix à l’enregistrement d’écran. Si vous l’avez déjà fait, veuillez actualiser la page et réessayer.",
    notInMainWindowVoice: "Les enregistrements vocaux ne sont pas autorisés dans le tiroir. Veuillez ouvrir le document dans un nouvel onglet pour effectuer cette action.",
    notInMainWindowScreen: "Les enregistrements d’écran ne sont pas autorisés dans le tiroir. Veuillez ouvrir le document dans un nouvel onglet pour effectuer cette action.",
    screenRecord: "Enregistrement d’écran",
    playbackReview: "Lire l’enregistrement ",
    recording: "Enregistrement en cours",

    /* Sign Offs */
    preparerHoverText: "Approuver comme préparateur",
    reviewerHoverText: "Approuver comme responsable de la revue",
    preparerTitle: "Approbations des préparateurs",
    reviewerTitle: "Approbations des responsables de la revue",
    preparerLetter: "P",
    reviewerLetter: "R",
    deleteHoverText: "Retirer l’approbation",
    signoffsrequired: "Approbations requises",
    signoffsOptional: "Associé responsable/Responsable de la revue de la qualité de la mission − Facultatif",
    eqrLabel: "RRQM",
    partnerInChargeLabel: "PIC",

    landingPage: "Page d’accueil",
    dashboardPage: "Tableau de bord",
    tasksPage: "Tâches",
    documentsPage: "Documents",
    collaborationPage: "Collaboration",
    automationPage: "Automatisation",
    newContentUpdate: "Mise à jour du contenu",
    contentUpdatesHistory: "Historique",
    history: "Historique",
    contentUpdateType: "Type de mise à jour de contenu",
    iniciatedBy: "Lancé par",
    date: "Date",
    clickForOptions: "Cliquez ici pour plus d’options",
    offline: "Hors ligne",
    eyServiceGateway: 'EY Service Gateway',
    eyAutomation: 'EY Automation',
    eyserviceGatewayAutomation: 'EY Service Gateway & Automation',

    // ContentUpdates
    contentUpdate: "Mises à jour du contenu",
    canvasFormUpdates: "Mises à jour des formulaires Canvas",
    syncFormProfile: "Synchronisation du profil associé à un formulaire",
    documentName: "Nom du document",
    analyticName: "Nom de l’analyse",
    formType: "Type de formulaire",
    dateOfContent: "Date du contenu",
    formStatus: "État",
    formsWarningMessage: "Vous devez sélectionner un ou plusieurs formulaires EY Canvas pour effectuer la mise à jour",
    formsUpdateSuccessMessage: "Mise à jour du formulaire EY Canvas envoyée",
    filterTypeOfFormLabel: "Type de formulaire",
    filterSourceOfFormLabel: "Source du formulaire",
    documentSelectionRequired: "Sélectionner un document à écraser",
    overwriteForm: "Écraser le formulaire",
    overwriteFormInstructionalText: "Sélectionnez un formulaire pour écraser les réponses à partir du formulaire Canvas actuel. Veuillez noter que le formulaire actuel sera déplacé vers les fichiers temporaires.",
    confirmOverwrite: "Confirmer l’écrasement",
    confirmOverwriteAreYouSure: "Voulez-vous vraiment copier le contenu du formulaire \'{0}\' dans le formulaire \'{1}\'?",
    confirmOverwriteDesc: "Les réponses seront écrasées dans le formulaire \'{1}\', mais pas les éléments probants ni les objets associés. Les éléments probants et les objets associés applicables doivent être réassociés au formulaire \'{1}\' une fois l’écrasement terminé. Les sections sur le profil et les volets de la MMA seront conservés dans le formulaire \'{0}\'. Par conséquent, si les sections sur le profil ne correspondent pas à celles du formulaire \'{1}\', veuillez passer en revue le contenu copié et le mettre à jour au besoin.",
    confirmOverwriteDoNotClose: "Ne fermez pas le navigateur ou la page pendant le processus d’écrasement. Une fois le processus terminé, le formulaire \'{0}\' sera déplacé vers les fichiers temporaires. Cette action ne peut pas être annulée.",
    sourceDocument: "document source",
    targetDocument: "document cible",
    profileLayers: "Volets de la MMA",
    pspAccountWarningMessage: "Vous devez sélectionner un ou plusieurs comptes pour effectuer la mise à jour",
    pspAccountUpdateSuccessMessage: "Mise à jour du contenu des PCB envoyée",
    pspAccountconfirmUpdateMessage: "La mise à jour de ces comptes pourrait avoir une incidence importante sur le contenu. Une fois lancée, aucune autre mise à jour de contenu ne pourra être effectuée avant la fin de cette opération.",
    est: "Une estimation y est associée.",
    bookmarkTaskModalHeader: "Impossible de télécharger les tâches sélectionnées",
    bookmarkTaskModalMessage: "Les tâches sélectionnées ne peuvent pas être téléchargées pour le travail hors ligne.",
    noGuidanceAvailable: "Aucune indication disponible",
    next: "Suivante",
    previous: "Précédente",
    guidanceLink: "Lien",
    addToEvidenceLabel: "Ajouter aux éléments probants",
    otherEngagements: "Autres missions",
    navigationView: "Vue - Navigation",
    listView: "Vue - Liste",
    detailsView: "Vue - Détails",
    closeguidance: "Fermer les indications",
    reviewNotesModalClose: "Fermer",
    gamGuidanceLinkLabel: "Indications de la MMA",
    inProgess: "En cours",
    upcomingReview: "Revue à venir",
    teamSummaryEmptyTaskDetailsMesage1: "Utilisez le Sommaire de l’équipe pour afficher les affectations de préparateur et de responsable de la revue pour chaque membre de l’équipe par état. Pour gérer toutes les affectations de la mission, sélectionnez ",
    teamSummaryEmptyTaskDetailsMesage2: "Gérer les affectations.",
    teamSummaryEmptyTaskDetailsMesage3: "Pour activer les contrôles en bloc, sélectionnez une ou plusieurs tâches en cochant les cases. Utilisez la touche Majuscule (Maj) pour sélectionner plusieurs tâches en même temps. Si vous souhaitez travailler sur une seule tâche, vous devez la sélectionner dans la liste des tâches. ",
    taskSummaryPoint1: "Sélectionnez «À préparer» pour afficher la liste des tâches de préparateur pour chaque membre de l’équipe.",
    taskSummaryPoint2: "Sélectionnez «À revoir» pour afficher la liste des tâches de responsable de la revue pour chaque membre de l’équipe.",
    taskSummaryPoint3: "Les affectations sont classées en fonction de leur état (non commencée, en cours, terminée).",
    noLinksfound: "Aucun lien disponible pour cette tâche.",
    noFormsfound: "Aucun formulaire disponible pour cette tâche.",
    workofflinemsg: "Cette fonction permet de télécharger la version la plus récente des tâches sélectionnées et de continuer à les modifier en mode hors ligne. La synchronisation de vos modifications se fera ultérieurement lors de la reconnexion.",
    workonlinemsg: "La synchronisation des modifications se fera automatiquement au moment de la reconnexion. Vérifiez votre connexion Internet avant de vous reconnecter.",
    workoffline: "Travailler hors ligne",
    workonline: "Travailler en ligne",
    duplicateFileNames: "Dupliquer les noms des fichiers",
    training: "Formation",
    duplicateFileNameValidationMessage: "Le fichier que vous essayez d’ajouter à cette mission porte le même nom qu’un autre fichier de cette mission. Pour continuer, renommez l’un des fichiers.",
	documentHelperConnectionIssue: 'Un problème concernant EY Canvas Document Helper a été détecté. Cliquez sur <a style="color: #467cbe" href="https://eyt.service-now.com/kb_view.do?sysparm_article=KB0486774" target="_blank">ici</a> pour obtenir des instructions sur la façon de régler ce problème.',
    incompleteCra: "EGR incomplète",
    noteItemCreated: "Créé le:",
    NetworkErrorMessage: "Une erreur s’est produite dans le réseau d’application. Actualisez la page et réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    saveClose: "Enregistrer et fermer",
    contentupdatePSPs: "Mise à jour du contenu – PCB",
    /* PAANS */
    paansIsNotReachable: "Le service de rédaction des directives d’EY, d’approbation et de notification n’est pas disponible pour le moment. Nous ne sommes pas en mesure de confirmer si toutes les directives pertinentes sont prêtes. <br/> Si vous n’avez pas revu les directives pertinentes, actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /* Add New Task */
    standardtask: "Tâche standard – ATS",
    substantivetask: "Tâche de corroboration – APC",
    walkthroughtask: "Tâche Test de cheminement – TC",
    controltask: "Tâche Contrôle – TDC",
    addnewTask: "Ajouter une nouvelle tâche",
    taskType: "Type de tâche",
    taskTypeError: "Veuillez sélectionner un type de tâche.",
    selectTaskTypeHeader: "Sélectionnez un type de tâche pour continuer.",
    selectTaskType: "Sélectionner un type de tâche",
    enterTaskDetails: "Entrer les détails de la tâche",
    assignTask: "Attribuer la tâche",
    taskGroup: "Groupe de tâches",
    finishLabel: "Enregistrer et fermer",
    addTaskContinueLabel: "Enregistrer et attribuer",
    AssignTaskStepSaveandContinueLabel: "Enregistrer et ajouter une autre tâche",
    addTaskDetailsHeader: "Entrer les détails de la tâche pour continuer.",
    addTaskAssignmentHeader: "Facultatif : Attribuer cette tâche.",
    addTaskDetailsSubHeader: "Cliquez sur <b>Enregistrer et attribuer</b> si vous souhaitez attribuer cette tâche maintenant ou sur <b>Enregistrer et fermer</b> si vous souhaitez l’attribuer plus tard.",
    addTaskAssignmentSubHeader: "Entrez les détails relatifs à l’affectation ci-dessous et sélectionnez Enregistrer et fermer pour terminer. Pour créer une autre affectation, sélectionnez Enregistrer et ajouter. ",
    addTaskAssignmentSubHeader1: "Entrez les détails relatifs à l’affectation ci-dessous et cliquez sur <b>Enregistrer et fermer</b> pour terminer. Pour créer une autre affectation, cliquez sur <b>Enregistrer et ajouter</b>.",
    addTaskGroup: "Ajouter un nouveau groupe de tâches ici. Une fois ajouté, vous pouvez sélectionner ce groupe de tâches lors de la création de nouvelles tâches et déplacer les tâches Autre procédure de corroboration existantes dans ce groupe de tâches.",
    relateObjectHeaderAccount: "Sélectionner une ou plusieurs assertions associées à un compte important ou à une information à fournir importante, ou sélectionner un compte présentant un risque limité.",
    relateObjectSubHeaderAccount: "Les tâches ne peuvent être associées qu’à un seul compte ou une seule information à fournir.",
    relateObjectHeader: "Associez un ou plusieurs objets pour continuer.",
    limitedRiskAccount: "Compte présentant un risque limité",
    onlyShowAddedObject: "Afficher les objets ajoutés seulement",
    relateObjectRequiredError: "Sélectionnez un ou plusieurs objets pour continuer.",
    invalidSelectionWarning: "Les tâches ne peuvent être associées qu’à un seul compte ou une seule information à fournir. Retirer les assertions sélectionnées ou le compte présentant un risque limité sélectionné pour associer la tâche aux assertions d’un compte différent, d’une information à fournir différente ou d’un compte présentant un risque limité différent.",
    invalidSelctionCRA: "Sélectionner un seul type d’objet",
    relateObjectOptionsHeaderAccountTask: "Assertions et comptes présentant un risque limité",
    relateObjectOptionsHeaderITWalkthroughTask: "Processus TI/SS",
    relateObjectOptionsHeaderITControlTask: "Contrôles généraux informatiques",
    relateObjectOptionsHeaderITSubstantiveTask: "Procédures de corroboration informatiques",
    relateObjectOptionsHeaderSCOTControlTask: "Contrôles",
    relateObjectOptionsHeaderSCOTWalkthroughTask: "Catégories importantes d’opérations",
    StrategyTypeControls: "Contrôles",
    StrategyTypeSubstantive: "Corroboration",

    //Manage quick filters labels
    manageQuickFilterHeader: "Sélectionnez un filtre enregistré ou suggéré comme valeur par défaut.",
    manageQuickFilterText: "Si vous sélectionnez un filtre comme valeur par défaut, celui-ci sera alors appliqué lorsque vous accéderez à la liste des tâches.",
    noDefaultFilter: "Aucun filtre par défaut",
    suggestedFiltersHeading: "Filtres suggérés",
    savedFiltersHeading: "Filtres enregistrés",
    manageQuickFilters: "Gérer les filtres rapides",
    manageLabel: "Gérer   ",


    /* RNH Labels */
    emptyNoteDetailsMessage: "Sélectionnez une note pour afficher les détails. Pour activer les contrôles en bloc, appuyez sur la touche Ctrl ou Maj et sélectionnez plusieurs notes de revue. Si vous souhaitez travailler sur une seule note, vous devez la sélectionner dans la liste.",
    emptyRepliesMessage: "Aucune réponse pour l’instant",
    emptyRepliesMessageAlt: "Aucune réponse",
    reviewNotes: "notes de revue",
    reviewNotesStatus: "État de la note de revue",
    reviewNotesStatusAssignedToMe: "État des notes de revue qui me sont attribuées",
    reviewNotesStatusAuthoredByMe: "État des notes de revue que j’ai rédigées",
    comments: "Notes de revue",
    showHideNotes: "Afficher/Masquer les notes",
    fileType: "Type de fichier",
    noteType: "Type",
    statusId: "État",
    rnhPriority: "Priorité",
    rnhDueDate: "Échéance : ",
    rnhModifiedDate: "Modifiée",
    textAreaPlaceholder: "Entrer une note",
    requiredFieldErrorMessage: "Ce champ est obligatoire.",
    meLabel: "Mes notes",
    editIconHoverText: "Modifier",
    deleteIconHoverText: "Supprimer",
    deleteIconModalTitle: "Supprimer la note",
    deleteIconCommentModalTitle: "Supprimer la note",
    deleteReplyIconModalTitle: "Supprimer la réponse",
    deleteIconModalConfirmMessage: "Voulez-vous vraiment supprimer votre réponse à cette note?",
    deleteIconModalConfirmMessageParent: "Voulez-vous vraiment supprimer la note sélectionnée?",
    deleteIconModalCommentConfirmMessage: "Voulez-vous vraiment supprimer cette réponse?",
    deleteIconModalCommentConfirmMessageParent: "Voulez-vous vraiment supprimer cette note? Toutes les réponses liées à cette note seront également supprimées.",
    deleteIconModalAcceptText: "Supprimer",
    replyInputPlaceholder: "Répondre à cette note",
    changeStatus: "Modifier l’état",
    emptyReplyErrorMsg: "Ajouter du texte ou une note vocale pour continuer",
    lengthReplyErrorMsg: "La réponse ne doit pas dépasser la limite de 4 000 caractères.",
    closeTitle: "Fermer",
    closedBy: "Fermée par",
    ClearedBy: "Effacée par",
    ReopenedBy: "Rouverte par",
    commentTitle: "Note",
    noteDueDateLabel: "Échéance",
    reopen: "Rouvrir",
    noNotesAssociatedWithDocumentLabel: "Veuillez laisser une note en utilisant les données ci-après. Attribuez la note à un utilisateur et indiquez la priorité ainsi que la date d’échéance.",
    noNotesFound: "Aucune note trouvée",

    /* Add new review note RNH */
    addNewNoteButtonTitle: "Nouvelle note",
    addNewNoteModalTitle: "Ajouter une nouvelle note",
    addNewNoteModalClose: "Fermer",
    backButtonLabel: "Retour",
    cancelButtonLabel: "Annuler",
    addNewNoteStep1Title: "Sélectionner le type de note",
    addNewNoteStep2Title: "Sélectionner un document ou une tâche",
    addNewNoteStep3Title: "Entrer les détails de la note",
    editNoteModalTitle: "Modifier la note",
    editReplyModelTitle: "Modifier la réponse",
    voiceNoteButtonLabel: "Note vocale",
    stopRecordingButtonLabel: "Arrêter",
    enterText: "Entrer le texte",

    /* RNH Review note hub Step 1 */
    step1Title: "Sélectionnez un type de note pour continuer.",
    step1Subtitle: "Vous pouvez uniquement ajouter une note de document et de tâche ici. Les commentaires pour les formulaires Canvas doivent être ajoutés dans le formulaire Canvas correspondant.",
    step1NoTypeSelectedError: "Sélectionnez un type de note pour continuer.",

    /* RNH Review note hub Step 2 */
    step2DocumentTitle: "Sélectionnez le document auquel vous souhaitez ajouter une note.",
    step2TaskTitle: "Sélectionnez la tâche à laquelle vous souhaitez ajouter une note.",
    step2SearchTitle: "Chercher",
    step2SearchClearTitleTip: "Effacer",
    step2ErrorMessageTop: "Sélectionner un élément pour continuer.",
    step2ErrorMessageBottom: "Remplir les champs requis identifiés ci-dessus pour continuer",
    step2EmptySearch: "Aucun résultat trouvé",

    /* RNH Review note hub Step 3 */
    step3InstructionalText: "Entrez les détails de la note pour le document ou la tâche sélectionné.",
    step3InstructionalSubTitle: "Cliquez sur <b>Entregistrer et fermer</b> lorsque vous avez terminé ou sur <b>Enregistrer et ajouter une autre note</b> si vous souhaitez ajouter une autre note au document ou à la tâche sélectionné.",
    step3SelectedDocument: "Document sélectionné :",
    step3SelectedTask: "Tâche sélectionnée :",
    step3SaveAndContinue: "Enregistrer et ajouter une autre note",
    step3SaveAndClose: "Enregistrer et fermer",

    /* RNH List Layout Labels*/
    searchReviewNotes: "Rechercher des notes",
    searchReviewNotesResultsNotFound: "Aucun résultat trouvé dans cette catégorie de note",
    searchReviewNotesNotAvailable: "Aucune note disponible",
    notesRepliesNotFound: "Aucune réponse n’a été trouvée pour les notes sélectionnées.",

    selectValueToContinue: "Veuillez sélectionner une valeur pour continuer.",
    required: "Requis",
    invalidEngagementId: "Le code de la mission est invalide. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    accessDenied: "Accès refusé!",
    annotationDeletedError: "La note sélectionnée a été supprimée. Actualisez la page et réessayez.",

    /* RNH Filters */
    rnhClearAll: "Tout effacer",
    rnhShowMore: "plus",
    rnhFilter: "Filtrer",
    hideFiltersLabel: "Masquer",
    noDocumentChangeTypes: "Aucun résultat trouvé",
    selectatasktype: "Sélectionner un type de tâche",
    importfromknowledge: "Importer de la base de connaissances",
    assigntaskoptional: "Attribuer la tâche (facultatif)",
    relateanobject: "Associer un objet",
    account: "Compte",
    userOrRole: "Utilisateur ou rôle",
    userSummary: "Synthèse de l’utilisateur",
    other: "Autre",
    userNotFound: "Utilisateur introuvable",
    dueOnOrBefore: "Échéant le ou avant le",
    dueOnOrAfter: "Échéant le ou après le",

    /*Dashboard - Milestone tile*/
    milestonesLabel: "Jalons",
    scopeAndStrategy: "Étendue et stratégie",
    scopeAndStrategyTabLabel: "Étendue et stratégie",
    executionTabLabel: "Exécution",
    conclusionTabLabel: "Conclusion",
    viewAllTabLabel: "Afficher tout",
    noTaskAssociatedToMilestoneMsg: "Aucune tâche n’est associée aux jalons de cette phase de l’audit.",
    overdueLabel: "En retard",
    upcomingLabel: "Date d’échéance à venir",
    quickLinkText: "Liens rapides",
    inreviewLabel: "En cours de revue",
    CompleteLabel: "Terminer",
    completeLabel: "terminer",
    startLabel: "Début",
    endLabel: "Fin",
    auditPhaseSummary: "Sommaire par phase de l’audit",
    milestoneView: "Vue par jalon",
    timePhaseView: "Vue par période",
    localLandingPageHeader: "Cette page affiche uniquement les missions EY Canvas qui sont disponibles dans ce centre de données.",
    localLandingPage: "PAGE D’ACCUEIL LOCALE",
    noEngagementsAvailable: "Aucune mission disponible pour ce centre de données",
    engagements: "Missions",
    /* Document List */
    docListRelatedTasks: "Tâches associées",
    temporaryFilesTab: "Fichiers temporaires",
    priorPeriodEvidenceTab: "Éléments probants de la période précédente",
    conflictsTab: "Conflits",
    recentlyDeletedTab: "Récemment supprimés",
    docListSelectedDocument: "{0} document sélectionné",
    docListSelectedDocuments: "{0} documents sélectionnés",
    shared: "Partagé",
    shareStatusOwned: "Appartenant à cette mission",
    shareStatusShared: "Partagé dans cette mission",
    unlinkInprogress: "Détachement en cours",
    unlinkError: "Erreur de détachement",
    documentList: "Documents",
    restoreModalTitle: "Restaurer les fichiers temporaires",
    restoreModalText: "Cliquez sur Restaurer pour retourner ce document dans les fichiers temporaires.",
    permanentlyDeleteModalTitle: "Supprimer de façon permanente",
    permanentlyDeleteModalText: "La suppression définitive du document le fera disparaître d’EY Canvas. Cette action ne peut pas être annulée. Cliquez sur Supprimer de façon permanente pour continuer.",
    misstatementsInstructionalText: "Le document est associé aux anomalies suivantes dans cette mission. Cliquez sur l’anomalie pour y accéder.",
    deficienciesInstructionalText: "Le document est associé aux déficiences suivantes dans cette mission. Cliquez sur la déficience pour y accéder.",
    referenceId: "Identifiant",
    findingDescription: "Description",
    deficienciesModalTitle: "Déficiences associées",
    misstatementsModalTitle: "Anomalies associées",
    startsWith: "Commence par",
    contains: "Contient",
    documentsWherePICEQRSignOffIsRequired: "Documents pour lesquels l’approbation de l’associé responsable/du responsable de la revue de la qualité de la mission est requise",
    otherDocuments: "Autres documents",
    documentsWherePICSignOffIsRequired: "Documents pour lesquels l’approbation de l’associé responsable est requise",
    documentSignoffRequiredLabel: "Approbations requises de :",
    timePhaseFilterLabel: "Période",
    drillDownTimePhaseFilterLabel: "Afficher par période",
    auditPhasesLabel: "Phase de l’audit",
    openedLabel: "Ouvert",

    clientApprovals: "Approbations externes",
    noTeamsAvailable: "Aucune équipe n’a encore été créée. Pour commencer, créez une équipe et envoyez une demande de lien.",
    noDocumentRecieved: "Aucun document n’a encore été reçu.",
    team: "Équipe",
    pendingEvidence: "En attente d’éléments probants",
    noTimePhasePlaceHolder: "Aucune période",

    regionComponentEvidence: "Éléments probants associés à une zone ou à une composante",
    preparersignoffs: "Approbations des préparateurs",
    reviewersignoffs: "Approbations des responsables de la revue",
    receivedon: "Reçu le : ",
    nosignoffsyet: "Aucune approbation pour l’instant.",
    noRegionComponentEvidence: "Aucun document n’a encore été reçu. Pour voir la liste des zones et des composantes qui n’ont pas encore envoyé les documents, sélectionnez <b>Documentation en attente</b>.",
    noComponentEvidence: "Aucun document n’a encore été reçu.",
    assignToRegionOrComponent: "Attribuer à une zone ou à une composante ",
    assignRegionComponentModalText: "Sélectionnez la zone ou la composante à laquelle vous souhaitez attribuer à ce document. ",
    documentAssignedToPGT: "Ce document a déjà été attribué à une autre zone ou composante. Il ne peut donc pas être attribué.",
    assignedToRegionComponent: "Zone ou composante à laquelle le document a été attribué :",
    noRegionComponentsAvailable: "Aucune zone ou composante n’est disponible",
    documentUnassignedFromComponent: "{0} n’est plus attribué à {1}.",
    documentUnassigned: "{0} n’est plus attribué.",
    documentReturnedToComponent: "{0} a été retourné à {1}.",
    documentReturned: "{0} a été retourné.",
    regionComponentName: "Nom de la zone ou de la composante",
    relatedReviewNoteCount: "1 note ouverte provenant d’autres missions",
    relatedReviewNotesCount: "{0} notes ouvertes provenant d’autres missions",

    deleteVersion: "Supprimer la version ",
    deleteVersionMessage: "Sélectionnez une version pour continuer.",
    deleteVersionDisabledMessage: "Les versions de l’historique ne peuvent être supprimées qu’à partir de la mission source du document par les administrateurs de la mission. ’",
    deleteVersionTitle: "Supprimer la version du document",
    deleteVersionPlaceholder: "Voulez-vous vraiment supprimer cette version de l’historique? Cette action ne peut pas être annulée.",

    childDocumentsCountLabel: "Copies existantes",
    childDocumentsModalTitle: "Copies existantes",
    childDocumentsModalDescription: "Les documents ci-dessous ont été créés à partir du document initial.",
    childDocumentsModalColumnDocumentName: "Nom du document",
    childDocumentsModalColumnDocumentType: "Type de document",
    childDocumentsModalColumnRelatedTasks: "Tâches associées",
    childDocumentsModalColumnSignoffs: "Approbations",

    bulkAddToEvidenceDescription1: "Créez une nouvelle copie des documents présentés à titre d’éléments probants, ou sélectionnez une copie existante disponible.",
    bulkAddToEvidenceDescription2: "Par défaut, les documents nouvellement créés seront ajoutés à toutes les tâches et à tous les formulaires Canvas auxquels l’ancien document était associé. Utilisez les « options avancées » pour sélectionner manuellement les tâches et les formulaires Canvas auxquels associer le nouveau document. Utilisez la fonction Rechercher et remplacer pour remplacer certaines parties du nouveau document ou de son nom (p. ex., l’année), cette fonction peut être utilisée plusieurs fois.",
    bulkAddToEvidenceDescription3: "Lorsqu’un document existant est sélectionné, il ne sera ajouté qu’à la tâche en cours. S’il n’existe qu’un seul document, il sera déjà sélectionné; sinon, veuillez choisir une copie existante à ajouter. ",
    bulkAddToEvidenceAdvancedOn: "Options avancées",
    bulkAddToEvidenceAdvancedOff: "Désactivées",
    bulkAddToEvidenceFindText: "Trouver le texte",
    bulkAddToEvidenceFindTextRequired: "Veuillez saisir du texte valide dans le champ Trouver le texte.",
    bulkAddToEvidenceReplaceWith: "Remplacer par",
    bulkAddToEvidenceReplaceSuccess: "Replacer {0} par {1}.",
    bulkAddToEvidenceUseExisting: "Utiliser les éléments probants existants",
    bulkAddToEvidenceCreateNew: "Créer de nouveaux éléments probants  ",
    bulkAddToEvidenceDocumentName: "Nom du document",
    bulkAddToEvidenceExistingDocument: "Document existant",
    bulkAddToEvidenceSelectANewOrExistingCopy: "Sélectionner une nouvelle copie ou une copie existante",
    bulkAddToEvidenceAssociateToTasks: "Associer aux tâches",
    bulkAddToEvidenceAssociateToCanvasForms: "Associer aux formulaires Canvas",
    bulkAddToEvidenceOtherRelatedTasks: "Autres tâches associées",
    bulkAddToEvidenceAssociateToTasksPlaceholder: "Seuls les documents nouvellement créés peuvent être associés à des tâches. Les documents existants seront automatiquement associés à la tâche en cours.",
    bulkAddToEvidenceSelectedTask: "{0} tâche associée",
    bulkAddToEvidenceSelectedTasks: "{0} tâches associées",
    bulkAddToEvidenceSelectedTasksPlaceholder: "Aucune tâche associée disponible",
    bulkAddToEvidenceAssociateToCanvasFormsPlaceholder: "Seuls les documents nouvellement créés peuvent être associés à des formulaires Canvas.",
    bulkAddToEvidenceRelatedCanvasForms: "Formulaires Canvas associés",
    bulkAddToEvidenceSelectedForm: "{0} formulaire Canvas associé",
    bulkAddToEvidenceSelectedForms: "{0} formulaires Canvas associés",
    bulkAddToEvidenceSelectedFormsPlaceholder: "Aucun formulaire Canvas associé",
    picRequiredValidation: "Le document pour lequel l’approbation de l’associé responsable est requise n’est pas associé à une tâche de l’associé responsable",
    eqrRequiredValidation: "Le document pour lequel l’approbation du responsable de la revue de la qualité de la mission est requise n’est pas associé à une tâche du responsable de la revue de la qualité de la mission",
    picEqrRequiredValidation: "Le document pour lequel l’approbation de l’associé responsable/du responsable de la revue de la qualité de la mission est requise n’est pas associé à une tâche de l’associé responsable/du responsable de la revue de la qualité de la mission",

    viewSwitcherDefault: "Vue par défaut",
    viewSwitcherEntity: "Vue par entité",
    viewSwitcherAllEntities: "Toutes les entités",
    viewByEntities: "Afficher par entités",

    /* bulk delete modal */
    bulkDeleteFilesModalMessage: "Voulez-vous vraiment supprimer les documents sélectionnés?",
    bulkDeleteFIlesModalMessageSub: "Les documents qui ne peuvent pas être supprimés sont indiqués ci-après et ne seront pas supprimés.",
    bulkDeleteModalLabel: "Supprimer les documents",
    bulkDeleteSuccessMessage: "documents ont bien été supprimés ",
    bulkDeleteValidDocumentsHeader: "Les documents suivants seront supprimés",
    bulkDeleteInvalidDocumentsHeader: "Les documents figurant dans la liste qui suit ne peuvent pas être supprimés",

    /* Bulk sign-off requirements modal */
    bulkSignOffRequirementsModalMessage: "Ajuster les exigences d’approbation par un cadre ci-après pour les documents sélectionnés. Certaines exigences d’approbation ne peuvent pas être ajustées, car ce sont des exigences par défaut d’EY Canvas.",
    bulkSignOffRequirementsResultMessage: "Les exigences d’approbation pour {0} documents ont bien été mises à jour ",


    bulkOpenCountWarning: "Le nombre de documents sélectionnés dépasse le nombre maximal de documents autorisé. Seuls les {0} premiers documents pourront être ouverts.",

    /* Pending evidence modal */
    pendingEvidenceInstructionalText: "Les équipes figurant dans la liste ci-dessous n’ont pas encore envoyé les documents pour l’audit de groupe.",
    pendingEvidenceDueDate: "Date limite",
    searchRegionComponentLabel: "Rechercher des zones et des composantes ",

    /* Review Notes Count */
    noReviewNotesAssignedOrAuthored: "Aucune note n’a été attribuée au membre de l’équipe sélectionné.",
    noUserSelected: "Sélectionnez un utilisateur pour afficher les détails. Vous ne pouvez pas associer une note à un rôle dans EY Canvas.",
    reviewNotesText: "notes de revue",
    assigned: "Attribuées",
    authored: "Rédigées",
    overdue: "en retard",
    comingDue: "Arrivant à échéance",
    cleared: "Effacées",
    open: "Ouvrir",
    closed: "Fermée",
    noTaskAssignedToUser: "Aucune tâche n’a été attribuée au membre de l’équipe ou au rôle sélectionné.",
    preparer: "Préparateur",
    reviewer: "Responsable de la revue",
    assignments: "affectations",
    notStarted: "Non commencée",
    inProgress: "En cours",
    done: "Terminée",
    forUpcomingReview: "À venir",
    noTaskOrNotesAssigned: "Aucune tâche ou note n’a été attribuée au membre de l’équipe ou au rôle sélectionné.",
    fromTo: "De/À",

    /* Collaboration grid */
    overdueCollaboration: "En retard",
    comingDueCollaboration: "Arrivant à échéance",

    /*Document Conflict*/
    documentConflict: "Conflit lié au document",
    documentConflictModalConfirm: "Conserver cette version",
    documentConflictModalClose: "Annuler",
    documentConflictInstruction: "Pour résoudre le conflit, sélectionner la version du document à conserver.",
    documentConflictMessage: "Cliquez sur le nom d’un membre de l’équipe pour ouvrir l’ancienne version de ce document en lecture seule. Les changements apportés à l’ancienne version ne seront pas enregistrés dans EY Canvas.",
    lastmodifiedDate: "Date de la dernière modification",
    modifiedBy: "Modifié par",
    documentConflictErrorMessage: "Sélectionner une version pour continuer.",
    currentVersion: "Version courante",
    documentConflictError: "Message d’erreur – conflit lié au document",
    documentConflictHeader: "Un conflit est lié à ce document.",
    viewHistory: "Afficher l’historique",
    confirmButtonToolTip: "Vous devez disposer d’une autorisation pour résoudre les conflits relatifs aux documents du groupe. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation d’effectuer cette action.",
    documentHistoryHeader: "L’historique de cette version du document est affiché ci-dessous.",
    documentHistoryMessage: "Cliquez sur le nom d’un membre de l’équipe pour ouvrir une version précédente de ce document en lecture seule. Les changements apportés à la version précédente ne seront pas enregistrés dans EY Canvas.",

    documentHistoryInstruction: "Si une version précédente doit être la version courante, sélectionnez-la et cliquez sur « Mettre à jour la version ».",
    documentHistoryAdminInstruction: "Si aucune version n’est requise, sélectionnez la version et cliquez sur « Supprimer la version ».",

    documentHistoryModalConfirm: "Mettre à jour la version",
    documentHistoryModalClose: "Fermer",
    documentHistoryErrorMessage: "Le document comporte un conflit. Veuillez le résoudre avant de continuer.",

    /* Dashboard  - Collaboration Tile*/
    clientCollboration: "Collaboration avec le client",
    nextwaveServices: "Services centralisés",
    receivedStatusLabel: "Reçues",
    acceptedStatusLabel: "Acceptées",
    outstandingStatusLabel: "En cours",
    collaborationNonUsageMessage1: "Utilisez l’onglet Collaboration pour envoyer des demandes et des tâches externes aux membres de l’équipe externe directement dans EY Canvas. Pour activer l’onglet, inscrivez d’abord votre client au portail client d’EY Canvas, puis configurez les groupes d’accès. Vous pouvez ensuite créer des demandes ou attribuez des tâches externes. Cliquez",
    collaborationNonUsageMessage2: "pour savoir par où commencer.",
    collaborationNonUsageMessageHyperlinkText: "ici",
    collaborationNonSentMessage1: "Allez à l’adresse",
    collaborationNonSentMessage2: "et envoyez une ébauche pour commencer.",
    collaborationNonSentMessageHyperlinkText: "Collaboration",
    noBodies: "Aucun corps de texte",
    editResponse: "Modifier la réponse",
    unsentDrafts: "ébauches non envoyées",
    unsentDraft: "projet non envoyé",
    noUnsentDrafts: "Toutes les ébauches ont été envoyées",
    requestsSent: "Demandes envoyées",
    nextWavetotalTasks: "NOMBRE TOTAL DE TÂCHES",
    comingDueTimeframe: "Période",
    otherTimeframeDataAvailableMessage: "Sélectionner une autre période de temps pour afficher les données",

    /* Dashboard Engagement Metrics */
    engagementMetricsTileHeader: "Mesures de la mission",
    overdueColumnHeader: "En retard",
    comingDueColumnHeader: "Arrivant à échéance",
    whatsNewColumnHeader: "Nouveautés",
    placeholderMessageNoContentInSpecifiedTimeframe: "Sélectionner une autre période pour afficher les données",
    placeholderMessageNoEngagementMetrics: "Aucune mesure n’est disponible dans le cadre de la mission.",
    performanceMetrics: "Mesures de la performance",
    reviewNotesAndAssignments: "Notes de revue et affectations",
    /*Dashboard Engagement overview*/
    engagementOverview: "Aperçu de la mission",
    engagementOverviewInstructionalText: "Passez en revue l’état d’avancement de vos missions par phase de l’audit ci-après.",

    /*Dashboard Milestone tile*/
    milestoneprogressTileHeader: "Jalons",
    milestoneprogressSubHeader: "Sélectionnez une phase de l’audit dans la liste qui suit pour afficher les tâches réalisées par jalon. Pour afficher l’avancement des tâches par période, sélectionnez <b>Afficher par période</b>. Pour afficher les détails de la progression pour chaque jalon ou chaque période, sélectionnez <b>Afficher les détails.</b>",
    tasksStatus: "État des tâches",
    preparerAssignments: "Affectations du préparateur",
    reviewerAssignments: "Affectations du responsable de la revue",
    openComments: "Notes ouvertes",
    /* Dashboard Profile Page */
    groupAudit: "Audit de groupe",
    groupStatus: "État de l’audit de groupe",
    viewInstructions: "Afficher les instructions",
    instructionsInstructionalText: "Les instructions reçues de l’équipe principale sont affichées ci-après. Sélectionner un lien pour afficher les instructions. ",
    noInstructionsAccepted: "Aucune instruction n’a encore été acceptée.",

    /* Dashboard SDM Summary */
    nextWaveservices: "Services centralisés",
    totalTasksLabel: "Nombre total de tâches",
    tasksUsingNextWaveservices: "tâches effectuées par les Services centralisés",
    tasksSuggestedForNextwaveUse: "tâches suggérées pour les Services centralisés",
    outOf: "sur",
    tasksUsing: "tâches reposant",
    suggestedFor: "pour lesquelles on pourrait",
    nextwaveUse: "Services centralisés",
    draftRequests: "rédiger des demandes",
    draftRequest: "rédiger une demande",
    createRequests: "Créer des demandes",
    noRequestCreated: "Aucune demande n’a été créée jusqu’à maintenant. Pour commencer, créez et envoyez une demande.",

    /* RNH Bulk Controls */
    rnhBulkAssignPriorityTitle: "Modifier la priorité",
    rnhBulkAssignPriorityTooltip: "Priorité",
    rnhBulkDueDateTooltip: "Date d’échéance",
    rnhBulkAssignPriorityModalHeader: "Les notes sélectionnées ne peuvent être modifiées",
    rnhBulkAssignPriorityModalContent: "Vous pouvez uniquement modifier la priorité des notes ouvertes. Ouvrez de nouveau les notes réglées ou fermées pour modifier la priorité.",
    rnhBulkAssignDueDateModalContent: "Vous pouvez uniquement modifier la date d’échéance des notes ouvertes. Ouvrez de nouveau les notes réglées ou fermées pour modifier la date d’échéance.",
    rnhBulkAssignUserTooltip: "Réaffecter",
    rnhBulkAssignUserSearch: "Chercher",
    rnhBulkAssignUserTitle: "Les notes de revue sélectionnées ne peuvent pas être modifiées.",
    rnhBulkAssignUserText: "Vous pouvez uniquement réaffecter les notes de revue ouvertes. Ouvrez de nouveau les notes réglées ou fermées pour les réaffecter.",
    rnhBulkAssignStatusTooltip: "État ",
    rnhBulkAssignUserNoFound: "Aucun résultat trouvé",
    rnhBulkDueDatePlaceholder: "Sélectionner une date",
    rnhBulkDeleteTextCorrect: "Voulez-vous vraiment supprimer les notes sélectionnées? Quand une note de revue est supprimée, vous ne pouvez plus y accéder.",
    rnhBulkDeleteTextIncorrect: "Vous pouvez uniquement supprimer les notes fermées. Vous devez fermer les notes ouvertes ou réglées pour pouvoir les supprimer.",
    rhnBulkDeleteTitleCorrect: "Supprimer les notes sélectionnées",
    rhnBulkDeleteTitleIncorrect: "Les notes sélectionnées ne peuvent être supprimées",
    rnhBulkDeleteTextIncorrectComment: "Vous pouvez uniquement supprimer les notes de revue fermées. Vous devez fermer les notes de revue ouvertes ou réglées pour pouvoir les supprimer.",
    rhnBulkDeleteDescriptionAuthorComment: "Vous pouvez uniquement supprimer les notes que vous avez rédigées.",
    rnhBulkDeleteEngagementComment: "Voulez-vous vraiment supprimer les notes de revue sélectionnées? Quand une note de revue est supprimée, vous ne pouvez plus y accéder.",
    rhnBulkDeleteTitleCorrectEngagementComment: "Supprimer les notes sélectionnées",
    rhnBulkDeleteTitleCommentCloseStatus: "Les notes sélectionnées ne peuvent être supprimées",


    fourFortyFilters: "filtres",
    fourFortySearch: "Chercher",

    /* Add External Member Start*/
    addExternalModalTitle: "Ajouter un membre externe",
    accessGroupSelection: "Sélection du groupe d’accès",
    noRecordinGroups: "Aucun résultat trouvé",
    permission: "Autorisations",
    permissionProjectManagement: "Gestion de projet",
    permissionProjectManagementDesc: "Vous pouvez consulter l’état des demandes au client et des tâches externes à partir du portail client d’EY Canvas. Ce membre externe ne pourra pas consulter le détail des demandes au client ni des tâches externes.",
    permissionInfoTooltip: "liste de toutes les autorisations",
    groupInfoTooltip: "Liste des groupes",
    groupRequired: "Veuillez sélectionner un ou plusieurs groupes",
    firstnameRequired: "Le prénom est requis",
    lastnameRequired: "Le nom de famille est requis",
    initialsRequired: "Les initiales sont requises",
    roleRequired: "Le rôle dans la mission est requis",
    confidentialityRequired: "Niveau de confidentialité requis",
    groupLabel: "Groupes d’accès",
    firstnameLabel: "Prénom",
    lastnameLabel: "Nom de famille",
    initialsLabel: "Initiales",
    userinfo: "Informations de l’utilisateur",
    userinfoDescription: "Entrez le prénom, le nom de famille ou l’adresse courriel du membre de l’équipe à qui vous souhaitez envoyer une invitation et appuyez sur Entrée.",
    inviteAndClose: "Inviter et fermer",
    inviteAndAddOther: "Inviter et ajouter un autre membre",
    addAndClose: "Inviter et fermer",
    addAndAddOther: "Inviter et ajouter un autre membre",
    externalUserCreatedSuccessMessage: "Vous avez bien ajouté ",
    accessGroupSelectionMessage: "Les groupes d’accès permettent aux équipes de déterminer qui des membres de l’équipe externe peuvent afficher les demandes envoyées vers le portail client d’EY Canvas. Établissez avec votre client la liste des groupes d’accès et des utilisateurs qui auront accès au portail client d’EY Canvas. Lorsqu’une demande est attribuée à un utilisateur externe faisant partie du groupe, elle sera visible pour TOUS les membres de ce groupe.",
    accessGroupSectionMessage1: "Les membres de l’équipe externe doivent être inscrits à l’aide du portail My EY Admin avant d’être ajoutés à EY Canvas. Cliquez",
    accessGroupSectionMessage2: "pour accéder au portail My EY Admin et commencer.",
    accessGroupMessageHyperlinkText: "ici",
    accessGroupUserMessage1: "Pour plus d’informations sur la façon d’intégrer des utilisateurs, cliquez ",
    accessGroupUserMessage2: "pour accéder à EY Atlas.",
    noRecordForExternalMember1: "L’adresse courriel est introuvable.",
    noRecordForExternalMember2: "Assurez-vous que le membre de l’équipe externe est inscrit sur My EY.",

    /* Add External Member End*/

    /* Edit External Member Start*/

    editExternalModalTitle: "Modifier un membre externe",
    editExternalaccessGroupSelection: "Sélection du groupe d’accès",
    editExternalGroupInfoTooltip: "Liste des groupes",
    editExternalGroupLabel: "Groupes d’accès",
    editExternalGroupRequired: "Veuillez sélectionner un ou plusieurs groupes",
    editExternalNoRecordinGroups: "Aucun résultat trouvé",
    editExternalUserinfo: "Information de l’utilisateur",
    editExternalUserinfoDescription: "Modifier le prénom, le nom de famille ou les initiales",
    editExternalEmailLabel: "Courriel",
    editExternalFirstnameLabel: "Prénom",
    editExternalLastnameLabel: "Nom de famille",
    editExternalInitialsLabel: "Initiales",
    editExternalSaveLabel: "Enregistrer",
    editExternalUsersSuccessMessage: "Les modifications apportées à {0} {1} ont bien été enregistrées.",
    editExternalUsersCloseLabel: "Fermer",

    /* Edit External Member End*/



    /*access group*/
    groupName: "Nom du groupe",
    groupNameHelp: "Un nom est requis pour créer un groupe d’accès.",
    groupNameHelpOnEdit: "Un nom est requis.",
    groupNameReq: "Nom du groupe requis",
    groupNameInvalidCharacter: "Caractères invalides",
    grpDomainManage: "Gérer les domaines",
    grpDomainHelp: "Les domaines réduisent le nombre d’utilisateurs qui peuvent être ajoutés à ce groupe d’accès. Au moins un domaine est requis pour créer un groupe d’accès. Les caractères qui suivent l’arobase (@) correspondent au domaine. Utilisez l’astérisque (*) en guise de caractère générique (p. ex., *.ey.com).",
    btnAddNewDomain: "Ajouter un nouveau domaine",
    btnAddExistingDomain: "Ajouter un domaine existant",
    domainValidation01: "Au moins un domaine valide est requis.",
    domainValidation02: "Sélectionner un domaine",
    domainValidation03: "Dupliquer les données",
    domainValidation04: "Nom du domaine invalide",
    domainValidation05: "Nom du domaine requis",
    domainName: "Nom du domaine",
    emailDomain: "Domaine de l’adresse courriel",
    groupDeletionErrorPendingReqMsg: "Une erreur s’est produite lors de la suppression du groupe d’accès. Assurez-vous qu’aucune demande ou tâche externe n’est attribuée à ce groupe ou aux membres de ce groupe et réessayez.",
    groupDeletionSuccessMsg: "{0} a été supprimé. Tous les membres actifs ont été désactivés.",

    /* uncommon values for internal mem */
    editInternalMember: "Modifier un membre interne",
    editThirdPartyMember: "Modifier un membre tiers",
    listOfAllPerm: "liste de toutes les autorisations",
    internalPermiInviteExt: "Inviter des membres internes",
    internalPermiInviteInt: "Inviter des membres externes",
    internalPermiAssignPer: "Affecter les autorisations",
    internalPermiDeleteEng: "Supprimer la mission",
    internalPermiArchEng: "Archiver la mission",
    internalPermiUpdateContet: "Mettre à jour le contenu",

    internalPermiInviteExtToolTp: "Vous pouvez inviter des membres de l’équipe internes à cette mission",
    internalPermiInviteIntToolTp: "Vous pouvez inviter des membres de l’équipe externes à cette mission",
    internalPermiAssignPerToolTp: "Vous pouvez affecter ces autorisations à des membres de l’équipe internes et externes dans cette mission",
    internalPermiDeleteEngToolTp: "Vous pouvez supprimer la mission",
    internalPermiArchEngToolTp: "Vous pouvez archiver la mission",
    internalPermiUpdateContetToolTp: "Vous pouvez choisir de modifier le profil et accepter la mise à jour du contenu.",
    internalMemberInviteSuccessMessage: "Vous avez bien envoyé une invitation à {0} {1}",
    internalMemberPostArchivalAdditionSuccessMessage: "Vous avez bien ajouté {0} {1}",
    invitePriorPeriodUsersSuccessMessage: "Vous avez bien envoyé une invitation aux utilisateurs inatifs.",
    editInternalUsersSuccessMessage: "Les modifications apportées à {0} {1} ont bien été enregistrées.",
    rbacErrorEditUser: "Les modifications ne peuvent pas être enregistrées pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    universalQueueErrorEditUser: "La page d’accueil d’EY Canvas, requise pour la modification, n’est pas accessible pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    removeExternalUsersSuccessMessage: "{0} {1} a bien été retiré.",
    reActivateExternalUsersSuccessMessage: "{0} {1} a été réactivé dans le(s) groupe(s) d’accès suivant(s) : {2}",

    /*user search component*/
    seachInputRequired: "Entrer le texte recherché",
    nameOrEmail: "Nom ou courriel",
    emailForExternal: "Adresse courriel",
    noRecord: "Aucun résultat trouvé",
    userSearchPlaceholder: "Entrez le nom ou le courriel et appuyez sur Entrée pour afficher les résultats.",
    userSearchPlaceholderForExternal: "Entrez l’adresse courriel et appuyez sur Entrée pour afficher les résultats.",
    clearAllValues: "Effacer toutes les valeurs",
    inValidEmail: "Veuillez entrer une adresse courriel valide.",

    maxLengthForEditResponse: "Le nombre maximal de caractères, y compris les balises de formatage de texte enrichi, est de 30 000 caractères. Supprimez le formatage non nécessaire et réessayez.",
    clickEditResponseToContinue: "Cliquer sur Modifier la réponse pour continuer",
    bodyDescriptionFromKnowledge: "Description du corps de texte à partir de la base de connaissances",
    execution: "Exécution",
    cannotpasteimages: "Impossible de coller les images",
    pastingImagesNotAllowed: "Il n’est pas permis de coller des images. Vous devez télécharger les images requises en tant qu’éléments probants et les intégrer par renvoi.",
    saveResponse: "Des changements n’ont pas été enregistrés, voulez-vous continuer?",
    conclusion: "Conclusion",
    referenceDocsPlaceHolder: "Ouvrez rapidement les fichiers fréquemment consultés en les ajoutant ici.",
    referenceDocsTeamPlaceHolder: "Aucun document de référence de l’équipe n’a été ajouté à cette mission. Pour commencer, cliquez sur Ajouter un document.",
    referenceDocsMyPlaceHolder: "Vous n’avez ajouté aucun document de référence. Pour commencer, cliquez sur Ajouter un document.",
    teamDocuments: "Épinglés par l’équipe",
    myDocuments: "Mes documents épinglés",
    teamDocumentsModalTitle: "Documents de l’équipe",
    myDocumentsModalTitle: "Mes documents",
    referenceDocuments: "Épinglés par l’équipe",

    /* PinnedDocument  */
    PinnedDocument: "Documents épinglés",
    PinnedDocumentSubTite: "Créez une liste des documents fréquemment consultés en épinglant des éléments à votre liste ou aux listes des équipes dont vous faites partie (indiquées ci-après). Pour modifier une liste, sélectionnez <b>Ajouter un document</b>.",
    PinnedDocPaceholder: "Vous n’avez épinglé aucun document. <br> Sélectionnez <b>Ajouter un document</b> pour épingler un document ici.",
    PinnedTeamDocPlaceholder: "Votre équipe n’a épinglé aucun document. <br> Sélectionnez <b>Ajouter un document</b> pour épingler un document ici.",
    PinnedDocAddDocHeaderText: "Sélectionner des éléments probants et des fichiers temporaires pour personnaliser la liste des documents épinglés. ",
    onlyShowPinnedDocuments: "N’afficher que les documents épinglés. ",
    pinned: "Épinglés",
    /* Arc Timeline */
    arcTitle: "Liste de contrôle de l’archivage",
    arcCompleted: "terminé",
    arcSubmit: "Envoyer l’archive",
    arcDescription: "Suivez tous les points de la liste de contrôle pour archiver cette mission.",
    invalidEngagementCode: "Code mission non valide",
    invalidClientCode: "Code client non valide",
    arcCheckBox: "Remplacement de l’archive",
    arcUnlinkEvidenceButtonText: "Détacher tout",
    arcUnlinkEvidenceModalTitle: "Détacher tous les éléments probants partagés",
    arcUnlinkEvidenceModalText: "Voulez-vous vraiment détacher tous les éléments probants partagés dans le cadre de cette mission des autres missions dans cet espace de travail? Une fois cette opération terminée, elle ne peut pas être annulée.",
    arcUnlinkEvidenceModalConfirmButton: "Détacher tout",
    arcUnlinkEvidenceModalCancelButton: "Annuler",
    arcUnlinkEvidenceButtonUnlinkInProgress: "Détachement en cours",
    arcUnlinkEvidenceButtonUnlinkError: "Erreur de détachement",
    arcUnlinkGroupEngagementButtonText: "Détacher du groupe",
    arcUnlinkGroupEngagementModalTitle: "Détacher cette mission du groupe",
    arcUnlinkGroupEngagementModalText: "Voulez-vous vraiment détacher cette mission des autres missions dans cet espace de travail? Une fois cette opération terminée, elle ne peut pas être annulée.",
    arcUnlinkGroupEngagementModalConfirmButton: "Détacher",
    arcUnlinkGroupEngagementModalCancelButton: "Annuler",
    arcUnlinkGroupEngagementButtonUnlinkInProcess: "Détachement en cours",
    arcModalTitle: "Dossier du Centre des archives existant",
    arcProceedWithArchive: "Procéder à l’archivage",
    arcModalBodyText: "Vous essayez d’archiver un dossier d’audit restauré. Ce dossier existe déjà dans le Centre des archives. Voulez-vous vraiment continuer?",
    noDataAvailabel: "Aucune donnée disponible pour le moment. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    reportDateBeforeCurrentDate: "La date du rapport de mission doit être antérieure ou identique à la date d’aujourd’hui. Actualisez la date du rapport pour continuer. Pour actualiser la date du rapport, cliquez sur le lien Confirmer l’exactitude des dates clés de la mission.",

    /*Helix Projects*/
    linkedProjects: "Projets associés",
    suggestedAnalyzers: "Analyseurs suggérés",
    linkSelected: "Lien sélectionné",
    noLinkedProjectsAvailable: "Aucun projet associé",
    helixProjectTitle: "Projets EY Helix",
    findProjects: "Trouver un projet",
    findProjectsModalTitle: "Trouver des projets EY Helix",
    selectProjectsToLink: "Sélectionnez un ou plusieurs projets EY Helix ci-dessous pour les associer à votre mission Canvas. Vous pouvez chercher d’autres projets EY Helix manuellement par code client.",
    newSearch: "Nouvelle recherche",
    noResultsFound: "Aucun résultat",
    enterClientCode: "Entrez un code client et cherchez de nouveau.",
    enterClientCodeToDisplayAnalizers: "Entrez un code client pour afficher la liste des analyseurs disponibles.",
    defaultClientCodeIsInvalid: "Le code client par défaut {0} pour cette mission est invalide. Entrez un code client valide pour afficher la liste des analyseurs disponibles.",
    mirrorCodesNotAccepted: "Veuillez noter que les codes miroirs ne sont pas acceptés.",
    helixProjectSearch: "Chercher",
    helixProjectsSearchPlaceholderText: "Entrez le code client et cherchez de nouveau.",
    helixWizardProjectsSearchPlaceholderText: "Chercher un analyseur par code client",
    selectOneOrMoreProjects: "Sélectionner dans la liste un ou plusieurs projets Helix à associer",
    noPermissionLabel: "Vous devez disposer des autorisations d’archivage pour envoyer cette mission aux archives.",
    linkProject: "Associer un projet ",
    oneAnalyzerMustBeSelected: "Un analyseur doit être sélectionné.",
    selectAnAnalyzer: "Sélectionner un analyseur",
    selectOneAnalyzer: "Sélectionnez un analyseur EY Helix ci-dessous pour l’associer à votre mission EY Canvas. Vous pouvez chercher des projets EY Helix et les analyseurs qui y sont associés manuellement par code client.",
    selectAnalyzerModalTitle: "Sélectionner l’analyseur pour ",
    selectAnalyzerModalBodyText: "Sélectionner un analyseur EY Helix à associer à votre mission EY Canvas",
    selectAnalyzerModalSubmitButtonLabel: "Associer un projet ",
    projectCanNotBeLikedTootip: "Ce projet EY Helix n’est pas disponible, car son emplacement ne correspond pas à celui de la mission EY Canvas.",
    unlinkProjectConfirmationModalTitle: "Avertissement ‒ Dissocier le projet",
    unlinkProjectConfirmationModalBodyText: "L’analyseur EY Helix à dissocier comporte des signets client associés à cette mission. Si vous dissociez cet analyseur, les signets ne seront plus disponibles. Cette action ne peut pas être annulée. Voulez-vous continuer?",
    defineConnectionSettings: "Définir les paramètres de connexion",

    helixConnectionPageTitle: "Connexions EY Helix",
    helixConnectionPageSubtitle: "Analyseurs EY Helix connectés et leurs données importées, et pourcentage de comptes GL qui ont été mappés à des comptes EY. Cliquez sur le pourcentage de comptes mappés pour ajuster le mappage. Le pourcentage de comptes mappés peut être différent entre les analyseurs connectés et les données importées. Par exemple, si le mappage a lieu après la date d’importation. Veuillez alors importer à nouveau les données pour obtenir le mappage le plus récent.",
    helixIntegrationPageNoConnectedAnalyzerLabel: "Aucun analyseur connecté",
    helixIntegrationPageTitle: "Intégration à EY Helix",
    helixIntegrationPageSubtitle: "Associez un ou plusieurs analyseurs EY Helix à votre mission EY Canvas.",
    helixIntegrationPageNoHelixProjectLinkedLabel1: "Aucun analyseur associé. Pour associer un nouvel analyseur,",
    helixIntegrationPageNoHelixProjectLinkedLabel2: "cliquez ici.",
    helixIntegrationPageColumnConnectionName: "Nom de la connexion",
    helixIntegrationPageColumnConnectionType: "Type de connexion",
    helixIntegrationPageColumnAnalysisPeriod: "Date de l’analyse",
    helixIntegrationPageColumnAnalyzerName: "Nom de l’analyseur EY Helix",
    helixIntegrationPageColumnLastConnectedBy: "Dernière connexion par",
    connectAnalyzer: "Connecter un analyseur",
    dataImportModalTitle: "Importer la confirmation",
    dataImportModalBodyLabel: "Les données de l’étape Étendue et stratégie ont déjà été importées dans cette mission. Une seule étape Étendue et stratégie peut être importée par mission. L’importation de ces données remplacera les données de l’étape Étendue et stratégie déjà importées. Voulez-vous continuer? Cette action ne peut pas être annulée.",
    dataImportModalBodyLabelMest: "Les données de l’étape Étendue et stratégie ont déjà été importées pour cette entité. Une seule étape Étendue et stratégie peut être importée par entité. L’importation de ces données remplacera les données de l’étape Étendue et stratégie déjà importées. Voulez-vous continuer? Cette action ne peut pas être annulée.",
    dataImportModalCancelButtonLabel: "Annuler",
    dataImportModalCloseButtonLabel: "Fermer",
    dataImportModalConfirmButtonLabel: "Importer",
    dataImportModalImportError: "Une erreur relative à l’analyseur EY Helix connecté s’est produite. Les données ne peuvent pas être importées.Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    //Entites to Business Mapping Modal
    entityMappingModalTitle: 'Entity mapping',
    entityMappingModalCancelLabel: 'Cancel',
    entityMappingModalSaveLabel: 'Save',
    entityMappingModalDescription: 'Manage the mapping between entities and business units for this connection. Each business unit can be mapped to a single entity only.',
    entityMappingModalBusinessUnitsPlaceholder: 'Business unit(s)',
    entityMappingModalAllBusinessUnitsLabel: 'All business units',
    entityMappingModalBusinessUnitSelectedCount: '{0} business unit',
    entityMappingModalBusinessUnitsSelectedCount: '{0} business units',
    entityMappingModalNoResultsFound: 'No results found',
    entityMappingModalNoEntitiesLabel1: 'No entities exists in the engagement.',
    entityMappingModalNoEntitiesLabel2: 'Create an entity to get started.',
    entityMappingModalBusinessUnitAlreadyMapped: 'A business unit can be related to only one entity. Unrelate from other entities to enable.',
    /*Entites to Business Table*/
    entityMappingTableEntityColumnLabel: 'Entity',
    entityMappingTableBusinessUnitsColumnLabel: 'Business unit(s)',

    helixProjectPageTitle: "Projets EY Helix",
    helixProjectPageSubtitle: "Liez le ou les projets EY Helix se rapportant à cette mission EY Canvas. Lorsque plus d’un projet EY Helix est lié à une mission EY Canvas, sélectionnez-en un comme projet principal pour permettre l’intégration des données dans EY Canvas. Seul le projet principal peut être intégré dans EY Canvas. Il doit donc contenir toutes les écritures de journal pour la date visée par la mission.",
    helixProjectPageNoHelixProjectLinkedLabel1: "Il n’y a actuellement aucun projet EY Helix associé à la mission. ",
    helixProjectPageNoHelixProjectLinkedLabel2: "Ajouter un nouveau projet EY Helix",
    helixProjectPageNoHelixProjectLinkedLabel3: "pour commencer.",
    helixProjectPageNoHelixProjectLinkedLabel4: "Cliquer sur ",
    linkToHelixProject: "Ouvrir dans EY Helix",
    addNewEYHelixProject: "Ajouter un nouveau projet EY Helix",
    eyHelixSetup: "Intégrer les données d’EY Helix",
    existingConnectionDetectedModalTitle: "Connexion(s) existante(s) supprimée(s)",
    existingConnectionDetectedDescription: "L’analyseur sélectionné a déjà été connecté à cette mission EY Canvas. Vous pouvez créer une nouvelle connexion ou sélectionner une connexion existante ci-après.",
    selectExistingConnection: "Sélectionner une connexion existante",
    selectCreateNewConnection: "Créer une nouvelle connexion",
    connectionNoRecords: "Aucune connexion trouvée",
    selectOneOfTheOptionsToProceed: "Sélectionnez une des options pour continuer.",
    saveHelixProjectErrorMessage: "Impossible d’enregistrer l’analyseur sélectionné. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    noResultFoundForAnalyzerSelection: "Assurez-vous que l’état de l’analyseur recherché est valide et que l’accès à l’analyseur vous a été accordé. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Entrez un code client et cherchez de nouveau.",

    /*Helix Analyzer Details Drawer*/
    connectButtonLabel: "Connecter",
    reConnectButtonLabel: "Reconnecter",
    demoteFromFinancialStatementsOptionLabel: "Dissocier des états financiers",
    promoteToFinancialStatementsOptionLabel: "Associer aux états financiers",
    deleteOptionLabel: "Supprimer",
    projectAndAnalyzerDetailsSectionTitle: "Détails du projet et de l’analyseur",
    projectNameLabel: "Nom du projet",
    clientCodeLabel: "Code client",
    analyzerNameLabel: "Nom de l’analyseur",
    periodEndDateLabel: "Date de fin",
    analysisDateLabel: "Date de l’analyse",
    lastConnectedByLabel: "Dernière connexion par",
    connectionSettingsSectionTitle: "Paramètres de connexion",
    connectionTypesLabel: "Type(s) de connexion",
    currencyTypeLabel: "Type de monnaie",
    currencyLabel: "Monnaie",
    currencyCodeLabel: "Code de monnaie",
    businessUnitsLabel: "Unité(s) fonctionnelle(s)",
    entitiesLabel: "Entités",
    analysisPeriodLabel: "Date de l’analyse",
    comparativePeriod1Label: "Date de comparaison 1",
    comparativePeriod2Label: "Date de comparaison 2",
    manageAccountMappingSectionTitle: "Gérer le mappage des comptes",
    manageAccountMappingButtonLabel: "Gérer le mappage des comptes",
    mappedGLAccountsLabel: "Pourcentage de comptes GL mappés : ",
    updateSettingsButtonLabel: "Mettre à jour les paramètres",
    deleteConnection: "Supprimer la connexion",
    deleteConnectionQuestion: "Voulez-vous vraiment supprimer la connexion sélectionnée? Toutes les données déjà intégrées qui sont associées à cette connexion seront supprimées. Cette action ne peut pas être annulée.",
    deleteConnectionWithAnalyticsQuestion: "Voulez-vous vraiment supprimer la connexion sélectionnée? Toutes les données déjà intégrées qui sont associées à cette connexion seront supprimées. De plus, la connexion sélectionnée comporte des signets client associés à cette mission. Si vous supprimez la connexion, les signets ne seront plus disponibles. Cette action ne peut pas être annulée.",

    /*Helix Projects Table*/
    tableShowing: "Affichage les résultats pour :",
    tableClientCode: "- Code client : ",
    tableEngagementCode: "Code mission",
    tableEngagementCodeName: "Nom de la mission",
    tableProjectID: "Code du projet",
    tableProjectName: "Nom du projet",
    tableAnalyzerName: "Nom de l’analyseur",
    tablePeriodEndDate: 'Period end date',
    tableEYHelixPeriodEndDate: "Date de fin",
    tableAnalysisDate: "Date de l’analyse",
    tableEYHelixAnalysisDate: "Date de l’analyse",
    tableAssignedPartner: "Associé désigné",
    tableProjectLinked: "Projet associé",
    tableTooltipAnalizerIsDeleted: "L’analyseur a été supprimé d’EY Helix. Pour supprimer la connexion de façon permanente, cliquez pour ouvrir le tiroir des détails. Veuillez déterminer s’il faut connecter un autre analyseur.",
    tableTooltipAnalizerIsUnavailable: "L’analyseur n’est pas disponible dans EY Helix. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, cliquez pour ouvrir le tiroir des détails. Veuillez déterminer s’il faut connecter un autre analyseur.",
    tableTooltipNotValidUser: "Vous n’êtes pas un membre autorisé de l’équipe de l’analyseur sélectionné. Veuillez communiquer avec l’administrateur de projet EY Helix pour obtenir l’accès et réessayer.",

    /*Helix Project Cards*/
    cardAnalyzerConnectionLabel: "Connexions",
    cardAnalyzerHelixLabel: "Analyseurs EY Helix",
    cardAnalyzerMappedGLAccountsLabel: "Comptes GL mappés",
    cardAnalyzerEntityMappingLabel: 'Entity mapping',
    cardAnalyzerManageGLAccountsLink: "Gérer le mappage des comptes",
    cardAnalyzerSectionScopeAndStrategy: "Étendue et stratégie",
    cardAnalyzerSectionFinancialStatements: "États financiers",
    cardAnalyzerSectionButtonLink: "ici",
    cardAnalyzerSectionButtonDisconnect: "Déconnecter un analyseur",
    cardAnalyzerSectionScopeAndStrategyNoBalance: "Les données de l’étape Étendue et stratégie sont utilisées pour présenter les soldes des activités de cette étape (p. ex. le seuil de signification). Cliquez sur {0} pour importer les données de l’étape Étendue et stratégie.",
    cardAnalyzerSectionFinancialStatementsNoBalance: "Les états financiers peuvent être importés dans EY Canvas pour l’obtention d’une vue détaillée des états financiers à l’emplacement où les travaux ont été réalisés dans la mission EY Canvas. Cliquez sur {0} pour importer les états financiers.",
    cardAnalyzerSectionAnotherAnalyzerType: "Cet analyseur a été connecté pour faciliter l’intégration entre EY Canvas, EY Helix et/ou EY Smart Sampling. Cliquez sur {0} pour déconnecter cet analyseur.",
    cardAnalyzerSectionButtonLinkDisableTooltip: "Vous n’êtes pas un membre autorisé de l’équipe de l’analyseur associé. Veuillez communiquer avec l’administrateur du projet EY Helix pour obtenir l’accès.",
    cardAnalyzerSectionButtonLinkDisableTooltipPermission: "Vous ne disposez pas des autorisations requises pour importer ces données. Veuillez vous assurer que vous disposez bien de l’autorisation « Importer les données EY Helix » dans cette mission Canvas et réessayer.",
    cardAnalyzerTrialBalanceAnalisysPeriod: "Date de l’analyse",
    cardAnalyzerTrialBalanceComparativePeriod: "Date de comparaison",
    cardAnalyzerTrialBalanceSecondComparativePeriod: "Deuxième date de comparaison",
    cardAnalyzerTrialBalanceLastImportDate: "Date de la dernière importation",
    cardAnalyzerTrialBalanceCurrency: "Monnaie",
    cardAnalyzerTrialBalanceBusinessUnits: "Unité(s) fonctionnelle(s)",
    cardAnalyzerTrialBalanceMapedGLAccounts: "Comptes GL mappés",
    cardAnalyzerTrialBalanceImportStatus: "État de l’importation",
    cardAnalyzerTrialBalanceCurrencyTypeFunctional: "Fonctionnelle",
    cardAnalyzerTrialBalanceCurrencyTypeReporting: "De présentation",
    cardAnalyzerTrialBalanceImportData: "Importer des données",
    cardAnalyzerTrialBalanceAdjustmentModule: "Module d’ajustement",
    cardAnalyzerTrialBalanceReImport: "Réimporter",
    cardAnalyzerTrialBalanceRemove: "Retirer",
    cardAnalyzerTrialBalanceImportStatusInProgress: "En cours",
    cardAnalyzerTrialBalanceImportStatusImported: "Importé",
    cardAnalyzerTrialBalanceImportStatusError: "Erreur",
    cardAnalyzerTrialBalanceImportStatusDisconnected: "Déconnecté",
    cardAnalyzerTrialBalanceImportModalTitle: "Importer des données",
    cardAnalyzerTrialBalanceImportModalDescription: "Sélectionnez les attributs de l’importation et cliquez sur « Importer ».",
    cardAnalyzerTrialBalanceImportModalButton: "Importer",
    cardAnalyzerTrialBalanceReImportModalTitle: "Réimporter des données",
    cardAnalyzerTrialBalanceReImportModalDescription: "Sélectionnez les attributs de l’importation et cliquez sur « Réimporter ».",
    cardAnalyzerTrialBalanceReImportModalButton: "Réimporter",
    cardAnalyzerTrialBalanceImportInProgressTooltip: "Importation en cours. Cette opération peut prendre plusieurs minutes.",
    cardAnalyzerTrialBalanceImportEntityTooltip: "L’entité ne peut pas être modifiée lors d’une réimportation. Créez une nouvelle importation pour sélectionner une entité différente.",
    cardAnalyzerTrialBalanceImportMestEntity: "Cette sélection a été effectuée à l’étape précédente. Pour la modifier, vous devez retourner à cette étape.",
    cardAnalyzerTrialBalanceMestBusinessUnit: "Cette sélection est fondée sur l’entité ci-dessus. Pour modifier la relation entre l’entité et la ou les unités fonctionnelles, accédez au mappage de l’entité à la page de résumé sous-jacente.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTypeTooltip: "Sélectionnez d’abord un type de monnaie pour activer ce champ.",
    cardAnalyzerTrialBalanceFirstSelectCurrencyTooltip: "Sélectionnez d’abord une monnaie pour activer ce champ.",

    /*Helis Linked Projects Cards*/
    analysisDate: "Date de l’analyse : ",
    unlinkProject: "Détacher le projet",
    editAnalyzer: "Modifier l’analyseur",
    deleteProject: "Supprimer le projet",
    projectDeleted: "Le projet a été supprimé.",
    loadingProjectDataLinked: "Chargement de données à partir d’EY Helix en cours",
    projectMarkPrimaryConfirmationHeader: "Modifier le projet EY Helix principal",
    projectMarkPrimaryConfirmationMsg: "Voulez-vous vraiment modifier le projet EY Helix principal?",
    projectPrimaryEYHexliProject: "Projet EY Helix principal",
    helixProjectUnlink: "Détacher",
    helixProjectDelete: "Supprimer",
    analyzersLabel: "Analyseurs :",


    /*Helix Import List*/
    importHelixList: "Liste d’importation d’EY Helix",
    importDocumentName: "Nom du document",
    importDocumentID: "Identifiant du document",
    importFileSize: "Taille du fichier (Ko)",
    importDownload: "Télécharger",
    importNoRecords: "Aucun document trouvé",
    importInvalidDocumentID: "L’identifiant du document doit être complet pour effectuer une recherche. Assurez-vous d’avoir bien saisi l’identifiant complet du document.",

    /*Helix Connect analyzer modal*/
    connectAnalyzerClientLabel: "Client :",
    addConnectionNameLabel: "Ajouter le nom de la connexion",
    connectionNamePlaceholder: "Nom de la connexion",
    connectionNameRequired: "Obligatoire",
    connectAnalyzerModalTitle: "Connecter un analyseur",
    connectAnalyzerDescription: "Sélectionnez un analyseur ci-dessous pour l’associer à cette mission EY Canvas. Recherchez des projets EY Helix et les analyseurs qui y sont associés par code client.",
    analyzerLocationIncompatibleErrorMessage: "L’analyseur ne peut pas être connecté, car l’emplacement où sont stockées ses données est incompatible avec celui de la mission EY Canvas.",
    analyzerMaxConnectionReachedErrorMessage: "Le nombre maximal de connexions autorisé a été atteint pour l’analyseur sélectionné. Veuillez sélectionner un autre analyseur pour continuer.",
    helixAnalyzerErrorMessage: "Une erreur de connexion à l’analyseur EY Helix s’est produite. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    helixAnalyzerGLAConnectionErrorMessage: "Une ou plusieurs erreurs de connexion à l’analyseur EY Helix se sont produites pour l’obtention du nombre de comptes mappés. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    helixReImportErrorMessage: "Une erreur s’est produite à l’importation des données d’EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*Helix Select Entity Modal*/
    selectEntityModalTitle: "Sélectionner l’entité",
    noEntitiesMappedToBusiness: "Aucune entité n’a été mappée à une ou plusieurs unités fonctionnelles.",
    noEntitiesMappedToBusinessFirst: "Cliquez ",
    noEntitiesMappedToBusinessLink: "ici",
    noEntitiesMappedToBusinessLinkText: " pour commencer.",
    searchEntityPlaceholder: "Rechercher l’entité",
    entityListHeader: "Entité",
    selectEntityErrorMessage: "Sélectionnez une entité pour continuer.",
    entityAlreadyConnectedToScopeAndStrategy: "Les données de l’étape Étendue et stratégie ont déjà été importées pour cette entité. Une seule étape Étendue et stratégie peut être importée par entité. Supprimez les données déjà importées pour permettre cette sélection.",
    selectEntityNoEntitiesFound: "Aucun résultat",
    selectEntityModalDescription: "Sélectionnez une entité pour laquelle vous voulez importer des données.",

    /*Manage Account Mapping*/
    manageAccountMapping: "Gérer le mappage des comptes",
    manageAccountMappingErrorMessage: "Impossible de se connecter à EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    helixViewerLoader: "Chargement du tiroir d’affichage de données EY Helix…",

    /*Helix Remove Import Modal*/
    removeImportModalTitle: "Supprimer l’importation",
    removeImportRemoveButtonLabel: "Supprimer",
    removeImportDescription: "Voulez-vous vraiment supprimer l’importation suivante?",
    removeImportActionUndoneDescription1: "Voulez-vous vraiment supprimer l’importation suivante? ",
    removeImportActionUndoneDescription2: "Cette action ne peut être annulée.",
    removeImportErrorMessage: "Les données importées ont changé depuis que vous avez ouvert cet écran. Pour procéder à la suppression, veuillez actualiser la page et réessayer.",

    /*Disconnect analyzer modal*/
    disconnectAnalyzerModalTitle: "Déconnecter l’analyseur",
    disconnectAnalyzerDisconnectButtonLabel: "Déconnecter",
    disconnectAnalyzerDescription: "Voulez-vous vraiment déconnecter l’analyseur sélectionné?",
    disconnectAnalyzerImportsExistErrorMessage: "Une importation a été ajoutée à cette connexion depuis que vous avez ouvert cet écran. Une connexion ne peut être déconnectée qu’en supprimant d’abord toutes les importations associées. Veuillez actualiser la page et réessayer.",

    /*Content Update */
    quote: '"',
    performContentUpdate: "Effectuer une mise à jour du contenu",
    contentupdate: "Mises à jour du contenu",
    btnContentUpdate: "Mise à jour",
    btnContentUpdateSelected: "Mettre à jour",
    updateSuccessMessage: "Mise à jour du contenu envoyée",
    msgContentUpdate: "Sélectionnez au moins une des catégories ci-dessous pour mettre à jour le contenu. Si une grande partie des travaux a déjà été réalisée, veuillez consulter les cadres de la mission pour savoir s’il est approprié de faire une mise à jour du contenu. Les mises à jour de contenu ne peuvent être annulées.",
    msgIndependance: "Il se peut que vous deviez remplir à nouveau les confirmations d’indépendance à la suite de la mise à jour du formulaire sur l’indépendance.",
    msgProfile: "La mise à jour du profil pourrait avoir une incidence importante sur le contenu de la mission. Les utilisateurs pourraient ne plus avoir accès à la mission jusqu’à ce qu’un nouveau profil soit envoyé. Cette action ne peut pas être annulée.",
    msgHistoryContentUpdate: "Mises à jour effectuées antérieurement et leur état",
    msgWarningTitle: "Avertissement",
    btnProceedContentUpdate: "Continuer",
    btnCancelContentUpdate: "Annuler",
    confirmationMessageP1: "Vous êtes sur le point de mettre à jour le contenu des catégories sélectionnées. Cliquez sur",
    confirmationMessageP2: "pour continuer ou sur",
    confirmationMessageP3: "si vous souhaitez reporter la mise à jour de contenu.",
    warningMessage: "Vous devez sélectionner un ou plusieurs types de contenu pour effectuer la mise à jour.",
    groupReportingFormsSent: "formulaires de rapport pour l’audit de groupe <b>envoyés</b>",
    groupReportingFromStatus: "État des formulaires de rapport pour l’audit de groupe ",
    primaryTeamReviewStatus: "État de la revue de l’équipe principale",
    reportingStatus: "État du rapport",
    taskStatusLabel: "État de la tâche",
    primaryTeam: "Équipe principale",
    componentTeam: "Équipe affectée à l’audit de la composante",
    groupTasksReceived: "tâches pour l’audit de groupe <b>reçues</b>",
    group: "Groupe",
    regionalTeam: "Équipe zonale",
    unlinkedLabel: "Détachée",
    linkedLabel: "Associée",
    unlinkedTasks: "<b>tâches non liées</b>",
    unlinkedTask: "<b>tâche non liée</b>",
    primaryTeamGroupTaskPlaceholder: "Créer des composantes et envoyer les instructions pour l’audit de groupe pour suivre l’état d’avancement ici.",
    componentTeamGroupTaskPlaceholder: "Accepter les tâches pour le groupe envoyées à la composante par l’équipe principale pour afficher l’état d’avancement ici.",
    confirmUpdateMessage1: "La mise à jour de ces formulaires pourrait avoir une incidence importante sur le contenu. Une fois lancée, aucune autre mise à jour de contenu ne pourra être effectuée avant la fin de cette opération.",
    confirmUpdateMessage2: "Cliquez sur Continuer pour lancer la mise à jour ou sur Annuler si vous souhaitez la reporter.",
    updateSelectedTitle: "Mise à jour sélectionnée",
    statusCodeForbidden: 403,
    pspAccountHeader: "Compte",
    pspAccountDateHeader: "Date du contenu",
    pspAccountStatus: "État",
    pspAccountSelected: "sélectionné",

    /*Preapre for Arc*/
    YearEndDate: "Date de clôture :",
    PeriodEndDate: "Date de fin de la période visée :",
    ReportDate: "Date du rapport :",
    ArcDeadlineDate: "Date limite d’archivage :",
    ClientCode: "Code client :",
    PrimaryEngCode: "Code mission principal :",
    SecondaryEngCode: "Code mission secondaire :",
    ReportType: "Une opinion avec réserve a-t-elle été exprimée de quelque façon que ce soit dans le rapport et/ou le rapport comprend-il un paragraphe d’observations?:",
    ProtectedDocuments: "Note : Les documents protégés ne doivent pas être conservés dans les dossiers de mission, sauf si cela est nécessaire.",
    noObjectsAvailable: "Aucun objet n’est disponible.",
    CurrentlyUnavailable: "Non disponible pour le moment",
    showMoreToggle: "Afficher plus",
    showLessToggle: "Afficher moins",

    //#region Document upload status

	docListUploadTemporaryPlaceholder: '<center>Aucun document disponible<br />―<br />Vous pouvez glisser et déposer un ou plusieurs documents ou cliquer sur <button class="motif-button motif-text-alt-button motif-button-small">Ajouter des fichiers temporaires</button></center>.',
    uploadEvidencePlaceholder: "Glissez et déposez un ou plusieurs documents ou cliquez sur <a>Ajouter des éléments probants</a>",
    uploadTemporaryPlaceholder: "Glissez et déposez un ou plusieurs documents ou cliquez sur <a>Ajouter des fichiers temporaires</a>",

    processing: "Traitement en cours",
    uploading: "Téléchargement en cours",
    uploadComplete: "Traitement en cours",
    downloading: "Téléchargement",
    downloadComplete: "Téléchargement terminé",
    loading: "Chargement en cours",

    //#region Filter

    filter: "Filtrer",
    noFiltersAvailable: "Aucun filtre disponible",
    pickADate: "Sélectionner une date",
    filterYes: "Oui",
    filterNo: "Non",

    //#region Document list filters
    filterGroupDocumentsLabel: "Documents",
    filterDocumentContentLabel: "Contenu du document",
    filterSharedEvidenceLabel: "Éléments probants partagés",
    filterFileExtensionLabel: "Extension de fichier",
    filterDocumentConflictLabel: "Conflits",
    filterDuplicateFileNameLabel: "Dupliquer le nom du fichier",
    filterCanvasFormsLabel: "Formulaires Canvas",

    filterGroupModificationsLabel: "Modifications",
    filterLastModifyUserLabel: "Dernière modification par",
    filterModifyAfterReviwerSignoffLabel: "Modifié depuis l’approbation du responsable de la revue",
    filterModifiedAfterLabel: "Modifié après",

    filterGroupReviewNotesLabel: "Notes de revue",
    filterReviewNoteStatusLabel: "État",
    filterReviewNoteAssignedToLabel: "Attribuée à",
    filterReviewNoteAuthoredByLabel: "Rédigée par",
    filterReviewNoteOtherEngagementLabel: "Provenant d’autres missions",

    filterGroupSignOffsLabel: "Approbations",
    filterSignOffMissingLabel: "Approbations manquantes",
    filterSignedOffByUserLabel: "Approuvé par",
    filterNotSignedOffByUserLabel: "Non approuvé par",
    filterSignOffRequirementsLabel: "Exigences d’approbation",

    filterGroupOtherLabel: "Autre",
    documentLink: "Lien vers les documents",
    filterByCopyLinkDocument: "Filtré par lien de documents copiés",
    filterGroupAuditComponentLabel: "Équipe zonale / affectée à l’audit d’une composante",
    noGroupAuditComponents: "Aucune composante n’a été créée.",
    filterFindingsLabel: "Constatations",
    filterGroupInstruction: "Instructions du groupe",
    noGroupInstruction: "Aucune instruction n’a été créée.",

    documentSearchPlaceholderLabel: "Rechercher des documents",
    analyticSearchPlaceholderLabel: "Rechercher des analyses",
    //#endregion

    //#endregion

    pendingResponseLabel: "En attente d’une réponse",
    receivedLabel: "Reçu",
    dueToPrimaryTeam: "À livrer à l’équipe principale",
    sentToPrimaryTeam: "Envoyée à l’équipe principale",
    documentationPending: "Documentation en attente",
    documentationComplete: "Documentation terminée",
    viewBytimephaseTextLabel: "Afficher par période",
    showDetails: "Afficher les détails",
    referenceDocAddDocHeaderText: "Associez les éléments probants ou les fichiers temporaires de cette mission pour pouvoir y accéder à partir du tableau de bord.",
    addDocsToTeam: "Ajouter des documents aux Documents de l’équipe",
    addDocsToMy: "Ajouter des documents à Mes documents",
    addDocument: "Ajouter un document",
    externalUserRemove: "Retirer",

    // Internal user roles abbr
    adminRole: "Admin",
    readOnlyRoleForThirdPartyUser: "Lecture seule",
    legacy: "Sans restriction",
    permissionLabel: "Autorisation",
    displayPermissionErrorText: "Les autorisations ne peuvent être affichées pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    onlyShowRelatedTasks: "Afficher seulement les tâches associées",

    softwareUpdate: "Mises à jour logicielles",
    updateNow: "Mettre à jour maintenant",
    updateMsg: "Des mises à jour logicielles sont disponibles pour EY Canvas. Sélectionnez Mettre à jour maintenant pour télécharger et installer les mises à jour. La page sera actualisée.",

    processingError: "Erreur de traitement",

    //Create tag modal labels
    createtags: "Créer les balises",
    reportDate: "Date du rapport :",
    managetags: "Gérer les balises",
    savechanges: "Enregistrer les modifications",
    manageTagGroupCreate: "Créer",
    manageTagGroupDiscard: "Ignorer",
    manageTagGroupCreateTooltip: "Groupe de balises",
    deletetag: "Supprimer la balise",
    deletetaggroup: "Supprimer le groupe de balises",
    createTagGroup: "Créer un groupe de balises",
    manageTagGroupName: "Groupe de balises",
    countOftasksAssigned: "Nombre de tâches attribuées",
    createTagGroupMessage: "Pour commencer, créez un groupe de balises et des balises. Cliquez sur {0} pour créer un groupe de balises.",
    tagsContnetSearchPlaceholder: "Rechercher des balises",
    deleteTagHoverText: " Une fois les changements enregistrés, les balises ou les groupes de balises supprimés ne pourront pas être récupérés.",
    deleteTagGroupHoverText: "Cette balise sera retirée de toutes les tâches de votre mission.",
    tagSaveChangesInfoText: "Toutes les balises que ce groupe contient seront supprimées et retirées de toutes les tâches de votre mission.",
    tagConfirmModalTitleText: "Les changements seront appliqués une fois qu’ils auront été enregistrés.",
    tagConfirmModalPrimaryMessage: "Voulez-vous vraiment enregistrer ces modifications?",
    tagConfirmModalSecondaryMessage: " Voulez-vous vraiment enregistrer ces changements?",
    tagDeleteModalSecondaryMessage: "Après l’enregistrement, les balises supprimées ne pourront pas être récupérées.",
    createNewTag: "Créer une nouvelle balise",
    tagWillBeRemovedFromRequests: "Cette balise sera supprimée de l’ensemble des demandes de votre mission.",
    eyTags: "Balises EY",
    clientTags: "Balises client",
    allTags: "Toutes les balises",
    // Add canvas form
    addCanvasForm: "Ajouter un formulaire Canvas",
    addCanvasFormName: "Nom du document",
    addCanvasFormNameBlankMessage: "Le champ Nom du document est obligatoire.",
	addCanvasFormNameInvalidCharacterMessage: 'Le nom ne peut pas contenir les caractères suivants : */:<br>\\?|"',
    addCanvasFormDigital: "Numérique",
    addCanvasFormCore: "De base",
    addCanvasFormNonComplex: "Non complexe",
    addCanvasFormComplex: "Complexe",
    addCanvasFormListed: "Entité cotée",
    addCanvasFormGroupAudit: "Audit de groupe",
    addCanvasFormPCAOBFS: "PCAOB – ÉF",
    addCanvasFormPCAOBIA: "PCAOB – AI",
    addCanvasFormStandards: "Normes",
    addCanvasFormStandardsNotSelectedMessage: "Le champ des normes doit être obligatoirement rempli",
    addCanvasFormLanguage: "Langue",
    addCanvasFormLanguageNotSelectedMessage: "Le champ de la langue doit être obligatoirement rempli",
    addCanvasFormNoResultFound: "Aucun résultat trouvé",
    addCanvasFormManageTasks: "Gérer les tâches",
    addCanvasFormAvailableTasks: "Nom de la tâche",
    addCanvasFormAvailableTaskType: "Type",
    addCanvasFormTypeOfForm: "Type de formulaire",
    addCanvasFormSubServiceLine: "Sous-gamme de services",
    addCanvasFormTypeOfFormNotSelectedMessage: "Le champ du type de formulaire doit être obligatoirement rempli",
    addCanvasFormSelectedTasks: "Tâches sélectionnées",
    addCanvasFormNoTaskDataAvailable: 'No tasks selected. Select at least one task to create a form.',
    addCanvasFormCreateForm: "Créer un formulaire",
    addCanvasFormCancel: "Annuler",
    addCanvasFormSuccessMessage: "{0} a bien été créé. L’envoi du contenu peut prendre jusqu’à 10 minutes.",
    // Add Canvas form manage Objects
    addCanvasFormManageObjects: "Gérer l’objet {0}",
    addCanvasFormAvailableObjects: "nom {0} //",
    addCanvasFormSelectedObjects: "Objet {0} sélectionné",
    addCanvasFormClickHereToOpenManageTab: "Cliquez ici pour ouvrir l’onglet Gérer {0}",
    addCanvasFormNoObjectsDataAvailableRequired: "Aucun objet {0} sélectionné. Sélectionner au moins un objet pour créer un formulaire",
    addCanvasFormNoObjectsDataAvailableOptional: 'No {0} selected.',
    addCanvasFormObjectNotDefinedMessage: "Les objets ne sont pas disponibles pour ce formulaire",
    addCanvasFormOptional: "(facultatif)",
    addCanvasFormObjects: "objets",
    addCanvasFormObject: "Objet",
    addCanvasFormSCOT: "Catégorie importante d’opérations",
    addCanvasFormSCOTs: "Catégories importantes d’opérations",
    addCanvasFormITProcess: "Processus informatique",
    addCanvasFormITProcesses: "Processus informatiques",
    addCanvasFormControl: "Contrôle",
    addCanvasFormControls: "Contrôles",
    addCanvasFormITControl: "Contrôle informatique",
    addCanvasFormITControls: "Contrôles informatiques",
    addCanvasFormITApplication: "Application informatique",
    addCanvasFormITApplications: "Applications informatiques",
    addCanvasFormSignoffRequirements: "Approbations requises :",
    addCanvasFormPICCheckBox: "PIC",
    addCanvasFormEQRCheckBox: "RRQM",
    itProcessRelatedITGCITSP: "Processus informatiques et CGI/procédures de corroboration liées aux TI connexes",
    taskTitle: "Comprendre et consigner le processus informatique : {0}",
    taskDescription: "Consignez notre compréhension du processus informatique. Joignez le formulaire pertinent à l’appui de notre compréhension du processus informatique.<br>Lorsque des CGI sont affichés dans la section Attributs de la tâche, exécutez des procédures de test de cheminement pour confirmer notre compréhension des CGI et en évaluer la conception et la mise en place. Joignez les éléments probants à l’appui de nos procédures.",
    addCanvasFormAccounts: "comptes",
    addCanvasFormAccount: "compte ",
    addCanvasFormErrorMessage: "Le présent formulaire ne peut être associé qu’à un seul compte",
    addCanvasFormValidationMessage: "Une réponse est requise",
    addCanvasFormEstimates: "estimations",
    addCanvasFormEstimate: "estimation ",
    addEstimateCanvasFormErrorMessage: "Le présent formulaire ne peut être associé qu’à une seule estimation.",
    addControlCanvasFormErrorMessage: "Le présent formulaire ne peut être associé qu’à un seul contrôle",
    addScotCanvasFormErrorMessage: "Le présent formulaire ne peut être associé qu’à une seule catégorie d’opérations importante",

    //Independence Confirmation
    sortOrderIndependence: "Ordre de tri",
    confirmationStatus: "État de la confirmation",
    confirmationDate: "Date de confirmation",
    independenceConfirmationSearch: "Rechercher des membres de l’équipe",
    editTemplate: "Modifier le gabarit",
    viewTemplate: "Afficher le gabarit",
    confirmedBy: "confirmée par",
    overriddenBy: "remplacée par",
    grantedBy: "accès accordé par ",
    deniedBy: "accès refusé par ",
    list: "Liste",
    paginationShow: " Afficher",
    options: "Options",
    removeTeamMemberModalText: "Voulez-vous vraiment retirer ce membre de l’équipe de mission? ",
    removeTeamMemberModalTitle: "Retirer le membre de l’équipe ",
    overrideRemovedBy: "Écrasement retiré par ",

    // Custom instructions
    addCustomInstruction: "Ajouter des instructions personnalisées",
    editCustomInstruction: "Modifier les instructions personnalisées",
    customInstructionInstructionalText: "Ajouter des instructions personnalisées ou modifier les instructions personnalisées ici. Ces instructions s’afficheront dans la confirmation d’indépendance individuelle de chaque membre de l’équipe afin de fournir des indications sur la manière de répondre aux questions propres au client.",
    customInstructionPermissionTooltip: "Vous devez disposer de l’autorisation <b>Gérer la mission</b> pour effectuer cette action. Communiquez avec l’<b>administrateur de la mission</b> pour demander une autorisation.",
    customInstructionMaxLengthExceeded: "Le texte dépasse la longueur maximale permise",

    //Independence Confirmation Details
    details: "Détails",
    question: "Question",
    answer: " Réponse",
    countTeamMembers: " Nombre de membres de l'équipe",
    executiveApproval: " Approbation des cadres",
    yes: " Oui",
    no: "Non",
    independenceModalText: " Les membres de l’équipe qui ont sélectionné cette réponse dans leur confirmation d’indépendance individuelle s’affichent ici.",
    notApplicable: "Sans objet",
    readMore: " Plus d’informations",
    readLess: " Moins d’informations",
    teamMembsersTitle: " Renseignements sur le membre de l’équipe",

    tasksSelected: "tâches sélectionnées",
    taskSelected: "tâche sélectionnée",
    unselectAll: "Tout désélectionner",
    addForm: "Ajouter un formulaire",
    addFormName: "Nom",
    addFormDigital: "Numérique",
    addFormCore: "De base",
    addFormNonComplex: "Non complexe",
    addFormComplex: "Complexe",
    addFormListed: "Entité cotée",
    addFormGroupAudit: "Audit de groupe",
    addFormPCAOBFS: "PCAOB – ÉF",
    addFormPCAOBIA: "PCAOB – AI",
    addFormStandards: "Normes",
    addFormLanguage: "Langue",
    addFormManageTasks: "Gérer les tâches",
    addFormManageObjects: "Gérer les objets",
    addFormAvailableTasks: "Tâches disponibles",
    addFormAvailableObjects: "Objets disponibles",
    addFormTypeOfForm: "Type de formulaire",
    addFormSelectedTasks: "Tâches sélectionnées",
    addFormSelectedObjects: "Objets sélectionnés",
    addFormCreateForm: "Créer un formulaire",
    addFormCancel: "Annuler",
    createtag: "Créer une balise",
    tagsLabel: "Balises",

    //Group instruction summary
    sInstruction: "Étendue",
    iInstruction: "Composante individuelle",

    //CGT and CGT Unlinked related labels
    cgtSend: "Envoyer",
    cgtDueDate: "Date d’échéance",
    cgtFrom: "De",

    notesSelected: "notes sélectionnées",
    noteSelected: "note sélectionnée",
    cgtUnlinkedLabel: "Détachée",
    cgtUnlinkedInformationMessage: "Cette tâche n’est plus associée à une autre mission de groupe et peut être supprimée si elle n’est plus requise.",
    sendtoPrimaryTeam: " Envoyer à l’équipe principale",
    sendtoPrimaryTeamdisableBtn: " Cette tâche doit contenir des éléments probants approuvés par au moins un préparateur et un responsable de la revue pour être envoyée à l’équipe principale.",
	cgtSendModalHeader: 'Sélectionner un ou plusieurs documents à envoyer à l’équipe principale. <span class="modal-instruction-text">Les formulaires Canvas seront envoyés en format PDF. Un enregistrement des formulaires Canvas en format PDF envoyés à l’équipe principale est conservé dans les fichiers temporaires.</span>',
    cgtNotifyCheck: " Aviser l’équipe principale qu’aucun autre document ne devrait être envoyé.",
    cgtCanvasFormValidation: "Ce formulaire Canvas comporte des validations non résolues. Déterminer si les validations devraient être résolues avant d’envoyer le formulaire à l’équipe principale. ",
    finalVersionLabel: "Version finale",
    draftVersionLabel: "Version projet",
    otherEvidence: "Autre élément probant",
    selectAtLeastOneDocument: "Sélectionner au moins un document pour continuer.",
	cgtsendmodelinstructionheader: "Sélectionner un ou plusieurs documents à envoyer à l’équipe principale. <span class='modal - instruction - text '>En désignant le document comme étant <b>à l'état de projet,</b> vous informez l’équipe principale que vous travaillez encore sur le document et que vous pourriez envoyer d’autres versions. En désignant le document comme étant <b>une version finale,</b> vous informez l’équipe principale que vous avez terminé votre travail et que vous ne pensez pas envoyer d’autres versions du document.</span>",
    //Independence confirmation
    undefined: "Non définie",
    incomplete: "Incomplète",
    nomattersidentified: " Aucune question n’a été relevée.",
    matteridentifiedpendingaction: " Problème soulevé - Mesure à prendre",
    matterresolveddeniedaccess: " Problème résolu - Accès refusé",
    matterresolvedgrantedaccess: " Problème résolu - Accès accordé",
    notapplicable: " Sans objet",
    restored: "Restaurée",
    overriden: "Remplacée",
    override: "Remplacer",
    priornomattersidentified: "Précédent ‒ Aucune question n’a été relevée",
    priormatteridentifiedpendingaction: "Précédent ‒ Question relevée – Mesure à prendre",
    priormatterresolvedgrantedaccess: "Précédent ‒ Question résolue – Accès accordé",
    priormatterresolveddeniedaccess: "Précédent ‒ Question résolue – Accès refusé",
    addTagsLabelForTaskList: "Ajouter des balises",
    addTagLabelForTaskDetails: "+ Ajouter une balise",
    manageTagsColorInputLabel: "Couleur",
    manageTagsTagNameInputLabel: "Nom de la balise",
    addTagRequiredMessage: "Requis",
    addNewTagLinkText: "Ajouter une nouvelle balise",
    manageTagsLabel: "Gérer les balises",
    manageTagGroupHeader: "Créer de nouvelles balises et de nouveaux groupes ici. Vous pouvez aussi modifier et supprimer des balises ou des groupes existants. L'utilisation de balises permet d’améliorer la structure de la mission et la gestion de projet.",
    //add tag color dropdown
    addTagRedColorText: "Rouge",
    addTagOrangeColorText: "Orange",
    addTagTealColorText: "Turquoise",
    addTagBlueColorText: "Bleu",
    addTagPurpleColorText: "Violet",
    addTagGreenColorText: "Vert",
    deleteAssignmentConfirmationMessage: " Voulez-vous vraiment supprimer cette affectation?",

    // Return label for Returned document
    recieved: "Reçue",

    selectServiceOffering: "Sélectionner une offre de services",
    selectTasks: "Sélectionner des tâches",
    reviewSuggestedTasks: "Passer en revue les tâches suggérées",
    reviewAvailableTasks: "Passer en revue les tâches disponibles",
    setDueDate: "Établir la date d’échéance",
    schedulerCreateRequestStep4TabText: "Protocoles de fonctionnement et de communication",
    createWorkRequestHeadingpart1: "Donner un nom à la demande de service et sélectionner une offre de services pour commencer.",
    createWorkRequestHeadingpart2: "Les services figurant dans la liste qui suit sont établis en fonction du profil de la mission et des services disponibles dans votre zone. Les coûts varient selon l’échelon des ressources affectées et la complexité.",
    createWorkRequestHeadingpart3: "Si votre mission a été récupérée, tous les services offerts dans le cadre de votre mission de la période précédente portent la mention ",
    createWorkRequestHeadingpart4: "mention",
    createWorkRequestHeadingpart5: "Période précédente.",
    createWorkRequestStep2Headingpart1: "Passer en revue les tâches disponibles pour ",
    createWorkRequestStep2Headingpart2: "service sélectionné.",
    createWorkRequestStep2Headingpart3: "<u>Pour les équipes participant au projet pilote de centralisation Wave 2 </u>, sélectionnez les tâches pertinentes en fonction des critères suivants, que les membres de l’équipe centralisée peuvent effectuer : 1) des procédures d’audit objectives (c.-à-d. les procédures qui requièrent l’exercice de peu ou pas de jugement); 2) des procédures subjectives uniquement (c.-à-d. les procédures qui requièrent l’exercice de jugement) pour des estimations présentant un risque faible ou lorsque le risque inhérent est faible pour la ou les assertions concernées. Les tâches qui sont déjà incluses dans une autre demande de services centralisés portent la mention  ",
    createWorkRequestStep2Headingpart4: ". Si vous avez déjà eu recours à ce service, les tâches qui étaient incluses dans votre demande pour la période précédente portent la mention ",
    createWorkRequestStep2Headingpart5: "Période précédente",
    requestName: "Nom de la demande",
    submittedBy: "Envoyée par",

    // Next wave labels
    totalTasks: "Tâches",
    noServiceRequest: "Aucune demande de service n’a été créée. Créer et envoyer une demande de service pour commencer.",
    eyContact: "Personne-ressource d’EY",
    requestStatusText: "État de la demande",
    requestsByStatusText: "Demandes par état",
    serviceRequest: "Demandes de services",
    serviceGateway: "Service Gateway",
    centralizedServices: "Faire une demande de services",
    serviceRequestDueDate: "Échéance",
    NA: "S. O.",
    more: "Plus",
    eycontacts: "Personnes-ressources d’EY",
    addEYContact: "Ajouter un contact d’EY",
    editEYContacts: "Modifier les contacts d’EY",
    addEYContactInstructions: "Ajouter ou retirer des contacts d’EY pour cette demande. Les mises à jour seront envoyées aux gestionnaires des ressources et aux ressources affectées.",
    editEYContactDisabledInstructions: "Vous devez avoir l’autorisation <b>Faire une demande de service</b> pour effectuer cette action. Communiquez avec un administrateur de la mission pour demander une autorisation.",
    emptyEYContactsPlaceholder: "Ajoutez au moins un contact d’EY pour continuer.",
    estimatedHours: "Délai d’exécution (heures)",
    resourceManagers: "Gestionnaires des ressources",
    nextWaveServices: "Services centralisés",
    centralizedservices: "Services centralisés",
    onlyShowAccepetedRequests: "Afficher seulement les demandes acceptées",
    showSelectedOnly: "N’afficher que les sélections ",
    emptyEngCodeMessage: "Il n'y a pas de code valide pour votre mission.",
    primary: "Principal",
    estimatedCosts: "Coûts estimés",
    assignedResources: "Ressources affectées",
    generalAuditTasks: "Tâches d’audit générales",
    generalInfo: "Informations générales",
    requestID: "Code de la demande",
    createdDate: "Créée",
    startDate: "Commencer",
    serviceRequestDue: "Échéance",
    comingDueIn: "Arrivant à échéance dans",
    comingDueTodayLabel: "Arrivant à échéance aujourd'hui",
    daysLabel: "jours",
    dayLabel: "jour",
    createByLabel: "Créée par",
    notProvidedLabel: "Non fournies",
    editLabel: "Modifier",
    serviceRequestNoHistoryLabel: "Il n'y a pas d’historique pour cette demande.",
    serviceRequestHistoryLabel: "Journal de l’historique",
    serviceRequestTasks: "Tâches - Demande de service",
    suggestedRequestTasks: "Tâches - Demande suggérée",
    estimatedCost: "Coût estimé",
    addinstructionsAndRelatedFiles: "Ajouter d’autres protocoles de fonctionnement et de communication à cette demande.",
    instructionText: "Les éléments probants associés à cette demande seront archivés et inclus à cette demande lorsque vous récupérerez la mission au prochain exercice. Les fichiers temporaires ne seront pas archivés et ne seront pas inclus à cette demande lorsque vous la récupérerez au prochain exercice.",
    instructionPlaceHolder: "Autres protocoles de fonctionnement et de communication ",
    warningText: "Les éléments probants seront archivés avec la demande mais les fichiers temporaires ne le seront pas.",
    availableDocuments: "Documents disponibles",
    noDocumentsAvailable: "Aucun document disponible.",
    selectAll: "Sélectionner tout",
    deselectAll: "Tout désélectionner",
    documentsSelected: "documents sélectionnés",
    selectedDocuments: "Documents sélectionnés",
    noDocumentSelected: "Aucun document n’a été sélectionné. Sélectionner un document pour commencer (facultatif).",
    TaskName: "Nom de la tâche",
    AssignmentsLabel: "Affectations",
    noTaskAssociatedToServiceRequest: "Aucune tâche n’est associée à cette demande.",
    requestServices: "Faire une demande de services",

    serviceNotEditable1: "Pour modifier les tâches incluses dans cette demande, sélectionnez ",
    serviceNotEditable2: "Modifier ",
    serviceNotEditable3: "à",
    serviceNotEditable4: "l’onglet",
    serviceNotEditable5: "Tâches. Pour apporter d’autres modifications ou annuler une demande de services, vous devez ",
    serviceNotEditable6: "communiquer avec l’un des gestionnaires des ressources ",
    serviceNotEditable7: "(si affecté).",

    serviceReqMarkComplete: "Si vous inscrivez une demande de services centralisés comme étant terminée, cela informera le fournisseur de services qu’il ne reste rien à faire et que vous avez terminé votre revue. Une fois la demande de services marquée comme étant terminée, cette action ne peut pas être annulée.",
    serviceReqMarkCompleted: "Terminée",
    editServiceRequestTasks1: "Passer en revue les tâches sélectionnées pour cette demande de services",
    editServiceRequestTasks2: "Toutes les tâches suggérées pour  ",
    editServiceRequestTasks3: "le service sélectionné s’affichent ici. Sélectionnez une tâche dans la liste ci-dessous pour l’ajouter. Désélectionnez la tâche pour la supprimer.",

    submitServiceRequestConfirmation1: "Voulez-vous vraiment envoyer cette demande de service?  ",
    submitServiceRequestConfirmation2: "Une demande pour le service que vous avez sélectionné a déjà été envoyée pour votre mission.",
    alreadyScheduledHeader: "Le service est déjà prévu",

    createServiceRequestPermission1: "Vous devez disposer d’une autorisation Créer une requête de service pour continuer.",
    createServiceRequestPermission: "Vous devez disposer de l’autorisation <b>Gérer les demandes de services</b> pour effectuer cette action. Communiquez avec un administrateur de la mission pour demander une autorisation. ",
    schedulerRequestSubmissionError: "Une erreur s’est produite et empêche l’envoi de cette requête au responsable du calendrier. Réessayez en sélectionnant <b>Renvoyer </b>. Si l’erreur persiste, communiquez avec le Service de dépannage.",
    resubmit: "Renvoyer",
    noServiceManager: "Aucun gestionnaire des ressources n’a été affecté à cette demande pour le moment.",
    noAssignedResource: "Aucune ressource n’a été affectée à cette demande pour le moment.",
    noMileStoneSetForService: "La date de début et la date limite du jalon n’ont pas encore été définies pour cette demande.",
    isEngagementNominnatedForCentralizeService: "Votre mission a-t-elle été sélectionnée ou acceptée par votre zone pour faire partie du projet pilote de centralisation auprès du groupe PSM?",
    needApprovalForSericeRequestCreation: "Veuillez communiquer avec l’associé directeur de Certification de votre zone afin d’obtenir l’autorisation requise pour poursuivre avec cette demande de services.",

    //TaskList Filters
    filterMissingRelatedTaskLabel: "Document pour lequel l’approbation de l’associé responsable/du responsable de la revue de la qualité de la mission est requise non associé à une tâche ",
    filterRelatedToRisksLabel: "Associée aux risques",
    filterGroupTasksLabel: "Tâches",
    filterGroupAssignmentsLabel: "Affectations",
    filterGroupDocumentsignoffsLabel: "Approbations du document",
    filterGroupProjectManagementLabel: "Gestion de projet",
    filterAssignmentTypeLabel: "Type d’affectation",
    filterTaskStatusLabel: "État de la tâche",
    filterTaskTypeLabel: "Type de tâche",
    filterAssignedToLabel: "Attribuée à",
    filterAssignmentStatusLabel: "État de l’affectation",
    filterTaskReviewNoteStatusLabel: "État de la note",
    filterTaskCommentStatusLabel: "État des notes",
    filterTaskReviewNoteAssignedToLabel: "Attribuée à",
    filterTaskReviewNoteAuthoredByLabel: "Créée par",
    filterPICDocumentsAssociated: "Documents nécessitant l’approbation de l’associé responsable associés",
    filterEQRDocumentsAssociated: "Documents nécessitant l’approbation du responsable de la revue de la qualité de la mission associés",
    missingSignOffs: "Approbations manquantes",
    signedOffBy: "Approuvé par ",
    notSignedOffBy: "Non approuvé par",
    filterTimePhaseLabel: "Période",
    filterMilestoneLabel: "Jalon",
    filterAuditPhaseLabel: "Phase de l’audit",
    filterEngagementPhaseLabel: "Phase de la mission",
    filterDocumentConflictsLabel: "Conflits liés au document",
    filterEntitiesLabel: "Entité",
    missingEntityDocuments: "Documents de l’entité manquants",
    filterDownloadedForOfflineLabel: "Téléchargée pour le travail hors ligne",
    filterNextwaveServicesLabel: "Services centralisés",
    filterServiceGateway: "Service Gateway",
    filterScheduledServicesLabel: "Services connexes",
    filterSuggestedServicesLabel: "Services suggérés",
    NoDocumentSignedOffLabel: "Aucun document approuvé par ",
    SomeDocumentSignedOffLabel: "Quelques documents approuvés par",
    AllDocumentSignedOffLabel: "Tous les documents approuvés par",
    usersLabel: "Team members",
    serviceRequests: "Services centralisés",
    backToMainPage: "Retour à la page principale",
    suggestedNextwaveRequests: "Demandes centralisées suggérées",
    /* Component Send Status */
    deliveredDate: "Livrée : {0}",
    sentDate: "Envoyée : {0}",
    sentFailure: "Une erreur de livraison s’est produite. Veuillez réessayer et si le problème persiste veuillez communiquer avec le Service de dépannage.",
    chooseTaskInstructionLabel: "Choisir les tâches à inclure à cette demande.",
    createSRstep2InstructionalTextPart1: "Des tâches déjà incluses dans une autre demande portent la mention",
    createSRstep2InstructionalTextPart2: ". Si vous avez déjà eu recours à ce service, les tâches qui étaient incluses dans votre demande pour la période précédente portent la mention ",
    createSRstep2InstructionalTextPart3: "Utiliser le bouton bascule ci-dessous pour n’afficher que les tâches suggérées.",
    availableTasksLabel: "Tâches disponibles",
    guidance: "Indications Atlas",
    helixAnalyzers: "Analyseurs Helix",
    eyHelix: "EY Helix",
    smartAutomationLinks: "Automatisation intelligente",
    createAutomation: "Créer une automatisation",
    noProjectTitle: "Lier un projet Helix",
    multipleProjectsTitle: "Sélectionnez un projet Helix lié",
    noProjectMessage: "Lier un projet Helix à cette mission pour commencer avec cet analyseur Helix.",
    multipleProjectsMessage: "Cette mission est liée à plusieurs projets Helix. Sélectionnez un projet Helix dans la liste ci-dessous pour continuer.",

    automationGuidanceHeader: "Automatisations suggérées",
    helixAnalyzersHeader: "Analyseurs suggérés",
    linkToHelixLabel: "Lien vers Helix",
    noSelectedTasksText: "Aucune tâche n’a été sélectionnée. Veuillez sélectionner une tâche pour commencer. ",
    selectedTasksLabel: "Tâches sélectionnées",
    serviceOffering: "Offre de service",
    submitRequest: "Envoyer la demande",
    scheduleYourRequest: "Planifier votre demande.",
    serviceRequestStep3HeaderText: "Sélectionnez la date à laquelle vous souhaitez que les ressources commencent à travailler sur ces tâches (date de début). Puis sélectionnez la date à laquelle ces tâches devraient être terminées.",
    serviceRequestMilestoneDueDateHeaderText1: "Sélectionner ",
    startanddue: "la date de début et la date limite",
    eachmilestone: "pour chaque jalon.",
    serviceRequestMilestoneDueDateHeaderText2: "Votre équipe est ultimement responsable des travaux livrés. Par conséquent, au moment de sélectionner la date d'échéance, assurez-vous de laisser suffisamment de temps à votre équipe pour passer en revue le travail livré.",
    serviceRequestMilestoneDueDateHeaderText3: "Le délai d’exécution estimé ne doit inclure que le temps qui, selon vous, est nécessaire au fournisseur de services pour effectuer le travail prévu.",
    schedulerBudgetMainQuestion: "Votre équipe de mission a-t-elle :",
    schedulerBudgetFirstQuestion: "inclus tous les travaux relatifs à cette demande dans vos processus financiers, de tarification et de planification?",
    schedulerBudgetSecondQuestion: "communiqué cette demande au gestionnaire des expériences local?",
    schedulerBudgetThirdQuestion: "ajusté les heures des membres de l’équipe locale de manière appropriée?",
    timetocompleteinfo1: "Le délai d’exécution estimé ne devrait inclure que",
    timetocompleteinfo2: "le temps qui, selon vous, est nécessaire au fournisseur de services pour effectuer le travail prévu.",
    serviceRequestStartDate: "Commencer",
    saveDraft: "Enregistrer le projet",
    step3ValidationError: "La date d’échéance doit être postérieure à la date de début.",
    scheduledLabel: "Planifiée",
    suggestedLabel: "Suggérée",
    searchTasksLabel: "Rechercher des tâches",
    submit: "Envoyer",
    selectTaskRequiredErrorMessage: "Vous devez sélectionner au moins une tâche pour continuer. ",
    moveToCompleted: "Déplacer vers Terminé",
    requestResubmitMessagePart1: "Si vous envoyez de nouveau cette demande, son état sera réinitialisé à ",
    requestResubmitMessagePart2: "En attente. ",
    requestResubmitMessagePart3: "Les changements apportés seront examinés par le responsable du calendrier.",
    showSuggestedTaskToggle: "Afficher les tâches suggérées seulement",

    // Assignments
    addAssignmentName: "Ajouter le nom de l’affectation",
    editAssignmentName: "Modifier le nom de l’affectation",
    deleteAssignmentName: "Supprimer le nom de l’affectation",
    deleteAssignmentNameInstructionalTextHeader: "Voulez-vous vraiment supprimer le nom de cette affection?",
    deleteAssignmentNameInstructionalText: "Une fois supprimée, l’affectation sera retirée pour tous les membres de l’équipe et  tous les rôles liés à votre mission.",
    assignmentType: "Type d’affectation",
    assignmentTypeInstructionalText: "Sélectionnez le type d’affectation et indiquez un nom ci-après. Cliquez sur <b>Ajouter</b> lorsque vous avez terminé.",
    assignmentEditInstructionalText: "Modifier le type d’affection et le nom de l’affection ci-après. Cliquez sur <b> Enregistrer les modifications</b> lorsque vous aurez terminé.",
    noSuggestedTaskLabel: "Cette catégorie ne contient aucune tâche suggérée.",
    manageAssignmentsLabel: "Gérer les affectations",
    myAssignmentsLabel: "Mes affectations",
    myAssignedTasks: "Tâches qui me sont attribuées",
    currentlyAssignedTasks: "Actuellement attribuées",
    assignmentModalInstructionalText1: "Pour réattribuer ou supprimer des tâches attribuées à un membre de l’équipe ou à un rôle, sélectionnez son nom ci-dessous. Vous pouvez également utiliser l’icône <b>Supprimer</b> pour supprimer toutes les tâches affectées à un membre de l’équipe ou à un rôle. Pour modifier ou supprimer le nom d’une affectation, sélectionnez le menu <b>Plus</b>",
    unassignedTasks: "Tâches non attribuées",
    assignedTasks: "Tâches attribuées",
    type: " Type",
    priorperiodservicerequests: "Demandes de services de la période précédente",
    unmarkcomplete: "Enlever la mention Terminée",
    taskAttributes: "Attributs de la tâche",
    engagementTeam: "Équipe de mission",
    assignTo: "Affecter à",
    reAssignTo: "Réaffecter à",
    assign: "Affecter",
    reAssign: "Réaffecter",
    reAssignWarningLabel: "Sélectionner une ou plusieurs tâches à réaffecter. ",
    assignWarningLabel: "Sélectionner une ou plusieurs tâches à affecter. ",
    searchByTaskName: "Chercher par nom de tâche",
    searchByTimePhaseName: "Chercher par nom de la période",
    assignment: "Affectation",
    noMembersWithThisAssignment: "Aucun membre de l’équipe ni aucun rôle n’est associé à cette affectation.",
    deleteTaskAssingmentByMemberAndAssignmentIntructionalText: "L’affectation sera retirée de l’ensemble des tâches de votre mission. ",
    noTaskAttributes: "Aucun attribut n’est proposé pour cette tâche. Pour commencer, cliquez sur Créer ou Associer.",
    assignmentWithoutAssignedUser: "Le nom de cette affectation n’est actuellement pas utilisé.",

    // v2 profile navigation Zeus to Hercules to Kronos message
    v2ProfileDocumentIdAvailableMessage: "En cours de traitement pour recueillir les informations sur le profil. Veuillez patienter.",
    v2ProfileDocumentIdDeletedMessage: "Informations sur le profil introuvables. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    accountAndRelatedAssertions: "Compte et assertions connexes",
    risks: "Risques",
    scotName: "Nom de la catégorie importante d’opérations",
    strategy: "Stratégie",
    transactionType: "Type d’opération",
    notSelectedText: "Non sélectionnée",
    relatedBy: "Liée par",
    collaboration: "Collaboration",
    controlsLabel: "Contrôles",
    scotAndRelatedControls: "Catégorie importante d’opérations et contrôles connexes",
    scotAndRelatedRisks: "Catégories importantes d’opérations et risques d’anomalies significatives associés",
    frequencyLabel: "Fréquence",
    operatingEffectively: "Fonctionnement efficace",
    designedEffectively: "Conception efficace",
    timeToCompleteHours: "Délai d’exécution (heures)",
    completeRequiredFieldValidationError: "Veuillez remplir tous les champs requis pour continuer.",
    itgcsAndItsps: "CGI et procédures de corroboration liées aux TI",
    itprocessItgcsAndItsps: "Processus informatiques et CGI/procédures de corroboration liées aux TI",
    approachLabel: "Approche",
    typeLabel: " Type",
    itProcessName: "Nom du processus informatique",
    processEvaluation: "Évaluation du processus",
    unrelatedControls: "Contrôles non associés",
    disableNextwavePlaceholder: "Les services centralisés ne sont actuellement pas disponibles dans votre pays. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    disableNextwavePlaceholderDataCenter: "Les services centralisés ne sont actuellement pas disponibles pour votre centre de données local. Actualisez la page et réessayez. Si l’erreur persiste, communiquez avec le Service de dépannage.",
    dataPrivacyInviteMessage: "Avant d’envoyer l’invitation, avez-vous bien tenu compte des restrictions d’accès aux feuilles de travail qui pourraient s’appliquer en raison des règles en matière de protection des données?  ",
    //Session Timeout
    sessionTimerMsg: "Votre session prendra fin bientôt pour cause d’inactivité. Par souci de sécurité, les sessions ouvertes prennent fin automatiquement après 30 minutes d’inactivité. Votre session actuelle expirera dans {0} minutes. Pour rester connecté, veuillez cliquer sur Continuer.",
    logout: "Déconnexion",
    sessionPopupTitle: "Déconnexion automatique pour votre protection",
    allSuggestedTasks: "Tâches",
    viewByAccount: "Afficher par compte",
    viewBySCOT: "Afficher par catégorie importante d’opérations",
    noServiceOfferingsAvailable: "Aucun service n’est disponible dans le cadre de la mission pour le moment. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    //Collaboration
    myRequests: "Mes demandes",
    allRequests: "Toutes les demandes",
    calendar: "Calendrier",
    calendarTodayButton: "Aujourd’hui",
    requestsListButton: "Liste des demandes",
    eventsButton: "Événements",
    analyticsButton: "Analyses",
    showAssignedToMe: "Afficher mes demandes",
    selectRequestsTitle: "Sélectionner une demande pour afficher les détails",
    selectRequestsSub1: "Pour activer les contrôles en bloc, cochez les cases à cocher ou appuyez sur",
    selectRequestsSub2: "la touche Majuscule (Maj) ou Contrôle (Ctrl) pour sélectionner plusieurs tâches.",
    noTagMessage: "Aucune balise n’a été créée. Cliquez <b>ici<b> pour commencer.",
    tagAs: "Identifier comme :",
    addTag: "Ajouter une balise",
    searchTag: "Rechercher des balises",
    documentsAttached: "Documents joints",
    editDraftRequest: "Modifier l’ébauche de demande",
    deleteRequest: "Supprimer la demande",
    deleteLabel: "Supprimer",
    deleteLabelDisabled: "Vous ne disposez pas des autorisations requises pour effectuer une suppression en bloc. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation d’effectuer une suppression en bloc.",
    DeleteRequestConfirmMsg1: "Voulez-vous vraiment supprimer cette demande?",
    DeleteRequestConfirmMsg2: "Cette action ne peut pas être annulée.",
    deleteRequestSuccess: "La demande a été supprimée. ",
    DeleteRequestsConfirmMsg1: "Voulez-vous vraiment supprimer ces {0} demandes?",
    dueDateCollabLabel: "Date d’échéance",
    requestLabel: "Demande",
    statusLabel: "État",
    inValidRequestTitleLabel: "Les demandes suivantes ne peuvent pas être supprimées étant donné leur état actuel",
    bulkSendButton: "Envoyer",
    bulkDeleteButton: "Supprimer",
    commentSyncFailedRetry: "Le commentaire n’a pas pu être livré au portail client d’EY Canvas.",
    commentSyncFailedRetrySendAgain: "Envoyer à nouveau.",
    commentDeleted: "Ce message a été supprimé.",
    CommmentDeletionSyncFailed: "Le commentaire n’a pas pu être supprimé du portail client d’EY Canvas. ",
    clickLabel: "Cliquez",
    toRetry: "pour réessayer.",
    replySyncFailedRetry: "La réponse n’a pas pu être livrée au portail client d’EY Canvas.",
    quickFilterPriority: "Priorité",
    quickFilterErrorCounterTooltip: "Une erreur s’est produite dans une ou plusieurs demandes, veuillez vérifier les demandes.",

    eyContactNoResultsFound: "Utilisateur introuvable",
    eyContactClear: "Effacer",
    eyContactSearch: "Rechercher",
    eyContactCollaboration: "Personne-ressource d’EY",
    eyParticipantsCollaboration: "Participants d’EY",
    externalParticipantsCollaboration: "Participants externes",
    syncInProgressEYContact: "Synchronisation en cours",
    syncErrorEyContact: "Erreur de synchronisation. Veuillez réessayer.",
    noAssignedContact: "Aucune personne-ressource affectée",
    noAssignedParticipant: "Aucun participant n’a été ajouté",

    commentsTooltipLabel: "Commentaires",
    recordingVirusScanInProgress1: "Analyse antivirus en cours. La note vocale sera disponible une fois que l’analyse sera terminée.",
    screenrecordVirusScanInProgress1: "Analyse antivirus en cours. L’enregistrement d’écran sera disponible une fois que l’analyse sera terminée.",
    recordingVirusScanInProgress2: "Veuillez actualiser la page et réessayer.",
    confidentialDocumentsModalTitle: "Documents confidentiels ",
    confidentialDocumentsModalMsg1: "Le ou les documents confidentiels suivants ont été ajoutés à la demande.",
    confidentialDocumentsModalMsg2: "En cliquant sur Continuer, vous confirmez que vous disposez du niveau de confidentialité requis pour envoyer le document vers le portail client d’EY Canvas et que vous avez revu l’affectation de la demande.    ",
    confidentialDocumentsModalMsg3: "Vous ne disposez pas du niveau de confidentialité approprié pour envoyer un ou plusieurs de ces documents vers le portail client d’EY Canvas. Veuillez retirer tout document confidentiel auquel vous n’avez pas accès pour continuer. ",
    confidentialityLevel: "Niveau de confidentialité ",
    voiceNoteUploadError: "Une erreur s’est produite lors de la récupération des renseignements sur le document. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    requestEventTitle: "Événement",
    noTaskDescription: "Aucune description de tâche",

    newRequestLabel: "Nouvelle demande",
    newEventLabel: "Nouvel événement",

    //Analytics Tab
    analyticsCreateDateLabel: "Date de création : ",
    createdByLabel: "Créée par : ",
    expirationDateLabel: "Date d’échéance : ",
    sharedWithLabel1: "Partagée avec",
    sharedWithLabel2: "demandes",
    sharedWithLabel3: "demande",
    analyticsTabTitle: "Analyses",
    analyticsTabSubtitle: "Partager des analyses avec des clients à partir de projets EY Helix connectés. Pour commencer, créez une demande d’informations pour le client à partir du panneau des signets dans ",
    analyticsTabSubtitle2: "EY Helix",
    analyticsTabSubtitle3: '.',
    noActiveAnalyticsLabel: "Aucune analyse sélectionnée",
    noActiveAnalyticsSubtitleLabel1: "Aucune analyse n’a été créée. Cliquez sur ",
    noActiveAnalyticsSubtitleLabel2: "ici ",
    noActiveAnalyticsSubtitleLabel3: "pour commencer.",
    noActiveAnalyticsSubtitleLabel4: "Après avoir lié un projet et enregistré les signets dans EY Helix, revenez à cette page pour avoir un aperçu des analyses qui pourront être partagées dans le portail client d’EY Canvas.",
    selectAnalyticsLabel: "Sélectionner une analyse",
    analyticsNoPrimaryHelixProjectsMessage: "Cette mission n’est pas liée à un projet EY Helix principal.",
    selectAnalyticsModal: {
        closeTitleTip: "Fermer",
        modalTitle: "Sélectionner une analyse",
        modalHeader: "Sélectionner une analyse à partager avec les membres de l’équipe externe",
        selectAnalyticPlaceholder: "Sélectionner une analyse",
        selectAnalyticError: "Une analyse est requise",
        analyticNamePlaceholder: "Entrer le nom de l’analyse (obligatoire)",
        analyticNameError: "Le nom de l’analyse est requis",
        cancel: "Annuler",
        viewPreview: "Afficher l’analyse",
        noPreviewAvailable: "Aucun aperçu disponible",
        noPreviewDescription: "Sélectionner un analyseur pour afficher un aperçu",
        clickPreviewAnalytic: "Cliquer pour afficher un aperçu de l’analyse",
        documentObservation: {
            label: "Consigner toute observation ou demande concernant l’analyse sélectionnée",
            placeHolderLabel: "Entrer une observation ou une demande (facultatif)"
        }
    },
    viewAnalyticsModal: {
        closeTitleTip: "Fermer",
        observationFieldPlaceholder: "Observations ou demandes concernant l’analyse sélectionnée",
        noObservationField: "Il n’y a aucune observation ni aucune demande concernant cette analyse.",
        appliedFiltersLabel: "Filtres appliqués",
        appliedFilters: [{
                id: '1',
                label: "Monnaie de l’analyse"
            },
            {
                id: '2',
                label: "Code de monnaie"
            },
            {
                id: '3',
                label: "Arrondissement"
            },
            {
                id: '4',
                label: "Groupe d’unités fonctionnelles"
            },
            {
                id: '5',
                label: "Unité fonctionnelle"
            },
            {
                id: '6',
                label: "Type de compte primaire"
            },
            {
                id: '7',
                label: "Sous-type de compte primaire"
            },
            {
                id: '8',
                label: "Catégorie de compte primaire"
            },
            {
                id: '9',
                label: "Sous-catégorie de compte primaire"
            },
            {
                id: '10',
                label: "Nom du compte primaire"
            },
            {
                id: '11',
                label: "Désignation du compte EY primaire"
            },
            {
                id: '12',
                label: "Compte EY primaire"
            },
            {
                id: '13',
                label: "Unité fonctionnelle"
            },
            {
                id: '14',
                label: "Date de l’analyse"
            },
            {
                id: '15',
                label: "Date de comparaison"
            },
            {
                id: '16',
                label: "Groupe segment 01 "
            },
            {
                id: '17',
                label: "Groupe segment 02 "
            },
            {
                id: '18',
                label: "Groupe segment 03 "
            },
            {
                id: '19',
                label: "Groupe segment 04 "
            },
            {
                id: '20',
                label: "Groupe segment 05 "
            }
        ],
        save: "Enregistrer",
        cancel: "Annuler",
        disabledEdit: "L’observation ne peut pas être modifiée, car la demande a déjà été envoyée vers le portail client d’EY Canvas. Veuillez retirer la demande pour permettre cette action.",
        errors: {
            unautorizedUser: "Vous n’êtes pas un membre autorisé du projet EY Helix associé. Veuillez communiquer avec l’administrateur de projet EY Helix pour obtenir l’accès et réessayez.",
            bookmarkNotFound: "L’analyse sélectionnée a été supprimée. Veuillez accéder à EY Helix pour gérer les analyses supprimées ou pour créer une nouvelle analyse.",
            unautorizedAccessToBookmark: "Vous n’avez pas accès au signet EY Helix demandé. Veuillez communiquer avec l’administrateur de projet EY Helix pour obtenir l’accès et réessayez.",
            authenticationError: "Erreur d’authentification. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
            genericError: "Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
            defaultError: "{0} Actualisez la page et réessayez. Si le problème persiste veuillez communiquer avec le Service de dépannage."
        }
    },
    deleteAnalyticModal: {
        modalTitle: "Supprimer l’analyse ",
        modalHeader: "Voulez-vous vraiment supprimer cette analyse? Elle ne sera plus disponible dans EY Canvas."
    },
    // activity feed
    search: "Rechercher",
    searchTeams: "Rechercher des équipes",
    clear: "Effacer",
    groupActivityLabel: "Activité du groupe",
    documents: "Documents",
    documentLabel: "Document",
    linkRequests: "Demandes de lien",
    received: "Reçu",
    returned: "Retourné",
    rejected: "Rejetée",
    accepted: "Acceptée",
    sent: "Envoyé",
    unlinked: "Détaché",
    finalized: "Terminé",
    groupActivityFeed: "Flux d’activité du groupe",
    component: "Composante",
    noExternalApprovalsMessage: "Il n’y a pas d’approbations externes.",
    noFileSelectedMessage: "Sélectionner un document pour afficher les détails",
    noInstructionSelectedMessage: "Sélectionner un élément pour afficher les détails",
    noLinkRequestSelectedMessage: "Sélectionner un élément pour afficher les détails",
    noItemSelectedMessage: "Sélectionner un élément pour afficher les détails",
    viewGroupActivity: "Afficher le flux d’activité du groupe",
    pointOfContact: "Personne-ressource",
    currentStatus: "État actuel",
    resolved: "Résolu",
    viewVersion: "Voir la version",

    // activity feed right pane headings
    scope: "Étendue",
    groupRole: "Rôle dans le groupe",
    linkRequestStatus: "État de la demande de lien",
    instructionStatus: "État de l’instruction",
    linkStatus: "État du lien",
    today: "Aujourd’hui",
    yesterday: "Hier",
    thisWeek: "Cette semaine",
    lastWeek: "La semaine dernière",
    twoWeeksAgo: "Il y a deux semaines",
    threeWeeksAgo: "Il y a trois semaines",
    lastMonth: "Le mois dernier",
    older: "Il y a plus d’un mois",
    actionsDateNote: "Toutes les dates et les heures sont présentées dans le fuseau horaire GMT.",
    noActionsMessage: "Aucune donnée à afficher.",
    noManageRequestPermissionMessagePart1: "Vous devez disposer d’une autorisation <b>Gérer la demande de services</b> pour effectuer cette action.",
    guidedWorkflow: "Outil FIT d’EY Canvas",
    navExecution: "Exécution",
    navCanvasEconomics: "Données financières d’EY Canvas",
    navOversight: "Surveillance d’EY Canvas",
    navConclusion: "Conclusion",
    navTeamMemberIndependence: "Indépendance des membres de l’équipe",
    navGroupAudit: "Direction du groupe",
    navGroupActivityFeed: "Flux d’activité du groupe",
    navPrimaryStatus: "État de l’équipe principale",
    navComponentStatus: "État de l’équipe affectée à l’audit de la composante",
    navGroupStatus: "État de l’audit de groupe",
    navEngagementManagement: "Gestion de la mission",
    navProfile: "Profil",
    navGroupStructureSummary: "Structure de l’audit de groupe",
    OpenGuidedWorkflowDocument: "Ouvrir ce document à partir de l’outil FIT d’EY Canvas",
    navNotApplicable: "Sans objet",
    canvasForms: "Formulaires Canvas",
    eYCanvasEconomics: "Données financières d’EY Canvas",
    overDueAssignments: "Affectations en retard",
    comingDueAssignments: "Affectations arrivant à échéance",
    overDueReviewNotes: "Notes de revue en retard",
    comingDueReviewNotes: "Notes de revue arrivant à échéance",

    //Group Audit/Status  for DashboardV2

    Reportingformsbystatus: "Formulaires de rapport par état",
    ReportingStatusSubTitle: "Affichez les tâches pour le groupe attribuées aux équipes affectées à l’audit des composantes ci-après ainsi que la synthèse des documents de l’audit de groupe reçus par état. <br> Vous pouvez passer en revue les détails de l’avancement en les filtrant par équipe ou par tâche pour le groupe. ",

    Total: "Total",
    Returned: "Retournés",
    Overdue: "En retard ",
    PendingResponse: "En attente d’une réponse",
    Received: "Reçus",
    ReadyForReview: "Prêts pour la revue",
    messageNoDocument: "Aucun document n’a encore été reçu.",
    byTeam: "Par équipe",
    byGroupTask: "Par tâche pour le groupe",
    groupStructureLabel: "Structure du groupe",
    instructionPending: "Instructions en attente d’approbation",
    linkRequestPending: "Demande de lien en attente",
    notusingeycanvas: "N’utilisant pas EY Canvas",
    pendingLabel: "En attente",
    teams: "Équipes",
    NoDocumentReceiced: "Aucun document n’a encore été reçu.",
    selectTeamToSeeData: "Aucune donnée disponible. Sélectionnez une équipe pour afficher les données ici.",
    noDataAvailable: "Aucune donnée disponible.",
    prepared: "Préparées",
    tasksAssigned: "Tâches attribuées",
    taskAssigned: "Tâche attribuée",
    instructionNotSent: "Instructions non envoyées",
    assignedTeamNotProvidedDocForTasks: "\{0}\ équipes n’ont pas envoyé de documents pour ces tâches | \{1}\ documents attendus",
    documentRecievedOutOfAssignedTasks: "Documents reçus <br><b>\{0}\</b> sur \{1}\ tâches attribuées",
    documentRecievedOutOfAssignedTeams: "Documents reçus <br><b>\{0}\</b> sur \{1}\ équipes affectées",

    groupStatusSubTitle: "Affichez les tâches pour le groupe attribuées par l’équipe principale ci-après ainsi que la synthèse des documents de l’audit de groupe par état. <br/> Les tâches pour le groupe peuvent être filtrées par tâche ou par état.",
    notSent: "Non envoyés",
    draftsent: "Projet envoyé",
    finalsent: "Envoi final",
    noTaskForComponent: "Aucune donnée disponible. <p> Les tâches pour le groupe envoyées par l’équipe principale seront affichées ici après avoir été acceptées.</p>",
    noTaskForComponentWithStatus: "Aucune donnée disponible. <p> Sélectionnez une ou plusieurs options relatives à l’état pour afficher les données ici.</p>",

    //Dashboard V2 - activity feed
    activityFeedSubHeadingText: "Sélectionnez un type d’activité pour passer en revue les activités pertinentes de la mission des 10 derniers jours. <br/> Cliquez sur le bouton d’<b>activité</b> souhaité pour afficher toutes les activités correspondantes. <br/> Vous pouvez également utiliser le bouton bascule pour filtrer les résultats affichés. ",
    activityFeedSubHeadingGroupAudit: "Sélectionnez un type d’activité pour passer en revue les activités pertinentes de la mission des 10 derniers jours. <br/> Cliquez sur le bouton d’<b>activité</b> souhaité pour afficher toutes les activités correspondantes. <br/> Vous pouvez également utiliser le bouton bascule pour filtrer les résultats affichés. ",
    teamHistoryInstructionalText: "Passer en revue l’activité pour cette équipe pour les dix derniers jours.",
    teamHistory: "Historique de l’équipe",
    onlySeeMyActivity: "N’afficher que mes activités",

    taskAddedBy: "Tâche ajoutée par",
    taskMarkedCompleteBy: "Tache marquée comme étant terminée par",
    taskUnmarkedCompleteBy: "Tâche à nouveau marquée comme non terminée par",
    taskHandedOffBy: "Tâche transmise par ",
    assignmentAddedBy: "Affectation ajoutée par ",
    assignmentEditedBy: "Affectation modifiée par ",
    assignmentClosedBy: "Affectation fermée par ",
    assignmentReOpenedBy: "Affectation rouverte par ",
    assignmentDeletedBy: "Affectation supprimée par",
    noteAddedBy: "Note ajoutée par",
    noteClearedBy: "Note réglée par",
    noteClosedBy: "Note fermée par",
    noteReopenedBy: "Note rouverte par",

    linkRequestSent: "Demande de lien envoyée par ",
    instructionSentBy: "Instructions envoyées par ",
    linkRequestAcceptedBy: "Demande de lien acceptée par ",
    engagementUnlinkedBy: "Mission dissociée par ",
    instructionAcceptedBy: "Instructions acceptées par ",
    instructionReturnedBy: "Instructions retournées par, ",
    labelTo: "à",
    instructionReceivedFrom: "Instructions reçues de",
    filtersLabel: "Filtres",
    advanceOptions: "Opérations en bloc",
    advanceOptionsLabel: "Opérations en bloc",
    relatedScots: "Catégories d’opérations importantes associées",
    noRelatedScots: "Aucune catégorie d’opérations importante associée",
    materialityLabel: "Seuil de signification",
    currentPeriod: "Date actuelle",
    previousPeriod: "Date précédente",
    showCurrentPeriod: "Afficher la date actuelle",
    showPriorPeriod: "Afficher la date précédente",
    planningMateriality: "Seuil de signification initial",
    tolerableError: "Erreur acceptable",
    sadNominalAmount: "Seuil minimal de report des anomalies",
    pmLabel: "SSI",
    teLabel: "EA",
    sadLabel: "Seuil minimal de report des anomalies",
    accountBalance: "Solde du compte ",
    mapAccountBalances: "Mapper les soldes de comptes",
    connectToHelixProject: "Connecter à un projet Helix",
    connectToImportBalances: "pour importer les soldes",
    helixMultiple: "Plusieurs",
    selectMESTentity: "Sélectionner une entité pour afficher les détails",
    relatedWCGWAndControls: "Erreurs possibles et contrôles associés",
    relateAtLeastOneWCGW: "Chaque assertion dont le risque lié au contrôle est « Appui » doit être associée à au moins une erreur possible.",
    notRelyRelateWCGW: 'Assertions with a control risk of Not Rely do not have a requirement to identify a WCGW.',
    relatedITProcesses: "Processus informatiques associés",
    noRelatedITProcesses: "Aucun processus informatique associé",
    relatedITRiskITGCs: "Risques liés aux TI, CGI et procédures de corroboration liées aux TI associés",
    relatedITRisks: "Risques liés aux TI associés",
    ALRAHigherRiskCode: "É",
    materialityMestSelectEntity: "Sélectionner une entité pour afficher les détails",
    OARCurrentPeriod: "Date de l’analyse",
    OARComparative1Period: "Date de comparaison 1",
    xTELabel: "xEA",
    priorPeriodDesignation: "Désignation de la période précédente :",
    priorPeriodEstimate: "Estimation de la période précédente :",
    notApplicableAbbreviation: "s. o.",
    accountDetails: "Détails du compte",
    launchGuidedWorkflow: "Lancement du flux de travail guidé",
    guidedWorkflowTitle: 'Guided workflow',
    viewAccountBalace: "Afficher les soldes de comptes",
    viewAccountBalaceForEntity: "Sélectionner une entité pour afficher les soldes de comptes",
    mainActivities: "Principales activités",
    oversightProjectTile: {
        typeOversight: "Surveillance",
        createProject: "Créer un projet",
        oversightProjectengagementNotConnectedMessage1: "Le module Surveillance d’EY Canvas résume l’état d’avancement concernant les jalons, la gestion de projet et l’audit de groupe pour les missions connectées. Veuillez l’utiliser pour faire le suivi de votre audit de groupe ou de votre portefeuille de missions. ",
        oversightProjectengagementNotConnectedMessage2: "Votre mission n’est connectée à aucun projet du module Surveillance d’EY Canvas.",
        click: "Cliquez sur",
        togetstarted: "pour commencer.",
        clickProjectmessage: "Cliquez sur <br> + Créer un projet </b> pour commencer.",
        lblclient: "Clients :",
        lblEngagementCount: "Missions :",
        lblTaskscompleted: "Tâches terminées :",
        lblMore: "plus",
        myProject: "Mes projets",
        OtherProject: "Autres projets",
        oversightNoProjectConnectedMessage: "Vous ne faites partie d’aucun des projets du module Surveillance d’EY Canvas auxquels votre mission est connectée.",
        oversightOtherProjectNotConnectedMessage: "Vous faites partie de tous les projets du module Surveillance d’EY Canvas auxquels votre mission est connectée.",
        draft: "En projet",
        allTask: "Toutes les tâches",
        totalTask: "Total des tâches"
    },

    economicsProjectTile: {
        typeEconomics: "Données financières ",
        economicsProjectengagementNotConnectedMessage1: "Le module Données financières d'EY Canvas résume les données financières et l’état d’avancement dans EY Canvas. Utilisez-la pour gérer les données financières de votre portefeuille de missions.",
        economicsProjectengagementNotConnectedMessage2: "Votre mission n’est connectée à aucun projet du module Données financières d’EY Canvas.",
        clickProjectmessage: "Cliquez sur <br> + Créer un projet </b> pour commencer.",
        economicsNoProjectConnectedMessage: "Vous ne faites partie d’aucun des projets du module Données financières d'EY Canvas auxquels votre mission est connectée.",
        lblForecasted: "Prévues :",
        lblActual: "Réelles :",
        lblETC: "ETC :",
        lblVariance: "Écart"
    },
    leftNavigation: {

        engagementOverview: "Aperçu de la mission",
        myProgress: "Mon avancement",
        executiveTasks: "Secteurs cibles",
        integration: "Intégration",
        groupAudit: "État de l’audit de groupe",
        pinnedDocuments: "Documents épinglés",
        Validations: "Validations",
        activityFeed: "Flux d’activité",
        primaryStatus: "État de l’équipe principale",
        componentStatus: "État de l’équipe affectée à l’audit de la composante",
        picProgress: "Progression de l’associé responsable",
        picEQRProgress: "Progression de l’associé responsable/du responsable de la revue de la qualité de la mission",
        drillDown: "Analyse détaillée",
        maps: "Schémas",
        financialStatement: "États financiers"
    },
    nowRowOverlayClientRequest: {
        createNew: "Cliquez sur Ajouter une demande pour créer une nouvelle demande",
        all: "Aucune demande n’a été créée",
        draft: "Aucune demande n’est à l’état «projet»",
        pending: "Aucune demande n’est à l’état «en attente d’une réponse»",
        received: "Aucune demande n’a été reçue",
        accepted: "Aucune demande n’a été acceptée",
        customFilter: "Aucun résultat. Veuillez réessayer."
    },

    clientRequestPrefixes: {
        draft: "Projet",
        returned: "Retournée",
        recalled: "Rappelée",
        withdrawn: "Retirée"
    },

    clientRequestsTabHeader: {
        all: "Toutes",
        draft: "En projet",
        pending: "En attente",
        received: "Reçues",
        accepted: "Acceptées"
    },

    clientRequestsPriorityFilters: {
        all: "Toutes",
        normal: "Normale",
        high: "Élevée",
        critical: "Critique",
        highAndCritical: "Élevée + Critique"
    },

    requestTableHeader: {
        requestId: "Identifiant de la demande",
        title: "Titre",
        receivedDate: "Date de réception",
        dueDate: "Date d’échéance",
        sentDate: "Date d’envoi",
        acceptedDate: "Date acceptée",
        assignedTo: "Attribués à ",
        group: "Audit de groupe",
        status: "État",
        priorityType: "Priorité",
        tags: "Balises"
    },

    dropdownColumnsFilter: {
        1: "Attribués à ",
        2: "Audit de groupe",
        3: "Date d’échéance",
        4: "Date d’envoi",
        5: "Date de réception",
        6: "Date d’acceptation",
        7: "État",
        8: "Priorité",
        9: "Balises"
    },

    requestTableDropdownFilter: {
        customizeTable: "Personnaliser le tableau",
        selectInfo: "Sélectionner jusqu’à quatre options",
        selectInfoTooltip: "Sélectionner jusqu’à quatre colonnes. Désélectionner une ou plusieurs options pour continuer."
    },

    ClientStatus: {
        1: "Projet",
        2: "Projet ‒ Aucun contact",
        3: "Envoyée",
        4: "Erreur système",
        5: "Client invalide",
        6: "En attente d’une réponse",
        7: "Reçue",
        8: "Acceptée",
        9: "Retournée",
        10: "Retirée",
        11: "Envoi en cours",
        12: "Acceptation en cours",
        13: "Retrait en cours",
        14: "Suppression en cours",
        15: "Retour en cours",
        16: "Réponse en cours",
        17: "Supprimée",
        18: "Client invalide",
        19: "Rappel en transit",
        20: "Rappelée",
        21: "Traitement en cours",
        22: "Rappel en cours"
    },

    analyticStatus: {
        1: "Ébauche",
        2: "Approbation en attente",
        3: "Approuvée",
        4: "Expirée"
    },

    paginationControl: {
        firstPage: "Première page",
        lastPage: "Dernière page",
        previousPage: "Page précédente",
        nextPage: "Page suivante",
        show: "Afficher"
    },

    auditPlanFilterLabels: {
        showMore: "plus",
        filterTypeOfScots: "Catégorie d’opérations importante",
        noScotsAvailable: "Aucune catégorie d’opérations importante disponible",
        filterTypeOfITProcess: "Processus informatique",
        noITProcessAvailable: "Aucun processus informatique disponible"
    },

    controlListBuildStep4FilterLabels: {
        scots: {
            filterTypeOfScots: "Catégories d’opérations importantes",
            noScotsAvailable: "Aucune catégorie d’opérations importante disponible"
        },
        testing: {
            filterTypeOfTesting: "Test",
            noTestingAvailable: "Aucun test disponible"
        },
        designEffectiveness: {
            filterTypeOfDesignEffectiveness: "Efficacité de la conception",
            noDesignEffectivenessAvailable: "Aucun type d’efficacité de la conception disponible"
        },
    },

    clientRequestsFilterLabels: {
        filterAssignedTo: "Attribuée à",
        filterAttachmentsLabel: "Type de pièce jointe",
        filterCreatedByLabel: "Créée par",
        filterStatusLabel: "État",
        filterDueAfterLabel: "Échéant après le",
        filterDueBeforeLabel: "Échéant avant le",
        filterErrorsLabel: "Erreurs",
        filterOverdueLabel: "En retard",
        filterTagLabel: "Balise",
        filterTimePhaseLabel: "Période",
        filterTypeLabel: "Type",
        filterPriorityLabel: "Priorité",
        searchMembers: "Rechercher des membres",
        noTags: "Aucune balise n’a été créée",
        noTimephase: "Aucune période",
        clearAll: "Tout effacer",
        clearHoverText: "Effacer",
        noResultsFound: "Aucun résultat",
        yes: "Oui",
        no: "Non",
        showMore: "Afficher plus",
        // Check this
        filterNoMatchesFound: "Aucun résultat. Veuillez réessayer.",
        filter: "Filtrer",
        title: "Filtres",
        noRelatedTask: "Aucune tâche associée"
    },
    //Dashboard - integration

    collaborationInstruction: "Affichez vos demandes de collaboration par état ci-après. <br/> Cliquez sur un nombre pour accéder à la liste des demandes à laquelle des filtres ont été appliqués. ",
    noValidationsAvailable: "Aucune validation pour cette phase de l’audit.",
    individualView: "Vue individuelle",
    engagementView: "Vue de la mission",
    centralizedServiceInstruction: "Afficher le pourcentage de tâches effectuées par les Services centralisés ainsi que les demandes par état ci-après. <section >Pour créer une nouvelle demande, sélectionner <b>Faire une demande de services.</b></section>",
    // Dashboard - todo list
    todoList: "Liste de tâches à faire",
    todoListInProgress: "En cours",
    todoListOpen: "À venir",
    todoListClosed: "Terminée",
    todoListInstruction: "Afficher les affectations et les notes de revue arrivant à échéance par état. <br /> Sélectionner une période ou une catégorie pour affiner la liste. <br /> /> Pour ouvrir un élément, cliquer sur le nom de la tâche ou de la note de revue.",
    noOpenAssignments: "Vous n’avez aucune affectation ouverte.",
    noInProgressAssignments: "Vous n’avez aucune affectation en cours.",
    noClosedAssignments: "Vous n’avez aucune affectation fermée.",
    allLabel: "Toutes",
    dueLabel: "Échéance",
    noAssignments: "Vous n’avez aucune affectation.",
    executiveReview: "Revue de la direction",
    epTasksStatusSignOffWithoutDetails: "Afficher une synthèse de l’état des tâches de l’associé responsable ci-après.",
    epTasksStatusSignOff: "Afficher une synthèse de l’état des tâches de l’associé responsable ci-après. Pour obtenir une vue détaillée, sélectionnez <b>Afficher les détails</b>.",
    epeqrTasksStatusSignOffWithoutDetails: "Afficher une synthèse de l’état des tâches de l’associé responsable et du Responsable de la revue de la qualité de la mission ci-après.",
    epeqrTasksStatusSignOff: "Afficher une synthèse de l’état des tâches de l’associé responsable et du Responsable de la revue de la qualité de la mission ci-après. Pour une vue détaillée, sélectionnez <b>Afficher les détails</b>.",
    eqrDefaultMessage: "L’approbation du responsable de la revue de la qualité de la mission n’est pas requise pour cette mission.",
    selectPartners: "Sélectionnez un associé",
    noPartnersInEng: "Aucun associé ne fait partie de votre mission.",
    epTasks: "Tâches de l’associé responsable",
    eqrTasks: "Tâches du Responsable de la revue de la qualité de la mission",
    viewDetails: "Afficher les détails",
    picReview: "Revue de l’associé responsable ",
    eqrReview: "Revue du responsable de la revue de la qualité de la mission",
    eqrtasksWithSignOff: "Tâches avec approbations du responsable de la revue de la qualité de la mission <br/> manquantes",
    eqrdocumentsWithSignOff: "Documents avec approbations du responsable de la revue de la qualité de la mission <br/> manquantes",
    pictasksWithSignOff: "Tâches avec approbations de l’associé responsable <br/> manquantes",
    picdocumentsWithSignOff: "Documents avec approbations de l’associé responsable <br/> manquantes",
    partnerSignoffs: "Approbations de l’associé",
    epTaskswithpartnersignoffs: "Cliquez sur un nombre pour accéder à la liste de tâches à laquelle des filtres ont été appliqués. ",
    allDocssignedoff: "Tous les documents <br/>approuvés",
    someDocssignedoff: "Quelques documents <br/>approuvés",
    noDocssignedoff: "Aucun document <br/>approuvé",
    partnernotinvited: "Associé non invité",
    noEQRsinyourengagement: "Aucun Responsable de la revue de la qualité de la mission ne fait partie de votre mission.",
    selectEQRs: "Sélectionnez un Responsable de la revue de la qualité de la mission",
    eqrNotinvited: "Responsable de la revue de la qualité de la mission non invité",
    eqrsignoffs: "Approbations du Responsable de la revue de la qualité de la mission",
    eqrtaskswithpartnersignoffs: "Cliquez sur un nombre pour accéder à la liste de tâches à laquelle des filtres ont été appliqués. ",
    allpartners: "Tous les associés",
    allEQRs: "Tous les responsables du contrôle qualité de la mission",
    reviewComments: "Notes de revue",
    noOpenReviewComments: "Vous n’avez aucune note de revue ouverte.",
    noClearedReviewComments: "Vous n’avez aucune note de revue réglée.",
    noClosedReviewComments: "Vous n’avez aucune note de revue fermée.",
    noReviewCommentsForSelectedTime: "Vous n’avez aucune note de revue pour la période sélectionnée. Sélectionnez une autre période pour continuer.",
    picTasksSomeDocSignOff: "Tâches avec quelques documents approuvés par l’associé responsable",
    picTasksNoDocSignOff: "Tâches sans document approuvé par l’associé responsable",
    eqrTasksSomeDocSignOff: "Tâches avec quelques documents approuvés par le responsable de la revue de la qualité de la mission ",
    eqrTasksNoDocSignOff: "Tâches sans document approuvé par le responsable de la revue de la qualité de la mission ",
    picNotIdentified: "Aucun associé responsable n’a été identifié",
    eqrNotIndentified: "Aucun Responsable de la revue de la qualité de la mission n’a été identifié",
    todoReviewNote: "Note de revue",

    // Dashboard - Executive Tasks
    executiveTasks: "Secteurs cibles",
    executiveTasksInstruction: "Cliquez sur le bonton Par risque ou le bouton Par compte ci-après pour afficher les tâches par risque ou par compte. <br/> Placez ensuite le pointeur sur un nombre pour afficher plus de détails ou sélectionnez une tâche pour accéder à une page de détails propres à cette tâche. ",
    byRisk: "Par risque",
    byAccount: "Par compte",
    responsiveTasks: "Tâches associées",
    openNotes: "Notes ouvertes",
    lowLabel: "Faible",
    mediumLabel: "Modérée",
    highLabel: "Élevée",
    criticalLabel: "Critique",
    epRequired: "Approbation de l’associé responsable requise",
    eqrRequired: "Responsable de la revue de la qualité de la mission requis",
    noDocumentsSignedOff: "Aucun document approuvé",
    someDocumentsSignedOff: "Quelques documents approuvés",
    allDocumentsSignedOff: "Tous les documents approuvés",
    completedAssignments: "Travail terminé",
    designation: "Désignation",
    significantAccount: "Compte important",
    epSignOff: "Approbation de l’associé responsable",
    eqrSignOff: "Approbation du Responsable de la revue de la qualité de la mission",
    someLabel: "Some",
    riskNoDataLabel: "Ce risque n’a été associé à aucune tâche.",
    accountNoDataLabel: "Ce compte et les assertions connexes n’ont été associés à aucune tâche.",
    NoDataLabel: "Aucune donnée disponible pour l’accordéon sélectionné ",
    // Manage tags
    manageTagsInstructionalText: "Créer de nouvelles balises ici. Vous pouvez aussi modifier et supprimer des balises existantes. L’utilisation de balises pour les demandes permet d’améliorer la structure de la mission et la gestion de projet.",
    noTagsAdded: "Aucune balise ajoutée. Créer une balise pour commencer.",

    // Client Request Comments
    noCommentsCreatedYet: "Aucun commentaire n’a encore été créé.",
    addCommentTitleTip: "Ajouter un commentaire",
    addReplyTitleTip: "Ajouter une réponse",
    addAComment: "Laisser un commentaire…",
    addAReply: "Ajouter une réponse",
    deleteCommentConfirmationModalTitle: "Supprimer le commentaire",
    deleteCommentConfirmationModalMessage: "Voulez-vous vraiment supprimer ce commentaire? Toutes les réponses à ce commentaire seront également supprimées.",

    // Client Request Voice Note Comment Labels
    voiceNoteCommentRecordLabel: "Note vocale",
    voiceNoteCommentStopLabel: "Arrêter",
    voiceNoteCommentPlayLabel: "Lire  ",
    voiceNoteCommentDeleteLabel: "Supprimer",

    //Client Request Status/Tooltip messages
    SendRequestSuccess: "La demande a bien été envoyée",
    BulkSendRequestSuccess: "{0} demandes ont bien été envoyées ",
    BulkSendOneRequestSuccess: "1 demande a été envoyée avec succès.",
    SendInProgress: "Envoi en cours",
    AcceptInProgress: "Acceptation en cours",
    CompleteInProgress: "Traitement en cours",
    HasErrorState: "La demande n’a pas pu être envoyée. Veuillez réessayer.",
    WithdrawRequestSuccess: "La demande a été retirée",
    WithdrawInProgress: "Retrait en cours",
    WithdrawRequestError: "La demande n’a pas pu être retirée. Veuillez réessayer.",
    DeleteRequestError: "La demande n’a pas pu être supprimée. Veuillez actualiser la page et réessayer.",
    AcceptRequestError: "La demande n’a pas pu être acceptée. Veuillez réessayer.",
    CompleteRequestError: "La demande n’a pas pu être traitée. Veuillez réessayer.",
    InvalidClientContact: "Client invalide.",
    BulkSendInvalid: "Une ou plusieurs demandes sélectionnées ne peuvent pas être envoyées sans que d’autres mesures soient prises. Veuillez passer en revue les demandes et réessayer.",
    returnInProgress: "Retour en cours",
    returnRequestError: "La demande n’a pas pu être retournée. Veuillez réessayer.",

    //Client Withdraw Request
    WithdrawRequest: "Retirer la demande",
    WithdrawReuestConfirmMsg: "Voulez-vous vraiment retirer cette demande? Une fois qu’elle sera retirée, le client ne pourra plus l’afficher. La demande sera déplacée dans la liste des projets une fois qu’elle aura été traitée. ",
    WithdrawMenuOption: "Retirer ",
    MoreOptions: "Plus d'options",
    Complete: "Terminée",
    WithdrawLabel: "Retirée",
    CompleteInstructionalText: "Cliquez sur Terminer lorsque les informations ont déjà été fournies par le client.  ",

    //Client Complete Request
    CompleteRequestConfirmMsg: "Lorsqu’on indique qu’une demande est terminée, celle-ci est retirée de la liste des tâches pour le client et l’état de la demande passe à Envoyée pour le client. La demande est déplacée dans la liste des demandes reçues d’EY Canvas. Ce peut être utile, par exemple, lorsque l’information demandée a déjà été reçue d’une autre façon.",
    CompleteRequest: "Traiter la demande",
    CompleteRequestSuccess: "La demande a été traitée",

    //Client Accept Return Request
    AcceptLabel: "Accepter",
    ReturnLabel: "Renvoyer",
    ReturnRequest: "Renvoyer la demande",
    acceptRequest: "Accepter la demande",
    acceptRequestWithoutTask: "Voulez-vous vraiment accepter la demande sélectionnée? ",
    acceptRequestWithTask: "<b>Voulez-vous vraiment accepter la demande sélectionnée?</b> Les documents joints seront disponibles à partir de l’onglet des documents externes de la tâche (des {0} tâches) associée(s).",
    acceptRequestSuccess: "La demande a été acceptée",
    returnedRequestSuccess: "La demande a été retournée -",

    // Client Request Relate Files modal
    noRecordsFound: "Aucun enregistrement trouvé",
    relateSelected: "Associer les documents sélectionnés",
    relateFilesModalHeader: "Pour associer des documents existants à cette demande, sélectionnez les documents et cliquez sur Associer les documents sélectionnés.",
    relateAnalyticModalHeader: "Pour associer des analyses existantes à cette demande, cocher la case correspondant à l’analyse sélectionnée. Pour afficher un aperçu d’autres analyses disponibles, cliquez sur ",
    relateAnalyticHereModalHeader: "ici",
    noAnalyticsRecordsFound: "Il n’y a aucune analyse disponible à associer. Cliquez",
    noAnalyticsRecordsFoundGetStarted: "pour commencer.",
    associateExistingDocumentsSelected: "documents ajoutés",
    associateExistingDocumentSelected: "document ajouté",

    // Client Request Details Header
    timePhaseLabel: "Période :",
    receivedDateLabel: "Reçue :",
    dueDateLabel: "Échéance : ",
    sentDateLabel: "Envoyée :",
    acceptedDateLabel: "Acceptée :",
    clientRequestSyncLabel: "Les mises à jour sont envoyées vers le portail client d’EY Canvas",
    editDescriptionLabel: "Modifier la description ",
    createdDateLabel: "Date de création : ",

    //Client Advance Search
    advancedSearch: "Recherche avancée",
    advancedSearchRefereceNumberCheck: "N° de référence",
    advancedSearchTitleCheck: "Titre",
    advancedSearchDocumentsCheck: "Documents ",
    advancedSearchCommentsCheck: "Commentaires",
    advancedSearchApplyButton: "Appliquer",
    searchRequest: "Rechercher",
    clearSearch: "Effacer la recherche",

    //Adjustment Topup module
    adjustmentModule: {
        currencyType: "Type de monnaie",
        currencyCode: "Code de monnaie",
        businessUnit: "Unité fonctionnelle",
        all: "Toutes",
        moduleName: "Module d’ajustement",
        financialStatement: "États financiers",
        viewByTrialBalanceType: "Afficher par type de balance des comptes",
        multiEntry: "Entités multiples",
        balanceSheet: "Bilan",
        incomeStatement: "État des résultats",
        currentperiodUnadjusted: "Analysis date ",
        unadjusted: "(non ajusté)",
        currentperiodAdjusted: "Analysis date ",
        adjusted: "(ajusté)",
        adjustment: "Ajustement",
        newAdjustment: "Nouvel ajustement",
        noRecordsFound: "Aucun enregistrement trouvé",
        periodEnded: " date de fin",
        periodsEnded: " date de fin",
        noResultsFound: "Aucun résultat",
        notApplicableAbbreviation: "S. O.",
        noAdjustmentCreated: "Aucun ajustement n’a été créé.",
        createAdjustment: "Créer un {0}.",
        next: "Page suivante",
        previous: "Page précédente",
        reclassification: "Reclassement",
        manageAdjustment: "Gérer les ajustements",
        lastPage: "Dernière page",
        firstPage: "Première page",
        filterYes: "Oui",
        filterNo: "Non",
        showOnlyAdjustedAccountClasses: "N’afficher que les catégories de comptes ajustés",
        noneAvailable: "Aucune information disponible",
        noImportedTrialbalanceAvailable: "Aucune balance des comptes importée.",
        trialBalanceRequired: "Balance des comptes",
        comparativeperiodUnadjusted: "Date de comparaison",
        comparativeperiodAdjusted: "Date de comparaison ",
        multityEntityRequired: "Entités multiples",
        placeHolderMessageWhenHelixMappingIsTrue: "Aucune balance des comptes importée. Cliquez sur {0} pour associer un nouvel analyseur.",
        placeHolderMessageWhenHelixMappingIsFalse: "L’intégration à EY Helix n’est pas disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
        eyHelixIntegrationLinkText: "Connexions EY Helix",
        noEntitiesAvailablePlaceholder: "Aucune entité créée. Pour commencer, créez des entités.",
        search: "Rechercher",
        viewAdjustmentWithValidations: "Afficher les ({0}) ajustements avec des validations",
    },

    misstatementLabels: {
        name: "Nom",
        notes: "Notes",
        signOffs: "Approbations",
        open: "Ouvrir",
        openReadOnly: "Ouvrir en lecture seule",
        delete: "Supprimer",
        rename: "Renommer",
        signOffRequirements: "Exigences d’approbation",
        confidentiality: "Confidentialité",
        unlink: "Dissocier",
        removeFromAdjustment: "Retirer de l’ajustement"
    },

    allControls: "Tous les contrôles",
    //Client Request Document labels
    clientRequestDocuments: {
        externalDocuments: "Externes",
        taskDocuments: "Documents",
        deletedDocuments: "Supprimés",
        priorPeriodDocuments: "Exercice précédent",
        priorPeriodInfoMessage: "Ces documents ne peuvent pas être téléchargés",
        uploadedBy: "Téléchargé par",
        deletedBy: "Supprimé par",
        lastModifiedBy: "Dernière modification par",
        eyBadge: "Supprimé des documents",
        externalBadge: "Supprimé des documents externes",
        uploadInProgress: "Téléchargement en cours",
        refreshdocuments: "Actualiser les documents",
        disabledDocument: "Les opérations en bloc ne sont pas autorisées pour ce type de document.",
        menuOptions: {
            delete: "Supprimer",
            open: "Ouvrir",
            openr: "Ouvrir en lecture seule",
            restore: "Restaurer",
            remove: "Retirer",
            rename: "Renommer",
            editInHelix: "Modifier dans EY Helix"
        },
        externalPriorPeriod: "Client",
        eyPriorPeriod: "EY",
        uploadedByEY: "EY"
    },

    //Client Request Assigned To Errors
    clientRequestAssignedToErrorLabel: "L’utilisateur ou le groupe désigné n’est pas valide. Veuillez mettre à jour l’affectation pour continuer. Cliquez",
    clientRequestAssignedToErrorLabelEnd: "pour modifier les membres de l’équipe externe.",
    clickHereLabel: "ici",
    clientRequestAssignedToIconErrorLabel: "Aucun membre actif pour le groupe désigné. Veuillez attribuer la demande à un utilisateur/groupe actif ou ajouter des membres au groupe pour continuer. ",
    clientRequestDueDateErrorLabel: "La date d’échéance est requise. Veuillez la mettre à jour pour continuer.",

    clientRequestDocumentsNoDocsFound: [{
            id: 'externalDocuments',
            label: "Aucun document externe n’a été ajouté"
        },
        {
            id: 'taskDocuments',
            label: "Glisser et déposer un ou plusieurs documents ou cliquer sur Ajouter un document"
        },
        {
            id: 'deletedDocuments',
            label: "Aucun document n’a été supprimé"
        },
        {
            id: 'searchRequestDocuments',
            label: "Aucun résultat. Veuillez réessayer."
        },
        {
            id: 'priorPeriodDocuments',
            label: "Aucun document de l’exercice précédent disponible"
        }
    ],

    liveNotifications: {
        "ey.at.hercules.annotation.created": "Annotation créée",
        "ey.at.hercules.annotation.edited": "Annotation modifiée",
        "ey.at.hercules.annotation.replied": "Annotation comportant une réponse",
        "ey.at.hercules.contentupdate.updated": "Contenu mis à jour",
        "ey.at.hercules.contentupdate.failed": "Échec de la mise à jour du contenu"
    },

    //Assign to
    usersOption: "Utilisateurs",
    externalUsersOption: "Utilisateurs externes ",
    groupsOption: "Groupes",
    lblassignedto: "Attribuée à",
    searchGroup: "Rechercher un groupe",
    requiredAssignedTo: "Le champ Attribuée à est requis.",
    rdSubmitRequest: "Envoyer la demande",

    closeDrawer: "Fermer et tout désélectionner",
    requestSelected: "demande sélectionnée",
    requestsSelected: "demandes sélectionnées",
    //GA Scopes labels
    engagementScopesAndCustomSubScopes: "Étendues des travaux et sous-étendues personnalisées",
    defineGroupScopes: "Définir l’étendue des travaux pour l’audit de groupe",
    gaScopeIntro: "Les étendues des travaux selon la MMA d’EY sont intégrées ici par défaut. Si vous devez personnaliser les tâches et les instructions pour l'audit de groupe pour les équipes qui se sont vues assigner la même étendue, pensez à créer une sous-étendue. Au moment d’envoyer les instructions, vous pourrez envoyer des versions différentes à chaque sous-étendue.",
    addSubScope: "Ajouter une sous-étendue",
    customSubScope: "Sous-étendue personnalisée",
    noCustomSubscopes1: "Cette mission ne contient aucune sous-étendue personnalisée.",
    noCustomSubscopes2: "Sélectionnez <b>Ajouter une sous-étendue<b> pour commencer.",
    subScopeName: "Nom de la sous-étendue",
    addDescription: "Ajouter une description",
    textExceedsLength500: "Le texte ne doit pas dépasser 500 caractères.",
    manageGroupPermission: "Vous devez disposer de l’autorisation <b>Gérer le groupe</b> pour effectuer cette action. Communiquez avec l’administrateur de la mission pour demander une autorisation.",
    deleteCustomSubScope: "Supprimer la sous-étendue personnalisée",
    areYouSureDeleteCustomSubScope: "Voulez-vous vraiment supprimer cette sous-étendue personnalisée?",

    //GA Component labels
    newTeam: "Nouvelle équipe",
    teamName: "Nom de l’équipe",
    legalEntityName: "Nom de l’entité juridique",
    parentTeam: "Équipe parent",
    isReferenceOnly: "Référence seulement",
    isNotUsingCanvas: "Équipe n’utilisant pas EY Canvas",

    referenceOnlyTooltip: "Les équipes pour lesquelles il est indiqué <b>Référence seulement</b> ne recevront pas les demandes de lien, les instructions ou les tâches. Elles sont indiquées à des fins d’organisation seulement.   ",

    canvasFormNotOwnedByEng: "Les formulaires Canvas partagés n’appartenant pas à cette mission ne peuvent pas être envoyés vers le portail client d’EY Canvas. Pour envoyer un formulaire Canvas partagé, veuillez en faire une copie ou l’envoyer directement à partir de la mission source.",
    canvasFormNotAllowedInCtry: "Le partage des formulaires Canvas avec les clients n’est pas disponible dans votre pays.",
    on: "le",
    sendRequest: "Envoyer une demande",
    selectUserOrGroup: "Sélectionnez un utilisateur ou un groupe",
    canvasFormShowAttachments: "Afficher {0} pièces jointes",
    canvasFormShowOneAttachment: "Afficher une pièce jointe",
    canvasFormHideAttachments: "Masquer {0} pièces jointes",
    canvasFormHideOneAttachment: "Masquer une pièce jointe",

    //GA Components
    createGroupStructure: "Créer la structure du groupe",
    componentText: "Créer des zones et des composantes pour chaque équipe de mission qui enverra des livrables au moyen d’EY Canvas. Pour les équipes qui n’enverront pas de livrables au moyen d’EY Canvas, vous pouvez sélectionner l’indication <b>N’utilise pas EY Canvas</b>. Vous pouvez aussi créer des équipes à des fins d’organisation en les désignant comme <b>Référence seulement</b>. Ces équipes ne recevront pas les demandes de lien, les instructions ou les tâches. Lorsque vous avez terminé, sélectionnez <b>Envoyer les demandes de lien</b>. ",
    addTeam: "Ajouter une équipe",
    sendLinkRequests: "Envoyer les demandes de lien",
    noComponents: "Aucune équipe n’a encore été créée. Sélectionner <b> Ajouter une équipe <b> pour commencer.",
    editTeam: "Modifier l’équipe",
    deleteTeam: "Supprimer l’équipe",
    deleteInstructional: "Voulez-vous vraiment supprimer cette équipe? <br/><br/> Le lien vers cette équipe sera brisé et l’échange de documents ne sera plus possible dans le cadre de vos missions avec cette équipe. De plus, toutes les instructions et les tâches personnalisées attribuées à cette équipe seront supprimées. ",
    linkRequestHasBeenSent: "Vous ne pouvez pas modifier l’étendue ou la désignation pour cette équipe, car une demande de lien a déjà été envoyée ou la désignation est déjà établie. ",
    selectScopes: "Sélectionner les étendues ",
    searchScopes: "Rechercher les étendues ",
    selectTeams: "Sélectionner les équipes",
    sendLinkRequestsDescription: "Sélectionnez les étendues ou les équipes auxquelles vous souhaitez associer votre mission.<br>Une demande de lien sera envoyée à la personne-ressource de chaque équipe. Lorsque la personne-ressource aura accepté la demande de lien, elle recevra les instructions et les tâches pour l’audit de groupe dans EY Canvas.",
    sendVersionsDescription: "Sélectionnez les étendues ou les équipes auxquelles vous souhaitez envoyer la dernière version des instructions et des tâches pour l’audit de groupe. <br>Une équipe doit être associée à votre mission pour recevoir les instructions et les tâches pour l’audit de groupe. La dernière version sera disponible dans la mission lorsque l’équipe l’aura acceptée. ",
    notSentYet: "Aucune version envoyée pour le moment",
    notLinkedYet: "Demande de lien non envoyée",
    cardView: "Vue Carte",
    noItemsPlaceholder: "Aucune version n’a encore été publiée. Publiez une version des instructions et des tâches pour l’audit de groupe pour afficher les données ici. ",

    //GA Instructions
    customizeGroupInstructions: "Personnaliser les instructions pour l’audit de groupe",
    gaInstructionsIntro: "Les instructions pour l’audit de groupe selon la MMA d’EY sont intégrées par défaut. Elles visent à instruire les équipes zonales et les équipes affectées à l’audit des composantes des principales informations, de l’étendue des travaux et des procédures dont la mise en œuvre est centralisée. Personnalisez les instructions de la MMA d’EY, ajoutez des instructions supplémentaires au besoin et indiquez pour chaque instruction si elle doit être assignée à une étendue ou à une équipe. Lorsque vous avez terminé, publiez les instructions afin qu’elles puissent être appliquées aux étendues spécifiées ou aux équipes concernées. ",
    addInstruction: "Ajouter une instruction",
    instruction: "Instruction",
    groupTaskSelected: "Tâche pour l’audit de groupe",
    assignScopes: "Attribuer aux étendues ",
    assignTeams: "Attribuer aux équipes ",
    maxLengthMessage: "Le texte ne doit pas dépasser <b>500<b> caractères.",
    addScope: "Ajouter une étendue ",
    editInstruction: "Modifier l’instruction personnalisée",
    editKnowledgeInstruction: "Modifier l’instruction de la base de connaissances",
    editKnowledgeTask: "Modifier la tâche de base de connaissances ",
    editCustomTask: "Modifier la tâche personnalisée",
    saveChangesInstruction: "Enregistrer les modifications",
    updatedOnInstruction: "Dernière modification :",
    knowledgeDescriptionInstruction: "Description de la base de connaissances",
    editDisabledTitle: "Vous devez disposer de l’autorisation <b>Gérer le groupe</b> pour effectuer cette action. Communiquez avec l’administrateur de la mission pour demander une autorisation.",
    deleteCustomInstruction: "Supprimer l’instruction",
    deleteGroupTask: "Supprimer la tâche pour l’audit de groupe",
    areYouSureDeleteCustomInstruction: "Voulez-vous vraiment supprimer cette instruction personnalisée?",
    areYouSureDeleteCustomTask: "Voulez-vous vraiment supprimer cette tâche personnalisée?",
    publishAfterDelete: "Si vous supprimez cette instruction, vous devez publier vos modifications et renvoyer l’ensemble des instructions nouvellement publiées aux équipes concernées et aux étendues des travaux spécifiées.",
    publishAfterDeleteGroupTask: "Si vous supprimez cette tâche pour l’audit de groupe, vous devez publier vos modifications et renvoyer l’ensemble des tâches nouvellement publiées aux équipes concernées et aux étendues des travaux spécifiés.",
    resendPublishInformation: "Vous pouvez publier vos modifications à cette étape et renvoyer l’ensemble des instructions nouvellement publiées à partir de la synthèse. ",
    resendPublishInformationGroupTask: "Vous pouvez publier vos modifications à cette étape et renvoyer l’ensemble des tâches nouvellement publiées à partir de la synthèse. ",
    compareVersionsNoVersionSelectedTitle: "Aucune version n’a été sélectionnée aux fins de comparaison!",
    compareVersionsNoVersionSelectedSubtitle: "Dans le menu déroulant, veuillez sélectionner la version à comparer avec la version la plus récente.  ",

    //Add Section
    addSection: "Ajouter une section",
    addSectionInstructionalText: "Ajouter une section pour organiser vos instructions personnalisées. ",
    addSectionPlaceholder: "Nom de la section",

    //Edit Section
    editSection: "Modifier le nom de la section",
    editSectionInstructionalText: "Modifier le nom de cette section personnalisée. <br> Lorsque vous aurez terminé, publiez vos changements pour envoyer une version mise à jour aux équipes concernées et aux étendues des travaux spécifiées. ",
    editSectionSave: "Enregistrer les modifications",

    //Delete Section
    deleteCustomSection: "Supprimer la section",
    areYouSureDeleteCustomSection: "Voulez-vous vraiment supprimer cette section?<br>Toutes les instructions de cette section seront supprimées. Lorsque vous aurez terminé, publiez vos changements pour envoyer une version mise à jour aux équipes et aux étendues des travaux sélectionnées.",
    customSection: "Section",

    //Publish Changes
    publishChanges: "Publier les modifications",
    publishChangesInstructional: "Voulez-vous vraiment publier les modifications apportées à l’ensemble des instructions et tâches existant?<br><br> L’ensemble d’instructions et de tâches précédent sera écrasé. Une fois que vous aurez publié vos modifications, vous pourrez envoyer l’ensemble d’instructions et de tâches mis à jour à partir de la synthèse.",
    publishChangesNotAvailable: "Pas encore disponible",

    //GA Tasks
    costomizeGroupTasks: "Personnaliser les tâches pour le groupe",
    gaTasksIntro: "Les tâches pour l’audit de groupe selon la MMA d’EY sont intégrées par défaut et envoyées aux missions qui ont été liées. Personnalisez les tâches de la MMA d’EY, ajoutez des tâches supplémentaires au besoin et indiquez pour chaque tâche si elle doit être assignée une étendue ou à une équipe. Lorsque vous avez terminé, publiez les tâches afin qu’elles puissent être appliquées aux étendues spécifiées ou aux équipes concernées. ",
    addCustomTask: "Ajouter une tâche personnalisée ",
    groupTask: "Tâches pour le groupe",
    gaTasks: "Tâches",
    attachments: "Pièces jointes",
    notAvailable: "Non disponible",
    gaDocument: "document",
    gaDocuments: "documents",
    gaScope: "étendue",
    gaScopes: "étendues",
    gaScopesCapitalized: "Étendues",
    gaTeam: "équipe",
    gaTeams: "équipes",
    gaUnassignedScopeTeam: "Non attribuées",
    hideDetails: "Masquer les détails",
    gaAssignedScopes: "Étendues déterminées",
    gaAssignedTeams: "Équipes affectées ",
    addTask: 'New task',
    due: "Échéance",
    noAttachments: "Aucune pièce jointe n’a été ajoutée.",

    // Chip component
    chipMore: "plus",

    // GS Group Summary labels
    assignedTeam: "Équipe affectée",
    lastPublished: "Dernière publication",
    versionStatus: "État de la version",
    lastSent: "Dernier envoi",
    lastSentTooltip: "Il s’agit de la date à laquelle la version la plus récente des instructions et des tâches a été envoyée à chaque équipe. Cliquez sur la date pour afficher la version envoyée à l’équipe. ",
    lastSentBeforeTooltip: "Une nouvelle version des instructions et des tâches est disponible pour <b><<nom de l’étendue>><b>. Déterminez si vous devriez envoyer la version la plus récente à cette équipe.",
    groupSummary: "Synthèse de l’audit de groupe",
    summarySubTitle: "Passez en revue la version la plus récente des instructions et des tâches assignées à chaque étendue ou à chaque équipe ci-après. Pour envoyer cette version aux équipes concernées et aux étendues spécifiées, sélectionnez <b>Envoyer la version</b>.<br/>. La version envoyée à une équipe donnée peut aussi être affichée en sélectionnant la date d’envoi pertinente.",
    compareVersions: "Comparer les versions",
    sendVersion: "Envoyer la version",
    compareVersionsInstructional: "Comparez la version la plus récente des instructions et des tâches publiée par rapport à la version envoyée à une équipe afin de relever les différences. S’il existe des différences entre les versions, déterminez si une nouvelle version doit être envoyée à l’équipe. ",
    publishedVersion: "Version publiée",
    sentVersion: "Version envoyée",
    emptyPublishedVersion: "Il n’y a aucune étendue disponible. <br/>Les étendues attribuées aux équipes affectées à l’audit des composantes figurent dans la liste qui suit.",
    emptySentVersion: "Aucune équipe disponible.",
    selectPublishedVersion: "Sélectionnez une version publiée pour afficher les données ici. ",
    selectSentVersion: "Sélectionnez une version envoyée pour afficher les données ici. ",
    dueDate: "Date d’échéance",
    emptyPublishedSnapshot: "Aucune version publiée des instructions et des tâches n’est disponible pour l’étendue sélectionnée. <br/>Publiez une version pour afficher les données ici.",
    emptySentSnapshot: "Les instructions et les tâches n’ont pas été envoyées à l’équipe sélectionnée. <br/>Publiez les instructions et les tâches et envoyez-les à cette équipe pour afficher les données ici.",
    update: "Mise à jour ",
    updates: "Mises à jour",
    noTeamsPlaceholder: "Aucun espace réservé pour les équipes",
    noTeamSelected: "Vous devez sélectionner au moins une étendue ou une équipe pour continuer.",
    latestVersionAlreadySent: "Aucune équipe n’a encore été créée. Vous devez créer au moins une équipe pour publier une version des instructions et des tâches.",
    latestHasBeenSended: "La version la plus récente des instructions et des tâches a déjà été envoyée à cette équipe",
    noNewVersionToSend: "Les étendues ou les équipes sélectionnées ont déjà reçu la dernière version des instructions et des tâches. Il n’y a pas de nouvelle version à envoyer.",
    notSelectedTask: "Non sélectionnée",
    assignedTeams: "Équipes affectées",
    noTeamsCreatedYet: "Aucune équipe n’a encore été créée. Vous devez créer au moins une équipe pour publier une version des instructions et des tâches.",
    newersTeamsSended: "La version la plus récente des instructions et des tâches a déjà été envoyée aux équipes concernées et aux étendues des travaux spécifiées. ",
    LinkRequestNotSent: "Demande de lien non envoyée",
    lastVersionSentInstructionalText: "La version des tâches et des instructions envoyée à <b>{teamName}</b> le <b>{sentDate}</b> est affichée ci-après. Il s’agit de la version la plus récente envoyée à cette équipe.",

    // ReceiveInstructions labels
    receiveInstructionsTitle: "Version {versionType} des instructions pour le groupe et des tâches",
    receiveInstructionsInstructional: "{primaryEng} a envoyé la version {versionType} des instructions pour le groupe et des tâches le {sentDate}. Passez en revue cette version et choisissez de l’accepter ou de la renvoyer. Vous pouvez utiliser l’option <b>Comparer les versions</b> pour comparer cette version aux versions précédentes.",
    fromLabel: "De",
    assignedScope: "Étendue attribuée",
    dateSent: "Date d’envoi",
    acceptVersion: "Accepter la version",
    returnVersion: "Renvoyer la version",
    returnPrimaryButton: "Retour",
    returnVersionDescription: "Voulez-vous vraiment renvoyer cette version des instructions et des tâches à l’équipe principale? <br>Cette version ne sera pas importée dans votre mission. Ajoutez un commentaire à l’intention de l’équipe principale expliquant votre raisonnement.",
    noContent: "Aucune instruction n’est disponible pour le moment, veuillez réessayer plus tard ou communiquer avec le Service de dépannage.",
    editorPlaceHolder: "Commentaire",
    receiveCompareVersionInstructional: "Comparez la version sélectionnée des instructions et des tâches reçue de {primaryEng} à une version antérieure pour relever les différences.",
    latestReceiveCompareVersionInstructional: "Comparez la version la plus récente des instructions et des tâches reçue de {primaryEng} à une version antérieure pour relever les différences.",
    latestVersion: "Version la plus récente",
    earlierVersion: "Version antérieure",
    earlierVersionEmpty: "Il n’y a aucune version antérieure disponible aux fins de comparaison.",
    selectEarlierVersion: "Sélectionnez une version antérieure pour afficher les données ici.",
    pstName: "Passer en revue les instructions de la mission pour l’audit de groupe.  ",
    pstDescription: "Passer en revue les instructions pour l’audit de groupe. Réaliser les tâches pour l’audit de groupe sous « Exécution − Général ». Ces tâches ont été ajoutées à la liste des tâches au moment de l’acceptation des instructions pour l’audit de groupe.",
    selectedVersion: "Version sélectionnée",
    issuingEngagement: "Transmission de la mission en cours",
    accountsAndDisclosureLink: "Compte et information à fournir",
    openRiskAssessmentDocuments: "Ouvrir les documents relatifs à l’évaluation des risques",
    openRiskAssessmentDocument: "Ouvrir le document relatif à l’évaluation des risques",

    //Client engagement name labels
    successQueueMessage: "Le nom d’affichage de la mission a bien été mis à jour dans le portail client d’EY Canvas.",
    clientEngagementInstructionalText: "Ajouter ou modifier un nom d’affichage de mission personnalisé ici. Les membres de l’équipe externe qui ont accès à cette mission dans le portail client d’EY Canvas pourront voir ce nom.",
    clientEngagementPlaceholder: "Nom d’affichage de la mission",
    clientEngagementModalTitle: "Nom d’affichage de la mission dans le portail client d’EY Canvas",
    clientDisplayName: "Nom d’affichage client",
    textExceedsLength: "Le texte ne doit pas dépasser 100 caractères.",

    // Manage client access locations
    location: "Emplacement",
    locationName: "Nom de l’emplacement",
    accessLocations: "Points d’accès",
    inputType: "Type d’entrée",
    ipAddress: "Adresse IP",
    ipAddresses: "Adresses IP",
    startOfIpRange: "Début de la plage d’adresses IP",
    endOfIpRange: "Fin de la plage d’adresses IP",
    cidrNotation: "Notation CIDR",
    manageClientAccessLocationsLink: "Ajouter un point d’accès",
    manageClientAccessLocationsModalTitle: "Gérer les points d’accès du client",
    manageClientAccessLocationsInstructionalText: "Ajouter les adresses IP à la liste ci-dessous pour activer les accès par emplacement au portail client d’EY Canvas. <br>Lorsque les points d’accès des clients sont activés, seuls les membres de l’équipe externe dont l’adresse IP figure dans la liste auront accès à la mission. Si aucune adresse IP n’a été ajoutée, les membres de l’équipe externes pourront accéder à cette mission à partir de n’importe quelle adresse IP.<br> Cliquez <b>ici<b> pour en apprendre davantage.",
    manageClientAccessLocationsNoResultFound: "Aucune adresse IP n’a été ajoutée pour cette mission. Les membres de l’équipe internes et externes peuvent accéder à la mission à partir de n’importe quel emplacement.",
    deleteAccessLocations: "Supprimer les points d’accès ",
    deleteAccessLocationsInstructionalText: "Voulez-vous vraiment supprimer le point d’accès sélectionné? <b>Si un membre de l’équipe externe essaie d’accéder au portail client d’EY Canvas à partir de ce point d’accès, il n’aura plus accès à cette mission.",
    locationLengthError: "Le nom de l’emplacement ne doit pas dépasser 100 caractères.",
    oneOrMoreIpAddressFormatError: "Une ou plusieurs adresses IP fournies ne sont pas valides.",
    ipAddressFormatError: "L’adresse IP fournie n’est pas valide.",
    ipSuffixError: "Le suffixe CIDR de l’adresse IP doit être un nombre décimal qui est ≥ à 1 et ≤ à 32.",
    ipRangeStartSmallerThanEnd: "Le num. de l’adresse IP de début doit être inférieur au num. de l’adresse IP de fin.",
    ipInputTypeInfo: "Sélectionner Adresse IP pour entrer une adresse IP unique ou une liste d’adresses IP. Seules les adresses IPv4 sont prises en charge. <br>Sélectionner Plage d’adresses IP pour entrer une plage d’adresses IP ayant le même préfixe réseau (c.-à-d., les trois premiers segments de l’adresse IP). <br>Sélectionner Bloc CIDR pour entrer une plage d’adresses IP avec une notation CIDR. Seules les adresses CIDR sont prises en charge.   ",
    ipAddressInfo: "Vous pouvez entrer les adresses IP sur une même ligne en les séparant par des virgules ou sous forme de liste, chaque adresse IP figurant sur une ligne séparée. <br>Une adresse IPv4 valide est composée de quatre nombres entiers compris entre 0 et 255, séparés par des points.",
    ipCidrInfo: "Entrer la notation CIDR représentant une plage d’adresses IP qui devraient pouvoir accéder à cette mission. <br>Une notation CIDR valide est composée d’une adresse IPv4 valide, d’une barre oblique (/) et d’un nombre décimal, dont le suffixe est ≥ à 1 et ≤ à 32.",
    ipAddressEg: "p. ex. 192.XXX.X.1 192.XXX.X.2",
    ipRangeStartEg: "p. ex. 192.XXX.X.1",
    ipRangeEndEg: "p. ex. 192.XXX.X.2",
    ipCidrEg: "p. ex. 192.XXX.X.1/22",
    searchIpPlaceholder: "Vérifier l’adresse IP",
    ipNotAddedMessage: "n’a pas été ajoutée à la liste des adresses IP autorisées.",
    ipIsAllowedMessage: "L’adresse IP est autorisée.",
    importAccessLocationsLink: "Importer des points d’accès",
    importAccessLocationsInstructionalText: "Les points d’accès peuvent être importés de votre mission précédente. <br>Voulez-vous vraiment importer les points d’accès? ",
    importAccessLocationsCloseButton: "Fermer",
    importAccessLocationsCancelButton: "Annuler",

    // Export Requests
    exportRequests: "Demandes d’exportation",

    // Add custom request labels
    addCustomRequestModal: {
        titleTip: "Nouvelle demande",
        titleTipAddButton: "Ajouter un nouveau",
        closeTitleTip: "Fermer",
        modalTitle: "Nouvelle demande",
        returnModalTitle: "Renvoyer la demande",
        modalHeader: "Ajouter une nouvelle demande à envoyer vers le portail client d’EY Canvas",
        requiredAssignedTo: "(obligatoire)",
        assignToError: "Le champ Attribuée à est requis.",
        dueDate: "Date d’échéance (requise)",
        dueDateError: "La date d’échéance est requise",
        titlePlaceholder: "Titre (requis)",
        titleError: "Le titre est requis",
        description: "Description",
        descriptionplaceholder: "Entrer une description",
        descriptionError: "La description de la demande dépasse la longueur maximale (4 000 caractères)",
        associateDocuments: "Associer les documents",
        emptyAssociatedDocumentsList: "Glisser et déposer un ou plusieurs documents ou cliquer sur Ajouter un document",
        addDocumentButton: "Ajouter un document",
        signOffCheckbox: "Les documents téléversés dans le portail client d’EY Canvas devront être approuvés.",
        sendRequest: "Envoyer une demande",
        returnRequest: "Renvoyer la demande",
        saveAsDraft: "Enregistrer comme projet",
        cancel: "Annuler",
        copyTitleAndDescription: "Copier le titre et la description à partir de la tâche",
        copyAssociatedDocuments: "Copier les documents à partir de la tâche",
        priority: "Priorité de la demande",
        addNewRequestButton: "Ajouter une nouvelle demande",
        addExistingRequestButton: "Ajouter des demandes existantes"
    },
    addCustomEventModal: {
        titleTip: "Nouvel événement",
        closeTitleTip: "Fermer",
        modalTitle: "Nouvel événement",
        eventDate: "Date de l’événement",
        eventDateError: "La date est requise",
        titlePlaceholder: "Titre ",
        titleError: "Le titre est requis",
        description: "Description (facultatif)",
        descriptionplaceholder: "Entrer une description",
        descriptionError: "La description de l’événement dépasse la longueur maximale (4 000 caractères)",
        sendEvent: "Envoyer l’événement",
        saveAsDraft: "Enregistrer l’événement comme ébauche",
        cancel: "Annuler",
        eyParticipantsCollaborationError: "Au moins un participant d’EY est requis",
        externalParticipantsCollaborationError: "Au moins un participant externe est requis"
    },
    eyHelixInstructionText: "Passez en revue les projets EY Helix associés et les analyseurs suggérés ci-après. <br/> Cliquez sur n’importe quel projet ou analyseur pour accéder à la page EY Helix qui y est associée. ",
    smartAutomationInstrText: "Passez en revue les solutions d’automatisation intelligente que vous utilisez actuellement ci-après. <br/> Cliquez sur une solution pour accéder au Centre d’automatisation intelligente.",
    smartAutomationSolutionsNotAvailable: "Les solutions d’automatisation intelligente ne sont actuellement pas disponibles pour votre mission. ",
    noSmartAutomationAvailable: "Aucune solution d’automatisation intelligente n’est disponible pour votre mission. ",
    availableSolutions: "Solutions disponibles",
    useOfSuggestedSolutions: "Utilisation des solutions suggérées",
    useOfOtherSolutions: "Utilisation d’autres solutions",
    suggestedSolutions: "Solutions suggérées",
    otherSolutions: "Autres solutions",
    currentlyusing: "En cours d’utilisation",
    suggested: "suggérée",
    primaryProject: "Project principal",
    noLinkedProjects: "Aucun projet associé pour votre mission.",
    noSuggestedAnalyzers: "Aucun analyseur suggéré pour votre mission.",
    eyHelixNotAvailable: "EY Helix non disponible",
    helixNotAvailableMessage: "EY Helix n’est actuellement pas disponible pour votre mission. ",

    noGroupTaskCreatedYet: "Aucune tâche pour le groupe n’a encore été créée.",
    noInstructionsCreatedYet: "Aucune instruction n’a encore été créée.",
    documentsReceived: "Documents reçus",
    documentsPending: "Documents en attente",

    teamLabel: "Équipe",
    scopeLabel: "Étendue",

    documentSignOffby: "Document approuvé par",
    documentAddedBy: "Document ajouté par",
    documentModifiedBy: "Document modifié par",
    documentDeletedBy: "Document supprimé par ",
    commentAddedBy: "Note ajoutée par",
    commentClearedBy: "Note réglée par",
    commentClosedBy: "Note fermée par",
    commentReopenedBy: "Note rouverte par",

    documentAssignedTo: "Document attribué à ",
    draftDocReceivedFrom: "Version provisoire du document reçue de ",
    finalDocReceivedFrom: "Version finale du document reçue de ",
    documentReturnedBy: "Document retourné par",
    returnedDocumentClearedBy: "Document retourné effacé par ",
    documentConflictResolvedBy: "Conflit lié au document résolu par",
    draftDocumentSentBy: "Version provisoire du document envoyée par ",
    documentReturnedFrom: "Document retourné de la part de ",
    finalDocumentSentBy: "Version finale du document envoyée par",
    noActivityAvailable: "Aucune activité disponible.",
    allEngagementFilterLabel: "Toutes les autres missions",
    otherEngagementComments: "Autres notes relatives à la mission",
    engagements: "Missions",
    engagement: "Mission",
    view: "Afficher",
    notesModalInstructionalText: "Afficher les notes pour le document/la tâche {0} sélectionné(e) ci-après et y répondre.",

    //New collaboration Related Labels
    searchRelateFileNoMatchesFound: "Aucun résultat. Veuillez réessayer.",

    //New collaboration Related tasks
    relatedTasksLabel: "Tâches associées",
    selectRelatedTasks: "Sélectionner la tâche",
    searchAndPressEnter: "Rechercher et appuyer sur Entrée",
    noRelatedTasksSelected: "Aucune tâche associée sélectionnée",
    relatedTasksCount: "tâches associées",
    notFoundTasks: "Tâche introuvable",
    dueDateDetailLabel: "Date d’échéance",
    requestType2MessageTitle: "Cette demande s’ouvrira dans un nouvel onglet.",
    requestType2MessageSubtitle: "Actualisez la page pour voir les changements apportés.",
    requestType2InTrnasitMessageTitle: "Cette demande ne peut pas être ouverte, car elle en transit.",
    requestType2InTrnasitMessageSubtitle: "Attendez que la synchronisation soit terminée, puis actualisez la page et réessayez.",

    //New collaboration Time Phase
    selectTimePhase: "Sélectionner la période",
    timePhaseNotFound: "Période introuvable",

    understandITProcess: "Comprendre les processus informatiques",

    //New collaboration Access Location
    accessLocationLabel: "Emplacement d’accès activé",
    accessLocationTitle: "Seuls les utilisateurs se connectant à partir d’un emplacement réseau autorisé auront accès au portail client d’EY Canvas pour cette mission. Les emplacements autorisés peuvent être gérés à partir de la page Emplacements d’accès dans le menu des options.",

    // Reporting Labels
    summaryScreenLabel: "Écran de synthèse",
    dataExportLabel: "Exportation des données",
    projectManagementLabel: "Gestion de projet",
    reportingHeaderName: "Rapport",
    repAllTasks: "Toutes les tâches",
    repDeletedTasks: "Tâches supprimées",
    repMultiEntityTasks: "Tâches entités multiples",
    repAllAuditPlan: "Plan de mission",
    repITAppSOSummary: "Synthèse TI/SS",
    repITProcessScotControls: "Processus informatique, catégorie d’opérations importante et contrôles",
    repTaskAssignments: "Tâches attribuées",
    repTaskDetails: "Détails de la tâche",
    repTaskAnalysis: "Analyse de la tâche",
    repTaskSummary: "Synthèse de la tâche (projet pilote)",
    repExportToExcel: "Exporter des données",
    repExportDate: "Date de l’exportation",
    repEngInfo: "Renseignements relatifs à la mission",
    repNoRecordMessage: "Aucun enregistrement à afficher",
    dateInUTC: "UTC",
    repSCOTsControls: "Catégories d’opérations importantes et contrôles",
    repITProcessSummary: "Synthèse du processus informatique",
    repCanvasForms: "Formulaires Canvas",
    repControlForms: "Formulaires sur les contrôles",
    projectInsight: "Aperçu du projet ",
    archiveForm: "Formulaire d’archivage",
    archive: "Archiver ",
    repCanvasFormResponse: "Réponses du formulaire Canvas",
    repCanvasFormRelatedComments: "Commentaires associés",
    repControlFormResponse: "Réponses fournies dans le formulaire sur les contrôles",
    repNoRecordFound: "Aucun enregistrement trouvé",
    repCanvasFormsIncomplete: "Réponses incomplètes",
    repCanvasFormRelatedObjects: "Objets associés",
    voiceNoteLabel: "Note vocale",
    repComponentTeamGroup: "Équipe affectée à l’audit de la composante",
    componentTeamCanvasFormExport: "Exportation des formulaires Canvas",

    // Reporting Tasks
    repTaskTitle: "Titre de la tâche",
    repTaskDescription: "Description de la tâche",
    repTaskSource: "Source de la tâche",
    repTaskNature: "Nature de la tâche",
    repTaskCloseEarly: "À l’avance",
    repTaskCloseLate: "En retard",

    // Reporting Documents
    repAllDocuments: "Tous les documents",
    repSignOffs: "Approbation",
    repDocumentsModified: "Documents modifiés après la date de délivrance du rapport",

    //Reporting Collaboration
    repRequestsAndTasks: "Demandes et tâches",
    repRequestsTasksComments: "Commentaires associés aux demandes/tâches",

    SCOTSummaryReportHeader: "Synthèse des catégories d’opérations importantes",
    GroupReportHeader: "Rapport sur l’audit de groupe",
    SCOTSummaryEffective: "Efficace",
    GroupInstructionSummary: "Synthèse des instructions relatives à l’audit de groupe",
    GroupActivity: "Historique du mappage des comptes des composantes",
    SEMReportHeader: "Matrice SEM",
    GroupComponentAccountReportHeader: "Mappage des comptes des composantes du groupe",
    AccountDisclosuresReportHeader: "Comptes et informations à fournir",

    //Reporting Collaboation Details
    collaborationDetails: "Détails de la collaboration",
    collaborationSummary: "Synthèse",
    collaborationActivity: "Détails de l’activité",
    ReviewNotesReportHeader: "Notes de revue",

    GroupStructureSummary: "Synthèse de la structure de l’audit de groupe",

    //Reporting CRT Summary
    wcgwSummary: "Synthèse des erreurs possibles",
    crtlabel: "Outil de revue des contrôles",
    assertionSummary: "Synthèse des assertions",
    scotSummary: "Synthèse des catégories d’opérations importantes",
    noRecordsToExport: "Aucun enregistrement à exporter",
    statisticsSummary: "Statistiques",
    qualityChecks: "Contrôles qualité",
    controlSummary: "Synthèse des contrôles",
    filterBySCOT: "Filtrer par catégorie d’opérations importante",

    //Reporting manage team
    independenceSummaryReportTabName: "Sommaire de l’information relative à l’indépendance",

    //MEST dashboard
    viewAllRiskTypesAndAssertions: "Afficher tous les types de risque et toutes les assertions",
    riskRelatedToAssertion: "Risque associé à l’assertion",
    higherRiskRelatedToAssertion: "Risque élevé associé à l’assertion",
    noRisksAvailable: "Aucun risque disponible",
    relatedEstimates: "Estimations associées",
    viewAllAssertions: "Afficher toutes les assertions",
    wcgwRelatedToAssertion: "Erreurs possibles liées à l’assertion",
    noWcgwsAvailable: "Aucune erreur possible disponible",
    goTo: "Accéder à ",
    allItems: "Tous les éléments",

    // Create TimePhase Labels
    createTimePhaseLabels: {
        modalTitle: "Ajouter une période",
        modalDescription: "Ajoutez les attributs et cliquez sur Enregistrer et fermer ou Enregistrer et ajouter.",
        timephaseNameLabel: "Nom de la période",
        milestoneSelectLabel: "Jalon",
        timephaseLabel: "Période",
        startDateLabel: "Date de début",
        endDateLabel: "Date de fin",
        startDateErrorMessage: "La date de début est requise.",
        endDateErrorMessage: "La date de fin est requise.",
        timephaseNameErrorMessage: "Un nom est requis.",
        milestoneErrorMessage: "Le jalon est requis.",
        isKeyEvent: "Événement clé",
        timephaseDescription: "Description (facultatif) ",
        addSuccessMessage: "La période a bien été ajoutée."
    },

    AccountListHeaderLabels: {
        pspAndosp: "PCB/APC",
        limitRiskAssertionLabel: "Compte présentant un risque limité",
        heading: "Comptes et informations à fournir et assertions associées",
        accountsOrDisclosure: "Comptes et informations à fournir",
        psps: "PCB  ",
        rejected: "Rejetées",
        remove: "Retirer",
        risks: "Risques",
        assertions: "Assertions",
        noRecordsFound: "Aucun compte ni aucune information à fournir disponible",
        noResultsFound: "Aucun résultat",
        responsiveHeading: "Réponse",
        rejectedPspsHeading: "PCB rejetées",
        importPsps: "Importer des PCB",
        importOsps: "Importer des APC",
        addOsps: "Ajouter des APC",
        pspEnded: "pour commencer.",
        noPspsandOsps: "Aucune {0} disponible.",
        allAreRejected: "Toutes les PCB ont été rejetées",
        rejectButton: "Rejeter",
        acceptButton: "Accepter",
        additionalInfo: "Justification :",
        noAssertionsAvailableLabel: "Aucune assertion disponible",
        noAssertionAvailableTooltip: "Aucune assertion disponible. Cliquez sur <strong>Gérer les comptes et les informations à fournir</strong> pour ajouter des assertions.",
        importFromKnowledge: "Importer de la base de connaissances",
        disabledAddOspTooltip: "Au moins une assertion doit être disponible pour ajouter une tâche Corroboration. Cliquez sur <strong>Gérer les comptes et les informations à fournir</strong> pour ajouter des assertions.",
        noPsps: "Aucune PCB disponible. {0} pour commencer.",
        noOspsPsps: "Aucune PCB/APC disponible. {0}, {1}, ou {2} pour commencer.",
        acceptErrorMsg: "Impossible d’accepter la tâche rejetée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
        build7NoPspOrOspAttachedToAssertion: "Chaque assertion doit être associée à au moins une procédure de corroboration pertinente. Les assertions suivantes ne sont associées à aucune PCB/APC pertinente : <b>{orphanAssertions}</b>. {0}, {1} ou ajoutez une {2} pour toutes les assertions relatives à ce compte, ou encore cliquez sur l’icône de modification lié aux PCB/APC actuelles se rapportant à ce compte afin de les associer à d’autres assertions. ",
        build7NoPspOrOsp: "Chaque assertion doit être associée à au moins une procédure de corroboration pertinente. Aucune des assertions n’est associée à des PCB/APC pertinentes. {0}, {1} ou créer une {2} pour toutes les assertions relatives à ce compte.",
        build7NoOspsAndAllPspAreRejected: "Chaque assertion doit être associée à au moins une procédure de corroboration pertinente. Toutes les PCB ont été rejetées et aucune des assertions n’est associée à des PCB/APC pertinentes. {0} ou créer une {1} pour toutes les assertions relatives à ce compte.",
        build6And7NoAssertions: "Chaque compte important ou information à fournir importante doit être associé à au moins une assertion disponible pour pouvoir ajouter une procédure de corroboration. Cliquez sur {0} pour ajouter des assertions. ",
        build7LimitedAccountNoPspOsp: "Chaque compte présentant un risque limité doit être associé à au moins une procédure de corroboration pertinente. {0} ou créer une {1} pour répondre aux risques de ce compte.",
        manageAccountAndDisclosures: "Gérer les comptes et les informations à fournir"
    },

    AddTaskLabels: {
        accountLabel: "Compte :",
        taskSectionLabel: "Section de tâches :",
        ospModelTitle: "Nouvelle APC",
        ostModelTitle: "Nouvelle ATS",
        saveAndClose: "Enregistrer",
        saveAndCreate: "Enregistrer et créer une autre procédure",
        cancel: "Annuler",
        prefix: "Préfixe",
        title: "Titre",
        suffix: "Suffixe",
        timePhase: "Période",
        description: "Description personnalisée",
        descriptionPlaceholder: "Description de la tâche personnalisée (obligatoire)",
        assertions: "Assertions",
        optional: "(facultatif)",
        required: "Obligatoire",
        noResultFound: "Aucun résultat",
        of: "de",
        characters: "caractères",
        descriptionMaxLengthError: "La longueur de la description dépasse la longueur maximale permise",
        noteDiscriptionErrorMessage: "La réponse contient {0} caractères, ce qui dépasse la longueur maximale de {1} caractères. Veuillez réduire la description ou ajuster le formatage puis réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
        customizeDescription: "Description de la tâche personnalisée (obligatoire)",
        errorMsg: "Échec de l’ajout de l’APC. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
        customizeTaskDescription: "Personnaliser la description de la tâche"
    },

    RemoveTaskLabels: {
        modelOspTitle: "Supprimer l’APC",
        modelOstTitle: "Supprimer l’ATS",
        deleteBtn: "Supprimer",
        cancel: "Annuler",
        confimationOspMsg: "Voulez-vous vraiment supprimer l’APC sélectionnée?",
        confimationOstMsg: "Voulez-vous vraiment supprimer l’ATS sélectionnée?",
        warning1Msg: "Les éléments probants correspondants qui ne sont associés à aucune autre tâche de cette mission seront déplacés dans les fichiers temporaires.",
        warning2Msg: "Les constatations et tâches Réponse qui ne sont associées à aucun autre élément probant seront supprimées."
    },

    TaskReportHeaderLabels: {
        Tasktype: "Type de tâche",
        Taskstatus: "État de la tâche",
        Taskassignedto: "Tâche attribuée à",
        Tasktitleprefix: "Préfixe du titre de la tâche",
        Tasktitle: "Titre de la tâche",
        Tasktitlesuffix: "Suffixe du titre de la tâche",
        Taskdescription: "Description de la tâche",
        Knowledgetasktitle: "Titre de la tâche de la base de connaissances ",
        Knowledgetaskdescription: "Description de la tâche de la base de connaissances",
        Oldtaskname: "Nom de l’ancienne tâche",
        Oldtaskdetail: "Détails de l’ancienne tâche",
        Rejected: "Rejetée",
        Rationalforrejection: "Raison du rejet",
        Auditphase: "Phase de l’audit",
        Timephasetype: "Jalon",
        Timephase: "Période",
        Timephasestartdate: "Date de début de la période",
        Timephaseduedate: "Date d’échéance de la période",
        Keyevent: "Événement clé",
        Tasksource: "Source de la tâche",
        Tasknature: "Nature de la tâche",
        Lasttaskstatuschangedate: "Date de la dernière modification apportée à l’état de la tâche",
        Taggroup: "Groupe de balises",
        Tags: "Balises",
        RelatedMESTentities: "Entités MEST associées",
        Schedulednextwaveservices: "Services NextWave prévus",
        Priority: "Priorité",
        Taskid: "Code de la tâche",
        Roleid: "Code du rôle",
        Tasktypeid: "Code du type de tâche",
        Taskstatusid: "Code de l’état de la tâche",
        Auditphaseid: "Code de la phase de l’audit",
        Timephasetypeid: "Code du jalon",
        Tasksourceid: "Code de la source de la tâche",
        Tasknatureid: "Code de la nature de la tâche"
    },

    glAccountDocumentLabels: {
        modelTitle: "Compte GL",
        modelName: "Associer les éléments probants",
        documentName: "Nom du document",
        documentCounter: "{0} document",
        documentsCounter: "{0} documents",
        btnCancel: "Annuler",
        btnSave: "Enregistrer",
        errorMessage: "Sélectionner un document pour continuer.",
        noResultsFound: "Aucun résultat",
        newTickMark: "Nouvelle marque de pointage",
        bulkModePlaceholder: "Sélectionnez un élément probant à associer et cliquez sur <strong>\'Enregistrer\'</strong> pour terminer."
    },

    // Edit TimePhase Labels
    editTimePhaseLabels: {
        modalTitle: "Modifier la période",
        modalDescription: "Modifiez les attributs et cliquez sur <b>Enregistrer</b>.",
        editSuccessMessage: "La période a bien été mise à jour."
    },

    // Delete TimePhase Labels
    deleteTimePhaseLabels: {
        deleteTimePhaseModalTitle: "Supprimer la période",
        deleteDescription: "Voulez-vous vraiment supprimer cette période?",
        showTimePhaseName: "Période",
        showMileStone: "Jalon",
        showStartDate: "Date de début",
        showEndDate: "Date de fin",
        showDescription: "Description :",
        showAssignedTasks: "Nombre de tâches attribuées",
        showAssignedAssignments: "Nombre d’affectations",
        deleteSuccessMessage: "La période a bien été supprimée."
    },

    // Create Tag Labels
    createTagGrouplabels: {
        modalTitle: "Ajouter un groupe de balises",
        modalDescription: "Entrez un nom et cliquez sur Enregistrer et fermer ou sur Enregistrer et ajouter pour continuer.",
        tagGroupNameLabel: "Groupe de balises",
        tagGroupNameErrorMessage: "Groupe de balises requis",
        saveAndClose: "Enregistrer et fermer",
        saveAndAdd: "Enregistrer et ajouter",
        addSuccessMessage: "Le groupe de balises a bien été ajouté."
    },

    // Bulk Tags
    tags: {
        noTagsAvailabel: "Aucune balise disponible",
        deleteTag: "Supprimer la balise",
        deleteDescription: "La suppression d’une balise ne peut pas être annulée, voulez-vous vraiment continuer?",
        showDeleteTagName: "Balise",
        showDeleteTagGroupName: "Groupe de balises",
        showAssignedTasks: "Tâches attribuées",
        deleteSuccessMessage: "La balise a bien été supprimée.",
        task: "Tâche",
        tasks: "Tâches  ",
        addTagGrouplabels: "Ajouter un groupe de balises",
        addTag: "Ajouter une balise",
        action: "Action ",
        addTagDesc: "<h3>Ajouter une balise</h3><p>Cliquez sur Ajouter un groupe de balises pour créer un nouveau groupe de balises qui peut être utilisé pour ajouter des balises.</p>",
        assignTagDesc: "<h3>Assigner des balises</h3><p>Glissez et déposez les éléments sélectionnés sur la balise visée sous un groupe de balises.</p> ",
        editTagDesc: "<h3>Modifier des balises</h3><p>Cliquez sur le menu de débordement (trois points) et sélectionnez Modifier pour modifer les propriétés de la balise.</p> ",
        deleteTagDesc: "<h3>Supprimer des balises</h3><p>Cliquez sur le menu d’options (trois points) et sélectionnez Supprimer pour supprimer la balise.</p>",
        removeTagDesc: "<h3>Retirer une balise</h3><p>Pour retirer une balise, glissez un ou plusieurs éléments associés à une balise existante vers le nom de la balise figurant sous un groupe de balises.</p> ",
        expand: "Développer",
        collapse: "Réduire",
        TagName: "Nom de la balise",
        TagGroupName: "Nom du groupe de balises",
        addTagSuccessMessage: "La balise a bien été ajoutée.",
        editTagSuccessMessage: "La balise a bien été mise à jour.",
        addTagModalTitle: "Ajouter la balise à",
        editTagModalTitle: "Modifier la balise  ",
        addTagModalDescription: "Créez une nouvelle balise et cliquez sur Enregistrer et fermer ou sur Enregistrer et ajouter pour continuer.",
        editTagModalDescription: "Modifier les attributs et cliquer sur <b>Enregistrer.</b> ",
        tagSetSuccessMessage: "balise définie avec succès.",
        tagsSetSuccessMessage: "balises définies avec succès.",
        tagRemoveSuccessMessage: "balise retirée avec succès.",
        tagsRemoveSuccessMessage: "balises retirées avec succès.",
        tagRemovedSuccessfully: "Balise retirée avec succès."
    },

    relateEvidenceHeader: "Associez les éléments probants qui fournissent des informations sur l’ajustement.",
    relatedDocumentCounter: "{0} document",
    relatedDocumentsCounter: "{0} documents",
    documentsLocationLabel: "Emplacement des documents",
    relateTemporaryFilesHeader: "Associer un document temporaire à partir de cette mission.",

    // Create Assignment Labels
    addAssignmentlabels: {
        modalTitle: "Ajouter une affectation",
        modalDescription: "Saisissez un nom et cliquez sur Enregistrer lorsque vous avez terminé.",
        assignmentNameLabel: "Nom de l’affectation",
        assignmentNameErrorMessage: "Le champ du nom du document ne peut pas être vide",
        saveAndClose: "Enregistrer et fermer",
        saveAndAdd: "Enregistrer et ajouter",
        addSuccessMessage: "Affectation ajoutée avec succès."
    },
    addUserOrRoleLabelto: "Ajouter un utilisateur ou un rôle à",
    addUserOrRoleheader: "Cherchez le membre de l’équipe ou le rôle que vous voulez ajouter.",
    saveAndAdd: "Enregistrer et ajouter",

    // Bulk Assignment
    BulkActionsLabel: "Actions en bloc",
    BulkAssignmentAction: "Action",
    BulkShow: "Afficher",
    BulkActionsInstructionalText: "Exécutez des opérations en bloc pour les regroupements de tâches en utilisant la fonction glisser et déposer. Pour afficher les tâches individuelles d’un regroupement de tâches, placez votre curseur sur le groupe de tâches et cliquez sur l’icône de la flèche.",
    bulkOperationsModalDescription: "Exécutez des opérations en bloc pour les tâches. Pour afficher les tâches individuelles d’un regroupement de tâches, placez votre curseur sur le groupe de tâches et cliquez sur l’icône de la flèche.",
    selectRequest: "Sélectionnez une réponse à envoyer.",
    replaceLabel: "Remplacer",
    labelStaff: "stagiaire -",
    addModeLabel: "Ajouter",
    replaceModeLabel: "Remplacer",
    dueDateModeLabel: "Mettre à jour le nombre de jours avant l’échéance",
    searchByAssignmentName: "Rechercher",
    addTeamMemberLabel: "Ajouter un membre de l’équipe",
    noTeamMembersFound: "Aucun membre de l’équipe n’est disponible",
    addMemberSuccessMessage: "Le membre a bien été ajouté à l’équipe.",
    addAssignmentLabel: "Ajouter une affectation",
    addAssignmentNameLabel: "Ajouter le nom de l’affectation",
    noAvailableAssignmentsMessage: "Aucune affectation disponible",
    showDuplicateError: "Une affectation en double au membre de l'équipe ou au rôle sélectionné pour la ou les tâches sélectionnées est impossible. Choisissez une autre affectation, un autre membre de l’équipe ou un autre rôle pour continuer.",
    infoBulkAssignments: "Affectations en bloc",
    infoBulkAssignmentDesc: "Sélectionnez un ou plusieurs groupes de tâches pour créer de nouvelles affectations ou remplacer des affectations existantes. Lorsque des affectations sont créées ou modifiées, les affectations en cours d’un membre de l’équipe seront redistribuées en fonction des échéances les plus rapprochées. ",
    infoAssignmentsDueDate: "Définition de la date d’échéance de la ou des affectations",
    infoAssignmentsDueDateDesc: "Utiliser le bouton bascule « Sélectionner la date/Calculer la date » pour définir la date d’échéance des affectations. Le bouton bascule peut être utilisé soit pour préciser la date d’échéance des tâches, soit pour indiquer le nombre de jours restant avant la date de fin de la période. ",
    infoAddAssignmentExisting: "Ajouter une affectation à un membre de l’équipe existant",
    infoAddAssignmentExistingDesc: "Le nombre de jours avant la date d’échéance doit être indiqué pour ajouter des affectations. La date d’échéance exacte peut aussi être définie en utilisant le contrôle de calendrier. Vous pouvez ensuite glisser-déposer les éléments sélectionnés pour créer un nouvel ensemble d’affectations.",
    infoAddAssignmentNew: "Ajouter une affectation à un nouveau membre de l’équipe",
    infoAddAssignmentNewDesc: "Si le membre de l’équipe ou le rôle ne s’affiche pas pour une affectation donnée, cliquez sur ajouter un membre de l’équipe pour voir la liste des membres de l’équipe et des rôles disponibles. Une fois le membre de l’équipe sélectionné, il sera ajouté à la fin de la liste et vous pourrez lui ajouter une affectation au moyen de la fonction glisser-déposer.",
    infoRemove: "Retirer l’affectation",
    infoRemoveDesc: "Pour retirer une affectation, glissez un ou plusieurs éléments vers un membre de l’équipe figurant sous le nom de l’affectation. Toute affection incomplète pour ce membre de l’équipe sera retirée. Les affectations terminées ne seront pas retirées. ",
    infoReplace: "Remplacer l’affectation",
    infoReplaceDesc: "Pour remplacer une affectation, vous devez glisser un ou plusieurs éléments vers un membre de l’équipe figurant sous le nom de l’affectation. Toute affectation existante ayant le même nom sera réaffectée au membre de l’équipe sélectionné. Si plusieurs membres de l’équipe ont des affectations portant ce même nom, elles seront regroupées sous l’utilisateur sélectionné. Il est facultatif de fixer un nombre de jours avant la date d’échéance dans le cas d’un remplacement d’affectation. Si le nombre de jours avant la date d’échéance n’a pas été fixé, c’est le nombre de jours existant avant la date d’échéance qui s’appliquera. ",
    infoUpdateDueDate: "Mettre à jour le nombre de jours avant l’échéance",
    infoUpdateDueDateDesc: "Définissez le nouveau nombre de « jours avant l’échéance », en choisissant « Sélectionner la date » ou « Calculer la date » puis glissez-déposez sur le nom du membre de l’équipe concerné. Les dates d’échéance des affectations ouvertes et en cours pour ce membre de l’équipe seront mises à jour. Les affectations terminées ne seront pas mises à jour.",
    infoDelete: "Supprimer l’affectation",
    infoDeleteDesc: "Cliquez sur l’affection située sur la droite. Une option permettant de supprimer cet ensemble d’affectations apparaîtra.",
    infoExecutive: "Affectations à la direction",
    infoExecutiveDesc: "Utilisez les fonctionnalités de filtre et de recherche pour filtrer les tâches qui s’appliquent aux cadres afin de les repérer et de les affecter plus rapidement. ",
    infoSpecificTask: "Affectations à des tâches spécifiques",
    infoSpecificTaskDesc: "Si des affectations doivent être faites au niveau des tâches, placez le curseur sur le regroupement situé à gauche et sélectionnez l’option d’affichage des tâches individuelles. Vous pourrez ainsi voir le détail des tâches pour l’audit de groupe et procéder aux affectations individuelles.",
    unassignedLabel: "non assignée",
    replaceSignleSuccessMessage: "tâche mise à jour avec succès.",
    replaceMultipleSuccessMessage: "tâches mises à jour avec succès.",
    dueDateSingleSuccessMessage: "affectation mise à jour avec succès.",
    dueDateMultipleSuccessMessage: "affectations mises à jour avec succès.",
    invalidAssignmentUpdate: "Attribuer la tâche à la même personne pour procéder à la mise à jour des dates d’échéance.",
    removeSuccessMessage: "affectation(s) mise(s) à jour avec succès.",
    colorCode: "Code de couleur",
    removeSuccessSingleMessage: "affectation mise à jour avec succès.",
    removeSuccessMultipleMessage: "affectations mises à jour avec succès.",
    assignmentRemovedSuccessfully: "Affectation retirée avec succès.",

    // Bulk Task
    itemsSelected: "tâches sélectionnées",
    itemSelected: "tâche sélectionnée",
    dragAndDrop: "Glisser et déposer",
    currentApplication: "Application actuelle",
    allAssignmentsClosed: "Toutes les affectations fermées",
    allAssignmentsCompleted: "Toutes les affectations terminées",

    onOrBeforeCurrentDate: "Avant ou à la date d’aujourd’hui",
    withInCurrentWeek: "Cette semaine",
    quickFilter: "Filtre rapide",
    suggestedFilters: "Filtres suggérés",
    showXMore: "Afficher {0} filtres de plus ",

    // Task due date Events
    addEventlabels: {
        modalTitle: "Ajouter un événement",
        startDateLabel: "Date de début",
        modalDescription: "Ajoutez les attributs et cliquez sur Enregistrer et fermer ou Enregistrer et ajouter.",
        eventNameLabel: "Nom de l’événement",
        eventType: "Type d’événement",
        singleDay: "Un seul jour",
        dateRange: "Fourchette de dates",
        eventDate: "Date de l’événement",
        eventDescription: "Description (facultatif)",
        isEvent: "Communiquer l’événement au client",
        EventNameErrorMessage: "Le nom de l’événement est requis.",
        eventDateErrorMessage: "La date de l’événement est requise.",
        addSuccessMessage: "Événement ajouté avec succès."
    },

    // Bulk Notes
    DeleteSomeNotesAreClosed: "<b>Seules certaines des notes que vous avez sélectionnées sont fermées et peuvent être supprimées.</b> <br /> Si vous choisissez de poursuivre, les notes figurant dans la liste qui suit seront supprimées. ",
    DeleteSomeNotesAreNotClosed: "Les notes figurant dans la liste qui suit ne peuvent pas être supprimées, car elles n’ont pas été fermées.",
    DeleteDontHaveClosedNotes: "Les notes figurant dans la liste qui suit ne peuvent pas être supprimées, car elles n’ont pas été fermées.",
    someNotesAreOpen: "<b>Seules certaines des notes que vous avez sélectionnées sont ouvertes.</b> <br/> Si vous choisissez de poursuivre, les notes figurant dans la liste qui suit seront mises à jour.",
    someNotesAreNotOpen: "Les notes figurant dans la liste qui suit ne seront pas mises à jour, car elles ont déjà été réglées ou fermées. ",
    dontHaveOpenNotes: "Les notes figurant dans la liste qui suit ne seront pas mises à jour, car elles ont déjà été réglées ou fermées. ",
    ShowNumberMore: "Afficher {0} de plus ",

    // Drag and Drop
    assignmentLabel: "affectation",
    assignmentsLabel: "affectations",
    singleAssignmentCreatedMessage: "affectation créée avec succès.",
    multipleAssignmentCreatedMessage: "affectations créées avec succès.",
    daysPriorWarning: "Avant de créer une affectation, définissez le nombre de jours avant la date d’échéance.",



    // Related Tasks - Engagement selector
    selectEngagement: "Sélectionner la mission",
    thisEngagement: "Cette mission",
    noResultsFoundLabel: "Aucun résultat",
    taskLocationLabel: "Emplacement de la tâche",

    // Delete Assginment
    deleteDescription: "La suppression de l’affectation ne peut pas être annulée, voulez-vous vraiment continuer?",
    deleteAssignmentModalTitle: "Supprimer l’affectation",
    deleteSingleSuccessMessage: "affectation supprimée avec succès.",
    deleteMultipleSuccessMessage: "affectations supprimées avec succès.",
    teamMemberLabel: "Membre de l’équipe",
    assignedTasksCountLable: "Tâches attribuées",
    deleteAssignmentLabel: "Affectation",
    selectengagement: "Sélectionner une mission",

    //Due Days
    dueDateTitle: "Entrer le nombre de jours avant l’échéance",
    dueDatedescription: "Entrer le nombre de jours avant la date d’échéance de la période à laquelle l’affectation devrait être terminée.",
    dueDateAssign: "Attribuer",
    dueDateSelect: "Sélectionner",
    dueDateCalculate: "Calculer",

    // Tasklist - bulk markcomplete
    markComplete: "Inscrire comme terminée",
    markCompleteMessgae1: "Voulez-vous vraiment <b>terminer les tâches sélectionnées</b>? <br /> Si vous avez des affectations incomplètes correspondant aux tâches sélectionnées, celles-ci seront fermées.",
    markCompleteMessgae2: "Seules certaines des tâches que vous avez sélectionnées peuvent être inscrites comme terminées.<br />Si vous choisissez de poursuivre, <b>les tâches figurant dans la liste qui suit seront inscrites comme terminées. Si vous avez des affectations incomplètes, celles-ci seront fermées.",
    markCompleteMessgae3: "<b>Les tâches figurant dans la liste qui suit ne seront pas inscrites comme terminées</b> étant donné qu’elles ne sont pas associées à des éléments probants ou que les éléments probants qui y sont associés n’ont pas été approuvés.",
    markCompleteMessgae4: "<b>Les tâches figurant dans la liste qui suit ne peuvent pas être inscrites comme terminées</b> étant donné qu’elles ne sont pas associées à des éléments probants ou que les éléments probants qui y sont associés n’ont pas été approuvés.",

    // Tasklist - bulk handoff
    handOffLabel: "Transmettre",
    confirmHandOff: "Confirmer la transmission",
    handOffMessgae1: "Voulez-vous vraiment <b>transmettre les tâches sélectionnées</b> au prochain membre de l’équipe? <br /> Si vous avez des affectations incomplètes correspondant aux tâches sélectionnées, celles-ci seront fermées.",
    handOffMessgae2: "Seulement certaines des tâches que vous avez sélectionnées sont affectées à un autre membre de l’équipe. <br />Si vous choisissez de poursuivre, <b>les tâches figurant dans la liste qui suit seront transmises</b>. Si vous avez des affectations incomplètes correspondant aux tâches sélectionnées, celles-ci seront fermées.",
    handOffMessgae3: "<b>Les tâches figurant dans la liste qui suit ne seront pas transmises</b> puisqu’elles ne comportent aucune affectation incomplète.",
    handOffMessgae4: "<b>Les tâches figurant dans la liste qui suit ne peuvent pas être transmises</b> puisqu’elles ne comportent aucune affectation incomplète.",
    closeMyAssignments: "Fermer mes affectations",

    saveQuickFilter: "Enregistrer le filtre rapide",
    saveQuickFilterModalHeader: "Enregistrez les pastilles de filtrage que vous avez appliquées comme filtre rapide.",
    saveQuickFilterModalText: "Sélectionnez les filtres rapides enregistrés et suggérés pour gagner du temps lorsque vous accédez à nouveau à cette mission. Vous pouvez créer jusqu’à cinq filtres rapides enregistrés par mission.",
    quickfiltername: "Nom du filtre rapide",
    taskCategory: "Catégorie de tâche",

    cannotsavefilter: "Le filtre rapide personnalisé ne peut pas être enregistré.",
    cannotsavefiltermodalheadertext: "<b>Vous pouvez enregistrer seulement cinq filtres rapides personnalisés par mission.</b> <br /> Pour continuer, supprimez l’un de vos filtres rapides personnalisés existants et réessayez.",
    savedFilters: "Filtres enregistrés",
    taskassignedto: "Tâche attribuée à",
    noteassignedto: "Note attribuée à",
    taskPrefix: "Préfixe de la tâche",
    taskSuffix: "Suffixe de la tâche",

    // Mark complete/HandOff Evidences category
    noSignOffs: "Aucune approbation ",
    noSignOffsByMe: "Aucune approbation par moi",
    myPreparerSignOffs: "Approbation de mon préparateur",
    myReviewerSignOffs: "Approbation de mon responsable de la revue",
    myPreparerAndReviewerSignOffs: "Approbations de mon préparateur et de mon responsable de la revue",

    notificationDownErrorMessage: "La fonction Notifications n’est pas disponible pour l’instant. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    notificationUpbutSomeLoadingErrorMessage: "Le centre de notification n’est pas disponible pour l’instant. Veuillez actualiser la page et réessayer. Il sera disponible sous peu.",

    timeTrackerErrorFallBackMessage: "La fonction Suivi du temps n’est pas disponible pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    timeTrackerLoadingFallbackMessage: "La fonction Suivi des heures n’est pas disponible pour le moment. Elle sera bientôt disponible.",

    signOffOnAllAs: "Tout approuver à titre de :",
    accountType: "Type de compte",

    openDocumentInstructionalText: "Ce document s’ouvrira automatiquement. <b>Vous n’avez pas besoin de cliquer pour l’ouvrir.</b> <br>Lorsque le document sera ouvert, vous pourrez fermer cet onglet. ",
    closeTab: "Fermer l’onglet",

    // Build Step - Add Due Date
    milestones: "Jalons",
    events: "Événements",
    noTimePhasesHaveBeenIdentified: "Aucune période n’a été identifiée.",

    wcgws: "Erreurs possibles",
    relatedControls: "Contrôles associés,",
    relatedControlsWCGWsRatio: "Contrôles / erreurs possibles associés",
    wcgwsToControlsRatio: "Ratio erreurs possibles/contrôles ",
    controlsToWCGWsRatio: "Ratio contrôles/erreurs possibles",
    testedControls: "Contrôles testés",

    // Collaboration request to Task relation
    CollaborationModalTitle: "Associer les demandes aux tâches",
    CollaborationModalDescription: "Pour associer une demande à une tâche, glissez et déposez une ou plusieurs demandes sur la tâche ci-dessous.",
    noDataFound: "Aucune donnée trouvée",
    taskName: "Tâche",
    showMessage: "Sélectionner une catégorie et un groupe de tâches pour commencer",
    showCategory: "Catégorie",
    showTaskGroup: "Groupe de tâches",
    optionITProcesses: "Processus informatiques",
    optionExecutionGeneral: "Exécution − Général",
    relatedRequestsLabel: "Demandes associées",
    relatedRequestsFormatted: "{0} demandes associées ",
    relatedRequestFormatted: "{0} demande associée ",
    relatedRequests: "Demandes associées",
    relatedTasks: "Tâches associées",
    relatedSuccessSingleMessage: "{0} demande a bien été associée à la tâche.",
    relatedSuccessMultipleMessage: "{0} demandes ont bien été associées à la tâche.",
    showUnrelated: "Afficher les {0} demandes non associées",
    unrelate: "Dissocier",
    noRequestsMessage: "Aucune demande disponible",
    requestNumber: "Numéro de la demande",
    sortAscending: "Ordre croissant",
    sortDescending: "Ordre décroissant",
    removeSorting: 'Remove sorting',

    // PIC Dashboard
    groupBy: "Grouper par",
    allTasks: "Toutes les tâches",
    iTSOs: "TI/SS",
    generalExecution: "Exécution – Général",
    PICSignOff: "Approbation de l’associé responsable",
    EQRSignOff: "Approbation du Responsable de la revue de la qualité de la mission",
    completed: "Terminées",
    allAssigned: "Attribuées en totalité",
    picTaskAssignmentLabel: "Vos affectations",
    assignReadyForReview: "En cours",
    assignUpcomingForReview: "À venir : ",
    assignReadyForReviewTasks: "Affectations actuelles",
    assignUpcomingForReviewTasks: "Affectations à venir",
    picTaskSignoffInComplete: "Tâches avec approbations de <b>l’associé responsable</b>manquantes",
    picDocSignoffInComplete: "Documents avec approbations de <b>l’associé responsable</b> manquantes",
    eqrTaskSignoffInComplete: "Tâches avec approbations du <b>responsable de la revue de la qualité de la mission</b> manquantes",
    eqrDocSignoffInComplete: "Documents avec approbations du <b>responsable de la revue de la qualité de la mission</b> manquantes",
    collapseCards: "Réduire les fiches",
    expandCards: "Développer les fiches",
    noUserSelectedPlaceholder1: "Aucun {0} n’a été identifié ou invité à la mission.",
    noUserSelectedPlaceholder2: "Cliquez ici",
    noUserSelectedPlaceholder3: "pour identifier ou inviter l’{0}.",
    notInvitedLabel: "Non invité",
    noTasksPlaceholder: "Aucune tâche n’est associée <br/>aux jalons de cette phase de l’audit.",
    noTasksTilesPlaceholder: "Aucune tâche n’a été attribuée à l’utilisateur sélectionné.",
    noAssignmentPlaceholder: "Aucune affectation trouvée",
    dueDateAssignmentPlaceholder: "Affectations par date d’échéance",
    countAssignmentPlaceholder: "Nombre d’affectations",
    OverduetPlaceholder: "En retard",
    TodayPlaceholder: "Aujourd’hui",
    tasksView: "Vue des tâches",
    documentsView: "Vue des documents",
    picAndEqr: "PIC et RRQM",
    ResponsiveToSR: "Associé à des ⚡risques importants",
    responsiveToFR: "Associé à des ⚡risques de fraude",
    relatedTasksFormatted: "{0} tâches associées",
    relatedTaskFormatted: "{0} tâche associée",
    autoAssignWarning2: "cliquer ici",
    toAssign: "à attribuer",
    taskAssignWarning: "tâche avec {0} exigences d’approbation non attribuée,",
    tasksAssignWarning: "tâches avec {0} exigences d’approbation non attribuées,",
    taskAdditionalFuncText1: "<b>D’autres fonctionnalités sont disponibles pour cette tâche. Veuillez</b>",
    taskAdditionalFuncText2: "<b> pour y accéder.</b><p>Les tâches de production ne requièrent pas d’être associées à des éléments probants pour être marquées comme étant terminées, à moins de devoir être revues par l’associé responsable/le RRQM.</p>",
    taskadditionalfunctionality: "<b>D’autres fonctionnalités sont disponibles pour cette tâche. Veuillez</b> {0} <b>pour y accéder.</b><p>Les tâches de production ne requièrent pas d’être associées à des éléments probants pour être marquées comme étant terminées, à moins que les tâches nécessitent d’être revues par l’associé responsable/le RRQM.</p>",
    taskclickhere: "cliquer ici",
    taskAutoAssignModalTitle: "Attribution automatique",
    taskAutoAssignModalDescription: "Il y a {0} tâches nécessitant l’approbation du responsable de la revue de la qualité de la mission qui n’ont pas été attribuées à {1}. Cliquez sur « Attribuer » pour créer des affectations de responsable de la revue de la qualité de la mission pour {1}.",
    tasksAutoAssignModalDescription: "Il y a {0} tâches nécessitant l’approbation du responsable de la revue de la qualité de la mission qui n’ont pas été attribuées à {1}. Cliquez sur « Attribuer » pour créer des affectations de responsable de la revue de la qualité de la mission pour {1}.",
    picTaskAutoAssignSuccessMessage: "tâche nécessitant l’approbation de l’associé responsable attribuée à",
    picTasksAutoAssignSuccessMessage: "tâches nécessitant l’approbation de l’associé responsable attribuées à",
    eqrTaskAutoAssignSuccessMessage: "tâche nécessitant l’approbation du responsable de la revue de la qualité de la mission attribuée à",
    eqrTasksAutoAssignSuccessMessage: "tâches nécessitant l’approbation du responsable de la revue de la qualité de la mission attribuées à",
    taskEntityDocumentValidationMsg: "Il n’y a pas d’éléments probants pertinents pour des entités associés à cette tâche. Cliquez sur le bouton d’affichage par entité pour savoir quelles entités nécessitent des informations supplémentaires.",
    // PIC/EQR Sign-Off validation message
    picSignOffValidationMsg: "Cette tâche nécessite l’approbation de l’associé responsable, mais aucun document pour lequel son approbation est requise n’y est associé. Ajouter au moins un document présentant cette exigence.",
    eqrSignOffValidationMsg: "Cette tâche nécessite l’approbation du responsable de la revue de la qualité de la mission, mais aucun document pour lequel son approbation est requise n’y est associé. Ajouter au moins un document comportant cette exigence.",
    picAndEQRSignOffValidationMsg: "Cette tâche nécessite l’approbation de l’associé responsable/du responsable de la revue de la qualité de la mission, mais aucun document pour lequel leur approbation est requise n’y est associé. Ajouter au moins un document comportant cette exigence.",
    updateDataOnPicEqrDashboardBannerMessage: "Les modifications effectuées n’ont pas été mises à jour ci-après. Veuillez {0} pour actualiser la page.",
    showMissingSignOffByLabel: "Afficher les documents pour lesquels il manque l’approbation suivante : {0}",

    FindingsReportName: "Constatations",
    FindingsDeficiencyReportTabName: "Déficience",
    FindingsMisstatementReportTabName: "Anomalie",
    FindingsDeficiencyITReportTabName: "Déficience–Informatique",
    auditPlanRelatedEvidenceReporLabel: "Plan de mission avec éléments probants connexes",
    groupStructureSummaryReportReportLabel: "Synthèse de la structure de l’audit de groupe",
    auditPlanReportLabel: "Rapport sur le plan de mission",
    itAppSOSummaryReportLabel: "Synthèse TI/SS",
    craSummaryReportLabel: "Synthèse de l’EGR",
    teamMembersLabel: "Membres de l’équipe",
    ipeLabel: 'Information produced by the entity (IPE)',
    validationChecksReportLabel: "Contrôles de validation",
    trialBalanceReportLabel: "Balance des comptes",
    trialBalanceReportTabLabel: "Rapport sur la balance des comptes",
    reportLabelYes: "Oui",
    reportLabelNo: "Non",
    assignedBy: "Attribuée par",
    openInReviewNotesHub: "Ouvrir dans le Centre des notes de revue",
    nextNote: "Suivant",
    previousNote: "Précédent",

    //component team group tab names
    accountInfoCanvasFormExport: "Information sur le compte",

    //project insight tab names
    projectInsightCanvasFormExport: "Exportation des formulaires Canvas",
    projectInsightSCOTToWCGWToControl: "Catégorie d’opérations importante > Erreur possible > Contrôle",
    projectInsightControlToITApplication: "Contrôle > Application informatique",
    projectInsightControlToAssertion: "Contrôle > Assertion",
    projectInsightRiskToWCGW: "Risques aux erreurs possibles",

    //IPE Report
    ipeControlsReport: 'Controls',
    ipeSubstantiveReport: 'Substantive',
    ipeITGCReport: 'ITGC',

    // Milestone tab names
    milestonesReport: "Rapport sur les jalons",
    unmappedTasks: "Tâches non mappées",

    // Effective
    isEffective: "Efficace",
    inEffective: "Inefficace",
    nonEffective: "Inefficace",

    clientRequests: "Demandes au client",
    externalTasks: "Tâches externes",
    requestPriority: "Priorité de la demande",
    scot: "Catégorie d’opérations importante",
    assertionR: "Assertion",
    wcgwToControlMappingTotal: "Totaux des erreurs possibles et des contrôles mappés",

    //CRA build step
    buildStep2EntityHeaderText: "Comptes importants et informations à fournir importantes, assertions, erreurs possibles et contrôles associés",
    buildStep4EntityHeaderText: "Comptes importants, informations à fournir, assertions associées",
    accountNameHeader: "Comptes importants et informations à fournir importantes",
    noAssertionsLabel: "Aucune assertion associée. Cliquer sur <a>Gérer les comptes et les informations à fournir</a> pour commencer.",
    noAssertionsBuildStep2text1: "Au moins une assertion doit être associée à ce compte. Cliquer sur ",
    accountWithoutAssertionsBuildStep2text1: "Chaque compte important ou information à fournir importante doit être associé à au moins une assertion. Cliquer sur",
    noAssertionsBuildStep2text2: "Gérer les comptes et les informations à fournir",
	noAccountsLabel: 'Aucun compte important ni aucune information à fournir importante n’ont été créés. Cliquer sur <span class="bold-text">Gérer les comptes et les informations à fournir</span> pour commencer.',
	noAccountsLabelPlaceHolder: 'Aucun compte important ni aucune information à fournir importante n’ont été créés. Cliquer sur <span class="bold-text">Gérer les comptes et les informations à fournir</span> pour commencer.',
    noAccountsOrDiscloserPreText: "Aucun compte important ni aucune information à fournir importante n’ont été créés.",
    noAccountsOrDiscloserText: "Gérer les comptes et les informations à fournir",
    noAccountsOrDiscloserPostText: "pour commencer.",
    noAssertionsBuildStep1text1: "Au moins une assertion doit être associée à ce risque. Cliquer sur ",
    noAssertionsBuildStep1text1Msg: "Chaque risque doit être associé à au moins une assertion.",
    noAssertionsBuildStep1text2: "Associer les assertions",
    noAssertionsBuildStep1text3: "pour commencer.",
    editRisk: "Modifier le risque",
    deleteRisk: "Supprimer le risque",
    noControlsRelatedWWCGW: "Aucun contrôle associé. ",
    noControlsRelatedWCGW: "Pour chaque erreur possible associée à une assertion dont le risque lié au contrôle est « Appui », au moins un contrôle doit être sélectionné aux fins des tests. Créer un",
    noControlsRelatedWCGWNewCont: "Nouveau contrôle",
    noControlsRelatedWCGWor: " ou ",
    noControlsRelatedWCGWRelateCont: "Associer un contrôle existant",
    noControlsForWCGW: "Il n’est pas obligatoire d’identifier de contrôles pour les assertions dont le risque lié au contrôle est « Pas d’appui ».",
    noControlsRelatedWCGWFooter: " pour commencer.",
    relateWCGWs: "<a>Associer les erreurs possibles</a>",
    noWCGWs: "Aucune erreur possible associée",
    noWCGWsClick: "Cliquer",
    noWCGWsFooter: "pour commencer.",
    showOnlyRisksWithNoAssertion: "Afficher seulement les risques auxquels aucune assertion n’est associée",
    showIncomplete: "Afficher seulement les assertions pour lesquelles l’EGR est incomplète",
    showOnlyInvalidBuildStep2: "Afficher seulement les comptes pour lesquels il manque des informations requises",
    noTestedControlsWithRelyAssertion: "Pour chaque erreur possible associée à une assertion dont le risque lié au contrôle est « Appui », au moins un contrôle doit être sélectionné aux fins des tests.",

    // Account build step
    accountOrDisclosure: "Compte / informations à fournir ",
    relatedAssertions: "Assertions connexes",
    relatedAccountsAndAssertions: "Comptes et assertions connexes",
    pspIndexTitle: "Référence PCB",
    statementTypeTitle: "Type d’état",
    significantAccountLabel: "Important",
    limitedRiskLabel: "Risque limité",
    insignificant: "Négligeable",
    significantDiscloure: "Information à fournir importante",
    accountAddedMessage: "Le compte « ## » a bien été créé",
    accounHeaderText: "Comptes et informations à fournir",

    // Add accounts / disclosures Modal labels
    accountsListTitle: "Comptes / informations à fournir et assertions correspondantes",
    addAccountsDisclosures: "Ajouter des comptes / informations à fournir ",
    editAccountsDisclosures: "Modifier des comptes / informations à fournir",
    accountNameLabel: "Nom du compte (obligatoire)",
    accountDesignationLabel: "Désignation (obligatoire)",
    accountEstimateLabel: "Une estimation est associée à ce compte",
    accountStatementTypeLabel: "Type d’état (obligatoire)",
    pspIndexDropdownLabel: "Référence PCB (obligatoire)",
    removePSPIndexLabel: "Supprimer la référence PCB",
    assertionsLabel: "Assertions (obligatoire)",
    noAccounsMessage: "Aucun compte trouvé. Ajouter des comptes pour commencer.",

    //Delete account / disclosure modal labels
    deleteAccountDisclosure: "Supprimer le compte / l’information à fournir",
    deleteAcConfirmMessage: "Voulez-vous vraiment supprimer le compte ou l’information à fournir {0}? Toutes les assertions correspondantes seront supprimées. Toute tâche uniquement associée au compte ou à l’information à fournir sélectionné(e) sera également supprimée.",

    true: "Vrai",
    false: "Faux ",
    taskSummaryReportEngagementInfo: "Plusieurs missions",
    viewPriority: "Afficher la priorité",
    priorityRequestsSent: "Demandes de priorité envoyées",

    //reactive frame
    maxTabsLocked: "Nombre maximal d’onglets autorisés atteint. Désépinglez et fermez l’un des onglets pour pouvoir en ouvrir un autre.",
    openInNewTab: "Ouvrir dans un nouvel onglet",
    copyLink: "Copier le lien",
    copySuccess: "Lien copié dans le presse-papiers",
    copyFailure: "Échec de la copie du lien dans le presse-papiers ",
    minimize: "Réduire",

    //Risk status for account cards
    riskStatusLabels: {
        NoAssertionsAvailableLabel: "Aucune assertion disponible",
        SignificanceNotSelectedLabel: "Importance non sélectionnée",
        InsignificantLabel: "Négligeable"
    },

    lockTab: "Épingler l’onglet",
    keyDocuments: "Principaux documents",
    suggestedDocuments: "Documents suggérés",
    noSuggestedDocuments: "Aucun document suggéré",
    exitBulkMode: "Quitter le mode bloc",
    bulkLabel: "Bloc",

    me: "Moi",
    viewByUser: "Afficher par utilisateur",
    unsentDraftCapitalized: "Ébauches non envoyées",
    picSignoffInComplete: "Approbation de l’associé responsable manquante",
    eqrSignOffIncomplete: "Approbation du RRQM manquante",

    tableView: "Affichage en mode tableau",
    noRelatedAssertions: "Aucune assertion associée. ",

    multiEntityTileMessage1: "Cliquer",
    multiEntityTileMessage2: "ici",
    multiEntityTileMessage3: "pour afficher le statut par entité ",
    allItemsMessage: "pour afficher tous les éléments",

    EntitySelector: "Sélectionner une entité pour commencer.",
    allEntities: "Toutes les entités",
    multiEntity: "Entités multiples",
    ungrouped: "Dissociées",
    numberSelected: "{0} sélectionnée(s)",
    allTimePhases: "Toutes",
    timePhases: "Période",
    noTimePhaseFound: "Aucune période trouvée",
    unrelatedAssignments: "Affectations non associées",
    unrelatedRequests: "Demandes non associées",
    relateRequests: "Associer les demandes",
    taskWithoutAnyAssignments: "Tâches sans affectation",
    privacyNotice: "Avis de confidentialité",
    lastPublishedAndSent: "Dernière publication et dernier envoi",
    drafts: "Ébauches",
    allEntitiesTask: "Il s’agit d’une tâche à l’échelle de la mission associée à toutes les entités ",
    noRelatedEntities: "Aucune entité associée",
    clickNewRisk: "pour commencer.",
    relatedAccountsDisclosuresAndAssertions: "Comptes importants, informations à fournir et assertions associés",
    relateAssertion: "Associer les assertions",
    taskByEntity: "Tâche par entité",
    engagementWideTask: "Tâche à l’échelle de la mission ",
    componentEngagementPill: "Équipe composante",
    primaryAndComponentEngagementPill: "Équipe principale/composante",
    // Scot build steps
    scotHeader: "Catégories d’opérations importantes",
    searchScot: "Rechercher",
    manageScots: "Gérer les catégories d’opérations importantes",
    superModelStep1ScotMessage: "Comptes importants et informations à fournir importantes et catégories d’opérations importantes associées",
    scotRelatedITApplicationServiceOrg: "Catégories d’opérations importantes et applications informatiques et sociétés de services associées",
    noScotsAvailable: "Aucun résultat trouvé",
    searchScotPlaceholder: "Rechercher",
    searchScotClearHoverText: "Effacer",
    showOnlyUnrelatedScotToggleSwitch: "Afficher seulement les catégories d’opérations importantes non associées",
    newScot: "Nouvelle catégorie d’opérations importante ",
    importFromKnowledgeScot: "Importer des catégories d’opérations importantes",
    importAccountsAndDisclosures: "Importer des comptes et des informations à fournir ",
    showOnlyAccountRelatedScot: "Afficher seulement les catégories d’opérations importantes auxquelles aucun compte important ni aucune information à fournir importante ne sont associés",
    warningMessageEstimateScotNotAssociatedWithEstimatedAccount: "Chaque catégorie d’opérations importante d’estimation doit être associée à au moins un compte important ou une information à fournir importante avec une estimation. Glissez et déposez cette catégorie d’opérations importante sur le compte important ou l’information à fournir importante correspondant(e).",
    warningMessageScotNotAssociatedWithAccount: "Chaque catégorie d’opérations importante doit être associée à au moins un compte important ou une information à fournir importante. Glissez et déposez cette catégorie d’opérations importante sur le compte important ou l’information à fournir importante correspondant(e).",
    showvalidations: "Afficher les validations",

    scotRelatedWCGWandControls: "Catégories d’opérations importantes et erreurs possibles et contrôles associés",
    newWcgw: "Nouvelle erreur possible",
    manageWCGWs: "Gérer les erreurs possibles",
    manageControl: "Gérer les contrôles",
    importWCGWs: "Importer des erreurs possibles",
    relateWCGWs: "Associer les erreurs possibles",
    newControl: "Nouveau contrôle",
    importControl: "Importer un contrôle",
    importControls: "Importer des contrôles",
    relateControl: "Associer les contrôles",
    scotStrategyIsControlMessage: "Aucun contrôle n’a été identifié pour cette erreur possible. La stratégie pour la catégorie d’opérations importante n’est pas définie.",
    scotStrategyIsWCGWMessage: "Aucune erreur possible n’a été identifiée pour cette catégorie d’opérations importante. La stratégie pour la catégorie d’opérations importante n’est pas définie.",
    controlsPlaceholderWithNoRelatedWCGWsMessage: "Chaque catégorie d’opérations importante doit être associée à au moins une erreur possible. Créez une",
    controlsPlaceholderWithNoRelatedControlsMessage: "Chaque erreur possible doit être associée à au moins un contrôle. Créez un",
    noITApplicationSOMessage: "Aucune application informatique ou société de services n’a été identifiée pour cette catégorie d’opérations importante. Cliquez ",
    relatedItAppSOHeaderMessage: "Applications informatiques et sociétés de services associées",
    substantivePlaceholderWithNoRelatedControlsMessage: "Aucun contrôle n’a été identifié pour cette catégorie d’opérations importante. Pour les catégories d’opérations importantes faisant l’objet d’une stratégie corroborative, il n’est pas nécessaire d’identifier de contrôles.",
    substantivePlaceholderWithNoRelatedWCGWsMessage: "Aucune erreur possible n’a été identifiée pour cette catégorie d’opérations importante. Pour les catégories d’opérations importantes faisant l’objet d’une stratégie corroborative, il faut identifier les erreurs possibles.",
    noITApplicationSOMessageText: "pour créer l’association requise.",
    notSelected: "Non sélectionnée",
    or: "ou",

    //WCGWControls
    showOnlyWCGWRelatedControls: "Afficher seulement les contrôles associés",

    createorRelateControl: "Créer un nouveau contrôle ou associer un contrôle existant.",

    //Accounts Scot build steps
    accountHeader: "Comptes",
    searchAccount: "Rechercher un compte",
    searchAccountPlaceholder: "Rechercher",
    manageAccounts: "Gérer les comptes et les informations à fournir",
    showOnlyUnrelatedAccountToggleSwitch: "Afficher seulement les éléments non associés ",
    searchAccountClearHoverText: "Effacer",
    noAccountsAvailable: "Aucun résultat",
    showOnlyScotRelatedAccount: "Afficher seulement les comptes importants et les informations à fournir importantes auxquels aucune catégorie d’opérations importante n’est associée",
    warningMessageEstimateAccountNotAssociatedWithEstimatedScot: "Chaque compte important ou information à fournir importante avec une estimation doit être associé à au moins une catégorie d’opérations importante d’estimation. Glissez et déposez une catégorie d’opérations importante pertinente existante sur ce compte important ou cette information à fournir importante",
    warningMessageAccountNotAssociatedWithScot: "Chaque compte important ou information à fournir importante doit être associé à au moins une catégorie d’opérations importante. Glissez et déposez une catégorie d’opérations importante pertinente existante sur ce compte important ou cette information à fournir importante",
    significantAccountsAndDisclosures: "Comptes importants et informations à fournir importantes",
    // Independence Only

    independenceOnlyStatus: "Indépendance seulement",

    //Controls
    controlDesignEffectivenessWarningValidation: "L’efficacité de la conception doit être sélectionnée pour les contrôles.",
    controlHeader: "Catégorie d’opérations importantes et contrôles associés",
    manageControls: "Gérer les contrôles",
    manageITApplications: "Gérer les applications informatiques",
    searchControlClearHoverText: "Effacer",
    searchControlPlaceholder: "Rechercher",
    noControlsAvailable: "Aucun résultat",
    controlName: "Nom du contrôle",
    frequency: "Fréquence",
    type: " Type",
    newSO: "Nouvelle SS",
    designEffectiveness: "Efficacité de la conception",
    testing: "Test",
    strategyTypeName: "Stratégie axée sur la catégorie d’opérations importante",
    controlTestingYes: "Oui",
    controlTestingNo: "Non",
    effective: "Efficace",
    ineffective: "Inefficace",
    noControlsResult: "Aucun résultat",
    noControlsLabel: "Aucun résultat",
    relatedControl: "Contrôle connexe",
    relateControls: "Associer les contrôles",
    controlTypeValues: {
        itApplication: "Contrôle des applications informatiques",
        itDependentManual: "Contrôle manuel lié aux TI",
        manualPrevent: "Contrôle manuel de prévention",
        manualDetect: "Contrôle manuel de détection"
    },
    controlFrequencyTypes: {
        manyTimesPerDay: "Plusieurs fois par jour",
        daily: "Une fois par jour",
        weekly: "Une fois par semaine",
        monthly: "Une fois par mois",
        quarterly: "Une fois par trimestre",
        annually: "Une fois par année",
        iTApplicationControl: "Contrôle des applications informatiques",
        other: "Autre"
    },
    filterTypeOfScots: "Catégories d’opérations importantes",
    noScotsAvailable: "Aucun résultat",


    onlyShowControlsWithNoDesignEffectiveness: "Afficher seulement les contrôles pour lesquels l’efficacité de la conception n’est pas sélectionnée",

    // control Tasks
    controlCount: "{0} contrôle(s)",

    //Create and Edit WCGW
    wcgwInputName: "Nom de l’erreur possible",
    editWCGW: "Modifier l’erreur possible",
    createNewWCGW: "Créer une nouvelle erreur possible",
    editTheWCGW: "Modifier l’erreur possible",
    createEditWCGWSave: "Enregistrer",
    createEditWCGWClose: "Annuler",
    createEditWCGWModelScot: "Catégorie d’opérations importante ",
    newWCGWTitel: "Nouvelle erreur possible",
    wcgwNameIsRequired: "Le nom de l’erreur possible est requis",
    deleteWCGW: "Supprimer l’erreur possible",


    //Audit Plan
    importPSPButtonText: "Importer des PCB",
    commonContentUpdateSuccessMessage: "Mise à jour du contenu en cours. Ce processus peut prendre jusqu’à quinze minutes. Veuillez actualiser la page pour afficher les PCB récemment importées.",
    responsivetoRisks: "Réponse à des risques",
    procedures: "Procédures",
    toc: "TDC",
    significantandFraudRisksHeading: "Risques importants et risques de fraude et procédures et contrôles en réponse à ces risques",
    risksBeingRespondedToByComponentTeam: "Les équipes affectées à l’audit des composantes traitent actuellement les risques.",
    responsivecontrolsandTOCs: "Contrôles et TDC en réponse aux risques",
    ResponsivePSPOSP: "PCB et APC en réponse aux risques",
    responsivePSPsOSPs: "PCB et APC en réponse aux risques",
    responsiveTOC: "TDC en réponse aux risques",
    responsiveControl: "Contrôle en réponse aux risques",
    responsivePSPOPSMessage: "Au moins une procédure de corroboration doit répondre à cette assertion pour ce risque. Cliquez sur {0} pour identifier les procédures de corroboration correspondantes.",
    responsiveControlMessage: "Au moins un contrôle (dont l’efficacité de la conception a été vérifiée) doit répondre à cette assertion pour ce risque. Cliquez sur {0} pour identifier les contrôles correspondants. Cliquez sur {1} pour définir l’efficacité de la conception ou la stratégie de test.’,",
    responsiveTOCMessage: "Les assertions dont le risque lié au contrôle est « Appui » doivent être associées à au moins un TDC pertinent compte tenu du risque pour un contrôle 1) qui n’est pas classé comme présentant un risque faible et 2) dont l’efficacité de la conception a été vérifiée. Cliquez sur <a>TDC pertinent</a> pour identifier les TDC applicables.",
    notcompleted: "Non terminée",
    noResponsiveTOCAvailable: "Aucun TDC pertinent n’a été identifié pour ce contrôle.",
    refresh: "Actualiser les données",
    tocHoverOverWhenControlTestingHasNoorNotCompleted: "Ce contrôle n’a pas été sélectionné aux fins des tests. Cliquer sur <b>Gérer les contrôles</b> pour modifier la sélection aux fins des tests.",
    noresponsiveTOCIdentified: "Aucun TDC en réponse aux risques n’a été identifié.",
    taskAssertionnotModified: "Les assertions associées à la tâche n’ont pas été modifiées. Modifier la relation des assertions pour continuer ou cliquer sur Annuler pour quitter.",
    failedToEditRelatedAssertions: "Échec de la modification des assertions associées à la tâche. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    assertionCannotEdited: "Les assertions dont les cases à cocher sont désactivées ont été définies conformément à la MMA d’EY et ne peuvent pas être modifiées.’,",
    editAssertionInfoMessage: "Ajouter ou supprimer des assertions pour la tâche. Au moins une assertion doit être sélectionnée.",
    editRelatedAssertions: "Modifier les assertions associées",
    loweRiskHeader: "Risque faible",
    placeholderWhenControlTestingHasNotCompleted: "Ce contrôle n’a pas été sélectionné aux fins des tests. Cliquez sur {0} pour modifier la sélection aux fins des tests.",
    pspandOSP: "PCB/APC",
    tocs: "TDC",
    norelatedAssertionPlaceHolder: "Au moins une assertion doit être associée à chaque risque important ou risque de fraude. Cliquez sur {0} pour identifier les assertions correspondantes.",
    assertionMustHaveOneControlWithCompleteDesignEffectiveness: "Chaque assertion doit être associée à au moins un contrôle dont l’efficacité de la conception a été vérifiée et qui répond au risque. Cliquez sur {0} pour identifier un contrôle répondant au risque.",
    controlRiskRelyNotLowerRisk: "Chaque assertion dont le risque lié au contrôle est « Appui » doit être associée à au moins un contrôle 1) qui n’est pas désigné comme présentant un risque faible, 2) dont la conception est efficace et 3) qui est sélectionné aux fins des tests. Cliquez sur {0} pour identifier un contrôle répondant au risque.",
    controlRiskRelyWithDesignEffectively: "Chaque assertion dont le risque lié au contrôle est « Appui » doit être associée à au moins un contrôle 1) dont la conception est efficace et 2) qui est sélectionné aux fins des tests. Cliquez sur {0} pour identifier un contrôle répondant au risque.",

    assertionWithControlRiskNotRely: "Il n’est pas obligatoire d’identifier un test des contrôles pour les assertions dont le risque lié au contrôle est « Pas d’appui ».",
    thisControlNotSelectedForTesting: "Ce contrôle n’a pas été sélectionné aux fins des tests. Cliquez sur {0} pour modifier la sélection liée aux tests.",
    testControlRelatedToControlAsLowerRisk: "Un test des contrôles associé à un contrôle qui est désigné comme présentant un risque faible ne répondra pas au risque associé à cette assertion.",
    testControlWithoutCompleteDE: "Un test des contrôles associé à un contrôle dont l’efficacité de la conception n’a pas été vérifiée ne répondra pas au risque associé à cette assertion. Cliquez sur {0} pour établir l’efficacité de la conception.",
    testControlrelatedToineffective: "Un test des contrôles associé à un contrôle dont la conception n’est pas efficace ne répondra pas au risque associé à cette assertion. Cliquez sur {0} pour changer l’efficacité de la conception.",
    anotherTestControlIdentified: "Un autre test des contrôles répond au risque associé à cette assertion et il n’est pas nécessaire d’identifier de tests des contrôles complémentaires. Aucun TDC pertinent n’a été identifié pour ce contrôle.",
    eachControlMustHaveOneToc: "Chaque assertion dont le risque lié au contrôle est « Appui » doit être associée à au moins un TDC répondant au risque pour un contrôle 1) qui n’est pas désigné comme présentant un risque faible, 2) dont la conception est efficace et 3) qui est sélectionné aux fins des tests. Aucun TDC pertinent n’a été identifié pour ce contrôle. Cliquez sur {0} pour identifier les TDC applicables.",
    eachAssertionControlHaveAtleasetOneTOC: "Chaque assertion dont le risque lié au contrôle est « Appui » doit être associée à au moins un TDC répondant au risque pour un contrôle 1) dont la conception est efficace et 2) qui est sélectionné aux fins des tests. Aucun TDC pertinent n’a été identifié pour ce contrôle. Cliquez sur {0} pour identifier les TDC applicables.",
    norepsonsivePSPOSPplaceholder: "Chaque assertion doit être associée à au moins une procédure de corroboration qui répond à ce risque. Cliquez sur {0} pour identifier une procédure de corroboration applicable.",

    //Reject Task
    rejectPspModalTitle: "Rejeter la PCB",
    rationaleRequired: "Obligatoire",
    rationaleTextEditorLabel: "Raison du rejet de la PCB",
    rejectTaskErrorMessage: "Impossible de rejeter la tâche. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    rejectTaskModalHeader: "Voulez-vous vraiment rejeter la PCB sélectionnée?",
    rejectTaskModaWarningText: "Les éléments probants correspondants qui ne sont associés à aucune autre tâche de cette mission seront déplacés dans les fichiers temporaires.",
    rejectTaskRationaleLabel: "Raison (obligatoire)",

    // Adobe Analytics
    aaCookieConsentTitle: "Bienvenue dans",
    aaCookieContentPrompt: "Voulez-vous autoriser les témoins?",
	aaCookieConsentExplanation: '<p>Outre les témoins strictement nécessaires au fonctionnement de ce site Web, nous utilisons les types de témoins suivants afin d’améliorer votre expérience et nos services : <strong>les témoins de fonctionnalité<strong>, qui nous permettent d’améliorer votre expérience utilisateur (p. ex., en conservant en mémoire tous les paramètres que vous avez sélectionnés); <strong>les témoins de performance<strong>, qui nous aident à évaluer la performance du site Web et à améliorer votre expérience utilisateur, <strong>les témoins à des fins de publicité ou de ciblage<strong>, qui sont configurés par des tiers avec lesquels nous réalisons des campagnes publicitaires et qui nous permettent de vous présenter des annonces pertinentes pour vous.</p><p>Consultez le site<a target="_blank" href="https://www.ey.com/fr_ca/cookie-policy">Politique sur l’utilisation de témoins</a> pour de plus amples renseignements.</p> ',
	aaCookieConsentExplanationWithDoNotTrack: '<p>Outre les témoins strictement nécessaires au fonctionnement de ce site Web, nous utilisons les types de témoins suivants afin d’améliorer votre expérience et nos services : <strong>les témoins de fonctionnalité<strong>, qui nous permettent d’améliorer votre expérience utilisateur (p. ex., en conservant en mémoire tous les paramètres que vous avez sélectionnés); <strong>les témoins de performance<strong>, qui nous aident à évaluer la performance du site Web et à améliorer votre expérience utilisateur, <strong>les témoins à des fins de publicité ou de ciblage<strong>, qui sont configurés par des tiers avec lesquels nous réalisons des campagnes publicitaires et qui nous permettent de vous présenter des annonces pertinentes pour vous.</p><p>Nous avons détecté que vous avez activé le paramètre Ne pas me suivre (DNT) dans votre navigateur; par conséquent, les témoins à des fins de publicité ou de ciblage sont automatiquement désactivés.</p><p>Consultez le site<a target="_blank" href="https://www.ey.com/fr_ca/cookie-policy">Politique sur l’utilisation de témoins d’EY</a> pour de plus amples renseignements.</p>',
    aaCookieConsentDeclineOptionalAction: "Je refuse les témoins optionnels",
    aaCookieConsentAcceptAllAction: "J’accepte tous les témoins",
    aaCookieConsentCustomizeAction: "Personnaliser les témoins",
    aaCookieConsentCustomizeURL: 'https://www.ey.com/en_us/cookie-settings',

    //Task Sections
    taskSectionLabels: {
        taskSectionHeader: "Groupes de tâches et tâches associées",
        manageTaskSections: "Gérer les groupes de tâches",
        taskSectionsAccordionHeader: "Groupes de tâches",
        phaseAccordionHeader: "Phase",
        tasksAccordionHeader: "Tâches",
        rejectedAccordionHeader: "Rejetées",
        noRelatedTasksMessage: "Aucune TSB et ATS disponible. Créer une {0} pour commencer.",
        taskSectionTaskHeader: "Tâches",
        newOSTButtonText: "Nouvelle ATS",
        cutomTaskSectionBadgeText: "Personnalisé",
        rejectedTasksLabel: "TSB rejetées",
        additionalInfo: "Justification",
        rejectButton: "Rejeter",
        acceptButton: "Accepter",
        removeButton: "Retirer",
        addButton: "Ajouter",
        allPSTsRejectedMessage: "Toutes les TSB ont été rejetées.",
        rejectModalTitle: "Rejeter la TSB",
        rationaleTextEditorLabel: "Raison du rejet de la TSB",
        rejectTaskModalHeader: "Voulez-vous vraiment rejeter la TSB sélectionnée?",
        noResultsMessage: "Aucun résultat",
        noTaskSetionsAvailableMessage: "Aucune section de tâches disponible",
        rejectTaskModaWarningText: "Les éléments probants correspondants qui ne sont associés à aucune autre tâche dans cette mission seront déplacés vers des fichiers temporaires. Les TSB comportant des documents transmis par EY Canvas ne peuvent pas être rejetées. ",
        rejectTaskRationaleLabel: "Raison (obligatoire)"
    },

    // Cookie Settings
    cookieSettings: {
        title: "Paramètres des témoins",
        explanation: "Veuillez consentir à l’utilisation de témoins sur ey.com et sur la plateforme My EY. Sélectionnez un ou plusieurs types de témoins ci-dessous, puis sauvegardez votre choix. Consultez la liste ci-dessous pour connaître les détails sur les types de témoins et leur fonction. ",
        emptyCookieListNotice: "Les témoins de cette catégorie ne sont pas utilisés dans cette application.",
        nameTableHeader: "Nom du témoin",
        providerTableHeader: "Fournisseur du témoin",
        purposeTableHeader: "Fonction du témoin",
        typeTableHeader: "Type de témoin",
        durationTableHeader: "Durée d’activité du témoin",
        formSubmit: "Enregistrer ma sélection",
        requiredCookieListTitle: "Témoins nécessaires",
        functionalCookieListTitle: "Témoins fonctionnels",
        functionalCookieAcceptance: "J’accepte les témoins fonctionnels ci-dessous.",
        functionalCookieExplanation: "Les témoins fonctionnels, qui nous permettent d’améliorer votre expérience utilisateur (p. ex., en conservant en mémoire tous les paramètres que vous avez sélectionnés).",
        performanceCookieListTitle: "Témoins de performance",
        performanceCookieAcceptance: "J’accepte les témoins de performance ci-dessous",
        performanceCookieExplanation: "Les témoins de performance, qui nous aident à évaluer la performance du site Web et à améliorer votre expérience utilisateur. Quand nous utilisons des témoins de performance, nous ne stockons pas de données à caractère personnel, et nous n’utilisons les informations recueillies à l’aide de tels témoins que sous leur forme agrégée et anonyme.",
        advertisingCookieListTitle: "Témoins de ciblage",
        advertisingCookieAcceptance: "J’accepte les témoins publicitaires / de ciblage ci-dessous.",
        advertisingCookieExplanation: "Les témoins publicitaires ou de ciblage, qui nous permettent de faire le suivi de l’activité et des sessions utilisateurs, de sorte que nous puissions fournir un service plus personnalisé. Dans le cas des témoins publicitaires, qui sont configurés par des tiers avec lesquels nous réalisons des campagnes publicitaires, ils nous permettent de vous présenter des annonces qui sont pertinentes pour vous.",
        doNotTrackNotice: "Nous avons détecté que vous avez activé le paramètre Ne pas me suivre (DNT) dans votre navigateur; par conséquent, les témoins à des fins de publicité ou de ciblage sont automatiquement désactivés.",
    },

    //Task Sections and related Tasks
    taskSectionAndRelatedTask: "Sections de tâches et tâches associées",
    manageTaskSections: "Gérer les sections de tâches",

    // Financial Statments
    financialStatementLabels: {
        financialStatements: "États financiers",
        trialBalance: "Balance des comptes",
        okButton: "OK",
        leadSheet: "Feuille maîtresse ",
        balanceSheet: "Bilan",
        incomeStatement: "État des résultats",
        eyreferences: "Référence",
        currenPeriod: "Date de l’analyse",
        comparativePeriod: "Date de comparaison",
        changeFrom: "Variation par rapport à",
        percentageChangeFrom: "% de variation par rapport à ",
        notesColumn: "Notes",
        viewTrialBalanceType: "Afficher par type de balance des comptes ",
        multiEntity: "Entités multiples",
        placeHolderText: "Rechercher les catégories de comptes",
        currencyType: "Type de monnaie",
        currencyCode: "Code de monnaie",
        businessUnit: "Unité fonctionnelle",
        periodEnded: "date de fin",
        periodsEnded: "date de fin",
        searchGLAccountPlaceholder: "Rechercher des comptes GL ",
        eyReferenceDocuments: "{0} documents",
        relatedNotes: "Notes associées",
        notAvailable: "Non disponible",
        significantDisclosures: "Informations à fournir importantes",
        noResultFound: "Aucun résultat",
        openEYHelixProjects: "Ouvrir des projets EY Helix",
        openAdjustmentModule: "Ouvrir le module d’ajustement",
        goToSubstantiveProcedureLink: "Accéder aux procédures de corroboration",
        cancel: "Annuler",
        remove: "Retirer"
    },

    financialStatementsClassView: {
        bulk: "Bloc",
        eyAccount: "Compte EY ",
        placeHolderText: "Rechercher les comptes GL",
        noAccountDesignation: "La désignation du compte n’a pas été établie. ",
        insignificantLeadSheetMessage: "Les feuilles maîtresses ne sont pas présentées pour les comptes négligeables. ",
        unmappedGLAccounts: "Les feuilles maîtresses ne sont pas présentées pour les comptes non mappés. ",
        unmappedAccountText: 'Unmapped'
    },
    financialStatementTypeIds: [{
            id: 1,
            label: "Actifs"
        },
        {
            id: 4,
            label: "Passifs"
        },
        {
            id: 7,
            label: "Capitaux propres"
        },
        {
            id: 8,
            label: "Produits"
        },
        {
            id: 9,
            label: "Charges"
        },
        {
            id: 17,
            label: "Résultat net"
        }
    ],
    copyrightMessage: "© <année> Tous droits réservés.",
    createNotes: {
        notesPlaceholderText: "Ajouter des notes en cliquant sur {0} ou {1}.",
        newNote: "Ajouter une note",
        relateNote: "Associer la note",
        addNewNotesHeader: "Entrer les détails relatifs à la note ci-dessous et sélectionner <b>\'Enregistrer et fermer\'</b> pour terminer. Pour créer une autre note, sélectionner <b>\'Enregistrer et créer une autre note\'</b>.",
        noteIndex: "Référence",
        noteIndexRequired: "Référence (obligatoire)",
        noteDescription: "Description",
        noteDescriptionRequired: "Description (obligatoire)",
        saveAndClose: "Enregistrer et fermer",
        newTickmarkDescription: "Sélectionner la raison pour laquelle ce compte GL ne comporte aucun renvoi à des éléments probants.",
        newTickmarkBulkModalDescription: " Sélectionnez la raison pour laquelle les comptes GL sélectionnés ne comportent aucun renvoi à des éléments probants."
    },
    deleteNotes: {
        deleteNote: "Supprimer la note",
        deleteNoteTitle: "Voulez-vous vraiment supprimer la note sélectionnée?",
        delete: "Supprimer",
        cancel: "Annuler"
    },
    editNotes: {
        editNote: "Modifier la note",
        editNotesHeader: "Modifiez les détails relatifs à la note ci-dessous et sélectionnez <b>\'Enregistrer et fermer\'</b> pour terminer.",
        edit: "Modifier",
        cancel: "Annuler"
    },
    notesListLabels: {
        actions: "Actions",
        noteCount: "{0} note",
        notesCount: "{0} notes"
    },
    relateNotes: {
        relateNoteLabel: "Associer la note",
        searchPlaceholder: "Rechercher",
        accountLabel: "Compte",
        indexLabel: "Référence",
        descriptionLabel: "Description",
        addedLabel: "Ajoutée",
        showOnlyRelatedLabel: "Afficher seulement les notes associées",
        noResultsFoundMessage: "Aucun résultat",
        noteCount: "{0} note",
        notesCount: "{0} notes",
        closeBtnTitle: "Fermer"
    },
    uploadEvidenceDocuments: {
        addnewEvidencesPlaceholderandLinks: "Ajouter des éléments probants en cliquant sur {0} ou {1} ou indiquer qu’aucun élément probant n’est requis en cliquant sur {2}.",
        newEvidence: "Nouvel élément probant",
        relateEvidence: "Associer les éléments probants",
        newTickMark: "Nouvelle marque de pointage",
        relateTasks: 'Relate task',
        noTasksSeleted: "Sélectionner une tâche pour continuer.",
        relateTaskPlaceholder: "Les nouvelles références doivent être associées à au moins une tâche. Sélectionner une tâche à laquelle ce document devrait être ajouté en tant qu’élément probant.  ",
        confirmButtonTitle: "Continuer",
        closeButtonTitle: "Annuler",
        noResultsFound: "Aucun résultat",
        taskType: "Type",
        taskName: "Nom de la tâche",
        taskCount: "{0} tâche",
        tasksCount: "{0} tâches",
        title: "Référence",
        removeReference: "Retirer la référence"
    },
    glAccountAssociatedNotes: {
        aggregatedNotesPlaceholder: "Aucune note disponible. Sélectionner un compte GL pour créer une note.",
        notes: "Notes",
        relatedGlAccountPlaceholder: "Comptes GL associés"

    },
    finacialStatementsBulkOperations: {
        relateEvidenceLabel: "Associer les éléments probants",
        selectedCountGLAccount: "{0} compte GL sélectionné",
        selectedCountGLAccounts: "{0} comptes GL sélectionnés",
        selectAll: "Tout sélectionner",
        deselectAll: "Tout désélectionner",
        exitBulkMode: "Quitter le mode bloc",
        noGLAccountsSelectedValidationMessageEvidence: "Sélectionnez au moins un compte GL pour associer des éléments probants ou cliquez sur Quitter le mode bloc.",
        noGLAccountsSelectedValidationMessageTickmark: "Sélectionnez au moins un compte GL pour ajouter une nouvelle marque de pointage ou cliquez sur Quitter le mode bloc.",
        noGLAccountsSelectedValidationMessageRemoveReference: "Sélectionnez au moins un compte GL pour retirer la référence ou cliquez sur Quitter le mode bloc.",
        relateTickmarkLabel: "Nouvelle marque de pointage",
        removeReferenceLabel: "Retirer la référence",
        removeReferenceConfirmationMsg: "Veuillez confirmer que vous souhaitez retirer la référence pour tous les comptes GL sélectionnés."

    },
    financialStatementsFilters: {
        referenceFilterKey: "Comptes GL pour lesquels il manque des renvois",
        accountFilterKey: "Comptes GL sans mappage",
        noResultsPlaceholder: "Aucun résultat",
        trialBalance: "Balance des comptes",
        noneAvailable: "Aucune information disponible",
        search: "Rechercher",
        multityEntity: "Entités multiples",
        placeHolderMessageWhenHelixMappingIsTrue: "Aucune balance des comptes importée. Cliquez sur {0} pour associer un nouvel analyseur.",
        placeHolderMessageWhenHelixMappingIsFalse: "L’intégration à EY Helix n’est pas disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
		eyHelixIntegrationLinkText: "Intégration à EY Helix",
        noEntitiesAvailablePlaceholder: "Aucune entité créée. Pour commencer créez des entités."
    },
    //Group instructions
    assertionTabButton: "Assertions",
    inherentRiskFactorButton: "Facteurs de risque inhérent",
    accountsAndDisclosure: "Comptes/Informations à fournir",
    assertions: "Assertions",
    assertionC: "Exh",
    assertionEO: "Exi/R",
    assertionMV: "M/Év",
    assertionRO: "D&O",
    assertionPO: "P&I",

    complexity: "Complexité",
    subjUncertainty: "Incertitude liée au degré de subjectivité",
    fraudOrError: "Fraude ou erreur",
    change: "Changement",
    natureOfAccount: "Nature du compte",
    relatedParties: "Parties liées",
    higherInherentRiskLabel: "Risque inhérent élevé",
    lowerInherentRiskLabel: "Risque inhérent faible",
    relevantLabel: "Risque associé",
    relevantContributeLabel: "Risque associé contribuant au risque inhérent élevé",
    incompleteInherentRiskTooltip: "Risque inhérent incomplet",
    estimateLabel: "Estimation",
    riskAssociatedLabel: "Risque associé",
    greaterExtentLabel: "Dans une grande mesure",
    lesserExtentLabel: "Dans une faible mesure",
    accordionNoRiskLabel: "Aucun risque associé à l’assertion à l’égard de ce compte.",
    accordionNoRiskAccountLabel: "Aucun risque associé à ce compte",
    accordionNoAssertionsLabel: "Aucune assertion associée à ce compte.",
    accordionLimitedRiskLabel: "Le compte a été identifié comme présentant un risque limité.",

    maps: "Schémas",
    financialStatements: "États financiers",
    serviceGatewayAutomation: "Service Gateway et automatisation",
    manageTaskGroups: "Gérer les groupes de tâches",
    openAssignmentsLabel: "Affectations ouvertes",
    inProgressAssignmentsLabel: "Affectations en cours",
    // My Progress collaboration view.
	calendarDays: [
		"Dimanche",
		"Lundi",
		"Mardi",
		"Mercredi",
		"Jeudi",
		"Vendredi",
		"Samedi"
	],
	calendarMonths: [
		"Janvier",
		"Février",
		"Mars",
		"Avril",
		"Mai",
		"Juin",
		"Juillet",
		"Août",
		"Septembre",
		"Octobre",
		"Novembre",
		"Décembre"
	],
    myProgressToday: "Aujourd’hui",
    noDueDateAssignedGroup: "Aucune date d’échéance attribuée",
    myProgressStatusTile: {
        yourRequests: "Vos demandes",
        totalCount: "Nombre total",
        requestStatus: "État de la demande",
        draft: "En projet",
        pending: "En attente",
        received: "Reçues",
        accepted: "Acceptées",
        overdue: "En retard",
        noRelatedTasks: "{0} sans aucune tâche associée",
        oneNoRelatedTask: "1 sans tâche associée",
        addRequest: "Nouvelle demande",

        //Requests dues tile 2
        pendingRequestsByDueDate: "Demandes en attente par date d’échéance",
        requestsYAxisLabel: "Demandes",
        requestsXAxisLabel: "Jours",
        tooltipDaysLabel: "jours",
        tooltipTotalLabel: "Total : ",
        normalLabel: "Normale",
        highLabel: "Élevée",
        criticalLabel: "Critique",
        overdueLabel: "En retard",
        overDueCatFirst: "Plus de 90 jours de retard",
        overDueCatSecond: "De 31 à 90 jours de retard",
        overDueCatThird: "De 10 à 30 jours de retard",
        overDueCatFourth: 'Overdue 1-9',
        catFifth: '1-9',
        catSixth: '10-30',
        catSeventh: '31-90',
        catEighth: '> 90',
        noRequestsFound: "Aucune demande trouvée",
        daysOverdue: 'Days overdue',
        daysComingDue: 'Days coming due'
    },
    documentAttributeReference: {
        name: "Nom",
        notes: "Notes",
        signOffs: "Approbations",
        tasks: "Tâches associées",
        open: "Ouvrir",
        openReadOnly: "Ouvrir en lecture seule",
        delete: "Supprimer",
        rename: "Renommer",
        signOffRequirements: "Exigences d’approbation",
        confidentiality: "Confidentialité",
        unlink: "Dissocier",
        relateTasks: "Associer des tâches"
    },
    aiChatbot: 'EYQ Assurance Knowledge',
    selectDueDate: "Sélectionner une date d’échéance",
    daysOverdue: 'Days overdue',
    daysComingdue: 'Days coming due',
    loadingDataMessage: 'Loading data... this may take a few seconds'
};

/*RBAC Errors*/
export const RbacErrors = {
    106: "Votre rôle ne vous permet pas de modifier le contenu. Vous pouvez obtenir les droits requis auprès de l’administrateur de la mission."
};

/*Errors*/
export const Errors = {
    /*Doc Helper Custom Messages */
    0: "Connexion perdue. Veuillez vous reconnecter et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    101: "État de la mission non valide",
    102: "Utilisateur de la mission valide introuvable",
    103: "Information manquante : Conformité aux obligations en matière d’indépendance de l’utilisateur de la mission",
    104: "Information manquante : Étendues requises dans Azure AD ",
    105: "Une erreur s’est produite lors de l’obtention des autorisations pour la mission. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    106: "Vous ne disposez pas des autorisations requises pour effectuer cette action.",
    107: "Utilisateur de la mission valide introuvable. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    108: "Le profil de la mission est incomplet. Veuillez aller à la page d’accueil et créer votre profil.",
    303: "Un document ayant le même nom est en cours de téléchargement.",
    401: "L’opération ne peut pas être traitée pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    403: "est dans un format de fichier qui n’est pas pris en charge et n’a pas été téléchargé. Enregistrez le document dans un format de fichier valide et téléchargez-le de nouveau. Si le problème persiste, communiquez avec le Service de dépannage.",
    410: "Ce document a été supprimé et ne peut donc pas être ouvert.",
    411: "Les documents vides ne sont pas autorisés.",
    412: "Un document du même nom existe déjà dans cette mission.",
    413: "Le document dépasse la taille de fichier maximale permise (250 Mo) et ne peut pas être téléchargé. Veuillez diminuer la taille du fichier et réessayer.",
    500: "Connexion perdue. Veuillez vous reconnecter et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    414: "Le nom dépasse la longueur maximale ({0} caractères).",
    600: "L’opération ne peut pas être traitée pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    601: "Un document du même nom existe.",
    602: "Le document est déjà en mode collaboration.",
    603: "Document introuvable.",
    'zip': "Le fichier .zip ne peut pas être téléchargé parce qu'il contient au moins un type de fichier qui n'est pas pris en charge ou il contient trop de fichiers .zip incorporés.",
    401000: "Un changement de réseau a été détecté. Veuillez actualiser la page pour continuer.",

    /*Accounts*/
    1001: "Échec de la demande de création du compte",
    1002: "Information manquante : nom du compte",
    1003: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1004: "Aucun résultat. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    1005: "Code de la mission invalide",
    1006: "Type de compte invalide",
    1007: "Type d’état invalide",
    1008: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1009: "Échec de la demande d’extraction par code de compte",
    1010: "Échec de la demande d’extraction de comptes par code de mission",
    1011: "Échec de la demande d’extraction de la synthèse des procédures de corroboration pour un code de compte en raison d’une demande invalide",
    1012: "Type de synthèse invalide",
    1013: "Échec de la demande de création de la revue des comptes",
    1014: "Échec de la demande de suppression de la revue des comptes",
    1015: "Demande de création de la revue des comptes invalide",
    1016: "Identifiant de la revue des comptes non valide.",
    1017: "Le compte ne fait pas partie de cette mission ou a été supprimé.",
    1018: "La revue des comptes a été créée par un autre utilisateur.",
    1019: "Le compte a été supprimé par un autre utilisateur. Veuillez actualiser la page et réessayer.",
    1020: "Les PCB du compte doivent être mises à jour",
    1024: "Le nom du compte ne doit pas dépasser 500 caractères.",
    1025: "Le compte négligeable ou présentant un risque limité ne peut pas faire l’objet d’une estimation",
    1026: "Le compte ne peut pas contenir des assertions ayant été dupliquées",
    1027: "Identifiant de l’assertion non valide",
    1037: "Ne peut contenir des références PCB déjà utilisées",
    1039: 'The selected Account has been deleted. Close this modal to see the updated list.',
    1048: "Le type d’exécution pour le compte est invalide.",
    1053: "Impossible de définir le compte comme présentant un risque limité ou comme un compte négligeable, car un risque ou une estimation y est associé.",
    1054: "Les assertions devant être supprimées sont associées à un risque ou à une estimation.",
    1065: "Vous ne pouvez pas modifier les assertions qui sont associées à un risque important, un risque de fraude, un risque d’anomalies significatives ou une estimation. Vous devez d’abord supprimer ces relations.",

    1266: 'Engagement has reached maximum number of multi-edit mode documents.  Check some documents back in and try again.  If the issue persists contact the Help Desk.',
    1267: 'Document is conflicted. Resolve conflicts and try again.  If the issue persists, contact the Help Desk.',
    1268: 'Document is already in co-edit mode. end co-edit mode and try again.  If the issue persists, contact the Help Desk.',
    1269: 'Document is a shared evidence. Unlink and try again.  If the issue persists, contact the Help Desk.',

    /*Assertions*/
    2001: "Demande de création invalide",
    2002: "Information manquante : nom de l’assertion",
    2003: "Assertion manquante",
    2004: "Échec de la demande d’extraction de l’assertion",
    2005: "Code de la mission invalide",
    2006: "Échec de la demande d’extraction par code d’assertion",
    2007: "Échec de la demande d’extraction des erreurs possibles associées à l’assertion",
    2050: "Assertion introuvable. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    /*Tags*/
    5120: "Code de la balise introuvable.",
    5121: "Code de la balise manquant.",
    5123: "Duplication d’associations aux balises",
    5124: "Éléments associés aux balises introuvables",


    /*Risks*/
    4001: "L’opération ne peut pas être traitée pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    4002: "Information manquante : nom du risque",
    4003: "Risque manquant",
    4004: "Échec de la demande d’extraction du risque",
    4005: "Code de la mission invalide",
    4006: "Échec de la demande d’extraction par code de risque ",
    4007: "Demande de recherche invalide",
    4008: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4009: "Demande de mise à jour invalide",
    4010: "Une erreur possible a déjà été associée à ce risque.",
    4011: "La liste d’erreurs possibles ne peut pas être nulle.",
    4012: "Échec de l’extraction des types de risques",
    4013: "Demande de création invalide",
    4014: "L’assertion associée est invalide. Actualisez la page et réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    4015: "L’erreur possible sélectionnée est invalide. Actualisez la page et réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    4016: 'The selected Risk has been deleted. Close this modal to see the updated list.',
    4017: "L’assertion associée au risque est invalide. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    4018: "Le code du type de risque transféré est invalide.",
    4019: "Le nom du risque est invalide.",
    4020: "Identifiant du document invalide.",
    4021: "Le nom du risque ne doit pas dépasser 500 caractères.",
    4023: "La liste des identifiants d’assertions ne peut être nulle.",
    4024: "Le formulaire relatif à la documentation sur le compte présentant un risque limité n’a pas pu être créé en raison d’une erreur. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    4025: "Identifiant du compte invalide",
    4026: "Identifiant de l’assertion invalide.",
    4027: "Le modèle de risque de l’assertion ne peut pas être vide",
    4031: "Option de risque ou de corps de texte invalide.",

    4035: "Impossible de modifier l’attribut de risque élevé pour les risques importants ou les risques de fraude.",
    4036: "KnowledgeAssertionId cannot be empty if no AssertionId is passed in. KnowledgeAssertionId must be in enums",
    4037: "Un identifiant de l’assertion de la base de connaissances existe déjà pour ce compte.",
    4038: "L’identifiant du type de risque ne correspond pas aux options permises.",
    4040: "Cette action n’est pas permise. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*TASK*/
    5001: "Échec de l’extraction",
    5002: "Cette tâche n’est plus disponible dans cette mission.",
    5003: "Échec de l’extraction des documents pour la tâche sélectionnée. Paramètres de demande invalides.",
    5004: "Échec de l’extraction des documents pour la tâche associée. Paramètres de demande invalides.",
    5005: "Échec de l’extraction par code de tâche ",
    5006: "Échec de la demande d’extraction des catégories de tâches",
    5007: "Échec de la demande d’extraction des sous-catégories de tâches",
    5008: "Échec de la demande d’extraction de la description de tâche",
    5009: "Échec de la demande d’extraction des demandes au client associées à la tâche",
    5010: "Échec de la demande d’enregistrement des demandes au client associées à la tâche",
    5011: "La tâche à laquelle vous voulez associer des éléments a été supprimée ou rejetée.",
    5012: "L’élément que vous voulez associer a été supprimé.",
    5013: "La tâche à laquelle vous voulez associer des éléments a été supprimée ou rejetée.",
    5014: "Le document que vous voulez associer a été supprimé.",
    5015: "Échec de la demande d’extraction des éléments probants associés à la tâche",
    5016: "Échec de la demande d’extraction de l’erreur possible associée à la tâche",
    5017: "Le code de la mission doit être supérieur à zéro.",
    5018: "Cette action ne peut pas être traitée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5019: "La description de la tâche est vide.",
    5020: "La tâche sélectionnée a été supprimée ou rejetée. Par conséquent, cette action ne peut pas être réalisée à l’heure actuelle.",
    5021: "Information manquante : code de la mission source",
    5022: "Échec de l’enregistrement de l’annotation",
    5023: "Utilisateur de la mission introuvable",
    5024: "Échec de la demande de suppression de la tâche",
    5025: "Échec de la demande de suppression des tâches",
    5026: "La liste des tâches est vide.",
    5027: "Revue introuvable",
    5028: "Le nom du fichier est requis.",
    5029: "L’extension de fichier est requise.",
	5030: 'Le nom du fichier ne peut pas contenir les caractères suivants : */:<>\\?|\"',
    5031: "Erreur dans la mise à jour du nom du document",
    5032: "Code du document invalide",
    5033: "Type d’opération introuvable",
    5034: "Échec de la modification de l’état de la tâche",
    5035: "L’action que vous essayez d’effectuer ne peut pas être réalisée à l’heure actuelle. Veuillez réessayer plus tard. Si le problème persiste, communiquez avec le Service de dépannage.",
    5036: "Le corps de texte de la demande ne peut pas être nul ou vide.",
    5037: "La demande ne peut contenir une requête nulle.",
    5038: "Entrer un nom de fichier unique pour continuer",
    5039: "Le nom du fichier est requis.",
    5040: "Le nom du fichier ne peut pas dépasser 100 caractères.",
	5041: 'Le nom du fichier ne peut pas contenir les caractères suivants : */:<>\\?|\"',
    5042: "La tâche sélectionnée est rejetée.",
    5043: "La tâche est une tâche Étape de production.",
    5044: "La tâche est une tâche Jalon.",
    5045: "La tâche n’est pas une tâche de type PCB ni APC.",
    5046: "La limite de caractères a été dépassée.",
    5047: "La limite de caractères a été dépassée.",
    5048: "Champ obligatoire",
    5049: "Le document sélectionné ne peut pas être retiré de cette tâche. Actualisez la page et réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage. ",
    5050: "Le code du groupe de tâches ne doit pas être zéro ou invalide.",
    5051: "Le code de la section de tâches ne doit pas être zéro ou invalide.",
    5052: "Une erreur s’est produite lors de l’ajout de ce document à la tâche actuelle. Échec de la demande.",
    5053: "Une erreur s’est produite lors de la mise à jour de ce document dans la tâche actuelle. Échec de la demande.",
    5054: "Une erreur s’est produite lors de l’ajout d’une copie de ce document à la tâche actuelle. Échec de la demande.",
    5055: "Une erreur s’est produite au moment de renommer le document. Échec de la demande.",
    5056: "Le titre de la tâche ne peut être modifié dans la base de connaissances ou pour le groupe.",
    5057: "Le type de tâche doit être réglé à ATS.",
    5058: "Ce document ne peut pas être retiré de la tâche, car il est associé au système.",
    5059: "Valeur de la période invalide",
    5060: "Erreur dans l’ajout d’éléments probants. Échec de la demande.",
    5061: "Un autre utilisateur a mis à jour l’information présentée. Actualisez la page et réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage. ",
    5062: "Le document demandé n’est pas disponible dans l’édition EY Atlas sélectionnée pour la mission. Afin d’en demander l’inclusion, veuillez communiquer avec le Service de dépannage, qui pourra transmettre l’information aux auteurs de contenu.",
    5063: "Opération de correction invalide",
    5064: "La tâche sélectionnée a été supprimée ou rejetée. Par conséquent, cette action ne peut pas être réalisée à l’heure actuelle.",
    5065: "Le type de source de la tâche ne peut être mis à jour. La demande est invalide.",
    5066: "Erreur lors de l’extraction des indications. Échec de la demande.",
    5067: "Le type de nature de la tâche ne peut être mis à jour. La demande est invalide.",
    5068: "Le type de nature de la tâche ne peut être mis à jour. La demande est invalide.",
    5069: "Échec de la demande de suppression de la tâche attribuée",
    5070: "Une ou plusieurs tâches sélectionnées ont été supprimées. Veuillez réessayer ou communiquez avec le Service de dépannage si le problème persiste.",
    5071: "L’affectation ne peut être mise à jour. La demande est invalide.",
    5072: "Préparateur introuvable. La demande est invalide.",
    5073: "Affectation introuvable.",
    5074: "Échec de l’enregistrement de la tâche attribuée.",
    5075: "La ou les tâches sélectionnées ont été attribuées deux fois au membre de l’équipe ou au rôle sélectionné. Choisissez une autre affectation, un autre membre de l’équipe ou un autre rôle pour continuer. Si le problème persiste, communiquez avec le Service de dépannage.",
    5076: "Le membre de l’équipe sélectionné n’est pas un membre actif de cette mission. Veuillez réessayer ou communiquez avec le Service de dépannage si le problème persiste.",
    5077: "Une ou plusieurs tâches sélectionnées ont été supprimées. Veuillez réessayer ou communiquez avec le Service de dépannage si le problème persiste.",
    5078: "L'attribution de tâche sélectionnée a été retirée. Veuillez réessayer ou communiquer avec le Service de dépannage si le problème persiste.",
    5079: "Une ou plusieurs tâches sélectionnées ont été supprimées. Veuillez réessayer ou communiquez avec le Service de dépannage si le problème persiste.",
    5080: "L’enregistrement de la version du document n’existe pas.",
    5081: "L’utilisateur actuellement affecté à cette tâche ne peut pas être réaffecté au rôle de préparateur.  Veuillez réessayer ou communiquez avec le Service de dépannage si le problème persiste.",
    5082: "Échec de la mise à jour. Le nom du document doit être unique pour une mission. Actualisez la page pour supprimer ce message.",
    5083: "La limite de caractères des détails de la tâche est dépassée.",
    5084: "Échec de la demande de création d’un document tâche.",
    5085: "Échec de la demande de suppression d’un document tâche.",
    5086: "Échec de la demande de création de transmission de tâche.",
    5087: "Task patch call failed.",
    5088: "Cette tâche doit contenir des éléments probants à transmettre. Veuillez réessayer ou communiquez avec le Service de dépannage.",
    5089: "Tous les éléments probants associés à cette tâche (sauf les profils papier) doivent avoir au moins un préparateur et un responsable de la revue pour être inscrits comme terminés. Veuillez réessayer ou communiquez avec le Service de dépannage si le problème persiste.",
    5091: "Le nom du profil papier existe déjà dans la mission.",
    5092: "Le nom ne peut pas contenir les caractères suivants : */:<>\\?|\\",
    5093: "Le nom du profil papier dépasse la longueur maximale (100 caractères).",
    5101: "Échec de la création de la tâche.",
    5102: "Description de la tâche manquante.",
    5103: "Titre de la tâche manquant.",
    5104: "Période relative à la tâche manquante.",
    5105: "L’association de tâches ne peut pas être modifiée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5106: "Phase de l’audit invalide.",
    5107: "La phase de l’audit devrait être 'Étendue et stratégie' ou 'Exécution'.",
    5108: "La description de la tâche est trop longue.",
    5109: "Paramètre du type de rôle invalide.",
    5110: "L’identifiant de l’affectation doit être supérieur à zéro.",
    5111: "L’élément auquel vous tentez d’associer des tâches a été supprimé. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5112: "L’élément auquel vous tentez d’associer des tâches a été supprimé. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5113: "L’élément auquel vous tentez d’associer des tâches a été supprimé. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5116: "Le type de document est non valide.",
    5119: "L’état de la tâche ou des tâches sélectionnées n’a pas été mis à jour. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5127: "Échec de l’association. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5129: "Échec de l’association. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5133: "Échec de l’association. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5137: "L’association de tâches ne peut pas être modifiée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5138: "L’association de tâches ne peut pas être modifiée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5140: "L’association de tâches ne peut pas être modifiée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5146: "Tous les éléments probants associés à une tâche (sauf les profils papier) doivent avoir au moins un préparateur et un responsable de la revue pour que la tâche puisse être terminée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5150: "Une ou plusieurs automatisations ne peuvent pas être associées à la tâche sélectionnée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    5156: "L’association de tâches ne peut pas être modifiée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5157: "L’association de tâches ne peut pas être modifiée. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5159: "Le type de document partagé n’est pas valide.",
    5160: "Une erreur s’est produite lors de l’association du document. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5174: "La tâche doit être associée à au moins une entité. Pour que la tâche s’applique à l’ensemble de la mission, cliquez sur le bouton Tâches par entité.",
    5184: "Le type de tâche ne correspond pas à une tâche standard de base ou à une procédure de corroboration de base.",
    5185: "La tâche comportant des documents transmis par EY Canvas ne peut pas être rejetée. ",
    5188: "Document invalide ou dissociation en cours.",
    5189: "La tâche comporte des documents avec des éléments probants liés ou des réponses liées. ",
    5190: "Au moins une assertion doit être associée à la tâche.",
    5191: "Échec de l’association. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5192: "L’élément auquel vous tentez d’associer des tâches a été supprimé. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    5193: "L’élément sélectionné a été supprimé. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",


    /*WCGW*/
    6001: "Échec de la demande de création de l’erreur possible",
    6002: "Information manquante : nom de l’erreur possible",
    6003: "Erreur possible manquante",
    6004: "Échec de la demande d’extraction de l’erreur possible",
    6005: "Code de la mission invalide",
    6006: "L’action demandée n’a pas pu être réalisée, car l’identifiant de l’assertion est invalide ou a été supprimé. Veuillez actualiser la page et réessayer.",
    6007: "Échec de la demande d’extraction par code d’erreur possible",
    6008: "Demande invalide",
    6009: "L’action demandée n’a pas pu être réalisée, car l’identifiant de l’erreur possible est invalide ou a été supprimé. Veuillez actualiser la page et réessayer.",
    6010: "La tâche n’a pas pu être associée à l’erreur possible.",
    6011: "L’erreur possible sélectionnée a été supprimée.",
    6012: "La tâche et l’erreur possible ne sont pas associées à la même assertion.",
    6013: "La tâche sélectionnée ne fait pas partie de la même mission.",
    6014: "La tâche n’a pas pu être dissociée de l’erreur possible.",
    6015: "La tâche n’a pas pu être associée à l’erreur possible.",
    6016: "La tâche est rejetée et ne peut pas être associée à l’erreur possible.",
    6017: "La tâche n’est pas une tâche Jalon et ne peut pas être associée à l’erreur possible.",
    6018: "La tâche n’est pas une tâche Étape de production et ne peut pas être associée à l’erreur possible.",
    6019: "La tâche n’est pas une tâche de type PCB ni APC et ne peut pas être associée à l’erreur possible.",
    6020: "La tâche et l’erreur possible sont associées à la même assertion et ne peuvent pas être associées à l’erreur possible.",
    6027: "Identifiant de l’erreur possible ou du contrôle non valide.",
    6028: "Échec de l’association. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    6029: "Échec du retrait. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*Engagement*/
    7001: "Extraction par code introuvable",
    7002: "Échec de la demande d’extraction des missions par code d’espace de travail",
    7003: "Échec de la demande d’extraction de toutes les entités de la mission",
    7004: "Échec de la demande d’extraction des missions par code",
    7005: "Échec de la demande d’extraction de tous les utilisateurs de la mission",
    7006: "Le nom de famille ne doit pas dépasser 250 caractères.",
    7007: "Erreur – Type d’utilisateur invalide",
    7008: "Le prénom ne doit pas dépasser 250 caractères.",
    7009: "L’identificateur unique mondial (GUI) de l’utilisateur ne peut pas être nul.",
    7010: "Erreur - État de l’utilisateur invalide",
    7011: "Échec de la demande de création de l’utilisateur de la mission",
    7012: "{0} {1} ne peut être invité(e) à participer, étant déjà un membre actif ou potentiel de l’équipe.",
    7013: "Les initiales ne doivent pas dépasser 3 caractères.",
    7014: "Vous ne pouvez pas accéder à la page d’accueil d’EY Canvas pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    7015: "{0} {1} ne peut pas être invité, car le(s) groupe(s) d’accès suivant(s) ont été supprimés de la mission : {2} Actualisez la page et réessayez.",
    7016: "{0} {1} ne peut pas être invité(e), car l’utilisateur est déjà un membre actif dans le(s) groupe(s) d’accès suivant(s) : {2}",
    7017: "Le(s) groupe(s) sélectionné(s) n’ont pas accès au domaine : {0}",
    7018: "L’adresse courriel ne doit pas être nulle.",
    7019: "Le prénom ne doit pas être nul.",
    7020: "Le nom de famille ne doit pas être nul.",
    7021: "Les initiales de l’utilisateur ne doivent pas être nulles.",
    7022: "Le bureau principal de l’utilisateur ne doit pas être nul.",
    7023: "Le nom de connexion de l’utilisateur ne doit pas être nul.",
    7024: "Le rôle de l’utilisateur chez EY ne doit pas être nul.",
    7025: "Le rôle de l’utilisateur dans la mission ne doit pas être nul.",
    7026: "L’opération ne peut pas être traitée pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    7027: "Adresse courriel invalide",
    7028: "Échec de la demande de correction de l’utilisateur de la mission",
    7029: "Utilisateurs de la mission - Code de l’état de l’utilisateur de la mission invalide",
    7030: "Utilisateurs de la mission - Code du rôle de l’utilisateur de la mission invalide",
    7031: "Un ou plusieurs identifiants utilisateur de la mission sont introuvables.",
    7032: "L’adresse courriel ne doit pas dépasser 250 caractères.",
    7033: "L’utilisateur demandé ne peut pas être nul.",
    7034: "Universal Message Processor Queue Failed.",
    7035: "Les initiales ne doivent pas dépasser 3 caractères.",
    7036: "Le prénom ne doit pas dépasser 250 caractères.",
    7037: "Le nom de famille ne doit pas dépasser 250 caractères.",
    7038: "Échec de la demande de création de l’utilisateur externe",
    7039: "Un ou plusieurs utilisateurs ne peuvent être invités à participer étant déjà des membres actifs ou potentiels de l’équipe. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    7040: "Le prénom ne doit pas dépasser 250 caractères.",
    7041: "Le nom de famille ne doit pas dépasser 250 caractères.",
    7042: "Les initiales ne doivent pas dépasser 3 caractères.",
    7043: "Le matricule mondial ne doit pas dépasser 250 caractères.",
    7044: "L’identificateur unique mondial (GUI) ne doit pas dépasser 250 caractères.",
    7045: "Échec de la récupération de l’utilisateur externe par son identifiant",
    7046: "L’utilisateur ne doit pas être nul.",
    7047: "Les modifications ne peuvent pas être enregistrées pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    7048: "La page d’accueil d’EY Canvas, requise pour la modification, n’est pas accessible pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    7049: "Échec de la demande de mise à jour de l’utilisateur de la mission",
    7050: "Les membres ne peuvent pas être désactivés. Au moins un membre de la mission doit être autorisé à gérer la mission. Veuillez modifier votre sélection et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    7051: "Échec de la récupération de l’utilisateur interne par son identifiant",
    7052: "Utilisateur introuvable",
    7053: "Extraction par identifiant introuvable",
    7054: "Échec de la demande de récupération des liens rapides par identifiant de mission",
    7055: "Vous ne disposez pas des droits requis pour ajouter d’anciens membres. Veuillez communiquer avec un membre de l’équipe de mission disposant des droits appropriés pour effectuer cette action.",
    7056: "Les modifications ne peuvent pas être enregistrées dans EY Canvas pour le moment. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    7057: "Vous ne disposez pas des droits requis pour ajouter de nouveaux membres. Veuillez communiquer avec un membre de l’équipe de mission disposant des droits appropriés pour effectuer cette action.",
    7058: "L’état de l’utilisateur a changé. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    7062: "Le portail client d’EY Canvas, requis pour la mise à jour des renseignements relatifs au membre existant, n’est pas accessible pour le moment. Essayez de nouveau et si le problème persiste, communiquez avec le Service de dépannage.",
    7063: "Il n’est pas possible de désactiver les membres externes. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    7064: "Opération de correction non valide",
    7065: "{0} {1} ne peut pas être activé dans un ou plusieurs groupes d’accès. Le(s) groupe(s) sélectionné(s) n’ont pas accès au domaine : {2}",
    7066: "{0} n’est pas un utilisateur valide.",
    7067: "Put external user call failed.",
    7068: "Le portail client d’EY Canvas, requis pour la mise à jour des renseignements relatifs au membre existant, n’est pas accessible pour le moment. Essayez de nouveau et si le problème persiste, communiquez avec le Service de dépannage.",
    7069: "Les groupes d’accès sélectionnés sont inactifs : {0}. Supprimez-les et réessayez.",
    7072: "Une erreur s’est produite pendant le processus de détachement de la mission. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    7074: "Les modifications ne peuvent pas être enregistrées. Au moins un membre actif de la mission doit être autorisé à gérer la mission et avoir résolu les questions d’indépendance. Si le problème persiste, communiquez avec le Service de dépannage.",
    7075: " {0} {1} ne peut être invité(e) à participer, étant déjà un membre actif de l’équipe.",
    7077: "Il n’est pas possible de désactiver un ou plusieurs utilisateurs. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    7079: "Le domaine n’est pas autorisé. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    7080: "Vous ne disposez pas des autorisations requises pour inviter des membres tiers. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage pour obtenir les autorisations s’il y a lieu. ",
    7094: "Le membre de l’équipe sélectionné a approuvé des documents dans le cadre de cette mission et ne peut pas être retiré.",
    7100: "Impossible de traiter les modifications apportées aux champs restreints. Actualisez la page et réessayez.",

    /*SCOT*/
    8001: "Échec de la demande de création de la catégorie importante d’opérations",
    8002: "Information manquante : nom de la catégorie importante d’opérations",
    8003: "Catégorie importante d’opérations manquante",
    8004: "Échec de la demande d’extraction de la catégorie importante d’opérations",
    8005: "Code de la mission invalide",
    8006: "Code de l’assertion invalide",
    8007: "Échec de la demande d’extraction par code de catégorie importante d’opérations",
    8008: "Demande invalide",
    8009: 'The selected SCOT has been deleted. Close this modal to see the updated list.',
    8028: 'The selected SCOT has been deleted. Close this modal to see the updated list.',

    /*User*/
    10001: "Préférences de l’utilisateur connecté introuvables",
    10002: "Échec de la demande d’extraction de tous les utilisateurs",
    10003: "Échec de la demande d’extraction de la disponibilité des utilisateurs",

    /*Risk Type*/
    11001: "Demande de création invalide",
    11002: "Information manquante : nom du type de risque",
    11003: "Information manquante : type de risque",
    11004: "Échec de la demande d’extraction du type de risque",
    11005: "Code de la mission invalide",

    /* Annotation Errors*/
    12001: "Paramètres de demande invalides",
    12002: "Échec de la demande de création de l’annotation",
    12003: "Échec de l’extraction de l’annotation",
    12004: "Code de la mission invalide",
    12005: "Les codes dans la collection doivent être supérieurs à zéro.",
    12006: "La collection de codes ne peut pas être vide.",
    12007: "Code de la tâche invalide",
    12008: "Code du document invalide",
    12009: "L’identifiant du document, de la tâche ou des états financiers doit être valide. ",
    12010: "Les réponses nécessitent un document parent.",
    12011: "Code de l’état invalide",
    12012: "Le type de document doit être 440GL.",
    12013: "Type d’annotation invalide",
    12014: "Utilisateur de la mission invalide",
    12015: "Ce document a été supprimé par un autre utilisateur.",
    12016: "Échec de la demande de mise à jour de l’annotation",
    12017: "La note à laquelle vous répondez a été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    12018: "Le type de modification de l’annotation ne doit pas être nul.",
    12019: "Note de revue supprimée",
    12020: "Action invalide",
    12021: "L’utilisateur n’est pas l’auteur de l’annotation.",
    12022: "Information manquante : utilisateur auteur",
    12023: "L’utilisateur auteur n’existe pas ou ne fait pas partie de la mission.",
    12024: "Utilisateur désigné requis",
    12025: "L’utilisateur désigné n’existe pas ou ne fait pas partie de la mission.",
    12026: "Notes invalides.",
    12027: "Les notes ne doivent pas être vides.",
    12028: "Date d'échéance requise",
    12029: "Priorité valide requise",
    12030: "L’état de cette note a changé. Vous ne pouvez plus la modifier ou y répondre. Veuillez fermer la fenêtre et la rouvrir pour voir les données mises à jour et poursuivre l’édition.",
    12031: "Annotation must be top level.",
    12032: "Annotation must not be top level.",
    12033: "Au moins une des valeurs suivantes ne doit pas être vide : type de priorité, date d’échéance, état ou utilisateur désigné.",
    12034: "Les notes dépassent la longueur maximale (4 000 caractères).",
    12035: "La chaîne de recherche dépasse la longueur maximale (500 caractères)",
    12036: "Seul le code de la tâche ou le code du document peut être accepté. Il n’est pas permis d’accepter les deux codes.",
    12037: "Opération de correction invalide",
    12038: "Vous essayez de modifier une note qui n’existe plus. Veuillez actualiser la page et réessayer.",
    12039: "Vous essayez de modifier la même note qu’un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    12040: "Échec de la demande d’extraction des utilisateurs de l’annotation",
    12041: "Échec de l’extraction des utilisateurs de l’annotation. Valeur de recherche invalide.",
    12042: "Le type de document ne permet pas de créer une annotation.",
    12043: "Vous essayez d’ajouter une note à une tâche ou à un document qui n’existe plus. Veuillez actualiser la page et réessayer plus tard.",
    12044: "Vous essayez de modifier une réponse à une note qui n’existe plus. Veuillez actualiser la page et réessayer.",
    12045: "Note de revue introuvable",
    12046: "Vous essayez de supprimer une note qui a déjà été supprimée par un autre membre de l’équipe. Actualisez la page et réessayez.",
    12047: "Vous pouvez uniquement supprimer les réponses aux notes ouvertes. Actualisez la page et réessayez.",
    12048: "Vous essayez de modifier l’état d’une note qui n’existe plus. Actualisez la page et réessayez.",
    12049: "Vous essayez de supprimer la réponse à une note qui a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    12050: "Vous pouvez uniquement supprimer les notes fermées.",
    12059: "Les notes de revue ne peuvent être supprimées que par l’utilisateur qui les a créées.",
    12066: "Vous pouvez uniquement répondre aux notes ouvertes.",
    12067: "Vous essayez de supprimer la réponse à un commentaire qui a déjà été supprimé par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    12068: "Le commentaire n’a pas pu être ajouté. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    12070: "Vous ne pouvez ajouter qu’un commentaire par état financier. Veuillez modifier le commentaire existant.",
    12071: "Échec de la suppression de l’information. Veuillez réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*Configuration*/
    13001: "Configuration introuvable",
    13002: "Get Configurations API call failed.",

    /*Documents*/
    14001: "La demande ne peut pas être soumise, car l’objet de la requête est nul.",
    14002: "Document introuvable. Échec de la demande.",
    14003: "Le code de la mission doit être supérieur à zéro.",
    14004: "Le code du document ne doit pas être nul ou vide.",
    14005: "Une erreur s’est produite lors de la récupération des tâches associées. Échec de la demande.",
    14006: "Le document sélectionné ne peut pas être supprimé. Réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage. ",
    14007: "Une erreur imprévue s’est produite.",
    14008: "Une erreur imprévue s’est produite lors de l’approbation.",
    14009: "Une erreur s’est produite lors de l’ajout d’une approbation.",
    14010: "Le code d’approbation doit être supérieur à zéro.",
    14011: "Une erreur s’est produite lors de la suppression d’une approbation.",
    14012: "Le corps de texte ne peut pas être vide.",
    14013: "Le document sélectionné ne peut pas être détaché. Réessayez plus tard. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    14014: "Échec de la demande de récupération par identifiant de document",
    14015: "Entité connexe invalide",
    14016: "Échec de la demande d’extraction de l’approbation du document",
    14017: "Échec de la demande d’extraction de toutes les constatations du document",
    14018: "Échec de la demande d’extraction de tous les documents",
    14019: "Approbation introuvable.",
    14020: "Valeur de l’action invalide",
    14021: "Type de constatation invalide",
    14022: "Le document ne fait pas partie de cette mission.",
    14023: "La modification apportée au document est invalide.",
    14024: "Échec de la demande d’extraction de tous les documents. Les paramètres sont invalides.",
    14025: "Une erreur s’est produite lors de la création de la revue du document. Échec de la demande de l’interface de programmation.",
    14026: "Une erreur s’est produite lors de la suppression de la revue du document. Échec de la demande de l’interface de programmation.",
    14027: "Le code mission ne doit pas être nul ou vide.",
    14028: "Le code utilisateur est invalide.",
    14029: "L’utilisateur n’est pas autorisé à effectuer cette action.",
    14030: "Aucun document avec le code transféré n’a été trouvé dans cette mission.",
    14031: "Le code de la revue du document est invalide.",
    14032: "Le code de l’examen du document est introuvable.",
    14033: "Le document a déjà été approuvé.",
    14034: "Un processus de détachement est en cours pour une autre mission dans l’espace de travail ou ce document a déjà été détaché. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    14035: "Le document n’est pas partagé avec la mission.",
    14036: "Le numéro de la version doit être supérieur à zéro.",
    14037: "L’opération ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    14038: "Échec de la récupération des raisons du changement du document",
    14039: "Échec de la récupération des raisons du changement du document par identifiant",
    14040: "Échec de la mise à jour de la raison du changement",
    14041: "Raison du changement invalide",
    14042: "Échec de la mise à jour de la raison du changement",
    14043: "Échec de la création de la raison du changement",
    14044: "Échec de la suppression de la raison du changement",
    14045: "Invalid change reason Id.",
    14046: "Le document n’est pas disponible. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    14047: "La raison du changement apporté au document a déjà été indiquée.",
    14048: "Le document comporte un conflit. Veuillez le résoudre avant de continuer.",
    14049: "Les données indiquant si le document a été ajouté à l’équipe ou à l’utilisateur sont invalides.",
    14050: "Une erreur s’est produite lors de la suppression du document de référence.",
    14051: "Unlink all shared evidence checklist not found.",
    14052: "Le texte recherché dépasse la longueur maximale permise (500 caractères)",
    14053: "La demande ne peut pas être soumise, car l’objet de la requête est nul.",
    14054: "Opération de correction non valide",
    14055: "Échec de la demande de résolution de l’historique des documents",
    14056: "Une erreur s’est produite lors de l’ajout du message à la file d’attente.",
    14057: "Un document du même nom existe déjà dans la mission.",
    14058: 'More than one document version with the same number has been found. Please contact Help Desk for further assistance.',
    14059: 'The selected document version couldnt be found. Please refresh the page and try again. If the issue persists, please contact Help Desk for further assistance.',
    14060: 'The operation couldnt be completed at the time. Please try again later. If the issue persists, please contact Help Desk for further assistance.',
    14061: 'Document is not shared, cant unlink the document. If the issue persists, please contact Help Desk for further assistance.',
    14062: 'The document confidentiality type id is not valid.',
    14063: 'Cannot change confidentiality type of this document type.',
    14064: 'User doesnt have permission.',
    14065: 'Invalid custom description.',
    14066: 'Failed to update extension.',
    14067: 'Invalid extension.',
    14068: 'Failed to get document extensions.',
    14069: "Ce document a déjà été dissocié par un autre membre de l’équipe. Actualisez la page et communiquez avec le Service de dépannage si le problème persiste.",
    14070: "Type de fichier invalide.",
    14071: "La version du document sélectionnée n’est plus disponible. Veuillez fermer et rouvrir cette fenêtre pour afficher le dernier ensemble de versions historiques de ce document.",
    14072: 'Source document Id should not be null or empty.',
    14073: 'Canvas form ids should not be null or empty.',
    14074: "Canvas form ID's should not be duplicates.",
    14075: 'Failed to associate document to canvas forms.',
    14076: "Document source associé aux formulaires Canvas introuvable.",
    14077: 'Source document not found. Call failed.',
    14078: 'Current document is already associated with given canvas forms.',
    14079: "Ce document a été supprimé et ne peut pas être ouvert.",
    14080: 'The source approval user id is invalid.',
    14081: 'The source approval user id should valid GUID and must not be empty GUID.',
    14082: 'The modify user id is invalid.',
    14083: 'The modify user id should be a valid GUID and must not be empty GUID.',
    14084: 'File name cannot include: */:<>\\?|""',
    14085: 'The document name exceeded maximum length allowed.',
    14086: 'DocService failed while updating document details.',
    14087: 'The input is not valid.',
    14088: 'A input has duplicate document names.',
    14089: "Le signet relatif à l’observation est invalide.",
    14090: "L’état de la demande a changé. Veuillez actualiser la page et réessayer s’il y a lieu. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    14091: "Cette demande a été supprimée. Veuillez actualiser la page pour afficher les données les plus récentes. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    14092: 'Document not eligible for update. Refresh the page and try again.  If the issue persists, contact the Help Desk.',

    /*SEM*/
    15001: "Échec de la demande d’extraction de la synthèse des procédures de corroboration pour un code de compte en raison d’une demande invalide",
    15002: "Code du compte invalide",
    15003: "Code de la mission invalide",
    15004: "Type de synthèse invalide",
    15005: "Le compte connexe est introuvable. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*Timephase*/
    16001: "Échec de l’extraction des périodes",
    16002: "La mission doit être supérieure à zéro.",
    16003: "La période doit être supérieure à zéro.",
    16004: "Valeur du code de la tâche invalide",
    16005: "Valeur de la période invalide",

    /*Validations*/
    17001: "Information manquante : code de l’étape de production ou du type de document",

    /*TaskGroupSection*/
    18001: "Échec de la demande de récupération de tous les groupes de tâches.",
    18005: "Ce groupe de tâches n’est plus disponible dans cette mission.",
    18006: 'This task group is no longer available. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    18016: "Les groupes de tâches peuvent être supprimés uniquement lorsqu’aucune tâche n’y est associée. Supprimez ou déplacez les tâches associées et essayez à nouveau.",
    18019: "Le groupe de tâches que vous essayez de mettre à jour a été supprimé.",

    /*Assignments*/
    19001: "Échec de la demande de création de l’affectation",
    19002: "Échec de la demande d’extraction de l’affectation",
    19003: "Le nom de l’affectation doit être unique",
    19004: "Nom de l’affectation non valide",
    19005: "Le nom de l’affectation dépasse la longueur maximale de 100 caractères.",
    19006: "Type d’affectation non valide",
    19007: "Recherchez les affectations dont l’énoncé dépasse 500 caractères. ",
    19008: "Le nom de cette affectation a été supprimé par un autre membre de l’équipe. Actualisez la page et réessayez.",

    19012: "Ces identifiants de tâche ne peuvent pas être répétés.",
    19013: "Il n’est pas possible de remplir le champ de l’identifiant du rôle et celui de l’identifiant de l’utilisateur en même temps. ",
    19014: "L’identifiant de l’utilisateur ne peut pas être la valeur par défaut.",
    19016: "Utilisateur invalide ou utilisateur non invité pour l’associé responsable.",
    19017: "Utilisateur invalide ou utilisateur non invité pour le responsable de la revue de la qualité de la mission.",
    19018: "Le nombre de jours avant l’échéance doit être compris entre 0 et 1 000. ",
    19019: "Échec de l’appel de création de l’attribution automatique de tâches.",

    /*Client Request*/
    21001: "La demande ne peut pas être envoyée vers le portail client d’EY Canvas. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21002: "Cette demande a été supprimée. Veuillez actualiser la page pour afficher les données les plus récentes. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21009: "Échec de la demande de suppression du document associé à la demande client.",
    21010: "Le commentaire auquel vous répondez a été supprimé par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    21011: "Le document associé à la demande client a été supprimé.",
    21012: "Le document associé à la demande client est introuvable.",
    21013: "Le champ Demande de document est vide.",
    21014: "L’identifiant du document est vide.",
    21015: "L’identifiant de la demande client est vide.",
    21016: "Échec de l’appel de création du document associé à la demande client.",
    21017: "Un ou plusieurs des documents associés ont été supprimés de la mission. Veuillez retirer le ou les documents supprimés de cette demande ou actualiser la page et réessayer.",
    21018: "Le document est introuvable.",
    21019: "L’état de la demande client a changé.",
    21030: "L’identifiant du groupe de clients ne concorde pas.",
    21031: "L’état de la demande a changé. Veuillez actualiser la page et réessayer s’il y a lieu. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21032: "L’utilisateur du groupe de clients n’est pas actif.",
    21033: "Le groupe de clients n’est pas actif.",
    21034: "Aucun utilisateur actif dans le groupe de clients.",
    21045: "L’état de la demande a changé. Veuillez actualiser la page pour voir les changements les plus récents.",
    21046: "La demande n’a pas pu être envoyée vers le portail client EY Canvas. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21050: "Les demandes n’ont pas pu être supprimées. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21053: "La tâche n’est plus disponible dans cette mission. Veuillez actualiser la page pour mettre à jour la liste.",
    21057: "Impossible d’assigner une personne-ressource d’EY. Veuillez actualiser la page et réessayer.",
    21028: "La date d’échéance est requise.",
    21036: "La période est introuvable",
    21064: "La tâche ne peut pas être associée à la demande. Les demandes peuvent être associées à jusqu’à un maximum de 25 tâches. Supprimez une ou plusieurs tâches déjà associées pour pouvoir en associer une nouvelle.",
    21065: "Un ou plusieurs documents confidentiels ont été ajoutés à la demande. Vous ne disposez pas du niveau de confidentialité approprié pour envoyer un ou plusieurs de ces documents vers le portail client d’EY Canvas. Veuillez retirer tout document confidentiel auquel vous n’avez pas accès pour continuer. ",
    21066: "Une erreur s’est produite lors de la récupération des données. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21067: "La priorité ne peut pas être mise à jour. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    21035: "Demande au client introuvable.",
    21074: "Impossible de modifier les champs Titre, Description et Priorité d’une demande reçue.",
    21075: "Impossible de modifier les champs Titre, Description, Attribuée à (groupe), Attribuée à (utilisateur), Date d’échéance et Priorité d’une demande acceptée.",
    21077: "La date d’échéance est requise pour les demandes aux clients dont l’état est Reçue ou En attente.",
    21039: "Identifiant du groupe de clients introuvable.",
    21078: "Les champs Groupe et Utilisateur doivent être remplis pour mettre à jour les champs Attribuée à (groupe) ou Attribuée à (utilisateur).",
    21079: "Le format de la date est invalide.",
    21027: "Le titre de la demande est requis.",
    21041: "Le titre de la demande dépasse le nombre maximal de caractères permis.",
    21042: "La description de la demande dépasse le nombre maximal de caractères permis.",
    21060: "L’identifiant de l’utilisateur client est vide.",
    21076: "Type de priorité non autorisé.",

    /* Group Components*/
    22001: "Échec de la demande d’extraction des composantes connexes  ",
    22002: "Échec de la demande de récupération des composantes du groupe.",
    22003: "Échec de la demande de création des composantes du groupe",
    22004: "Identifiant de la composante parent invalide. La composante parent spécifiée n’existe pas. ",
    22005: "Le nom de l’équipe dépasse la longueur maximale. ",
    22006: "Le nom légal de l’équipe dépasse la longueur maximale. ",
    22008: "L’étendue spécifiée n’existe pas. ",
    22009: "Nom abrégé de la composante invalide.",
    22010: "Nom légal de la composante invalide.",
    22011: "Identifiant de l’étendue de la composante invalide.",
    22012: "Si le l’adresse courriel de la personne-ressource a été fournie, l’identificateur unique mondial (GUI) de la personne-ressource ne peut pas être nul ou vide. ",
    22013: "Si le l’adresse courriel de la personne-ressource a été fournie, le texte de la personne-ressource ne peut pas être nul ou vide. ",
    22016: "Cette équipe a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    22022: "Une équipe du même nom existe déjà dans cette mission. ",
    22043: "Échec de la demande d’envoi des instructions.",

    /*User Presence*/
    23001: "Disponibilité de l’utilisateur connecté introuvable",
    23002: "User presence get call failed.",
    23003: "User presence document validation failed.",
    23004: "User presence delete call failed.",
    23005: "Le document n’est plus ouvert par d’autres utilisateurs. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /* Forms */
    24001: "Échec de la demande d’extraction du formulaire",
    24002: "Code de la mission invalide",
    24003: "Le code du document ne doit pas être nul ou vide.",
    24004: "Code du document invalide",
    24005: "Code de l’en-tête du formulaire invalide",
    24006: "Code de la section du formulaire invalide",
    24007: "Paramètres de demande invalides",
    24008: "Le code de l’en-tête ne doit pas être nul ou vide.",
    24009: "Le code de la section ne doit pas être nul ou vide.",
    24010: "Échec de la mise à jour de la réponse associée au corps de texte du formulaire",
    24011: "Demande invalide pour la mise à jour de la réponse associée au corps de texte du formulaire",
    24012: "Code du corps de texte invalide",
    24013: "Code de l’option de corps de texte du formulaire invalide",
    24014: "Code du type de corps de texte du formulaire invalide",
    24015: "Demande invalide pour un code du type de corps de texte donné",
    24016: "Champ de saisie de texte invalide pour un code de type de corps de texte donné",
    24017: "Le nombre maximal de caractères comprend les balises de formatage de texte enrichi. Veuillez réduire la longueur ou supprimer le formatage non nécessaire et réessayer.",
    24018: "Il n’est pas permis de répondre au code du type de corps de texte donné.",
    24019: "Le code du corps de texte ne doit pas être nul ou vide.",
    24020: "Corps de texte de la demande invalide",
    24021: "Le corps de texte a été supprimé.",
    24038: "Le document est non valide ou n’existe pas.",
    24049: "Un ou plusieurs objets sélectionnés ont été supprimés. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    24057: "Échec de la validation du profil du formulaire associé au document.",
    24063: "L’identifiant du pays est non valide.",
    24064: "L’identifiant de la langue est non valide.",

    /*Document Change Types*/
    25001: "Échec de la récupération des types de changements apportés au document",
    25002: "Identifiant de la mission non valide",
    25003: "Demande invalide",

    /* Manage team */
    26001: "ClientUserGroups GetAll call failed.",
    26002: "Échec de la demande de création du nouveau groupe de clients / domaine de l’adresse courriel    ",
    26003: "Le nom du groupe ne doit pas être nul.",
    26004: "Le domaine de l’adresse courriel ne doit pas être nul.",
    26005: "{0} L’étiquette du domaine de l’adresse courriel ne doit pas dépasser 263 caractères.",
    26006: "{0} Le domaine de l’adresse courriel ne doit pas dépasser 263 caractères.",
    26007: "{0} La première partie du domaine de l’adresse courriel peut comprendre un astérique (*) ou des caractères alphanumériques. Les autres caractères spéciaux ne sont pas permis.",
    26008: "{0} Si la première partie comporte un caractère de remplacement, elle doit être suivi de deux autres parties ou plus.",
    26009: "{0} La première partie peut comprendre un astérique (*) ou des caractères alphanumériques. Les caractères spéciaux ne sont pas permis dans les autres parties du domaine.",
    26010: "Le domaine de l’adresse courriel doit être unique.",
    26011: "L’identifiant du groupe d’accès client fourni est non valide.",
    26012: "Une erreur s’est produite lors de la suppression du groupe d’accès. Assurez-vous qu’aucune demande ou tâche externe n’est attribuée à ce groupe ou aux membres de ce groupe et réessayez.",
    26013: "Le groupe d’accès a déjà été supprimé. Veuillez actualiser la page pour afficher les données les plus récentes.",
    26014: "Au moins un domaine de l’adresse courriel est requis.",
    26015: "Le portail client d’EY Canvas, requis pour la mise à jour des renseignements relatifs au membre existant, n’est pas accessible pour le moment. Essayez de nouveau et si le problème persiste, communiquez avec le Service de dépannage.",
    26016: "Une erreur s’est produite lors de l’opération de suppression.",
    26017: "Échec de la récupération des données ",
    26018: "En raison d’un problème d’accès concurrentiel, le groupe d’accès n’est plus actif. Actualisez la page et réessayez.",
    26019: "Échec de l’enregistrement de l’opération",
    26020: "Les domaines de l’adresse courriel ne peuvent pas être supprimés, car ils sont associés à des utilisateurs actifs. Les modifications n’ont donc pas été enregistrées. ",


    /* TimePhaseTypes - Milestones */
    27001: "Échec de l’extraction des détails du jalon",

    /*Client Request Counts*/
    28001: "Get Client Requests Info call did not fetch any results.",

    /*Content updates Error messages*/
    29001: "Extraction par identifiant introuvable",
    29002: "Type d’action introuvable",
    29003: "Identifiant(s) de contenu introuvable(s)",
    29004: "Échec de la demande de mise à jour du contenu de l’interface de programmation",
    29005: "La mise à jour du contenu est en cours. Veuillez réessayer et si le problème persiste, communiquez avec le Service de dépannage.",
    29006: "Invalid request parameters.",
    29010: "Le contenu est en cours d’actualisation. Réessayez plus tard. Si le problème persiste, communiquez avec le Service de dépannage.",
    29012: "Il n’y a pas d’indication sur les normes applicables dans le profil de la mission. Veuillez communiquer avec le Service de dépannage.",
    29013: "Les mises à jour des tâches standard de base (TSB) et du contenu du profil ne sont pas permises lorsque des activités de l’outil FIT d’EY Canvas sont partagées. Pour mettre à jour les TSB ou le contenu du profil, veuillez dissocier ces activités. Si plusieurs types de mises à jour de contenu ont été sélectionnés, veuillez désélectionner les TSB et/ou le profil et lancer à nouveau la mise à jour.",
    /*IT Process*/
    30001: "Get all ITProcess failed.",
    30002: "Get all ITProcess - invalid engagement ID.",
    30003: "Le nom du processus informatique ne peut être vide.",
    30004: "Le nom du processus informatique ne doit pas dépasser 500 caractères.",
    30005: "L’identifiant du processus informatique est non valide.",
    30006: "Échec de la demande de récupération du processus informatique par son identifiant.",
    30007: "Demande invalide.",
    30008: "Le processus informatique n’est pas valide.",
    30009: "Document introuvable.",
    30010: "Échec de la suppression du processus informatique.",
    30012: "Risque lié aux TI invalide.",

    /*Checklist*/
    31001: "GetAll CheckLists call failed.",
    31002: "Put CheckLists call failed.",
    31003: "Invalid CheckList parameter.",
    31004: "Invalid Engagement Error.",
    31005: "Invalid Request Parameters Error.",
    31006: "Invalid IsChecked request parameter Error.",

    /*Archive*/
    32001: "L’état de la mission n’est pas valide. Veuillez résoudre la validation et relancer le processus d’archivage. Si le problème persiste, communiquez avec le Service de dépannage.",
    32002: "Échec de l’archivage lors de la mise à jour de l’état d’affichage du corps de texte des formulaires. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32003: "Échec de l’archivage lors de la mise à jour de l’état de la mission. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32004: "Échec de l’archivage lors de l’invalidation du cache de la mission. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32005: "La mise à jour du contenu est en cours. Vous ne pouvez pas archiver cette mission avant la fin de la mise à jour. Veuillez réessayer plus tard et communiquer avec le Service de dépannage si le problème persiste.",
    32006: "Cette mission comprend des validations non résolues. Veuillez actualiser la page, résoudre les validations et relancer le processus d’archivage. Si le problème persiste, communiquez avec le Service de dépannage.",
    32007: "Échec de l’archivage lors de l’élaboration du modèle de demande du Centre des archives. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32008: "Échec de l’archivage lors de la récupération de l’adresse URL de l’interface de programmation du Centre des archives. Si le problème persiste, communiquez avec le Service de dépannage.",
    32009: "Échec de l’archivage lors de la demande de création de l’adresse URL de l’interface de programmation du Centre des archives. Si le problème persiste, communiquez avec le Service de dépannage.",
    32010: "Échec de l’archivage en raison de données manquantes dans la réponse de l’interface de programmation du Centre des archives. Veuillez réessayer. Si l’erreur persiste, communiquez avec le Service de dépannage.",
    32011: "Échec de l’archivage lors de l’enregistrement des données du formulaire du Centre des archives. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32012: "Échec de l’archivage lors de la nouvelle tentative de mise à jour de l’état de la mission. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32013: "Échec de l’archivage lors de l’ajout du message d’archivage à la file d’attente. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32014: "L’archivage a réussi, mais une erreur s’est produite lors de l’ajout du message de mise à jour du statut universel à la file d’attente. Si le problème persiste, communiquez avec le Service de dépannage.",
    32015: "L’archivage a réussi, mais une erreur s’est produite lors de l’ajout du message de mise à jour du statut du PCC à la file d’attente. Si le problème persiste, communiquez avec le Service de dépannage.",
    32016: "L’état de la mission doit être réglé à Erreur d’archivage pour relancer le processus d’archivage.",
    32017: "Mission introuvable. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32019: "Nous ne pouvons pas traiter votre demande pour le moment. Veuillez réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    32020: "L’adresse URL du Centre des archives n’a pas été configurée. Veuillez réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    32200: "Votre mission comprend des validations non résolues. Veuillez générer un rapport des contrôles de validation dans Rapport ou vous reporter au lien « Aide relative à la validation » dans le menu « Plus » pour plus de détails. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    32400: "Les erreurs suivantes se sont produites lors de la communication avec le système du Centre des archives. Veuillez communiquer avec le Service de dépannage et leur signaler ce message d’erreur pour continuer.",

    /*RBAC*/
    33001: "Identifiant de la mission introuvable.",
    33002: "Identifiant de l’utilisateur introuvable.",

    /*Helix Linked Projects*/
    34001: "Le projet EY Helix a déjà été dissocié. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    34002: "L’identifiant de la mission ne doit pas être nul ou vide.",
    34003: "Body cannot be null or empty in the call.",
    34004: "L’identifiant du projet ne peut pas être nul ou vide.",
    34005: "Le nom du projet ne peut pas être nul ou vide.",
    34006: "Le projet EY Helix a déjà été associé. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    34007: "GetAll Helix Projects call failed.",
    34008: "L’identifiant de la mission doit être supérieur à zéro.",
    34009: "L’opération a échoué. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    34020: "Impossible d’associer le projet EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    34024: "Impossible d’envoyer de notifications à Helix. Il manque les informations sur la zone pour le projet.",
    34029: "Projet non associé, car son emplacement ne correspond pas à celui de la mission EY Canvas.",
    34030: "L’analyseur ne peut pas être lié. Vous n’êtes pas un membre autorisé de l’équipe de l’analyseur sélectionné. Veuillez communiquer avec l’administrateur du projet EY Helix pour obtenir l’accès et réessayez.",
    34031: "Il semblerait que vous n’avez encore jamais accédé à l’application EY Helix.",
    34038: "L’analyse sélectionnée n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",
    34043: "Le projet EY Helix sélectionné n’est plus disponible. Veuillez cliquer sur « Associer un projet » pour associer un autre projet. ",
    34044: "Le projet EY Helix sélectionné est marqué pour suppression. Veuillez cliquer sur « Associer un projet » pour associer un autre projet.",
    34045: "Le projet EY Helix sélectionné est marqué pour stockage. Veuillez cliquer sur « Associer un projet » pour associer un autre projet.",
    34046: "L’analyseur est invalide ou manquant dans EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    34047: "L’analyseur sélectionné n’est pas disponible dans EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    34048: "L’analyse n’est pas disponible pour le projet associé. Veuillez accéder à EY Helix et réaliser les étapes de traitement et d’analyse de données pour continuer.",
    34080: "Le nombre maximal de connexions autorisées à Helix a été dépassé pour la mission.",

    /* PAANS */
    35001: "Le service de rédaction des directives d’EY, d’approbation et de notification n’est pas disponible pour le moment. Nous ne sommes pas en mesure de confirmer si toutes les directives pertinentes sont prêtes. Si vous n’avez pas revu les directives pertinentes, actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",

    /*Engagement Comments*/
    38001: "Échec de la demande de création de commentaires pour la mission",
    38002: "Échec de la demande de récupération de commentaires pour la mission",
    38003: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38004: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38005: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38006: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38007: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38008: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38009: "Impossible de traiter cette action. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38010: "Le corps de texte ne doit pas être nul",
    38011: "La zone de texte de commentaire ne doit pas être nulle ou vide",
    38012: "L’entité n’existe pas pour cette mission",
    38013: "L’identifiant de l’état des commentaires de la mission doit être supérieur à zéro",
    38014: "L’identifiant des commentaires de la mission de l’entité parent doit être supérieur à zéro",
    38015: "Aucun corps de texte ne correspond au critère spécifié pour un formulaire Canvas",
    38016: "La note à laquelle vous répondez a été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    38017: "Le commentaire de la mission de l’entité parent est réglé",
    38018: "Le commentaire de la mission de l’entité parent constitue une réponse",
    38019: "La zone de texte de commentaire doit se situer entre 1 et 4 000 caractères",
    38020: "L’identifiant unique de l’entité est invalide",
    38021: "L’identifiant unique de l’entité parent est invalide",
    38022: "Échec de la demande de suppression des commentaires de la mission",
    38023: "L’identifiant du commentaire ne doit pas être vide",
    38024: "Cette action doit être valide",
    38025: "L’état de cette note a changé. Veuillez actualiser la page et réessayer.",
    38026: "Les notes de revue ne peuvent être supprimées que par l’utilisateur qui les a créées.",
    38027: "Vous essayez de modifier un commentaire qui n’existe plus. Veuillez actualiser la page et réessayer.",
    38028: "Il n’est pas permis de mettre à jour les commentaires réglés ",
    38029: "Seul l’auteur peut modifier le texte de commentaires",
    38030: "L’identifiant du commentaire de la mission est invalide",
    38031: "L’identifiant de l’état du commentaire ne doit pas être vide",
    38032: "Il n’y a aucun enregistrement de la relation entre l’utilisateur demandé et la mission. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    38033: "La demande de mise à jour est invalide",
    38034: "L’identifiant du commentaire demandé est déjà utilisé pour un autre commentaire",
    38035: "L’identifiant du commentaire est invalide",
    38036: "L’identifiant du document ne doit pas être nul ou vide",
    38037: "L’identifiant de l’utilisateur auquel le commentaire sera attribué ne doit pas être nul",
    38038: "Le commentaire ne doit pas être réattribué pendant son ouverture ou sa fermeture",
    38039: "La note pour laquelle vous essayez de supprimer une réponse a déjà été supprimée. Veuillez actualiser la page et réessayer.",
    38040: "La réponse ne doit pas avoir de date d’échéance",
    38041: "La réponse ne doit pas avoir de priorité",
    38042: "Le commentaire doit avoir une date d’échéance",
    38043: "Le commentaire doit avoir une priorité",
    38044: "Vous essayez de modifier une réponse à un commentaire qui n’existe plus. Veuillez actualiser la page et réessayer. ",
    38045: "Il n’est pas permis de modifier l’identifiant de l’état et le contenu de la mission, lorsque ceux-ci ont été attribués à un utilisateur ou qu’une priorité a été définie",
    38046: "Échec de la demande de mise à jour des commentaires de la mission",
    38047: "Vous pouvez uniquement répondre aux notes ouvertes.",

    /*Tags*/
    39004: "Le groupe de balises que vous modifiez a été supprimé par un autre membre de l’équipe. Actualisez la page et réessayez.",
    40003: "Le groupe de balises sélectionné a été supprimé par un autre membre de l’équipe. Veuillez sélectionner un autre groupe de balises pour continuer.",
    40007: "Une ou plusieurs notes sélectionnées ont été supprimées. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    40011: 'Note index cannot exceed 5 characters.',
    40012: "Le code de couleur de la balise est invalide. Veuillez actualiser la page et réessayer.",
    40014: "Le groupe de balises dans lequel figure la balise que vous modifiez a été supprimé par une autre membre de l’équipe. Actualisez la page et réessayez.",
    40016: "Les balises associées à une ou à plusieurs tâches sélectionnées n’ont pas pu être ajoutées ou supprimées. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    40019: "Une ou plusieurs balises en cours de modification ont été supprimées par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    40020: "Une ou plusieurs balises ne peuvent pas être synchronisées pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    40021: "Une ou plusieurs balises sélectionnées ont été supprimées. Veuillez actualiser la page et réessayer.",
    40022: "Ajoutez un ou plusieurs membres de l’équipe externe à cette mission, puis réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    40027: 'Description is too long.',

    // Scheduler request
    70022: "Aucune tâche n’est associée à cette demande de services. Pour continuer, actualisez la page et sélectionnez une ou plusieurs tâches non supprimées. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    70024: "Les services centralisés ne sont pas disponibles pour votre mission. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    70025: "Les services centralisés ne sont actuellement pas disponibles dans votre pays. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",

    /* TaskDocumnet */
    80001: "Échec de la création de l’association du document à la tâche.",
    80002: "Au moins une tâche doit être associée à la demande.",
    80003: "L’identifiant du document doit être indiqué.",
    80004: "La ou les tâches sélectionnées ont été supprimées. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    80005: "L’identifiant du document est non valide.",
    80006: "L’utilisateur n’a pas les autorisations suffisantes pour effectuer l’opération.",
    80007: "Échec de l’association du document à la tâche.",
    80008: "Échec de la modification de l’état de la tâche par suite de l’association du document à la tâche.",
    80011: "Les documents confidentiels ne doivent pas être partagés. ",
    80012: "Charge utile de la demande invalide ou vide.",
    80013: "La limite pour le nombre de tâches est dépassée. Vous ne pouvez pas sélectionner plus de 300 tâches à la fois.",
    80014: "Une erreur s’est produite lors de l’association du document. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /* ITApplication / SO */
    81001: "Échec de la récupération de toutes les applications informatiques.",
    81002: "Récupération de toutes les applications informatiques ‒ identifiant de la mission invalide  ",
    81003: "L’application informatique sélectionnée a été supprimée. Veuillez fermer cette fenêtre modale pour voir la liste à jour.",
    81004: "Le nom doit être indiqué.",
    81005: "Le nom ne doit pas dépasser 500 caractères.",
    81006: "Identifiant du type de stratégie invalide.",
    81007: "Identifiant du document invalide.",
    81008: "Échec de la récupération par identifiant de l’application informatique.",
    81009: "Classement invalide.",
    81010: "Catégorie d’opérations importante invalide.",
    81011: "Contrôle invalide.",
    81012: "L’identifiant de l’application informatique ne doit pas être nul ou vide. ",
    81013: "Application informatique introuvable. ",
    81014: "Échec de la demande de suppression de l’application informatique/du processus informatique.",
    81015: "Le champ de l’application informatique/du processus informatique ne doit pas être vide. ",
    81016: "Identifiant de l’application informatique/du processus informatique invalide. ",
    81017: "Application informatique/processus informatique introuvable.",
    81018: "Échec de la demande de création de l’application informatique/du processus informatique. ",
    81019: "Envoi de la société de services au lieu de l’application informatique.",

    /* Controls */
    83001: "Échec de la demande de récupération des contrôles.",
    83002: "Cette action ne peut pas être traitée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    83003: "L’identifiant du contrôle est nul ou vide.",
    83004: 'The selected Control has been deleted. Close this modal to see the updated list.',
    83005: "L’identifiant du document est invalide.",
    83006: "Information manquante : nom du contrôle.",
    83007: "Longueur du nom du contrôle invalide.",
    83008: "Demande invalide.",
    83009: "Identifiant de la fréquence du contrôle invalide.",
    83010: "Identifiant du type de contrôle invalide.",
    83011: "Applications informatiques du contrôle invalides.",
    83012: "Identifiant du type d’efficacité de la conception du contrôle invalide.",
    83013: "Applications informatiques invalides.",
    83014: "Seules les applications informatiques de type SS sont autorisées lorsque le type de contrôle est un contrôle manuel de prévention ou un contrôle manuel de détection.",
    83015: "Un test manuel des IPE ne peut être sélectionné que dans le cas d’un contrôle manuel lié aux TI.",
    83016: "Les contrôles présentant un risque faible ne sont pas permis pour ce type de profil de mission.",
    83017: "Filtre appliqué aux catégories d’opérations importantes déjà utilisé",
    83018: "Le nom du contrôle ne doit pas dépasser 500 caractères.",
    83019: "Identifiants d’erreur possible invalides.",
    83020: "Il n’est pas permis d’utiliser des identifiants d’erreur possible plus d’une fois.",
    83021: "Il n’est pas permis d’utiliser des identifiants d’application informatique plus d’une fois.",
    83023: "Page active invalide.",
    83024: "Taille de la page invalide.",
    83025: "La chaîne de recherche ne doit pas dépasser 100 caractères.",
    83026: "Une application informatique à laquelle aucune société de services n’est associée peut être associée seulement à un contrôle manuel lié aux TI ou un contrôle des applications informatiques.",
    83027: "Filtre appliqué aux erreurs possibles déjà utilisé.",
    83028: "Identifiant du contrôle de la base de connaissances invalide.",

    /* ITControl */
    84001: "Échec de la récupération des contrôles informatiques. ",
    84002: "Échec de la récupération du contrôle informatique par identifiant.",
    84003: "L’identifiant du contrôle informatique est nul ou vide.",
    84004: "Identifiant du contrôle informatique invalide.",
    84005: "L’identifiant du document est invalide.",
    84006: "Information manquante : nom du contrôle informatique ",
    84007: "Longueur du nom du contrôle informatique invalide.",
    84008: "Identifiant de la fréquence du contrôle informatique invalide. ",
    84009: "Identifiant du type d’approche pour le contrôle informatique invalide.  ",
    84010: "Identifiant du type d’efficacité de la conception du contrôle informatique invalide.",
    84011: "Valeur de test du contrôle informatique invalide. ",
    84012: "Identifiant du type d’efficacité du fonctionnement du contrôle informatique invalide.",
    84013: "Information manquante : fréquence du contrôle informatique.",
    84014: "Échec de la suppression du contrôle informatique. ",
    84015: "La chaîne de recherche ne devrait pas dépasser 100 caractères. ",

    /*GroupTasks*/
    85001: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si l’erreur persiste, communiquez avec le Service de dépannage.",
    85002: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    85003: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si l’erreur persiste, communiquez avec le Service de dépannage.",
    85004: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85005: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85006: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85007: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85008: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85009: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85010: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85011: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85012: "Le document sélectionné a déjà été attribué à une autre zone ou composante. Il ne peut donc pas être attribué. Actualisez la page et réessayez.",
    85013: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85014: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85015: "L’opération sélectionnée ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le l’erreur persiste, communiquez avec le Service de dépannage.",
    85016: "L’identifiant de la mission doit être supérieur à zéro.",
    85017: "Cette tâche n’est plus disponible dans cette mission.",
    85018: "Identifiant du document invalide.",
    85019: "Vous ne disposez pas du niveau de confidentialité requis pour envoyer ces documents. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    85020: "Un ou plusieurs documents que vous essayez d’envoyer ne sont plus disponibles. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    85021: "Formulaires non disponibles pour être envoyés à l’équipe principale.",
    85022: "Un ou plusieurs documents n’ont pas pu être envoyés. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /* ITRisk */
    86001: "Le nom du risque lié aux TI ne peut être vide.",
    86002: "Le nom du risque lié aux TI ne doit pas dépasser 500 caractères.",
    86003: "Identifiant du risque lié aux TI invalide.",
    86004: "Échec de la demande de récupération du risque lié aux TI par identifiant.",
    86005: "Risque lié aux TI introuvable.",
    86006: "Échec de la demande de création du contrôle informatique du risque lié aux TI.",
    86007: "Identifiant du contrôle informatique invalide.",
    86008: "Échec de la demande de suppression du contrôle informatique du risque lié aux TI. ",
    86009: "Identifiant du contrôle informatique du risque lié aux TI invalide. ",
    86010: "Échec de la suppression du risque lié aux TI. ",


    /*Copyhub*/
    88017: "Le processus d’exportation est hors service – la création du paquet a réussi en partie.",
    88018: "L’utilisateur sélectionné pour l’envoi du paquet n’est pas valide (adresse courriel, identificateur unique mondial [GUI] ou nom invalide)",
    88033: "État du paquet de données pour copie invalide pour l’importation.",
    88042: "Vous ne disposez pas des autorisations requises pour effectuer une exportation en bloc.",
    88045: "Vous ne disposez pas des autorisations requises pour créer le gabarit de la mission.",
    88048: "Le paquet est en cours d’importation par un autre utilisateur. Veuillez réessayer plus tard.",
    88049: "Le paquet n’existe plus. Veuillez actualiser l’onglet. ",
    88050: "Une autre copie de la mission est en cours. ",
    88051: "Il y a trop de copies en cours pour cette mission. Veuillez attendre que les copies soient terminées avant d’en effectuer d’autres. ",
    88056: "L’action ne peut pas être réalisée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    88057: "Certains documents sélectionnés contiennent des éléments probants associés en mode édition multiutilisateur. Veuillez archiver les éléments probants associés pour continuer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /* Group Scopes */
    92001: "Échec de l’appel de récupération de toutes les étendues des travaux pour l’audit de groupe.",
    92002: "Échec de l’appel de création de l’étendue des travaux pour l’audit de groupe.",
    92003: "Demande de mise à jour de l’étendue des travaux pour l’audit de groupe non valide.",
    92004: "Nom de l’étendue invalide",
    92005: "Identifiant de l’étendue parent non valide",
    92006: "L’étendue parent n’existe pas.",
    92007: "Description de l’étendue non valide.",
    92008: "Le nom de l’étendue des travaux pour l’audit de groupe dépasse la longueur maximale de 100 caractères.",
    92009: "La description de l’étendue des travaux pour l’audit de groupe dépasse la longueur maximale de 500 caractères.",
    92010: "Échec de la demande de suppression de l’étendue des travaux pour l’audit de groupe.",
    92011: "La sous-étendue personnalisée que vous essayez de modifier a été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    92012: "L’identifiant de l’étendue spécifiée n’est pas valide.",
    92013: "La sous-étendue personnalisée a été attribuée à une ou plusieurs équipes et ne peut pas être supprimée.",
    92014: "La sous-étendue personnalisée que vous essayez de supprimer a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer.",
    92015: "L’utilisateur n’a pas les autorisations suffisantes pour effectuer l’opération.",
    92016: "Une étendue du même nom existe déjà pour cette mission ",
    92017: "Échec de l’appel de récupération des étendues des travaux pour l’audit de groupe par identifiant.",

    /* Group Sections */
    101001: "Échec de l’appel de création de sections pour l’audit de groupe.",
    101002: "Le nom associé à l’audit de groupe ne peut pas être nul ou vide.",
    101003: "Le nom de la section de l’audit de groupe dépasse la longueur maximale de 100 caractères.",
    101004: "Le nom de la section existe déjà dans cette mission.",
    101005: "Échec de l’appel de modification des sections de l’audit de groupe.",
    101006: "Identifiant de la section invalide.",
    101007: "La section de l’audit de groupe n’existe pas.",
    101008: "Identifiant de la mission invalide.",
    101009: "Section Connaissance de l’audit de groupe invalide.",

    /* Group Documents */
    110001: "Identifiant de la mission invalide.",
    110002: "État des instructions invalide.",
    110003: "Échec de l’appel de récupération de la mission par son identifiant.",

    /* ClientEngagement */
    93001: "Description de la mission client introuvable.",
    93002: "La description de la mission client ne doit pas dépasser 100 caractères.",
    93003: "Le champ Demande de la mission client est vide.",
    93004: "Échec de l’appel de récupération de la mission client.",
    93005: "Échec de l’appel de mise à jour de la mission client.",
    93006: "Le nom d’affichage de la mission ne peut pas être mis à jour pour le moment. Veuillez actualiser la page et réessayer. Si le problème persiste, communiquez avec le Service de dépannage.",

    /*IP FIltering */
    96005: "{0} n’a pas été ajoutée à la liste des adresses IP autorisées.",
    96015: "Aucun point d’accès disponible permettant l’importation à partir de la mission source.",
    96016: "Aucun point d’accès disponible permettant l’importation à partir de la mission source.",

    /*RBAC SchedulerRequests */
    'permissionIssueForScheduler': "Vous ne disposez pas des autorisations requises pour faire une demande de services. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation d’effectuer cette action.",

    /* GroupInstructions */
    98001: "Échec de la demande de récupération des instructions pour l’audit de groupe.",
    98002: "Un ou plusieurs identifiants de la section des instructions pour la base des connaissances ne sont pas valides.",
    98003: "Échec de la demande de création des instructions pour l’audit de groupe. ",
    98004: "Le nom de l’instruction ne peut être vide.",
    98005: "Le nom de l’instruction ne doit pas dépasser 500 caractères.",
    98006: "La description de l’instruction ne peut être vide. ",
    98007: "La description des instructions ne doit pas dépasser 4 000 caractères.",
    98008: "L’instruction doit être attribuée à des étendues ou des équipes. ",
    98009: "Le nom de l’instruction existe déjà dans la mission",
    98011: "Cette instruction pour l’audit de groupe a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    98012: "Cette instruction pour l’audit de groupe a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    98016: "L’instruction pour l’audit de groupe que vous modifiez a été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    98017: "Cette tâche pour l’audit de groupe a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    98018: "Cette tâche pour l’audit de groupe a déjà été supprimée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    98019: "Entité introuvable",

    /* Group Snapshots */
    102001: "Échec de l’appel de création de l’instantané des instructions pour l’audit de groupe.",
    102002: "Erreur − Paramètres de la demande invalides.",
    102003: "Erreur − Mission invalide.",
    102004: "Échec de l’appel de récupération de tous les instantanés pour l’audit de groupe.",
    102005: "Échec de l’appel de récupération de tous les instantanés pour l’audit de groupe par identifiant.",
    102006: "Instantané introuvable.",
    102007: "La capture d’écran sélectionnée n’est pas valide.",

    /* Group Links - Send link request */
    106001: "Échec de l’envoi du lien pour le groupe.",
    106002: "La liste des membres de l’équipe ne peut pas être vide.",
    106003: "Une ou plusieurs équipes sélectionnées ne sont pas valides.",
    106004: "Échec de l’ajout à la file d’attente du message du lien pour le groupe.",
    106005: "La demande à l’équipe ne peut pas être répétée.",
    106006: "The concurrency tokens cannot be repeated.",

    /* GroupInstructions - Send Version request */
    22019: "L’équipe a été supprimée.",
    22023: "Échec de la demande d’envoi des instructions.",
    22024: "La composante à laquelle vous tentez d’envoyer des instructions n’est pas disponible ou a déjà été supprimée.",
    22025: "Le champ Identifiant de la mission ne peut pas être vide.",
    22026: "Le champ Identifiant de la composante ne peut pas être vide.",
    22027: "Les instructions pour le groupe trouvées n’ont pas de date d’échéance.",
    22028: "Les instructions relatives à l’étendue n’ont pas encore été publiées pour la composante.",
    22029: "Aucune nouvelle instruction publiée pour la composante à envoyer.",
    22030: "Cette version des instructions et des tâches a déjà été acceptée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    22031: "Échec de l’appel de la version pour l'audit de groupe.   ",

    /* GroupVersion */
    22032: "Les instructions n’existent pas.",

    22034: "Échec de l’appel de récupération de la version pour l’audit de groupe par identifiant.",
    22035: "Le champ de l’identifiant de l’ensemble d’instructions ne peut pas être vide.  ",

    /* Return instruction concurrency scenario*/
    22036: "Une nouvelle version des instructions et des tâches est disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    22037: "Cette version des instructions et des tâches a déjà été acceptée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    22038: "Cette version des instructions et des tâches a déjà été retournée par un autre membre de l’équipe. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    37018: "Ce compte GL n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    37019: "L’association de documents ne peut pas être modifiée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    37030: "Ce compte GL n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    37032: "L’association de documents ne peut pas être modifiée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    37033: "L’association de documents ne peut pas être modifiée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    37034: "L’association de documents ne peut pas être modifiée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    37037: "Cet ajustement n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /* EngagementReports */
    111001: "Échec de la demande d’extraction par type de rapport",
    113015: "Balance des comptes non disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113025: "Il est obligatoire de filtrer par identifiant de catégorie de compte ou par identifiant de compte. Impossible de continuer. ",
    113050: "La balance des comptes ou l’état financier ne fait pas partie de cette mission ou a peut-être été supprimé. Impossible de continuer.",

    /*Information Security */
    200001: "Cette action est interdite par les services de sécurité de l’information d’EY. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*GL account concurrency scenario*/
    113043: "Ce compte de rapprochement n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113019: "Ce compte de rapprochement n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113022: "L’action ne peut pas être réalisée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113039: "Un renvoi est déjà associé à ce compte GL. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113021: "This GL account is no longer available. Refresh the page and try again. Contact the Help Desk if the error persists.",
    113035: "Un renvoi est déjà associé à ce compte GL. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113020: "Ces éléments probants ne sont plus disponibles. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113037: "Ce compte GL n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    40029: "Ce compte GL n’est plus disponible. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",

    /*Trial balance*/
    113060: "MultiEntity required for MEST engagement.",
    113061: "MultiEntity not required for none MEST engagement.",
    113057: "Helix introuvable pour la mission.",
    113094: "Trial Balance to update must be Planning and IstrialBalance true.",
    113095: "Trial Balance to update should not be Planning and IstrialBalance true when financial type is trial balance.",
    113069: "Les données de l’étape Étendue et stratégie ont déjà été importées dans cette mission.",
    113009: "Identifiant de la balance des comptes invalide. Impossible de continuer.",
    113092: "Trial Balance is both Planning and Financial Statements. Can not proceed to soft delete.",
    114033: "All business units mapped to a given entity must share at least one currency type and currency code. Please re-map your data and try again."

};

export const controlRiskTypeStep2 = [{
        id: 1,
        name: "Appui"
    },
    {
        id: 2,
        name: "Pas d’appui"
    },
    {
        id: 3,
        name: "Tester les procédures de la direction"
    }
];

/*Label Collections */
//Canvas Forms Statuses
export const canvasFormStatus = [{
        id: 1,
        value: "Mise à jour en cours"
    },
    {
        id: 3,
        value: "Erreur"
    },
    {
        id: 5,
        value: "Mise à jour en cours"
    },
    {
        id: 6,
        value: "Erreur"
    }
];

export const riskTypes = [{
        id: 1,
        name: "Risques importants",
        abbrev: "RI ",
        title: "Risque important"
    },
    {
        id: 2,
        name: "Risques de fraude",
        abbrev: "RF",
        title: "Risque de fraude"
    },
    {
        id: 3,
        name: "Risques d’anomalies significatives",
        abbrev: "R",
        title: "Risque d’anomalies significatives/risque inhérent"
    }
];

export const riskTypesToolTip = [{
        id: 1,
        name: "Risques importants",
        abbrev: 'SR',
        label: "Important",
        title: "Risque important"
    },
    {
        id: 2,
        name: "Risques de fraude",
        abbrev: "RF",
        label: "Fraude",
        title: "Risque de fraude"
    },
    {
        id: 3,
        name: "Risque d’anomalies significatives",
        abbrev: "R",
        label: "Risque d’anomalies significatives",
        title: "Risque d’anomalies significatives"
    }
];

export const risksTypes = [{
        id: 1,
        name: "Risques importants",
        abbrev: "RI ",
        title: "Risques importants"
    },
    {
        id: 2,
        name: "Risques de fraude",
        abbrev: "RF",
        title: "Risques de fraude"
    },
    {
        id: 3,
        name: "Risques d’anomalies significatives",
        abbrev: "R",
        title: "Risques d’anomalies significatives"
    }
];

export const emptyRiskTypes = [{
        id: 1,
        label: "Aucun risque important n’a été identifié"
    },
    {
        id: 2,
        label: "Aucun risque de fraude n’a été identifié"
    },
    {
        id: 3,
        label: "Aucun risque d’anomalies significatives n’a été relevé"
    }
];

export const controlRiskType = [{
        id: 1,
        name: "Avec appui"
    },
    {
        id: 2,
        name: "Pas d’appui"
    },
    {
        id: 3,
        name: "Tester les procédures de gestion"
    }
];
export const inherentRiskType = [{
        id: 1,
        name: "Élevé"
    },
    {
        id: 2,
        name: "Faible"
    }
];
export const CRAStrings = {
    Minimal: "Minime",
    Low: "Faible",
    'Low +SC': "Faible + cons. part.",
    Moderate: "Modéré",
    High: "Élevé",
    'High +SC': "Élevé + cons. part."
};
export const priorityType = [{
        id: 1,
        name: "Faible",
        className: 'Low',
        label: "L"
    },
    {
        id: 2,
        name: "Moyenne",
        className: 'Medium',
        label: "M"
    },
    {
        id: 3,
        name: "Élevée",
        className: 'High',
        label: "H"
    },
    {
        id: 4,
        name: "Critique",
        className: 'Critical',
        label: "C"
    }
];
export const reviewNoteFilterTypes = [{
        value: 0,
        label: "Toutes"
    },
    {
        value: 1,
        label: "Ouvertes"
    },
    {
        value: 2,
        label: "Réglées"
    },
    {
        value: 3,
        label: "Fermées"
    }
];
export const reviewStatus = [{
        id: 1,
        name: "Ouverte"
    },
    {
        id: 2,
        name: "Réglée"
    },
    {
        id: 3,
        name: "Fermée"
    }
];
export const reviewNoteOpenStatusOption = [{
        value: 2,
        label: "Effacer"
    },
    {
        value: 3,
        label: "Fermer"
    }
];
export const reviewNoteClearedStatusOption = [{
        value: 1,
        label: "Rouvrir"
    },
    {
        value: 3,
        label: "Fermer"
    }
];
export const reviewNoteBulkClearedStatusOption = [{
        value: 1,
        label: "Rouvrir"
    },
    {
        value: 2,
        label: "Effacer"
    },
    {
        value: 3,
        label: "Fermer"
    }
];
export const reviewNoteClosedStatusOption = [{
    value: 1,
    label: "Rouvrir"
}];
export const signOffTypes = [{
        value: 0,
        label: "Préparateur"
    },
    {
        value: 1,
        label: "Responsable de la revue"
    },
    {
        value: 2,
        label: "Aucun"
    }
];
export const RNHNoteStatusOptions = [{
        value: 1,
        label: "Ouvertes"
    },
    {
        value: 2,
        label: "Fermées"
    },
    {
        value: 3,
        label: "Réglées"
    }
];
export const assertions = [{
        id: 1,
        assertionname: "Exhaustivité",
        assertionabbreviation: "Exh",
        statementtypeid: 2,
        displayorder: 1
    },
    {
        id: 2,
        assertionname: "Existence",
        assertionabbreviation: "Exi",
        statementtypeid: 2,
        displayorder: 2
    },
    {
        id: 3,
        assertionname: "Évaluation",
        assertionabbreviation: "Év",
        statementtypeid: 2,
        displayorder: 3
    },
    {
        id: 4,
        assertionname: "Droits et obligations",
        assertionabbreviation: "D&O",
        statementtypeid: 2,
        displayorder: 4
    },
    {
        id: 5,
        assertionname: "Présentation et informations fournies",
        assertionabbreviation: "P&I",
        statementtypeid: 2,
        displayorder: 5
    },
    {
        id: 6,
        assertionname: "Exhaustivité",
        assertionabbreviation: "Exh",
        statementtypeid: 1,
        displayorder: 6
    },
    {
        id: 7,
        assertionname: "Réalité",
        assertionabbreviation: "R",
        statementtypeid: 1,
        displayorder: 7
    },
    {
        id: 8,
        assertionname: "Mesure",
        assertionabbreviation: "M",
        statementtypeid: 1,
        displayorder: 8
    },
    {
        id: 9,
        assertionname: "Présentation et informations fournies",
        assertionabbreviation: "P&I",
        statementtypeid: 1,
        displayorder: 9
    },
    {
        id: 10,
        assertionname: "Exhaustivité",
        assertionabbreviation: "Exh",
        statementtypeid: 3,
        displayorder: 10
    },
    {
        id: 11,
        assertionname: "Existence/Réalité",
        assertionabbreviation: "Exi/R",
        statementtypeid: 3,
        displayorder: 11
    },
    {
        id: 12,
        assertionname: "Mesure/Évaluation",
        assertionabbreviation: "M/Év",
        statementtypeid: 3,
        displayorder: 12
    },
    {
        id: 13,
        assertionname: "Droits et obligations",
        assertionabbreviation: "D&O",
        statementtypeid: 3,
        displayorder: 13
    },
    {
        id: 14,
        assertionname: "Présentation et informations fournies",
        assertionabbreviation: "P&I",
        statementtypeid: 3,
        displayorder: 14
    }
];
//Add Review Note
export const priorityTypes = [{
        value: 1,
        label: "Faible"
    },
    {
        value: 2,
        label: "Moyenne"
    },
    {
        value: 3,
        label: "Élevée"
    },
    {
        value: 4,
        label: "Critique"
    }
];
/*Cog Menu*/
export const cogMenuOptions = {
    Open: "Ouvrir",
    'Start Co-edit mode': "Lancer le mode édition multiutilisateur",
    'End Co-edit mode': "Quitter le mode édition multiutilisateur",
    'Open read-only': "Ouvrir en lecture seule",
    'View history': "Afficher l’historique",
    CopyLink: "Copier le lien",
    Rename: "Renommer",
    Delete: "Supprimer",
    'Remove from task': "Retirer de la tâche",
    Remove: "Retirer",
    Unlink: "Détacher",
    RelateTasks: "Associer les tâches",
    RelateEntities: "Associer des entités",
    Restore: "Restaurer",
    PermanentlyDelete: "Supprimer de façon permanente",
    ChangeReason: "Modifier la raison",
    Confidentiality: "Confidentialité",
    SignoffRequirements: "Exigences d’approbation",
    AssignRegionComponent: "Attribuer à la zone ou à la composante",
    UnassignRegionComponent: "Annuler l’attribution à la zone ou à la composante",
    ReturnToRegionComponent: "Renvoyer à la zone ou à la composante",
    ClearReturnToRegionComponent: "Supprimer l’indicateur de renvoi à la zone ou à la composante",
    OverwriteForm: "Écraser le formulaire",
    Finalize: "Finaliser le document"
};

export const pagingSvgHoverText = {
    first: "Première page",
    previous: "Page précédente",
    next: "Page suivante",
    last: "Dernière page"
};
export const controlFrequencyType = {
    1: "Plusieurs fois par jour",
    2: "Une fois par jour",
    3: "Une fois par semaine",
    4: "Une fois par mois",
    5: "Une fois par trimestre",
    6: "Une fois par année",
    7: "Contrôle des applications informatiques",
    8: "Autre"
};
export const itApproachType = {
    1: "Contrôles",
    2: "Corroboration"
};
export const controlType = {
    1: "Contrôle des applications informatiques",
    2: "Contrôle manuel lié aux TI",
    3: "Contrôle manuel de prévention",
    4: "Contrôle manuel de détection"
};
export const aggregateITEvaluationType = {
    1: "Appui",
    2: "Pas d’appui",
    3: "Appui -  ÉF et CIIF",
    4: "Appui -  ÉF seulement"
};
export const entityType = {
    'ENTITY3': "Compte",
    'ENTITY4': "Catégorie d’opérations importante",
    'ENTITY5': "Processus informatique",
    'ENTITY7': "Risque",
    'ENTITY18': "Erreur possible",
    'ENTITY19': "Contrôle",
    'ENTITY20': "TI/SS",
    'ENTITY24': "Assertion",
    'ENTITY34': "Contrôle informatique ",
    'ENTITY35': "Risque lié aux TI"
};
export const trueFalseToYesNo = {
    'true': "Oui",
    'false': "non"
}
export const trueFalseToYesOnly = {
    'true': "Oui"
}
export const yesNoLocalized = {
    'Yes': "Oui",
    'No': "non"
}
export const iTProcessEvaluationType = {
    1: "Efficace",
    2: "Inefficace",
    3: "Fiable",
    4: "Non testé"
};

export const strategyType = {
    1: "Contrôles",
    2: "Corroboration",
    3: "Appui",
    4: "Pas d’appui"
};
export const accountType = {
    1: "Comptes importants",
    2: "Compte présentant un risque limité"
};

export const scotTypes = {
    1: "Courante",
    2: "Non courante",
    3: "Estimation"
};
export const taskNavigation = {
    1: "Mes tâches",
    2: "Toutes les tâches",
    3: "Étendue et stratégie",
    4: "Catégories importantes d’opérations",
    5: "TI/SS",
    6: "Comptes",
    7: "Exécution — Général",
    8: "Conclusion",
    9: "Sommaire de l’équipe",
    10: "Risques"
};
export const subCategoty = {
    1: "Afficher tout",
    2: "À préparer",
    3: "À revoir"
};
export const subCategoryType = {
    AllTasks: {
        id: 1,
        title: "Afficher tout",
        label: "Afficher tout"
    },
    ToPrepare: {
        id: 2,
        title: "À préparer",
        label: "À préparer"
    },
    ToReview: {
        id: 3,
        title: "À passer en revue",
        label: "À passer en revue"
    },
    Preparers: {
        id: 2,
        title: "Préparateurs",
        label: "Préparateurs"
    },
    Reviewers: {
        id: 3,
        title: "Responsables de la revue",
        label: "Responsables de la revue"
    }
};
/*Task Types*/
export const taskType = {
    1: "Tâche standard",
    2: "Tâche standard de base",
    3: "Tâche Test de cheminement",
    4: "Tâche Contrôle",
    5: "Tâche Corroboration",
    6: "Tâche Procédure de corroboration de base",
    7: "Tâche Réponse",
    8: "Tâche pour le groupe"
};

export const taskTypesForAddTask = {
    importfromknowledge: "Importer de la base de connaissances",
    custom: "Personnaliser",
    account: "Compte",
    itsubstantive: "Procédures de corroboration liées aux TI",
    scotwalkthroughtask: "Test de cheminement – Catégorie importante d’opérations",
    scotcontroltask: "Contrôle – Catégorie importante d’opérations",
    itwalkthroughtask: "Test de cheminement TI",
    itcontroltask: "Contrôle informatique"
};

export const taskTypeBadge = {
    1: "OST",
    2: "PST",
    3: "WT",
    4: "TOC",
    5: "OSP",
    6: "PSP",
    7: "RT",
    8: "GT",
    9: "PIC",
    10: "RRQM",
    11: "PIC/RRQM",
    22: "ACT",
    23: "UDP"
};
/*Task Types*/
export const taskTypeAbbreviation = {
    1: "TOC",
    2: "TOC",
    3: "TOC",
    4: "TOC",
    5: "TOC",
    6: "TOC",
    7: "RT",
    8: "RT",
    9: "RT",
    10: "RT",
    11: "RT",
    13: "OST",
    14: "PST",
    16: "OSP",
    17: "PSP",
    18: "WT",
    19: "UDP",
    20: "WT",
    22: "ACT",
    23: "GT",
    24: "GT",
    25: "GT",
    26: "OSP",
    27: "GT"
};
export const auditPhase = {
    1: "Étendue et stratégie",
    2: "Exécution",
    3: "Conclusion"
};
export const ProfileActionType = {
    1: "Profil envoyé – Première utilisation",
    2: "Profil envoyé – Récupération",
    3: "Modification du profil",
    4: "Mise à jour du contenu mondial",
    5: "Importer des PCB",
    6: "Importer des TBS",
    7: "Mise à jour du contenu des formulaires Canvas",
    8: "Importer les instructions pour l’audit de groupe",
    9: "Ajouter un formulaire à remplir à la main",
    10: "Envoi du profil",
    11: "Mise à jour de contenu obligatoire",
    12: "Synchronisation du profil associé à un formulaire Canvas"
};

export const taskGroup = {
    1: "Mettre en œuvre les autres procédures de planification",
    2: "Flux lié aux comptes",
    3: "Flux lié aux catégories importantes d’opérations",
    4: "Flux lié aux applications informatiques et aux sociétés de services",
    5: "Flux lié à l’évaluation globale des risques (EGR)",
    6: "Flux pour le plan de mission",
    7: "Mettre en œuvre les procédures de clôture",
    8: "Sommaire des anomalies",
    9: "Évaluer les résultats de l’audit",
    10: "Mettre en œuvre les autres procédures d’audit",
    11: "Structure de l’audit de groupe",
    12: "Instructions relatives à l’audit de groupe",
    13: "Tâches du groupe principal",
    14: "Component Group Tasks",
    15: "Plan de travail",
    16: "Accounts Flow - MEST",
    17: "Mettre en œuvre les procédures d’examen",
    18: "Réaliser les activités préliminaires à la planification de la mission",
    19: "Mettre sur pied l’équipe",
    20: "Saisir les données de la mission",
    21: "Mettre en œuvre des procédures analytiques d’évaluation des risques et déterminer le seuil de signification",
    22: "Identify significant accounts - MEST",
    23: "Procédures supplémentaires pour établir nos évaluations des risques",
    24: "Identifier les sources",
    25: "Identifier les comptes importants",
    26: "Relever et comprendre les catégories importantes d’opérations",
    27: "Relever et comprendre les processus informatiques et les sociétés de services",
    28: "Confirmer la stratégie et l’EGR",
    29: "Mettre en œuvre les procédures d’identification des risques supplémentaires requises",
    30: "Envisager l’utilisation de la fonction d’audit interne",
    31: "Répondre aux évaluations des risques",
    32: "Finaliser la stratégie",
    33: "Procédures relatives à la revue de contrôle qualité",
    34: "Concevoir les procédures",
    35: "Évaluer les éléments probants de l’audit et formuler une conclusion",
    36: "Produire les communications et les livrables",
    37: "Procédures relatives à la revue de contrôle qualité",
    38: "Préparer et délivrer le rapport de l’auditeur",
    39: "Finaliser la documentation et archiver",
    40: "Tester les contrôles au niveau de l’entité",
    41: "Évaluer les données utilisées dans les techniques automatisées",
    42: "Mettre en œuvre les procédures requises relatives à la fraude",
    43: "Mettre en œuvre les procédures relatives aux auditeurs internes et aux spécialistes",
    44: "Évaluer les processus informatiques",
    45: "Examen des procès-verbaux, des contrats et des litiges",
    46: "Mettre en œuvre les procédures relatives aux états financiers",
    47: "Mettre en œuvre les procédures relatives aux opérations entre parties liées, à la continuité de l’exploitation et aux textes légaux et réglementaires",
    48: "Discuter des modifications apportées à la stratégie d’audit",
    49: "Conclusion à l’égard de l’exécution",
    50: "Procédures relatives à la revue de contrôle qualité",
    51: "Réaliser les activités axées sur la qualité en lien avec l’étendue et la stratégie",
    52: "Mettre en œuvre les procédures d’audit initial",
    53: "Mettre en œuvre les procédures d’évaluation des risques",
    54: "Identifier les sociétés de services",
    55: "Numérique - Groupe de tâches 5",
    56: "Identifier et comprendre les processus informatiques ",
    57: "Mettre en œuvre les procédures de planification",
    58: "Audit de groupe ‒ Structure, instructions et participation",
    59: "Identifier les informations à fournir importantes",
    60: "Identifier et comprendre les processus d’information importants",
    61: "Numérique ‒ Groupe de tâches 11",
    62: "Numérique - Groupe de tâches 12",
    63: "Numérique - Groupe de tâches 13",
    64: "Numérique - Groupe de tâches 14",
    65: "Numérique - Groupe de tâches 15",
    66: "Numérique - Groupe de tâches 16",
    67: "Numérique - Groupe de tâches 17",
    68: "Réaliser les activités de gestion de projet post-intermédiaires",
    69: 'Execute substantive procedures - Governance',
    70: 'Execute substantive procedures - Strategy',
    71: 'Execute substantive procedures - Risk Management',
    72: 'Execute substantive procedures - Metrics and Targets',
    73: "Mettre en œuvre les procédures de corroboration – Autre",
    74: "Évaluer les travaux d’autres personnes",
    75: "Numérique - Groupe de tâches 25",
    76: "Numérique - Groupe de tâches 26",
    77: "Numérique - Groupe de tâches 27",
    78: "Numérique - Groupe de tâches 28",
    79: "Numérique - Groupe de tâches 29",
    80: "Numérique - Groupe de tâches 30",
    81: "Numérique - Groupe de tâches 31",
    82: "Numérique - Groupe de tâches 32",
    83: "Numérique - Groupe de tâches 33",
    84: "Numérique - Groupe de tâches 34",
    85: "Évaluer les éléments probants de l’examen et formuler une conclusion",
    86: "Mettre en œuvre les procédures de certification générales",
    87: "Évaluer les éléments probants et formuler une conclusion",
    88: "Numérique - Groupe de tâches 38",
    89: "Numérique - Groupe de tâches 39",
    90: "Numérique - Groupe de tâches 40",
    91: "Numérique - Groupe de tâches 41",
    92: "Numérique - Groupe de tâches 42",
    93: "Numérique - Groupe de tâches 43",
    94: "Numérique - Groupe de tâches 44",
    95: "Numérique - Groupe de tâches 45",
    96: "Numérique - Groupe de tâches 46",
    97: "Numérique - Groupe de tâches 47",
    98: "Numérique - Groupe de tâches 48",
    99: "Numérique - Groupe de tâches 49",
    100: "Numérique - Groupe de tâches 50"
};
export const AutomationHubRequestStatus = {
    Draft: "Projet",
    Submitted: "Envoyé",
    Sent: "Envoi en cours ",
    InProgress: "Traitement en cours ",
    Failed: "Erreur de traitement",
    Completed: "Terminé",
    FailedToSendToBP: "Erreur de traitement",
    QueueingFailed: "Échec de l’envoi",
    ActionRequired: "Action requise"
};
export const milestonesLabels = {
    1: "Étendue",
    2: "Stratégie",
    3: "Tests de cheminement",
    4: "Tests des contrôles intermédiaires",
    5: "Tests de corroboration intermédiaires",
    6: "Tests de cheminement (processus de fin d’exercice)",
    7: "Test des contrôles de fin d’exercice",
    8: "Tests de corroboration de fin d’exercice",
    9: "Conclusion",
    10: "Sans objet",
    11: "Exécution",
    12: "Activités axées sur la qualité en lien avec l’étendue et la stratégie",
    13: "Autres activités à l’étape Étendue et stratégie",
    14: "EGR",
    15: "Évaluation des risques et caractère significatif",
    16: "Finaliser l’étendue et la stratégie",
    17: "Activités de gestion de projet post-intermédiaires"
};

export const TasksFilterGroups = {
    Tasks: "Tâches",
    Assignments: "Affectations",
    ReviewNotes: "Notes de revue",
    ProjectManagement: "Gestion de projet",
    Other: "Autre"
};

export const TasksFilterTypes = {
    TaskStatus: "État de la tâche",
    TaskType: "Type de tâche",
    AssignedTo: "Attribuée à",
    OpenAssignments: "Affectations ouvertes",
    ReviewNotesStatus: "État des notes de revue",
    ReviewNotesAssignedTo: "Notes de revue attribuées à",
    ReviewNotesCreatedBy: "Notes de revue créées par",
    TimePhase: "Période",
    Milestone: "Jalon",
    AuditPhase: "Phase de l’audit",
    DocumentConflict: "Conflit lié au document",
    Findings: "Constatations",
    Entity: "Entité",
    IsBookmarked: "Téléchargée pour travail hors ligne"
};

export const quickFilterTaskStatus = [{
        value: '1',
        label: "Ouverte"
    },
    {
        value: '2',
        label: "En cours"
    },
    {
        value: '3',
        label: "En cours de revue"
    },
    {
        value: '4',
        label: "Terminée"
    }
];

export const quickFilterAssignmentStatus = [{
        value: '1',
        label: "Ouverte"
    },
    {
        value: '2',
        label: "En cours"
    },
    {
        value: '3',
        label: "Fermée"
    },
    {
        value: '4',
        label: "Non attribuée"
    }
];

export const dataExport = [
	// 'Archive Form',
	// 'Canvas Forms',
	"Collaboration",
	// 'Control Forms',
	"Documents",
	"Tâches",
	"Synthèse des catégories d’opérations importantes ",
	// 'Team Members',
	// 'Trial Balance'
];
export const dataExportReportNames = {
    'Archive Form': "Formulaire d’archivage",
    'Canvas Forms': "Rapport sur les formulaires Canvas",
    'Collaboration': "Collaboration",
    'Control Forms': "Rapport sur les contrôles",
    'Documents': "Rapport sur tous les documents",
    'Tasks': "Rapport sur toutes les tâches",
    'Team Members': "Membres de l’équipe",
    'Trial Balance': "Rapport sur les chiffres"
};
export const projectManagement = [
	"Détails de la collaboration",
	// 'Digital scorecard',
	// 'Milestones',
	// 'Review Notes',
	// 'Validation Checks'
];

export const projectManagementReportNames = {
    'Collaboration Details': "Tableau de bord de collaboration avec les clients",
    'Milestones': "Rapport sur les jalons",
    'Review Notes': "Rapport sur les notes de revue",
    'Validation Checks': "Rapport sur les contrôles de validation"
};

export const taskQuickFilterOptions = [{
        id: 'taskToPreparer',
        label: "Tâches à préparer",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'tasksReadyForReview',
        label: "Tâches prêtes pour la revue",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allAssignedTasks',
        label: "Toutes les tâches attribuées",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allOverdueTasks',
        label: "Tâches en retard",
        uiViewId: uiViews.taskSystemSuggestedFilter
    },
    {
        id: 'allTasksDueThisWeek',
        label: "Tâches arrivant à échéance cette semaine",
        uiViewId: uiViews.taskSystemSuggestedFilter
    }
];

export const noDefaultFilter = {
    id: 'noDefaultFilter',
    label: "Aucun filtre par défaut"
};

export const taskTypes = [{
        id: '1',
        label: "Tâche Contrôle"
    },
    {
        id: '2',
        label: "Tâche Contrôle - Contrôle"
    },
    {
        id: '3',
        label: "Tâche Contrôle - Contrôle au niveau de l’entité"
    },
    {
        id: '4',
        label: "Tâche Contrôle - TI/SS"
    },
    {
        id: '5',
        label: "Tâche Contrôle - Procédure de gestion"
    },
    {
        id: '6',
        label: "Tâche Contrôle - SS"
    },
    {
        id: '7',
        label: "Tâche Réponse"
    },
    {
        id: '8',
        label: "Tâche Réponse - Anomalie liée aux flux de trésorerie"
    },
    {
        id: '9',
        label: "Tâche Réponse - Déficience"
    },
    {
        id: '10',
        label: "Tâche Réponse - Anomalie liée à une information à fournir"
    },
    {
        id: '11',
        label: "Tâche Réponse - Anomalie"
    },
    {
        id: '12',
        label: "Tâche standard"
    },
    {
        id: '13',
        label: "Autre tâche standard"
    },
    {
        id: '14',
        label: "Tâche standard de base"
    },
    {
        id: '15',
        label: "Tâche Corroboration"
    },
    {
        id: '16',
        label: "Tâche Autre procédure de corroboration"
    },
    {
        id: '17',
        label: "Tâche Procédure de corroboration de base"
    },
    {
        id: '18',
        label: "Tâche Test de cheminement"
    },
    {
        id: '19',
        label: "Tâche Test de cheminement - TI/SS"
    },
    {
        id: '20',
        label: "Tâche Test de cheminement - Catégorie d’opérations importante "
    },
    {
        id: '21',
        label: "À faire"
    },
    {
        id: '22',
        label: "Tâche Conclusion sur le compte"
    },
    {
        id: '23',
        label: "Tâche Audit de groupe"
    },
    {
        id: '24',
        label: "Tâche Audit de groupe (équipe principale)"
    },
    {
        id: '25',
        label: "Tâche Audit de groupe (composante)"
    },
    {
        id: '26',
        label: "Tâche Autre de procédure de corroboration - TI/SS"
    },
    {
        id: '27',
        label: "Tâche Audit de groupe (composante) non liée"
    }
];

export const filterAssignmentType = [{
        value: '1',
        label: "Préparateur"
    },
    {
        value: '2',
        label: "Responsable de la revue détaillée"
    },
    {
        value: '3',
        label: "Responsable de la revue générale"
    },
    {
        value: '4',
        label: "Associé"
    },
    {
        value: '5',
        label: "RRQM"
    },
    {
        value: '6',
        label: "Autre"
    }
];

export const filterTaskStatus = [{
        value: '1',
        label: "Ouvrir"
    },
    {
        value: '2',
        label: "En cours"
    },
    {
        value: '3',
        label: "En cours de revue"
    },
    {
        value: '4',
        label: "Terminer"
    },
    {
        value: '5',
        label: "Aucun élément probant"
    }
];

export const filterAssignmentStatus = [{
        value: '1',
        label: "Ouverte"
    },
    {
        value: '2',
        label: "En cours"
    },
    {
        value: '3',
        label: "Fermée"
    },
    {
        value: '4',
        label: "Non attribuée"
    }
];

export const filterTaskType = [{
        value: '1',
        label: "Tâche Contrôle"
    },
    {
        value: '7',
        label: "Tâche Réponse"
    },
    {
        value: '13',
        label: "Autre tâche standard"
    },
    {
        value: '14',
        label: "Tâche standard de base"
    },
    {
        value: '16',
        label: "Tâche Autre procédure de corroboration"
    },
    {
        value: '17',
        label: "Tâche Procédure de corroboration de base"
    },
    {
        value: '18',
        label: "Tâche Test de cheminement  ̶  Comprendre le processus"
    },
    {
        value: '22',
        label: "Tâche Conclusion sur le compte"
    },
    {
        value: '999',
        label: "Approbation de l’associé responsable requise"
    },
    {
        value: '1000',
        label: "Approbation du Responsable de la revue de la qualité de la mission requise"
    }
];

export const filterTaskTypeGroupEngagement = [{
        value: '1',
        label: "Tâche Contrôle"
    },
    {
        value: '7',
        label: "Tâche Réponse"
    },
    {
        value: '13',
        label: "Autre tâche standard"
    },
    {
        value: '14',
        label: "Tâche standard de base"
    },
    {
        value: '16',
        label: "Tâche Autre procédure de corroboration"
    },
    {
        value: '17',
        label: "Tâche Procédure de corroboration de base"
    },
    {
        value: '18',
        label: "Tâche Test de cheminement  ̶  Comprendre le processus"
    },
    {
        value: '22',
        label: "Tâche Conclusion sur le compte"
    },
    {
        value: '23',
        label: "Tâche pour le groupe"
    },
    {
        value: '999',
        label: "Approbation de l’associé responsable requise"
    },
    {
        value: '1000',
        label: "Approbation du Responsable de la revue de la qualité de la mission requise"
    }
];

export const filterTaskTypeInterimEngagement = [{
        value: '14',
        label: "Tâche standard de base"
    },
    {
        value: '13',
        label: "Autre tâche standard"
    },
    {
        value: '23',
        label: "Tâche pour le groupe"
    },
    {
        value: '999',
        label: "Approbation de l’associé responsable requise"
    },
    {
        value: '1000',
        label: "Approbation du Responsable de la revue de la qualité de la mission requise"
    }
];

export const filterMilestones = [{
        value: '1',
        label: "Étendue",
        hideFromMenu: true
    },
    {
        value: '2',
        label: "Stratégie",
        hideFromMenu: true
    },
    {
        value: '12',
        label: "Activités axées sur la qualité en lien avec l’étendue et la stratégie"
    },
    {
        value: '13',
        label: "Autres activités de l’étape Étendue et stratégie"
    },
    {
        value: '14',
        label: "EGR"
    },
    {
        value: '15',
        label: "Évaluation des risques et caractère significatif"
    },
    {
        value: '16',
        label: "Finaliser l’étendue et la stratégie"
    },
    {
        value: '17',
        label: "Activités de gestion de projet post-intermédiaires"
    },
    {
        value: '3',
        label: "Tests de cheminement"
    },
    {
        value: '4',
        label: "Tests des contrôles intermédiaires"
    },
    {
        value: '5',
        label: "Tests de corroboration intermédiaires"
    },
    {
        value: '6',
        label: "Tests de cheminement (processus de fin d’exercice)"
    },
    {
        value: '7',
        label: "Test des contrôles de fin d’exercice"
    },
    {
        value: '8',
        label: "Tests de corroboration de fin d’exercice"
    },
    {
        value: '11',
        label: "Exécution"
    },
    {
        value: '9',
        label: "Conclusion"
    },
    {
        value: '10',
        label: "S. O."
    },
    {
        value: '0',
        label: "Aucun jalon"
    }
];

export const documentListMilestones = [{
        value: '1',
        label: "Étendue"
    },
    {
        value: '12',
        label: "Activités de gestion de projet de l’étape Étendue et stratégie"
    },
    {
        value: '13',
        label: "Autres activités de l’étape Étendue et stratégie"
    },
    {
        value: '2',
        label: "Stratégie"
    },
    {
        value: '14',
        label: "EGR"
    },
    {
        value: '15',
        label: "Évaluation des risques et caractère significatif"
    },
    {
        value: '16',
        label: "Finaliser l’étape Étendue et stratégie"
    },
    {
        value: '17',
        label: "Activités de gestion de projet post-intermédiaires"
    },
    {
        value: '3',
        label: "Tests de cheminement"
    },
    {
        value: '4',
        label: "Tests des contrôles intermédiaires"
    },
    {
        value: '5',
        label: "Tests de corroboration intermédiaires"
    },
    {
        value: '6',
        label: "Tests de cheminement (processus de fin d’exercice)"
    },
    {
        value: '7',
        label: "Test des contrôles de fin d’exercice"
    },
    {
        value: '8',
        label: "Tests de corroboration de fin d’exercice"
    },
    {
        value: '11',
        label: "Exécution"
    },
    {
        value: '9',
        label: "Conclusion"
    },
    {
        value: '10',
        label: "s. o."
    }
];

export const filterAuditPhases = [{
        value: '1',
        label: "Étendue et stratégie"
    },
    {
        value: '2',
        label: "Exécution"
    },
    {
        value: '3',
        label: "Conclusion"
    }
];


export const filterDocListReviewNoteStatus = [{
        value: 1,
        label: "Ouvertes"
    },
    {
        value: 5,
        label: "Réglées"
    },
    {
        value: 2,
        label: "Fermées"
    }
];

export const filterDocumentConflicts = [{
    value: '1',
    label: "Oui"
}, {
    value: '0',
    label: "Non"
}];
export const filterDownloadedForOffline = [{
    value: '1',
    label: "Oui"
}, {
    value: '2',
    label: "Non"
}];

export const missingEntityDocuments = [{
    value: 10034,
    label: "Oui"
}]


export const filterTaskFindings = [{
        value: '1',
        label: "Déficience"
    },
    {
        value: '2',
        label: "Anomalie"
    }
];

export const ConfidentialityTypes = [{
        id: 1,
        Name: "Par défaut"
    },
    {
        id: 2,
        Name: "Faible"
    },
    {
        id: 3,
        Name: "Modéré"
    },
    {
        id: 4,
        Name: "Élevé"
    },
    {
        id: 5,
        Name: "Confidentiel"
    }
];

export const RoleForMember = [{
        id: 1,
        role: "Associé responsable de l'audit",
        roleAbbreviation: "PIC",
        displayOrder: 9
    },
    {
        id: 2,
        role: "Associé responsable de la mission",
        roleAbbreviation: "Associé de la mission",
        displayOrder: 8
    },
    {
        id: 3,
        role: "Associé délégué",
        roleAbbreviation: "Associé délégué/directeur",
        displayOrder: 5
    },
    {
        id: 4,
        role: "Principal",
        roleAbbreviation: "Principal",
        displayOrder: 6
    },
    {
        id: 5,
        role: "Chef d'équipe senior",
        roleAbbreviation: "Chef d’équipe senior",
        displayOrder: 4
    },
    {
        id: 6,
        role: "Chef d'équipe",
        roleAbbreviation: "Chef d’équipe  ",
        displayOrder: 3
    },
    {
        id: 7,
        role: "Comptable senior",
        roleAbbreviation: "Professionnel senior",
        displayOrder: 2
    },
    {
        id: 8,
        role: "Stagiaire",
        roleAbbreviation: "Stagiaire",
        displayOrder: 1
    },
    {
        id: 9,
        role: "Stagiaire",
        roleAbbreviation: "Stagiaire"
    },
    {
        id: 10,
        role: "Responsable de la revue de la qualité de la mission",
        roleAbbreviation: "RRQM",
        displayOrder: 10
    },
    {
        id: 11,
        role: "Autre associé",
        roleAbbreviation: "Autre associé",
        displayOrder: 7
    },
    {
        id: 12,
        role: "Groupe PSM – Stagiaire",
        roleAbbreviation: "Groupe PSM – Stagiaire",
        displayOrder: 13
    },
    {
        id: 13,
        role: "Consultation (groupe Risque et certification en TI, SCT, Capital humain ou autre)",
        roleAbbreviation: "Consultation"
    },
    {
        id: 14,
        role: "Fiscalité",
        roleAbbreviation: "Fiscalité"
    },
    {
        id: 15,
        role: "Services de soutien aux cadres",
        roleAbbreviation: "Services de soutien aux cadres"
    },
    {
        id: 16,
        role: "Directeur des affaires juridiques",
        roleAbbreviation: "Bureau mondial de la conformité",
        displayOrder: 12
    },
    {
        id: 17,
        role: "Responsable du contrôle qualité de l’audit",
        roleAbbreviation: "Responsable du contrôle qualité de l’audit",
        displayOrder: 11
    },
    {
        id: 18,
        role: "Équipe affectée à l’audit d’une composante pour les entités à établissements multiples",
        roleAbbreviation: "Équipe affectée à l’audit d’une composante pour les entités à établissements multiples"
    },
    {
        id: 19,
        role: "Superviseur du client",
        roleAbbreviation: "Superviseur du client"
    },
    {
        id: 20,
        role: "Personnel du client",
        roleAbbreviation: "Personnel du client"
    },
    {
        id: 21,
        role: "Superviseur de la fonction d’audit interne",
        roleAbbreviation: "Superviseur de la fonction d’audit interne"
    },
    {
        id: 22,
        role: "Personnel de la fonction d’audit interne",
        roleAbbreviation: "Personnel de la fonction d’audit interne"
    },
    {
        id: 23,
        role: "Autorité de réglementation",
        roleAbbreviation: "Autorité de réglementation"
    },
    {
        id: 24,
        role: "Autre (p. ex., revue de contrôle préalable)",
        roleAbbreviation: "Autre  "
    },
    {
        id: 25,
        role: "Bureau",
        roleAbbreviation: "Bureau"
    },
    {
        id: 26,
        role: "Région",
        roleAbbreviation: "Région"
    },
    {
        id: 27,
        role: "Secteur",
        roleAbbreviation: "Secteur"
    },
    {
        id: 28,
        role: "National",
        roleAbbreviation: "National"
    },
    {
        id: 29,
        role: "Mondial",
        roleAbbreviation: "Mondial"
    },
    {
        id: 30,
        role: "Groupe PSM – Professionnel senior",
        roleAbbreviation: "Groupe PSM – Professionnel senior",
        displayOrder: 14
    },
    {
        id: 31,
        role: "Groupe PSM – Chef d’équipe",
        roleAbbreviation: "Groupe PSM – Chef d’équipe",
        displayOrder: 15
    }
];

export const SubServiceLines = [{
        subServiceLineId: 1,
        subServiceLineName: "Audit",
        displayOrder: 1
    },
    {
        subServiceLineId: 2,
        subServiceLineName: "Services de juricomptabilité et de soutien à l’intégrité",
        displayOrder: 2
    },
    {
        subServiceLineId: 9,
        subServiceLineName: "SCCF",
        displayOrder: 3
    },
    {
        subServiceLineId: 11,
        subServiceLineName: "SCCDD",
        displayOrder: 4
    },
    {
        subServiceLineId: 12,
        subServiceLineName: "SFE",
        displayOrder: 5
    },
    {
        subServiceLineId: 13,
        subServiceLineName: "Capital humain",
        displayOrder: 6
    },
    {
        subServiceLineId: 14,
        subServiceLineName: "Services juridiques",
        displayOrder: 7
    },
    {
        subServiceLineId: 15,
        subServiceLineName: "Taxes indirectes",
        displayOrder: 8
    },
    {
        subServiceLineId: 16,
        subServiceLineName: "ODEM",
        displayOrder: 9
    },
    {
        subServiceLineId: 17,
        subServiceLineName: "Fiscalité transactionnelle",
        displayOrder: 10
    },
    {
        subServiceLineId: 18,
        subServiceLineName: "SFI",
        displayOrder: 11
    },
    {
        subServiceLineId: 19,
        subServiceLineName: "Bureau du directeur des affaires juridiques ",
        displayOrder: 12
    },
    {
        subServiceLineId: 20,
        subServiceLineName: "Consultation ‒ Entreprises",
        displayOrder: 13
    },
    {
        subServiceLineId: 21,
        subServiceLineName: "Consultation ‒ Technologies",
        displayOrder: 14
    },
    {
        subServiceLineId: 22,
        subServiceLineName: "Transactions et conseils en financement ",
        displayOrder: 15
    },
    {
        subServiceLineId: 23,
        subServiceLineName: "EY Parthenon",
        displayOrder: 16
    },
    {
        subServiceLineId: 24,
        subServiceLineName: "Autre",
        displayOrder: 17
    },
    {
        subServiceLineId: 25,
        subServiceLineName: "Risque technologique",
        displayOrder: 18
    }
];

export const SchedulerRequestRole = [{
        id: 31,
        userTypeId: 4,
        label: "Chef d’équipe, groupe PSM"
    },
    {
        id: 31,
        userTypeId: 3,
        label: "Gestionnaire de la demande"
    }
];

/* Task Status */
export const TaskStatus = [{
        id: 1,
        label: "Ouverte(s)"
    },
    {
        id: 2,
        label: "En cours"
    },
    {
        id: 3,
        label: "En cours de revue"
    },
    {
        id: 4,
        label: "Terminée(s)"
    },
    {
        id: 5,
        label: "Supprimée"
    },
    {
        id: 6,
        label: "Approbation de l’associé responsable/du RRQM fournie"
    }
];
/* GATaskSendStatus*/
export const GATaskSendStatus = [{
        id: 1,
        label: "Non envoyée"
    },
    {
        id: 2,
        label: "En cours"
    },
    {
        id: 3,
        label: "Envoyée"
    },
    {
        id: 4,
        label: "Retournée"
    }
];
// 9 - Return error (UI value, doesn't exist in database)
export const GAComponentDocumentStatusLabels = [{
        id: GAComponentDocumentStatus.Open,
        label: "Ouvert"
    },
    {
        id: GAComponentDocumentStatus.InProgress,
        label: "Reçu"
    },
    {
        id: GAComponentDocumentStatus.Submitted,
        label: "Envoyé"
    },
    {
        id: GAComponentDocumentStatus.Returned,
        label: "Retournée"
    },
    {
        id: GAComponentDocumentStatus.InReview,
        label: "Préparé"
    },
    {
        id: GAComponentDocumentStatus.Complete,
        label: "Revu"
    },
    {
        id: GAComponentDocumentStatus.Dismissed,
        label: "Rejeté"
    },
    {
        id: GAComponentDocumentStatus.RejectInTransit,
        label: "Retour en cours"
    },
    {
        id: GAComponentDocumentStatus.ReturnError,
        label: "Erreur d’envoi"
    }
];
export const TeamSummaryPreparerTaskStatus = [{
        id: 1,
        label: "Ouverte"
    },
    {
        id: 2,
        label: "En cours"
    },
    {
        id: 3,
        label: "Fermée"
    }
];
export const TeamSummaryReviewerTaskStatus = [{
        id: 1,
        label: "Ouverte"
    },
    {
        id: 2,
        label: "En cours"
    },
    {
        id: 3,
        label: "Fermée"
    }
];

export const DocumentHelper = {
    401: "L’opération ne peut pas être traitée pour le moment. Actualisez la page et réessayez. Si le problème persiste, communiquez avec le Service de dépannage.",
    413: "Le document dépasse la taille de fichier maximale permise (250 Mo) et ne peut pas être téléchargé. Veuillez diminuer la taille du fichier et réessayer.",
    412: "Un document du même nom existe déjà dans cette mission.",
    414: "Le nom dépasse la longueur maximale ({0} caractères).",
    410: "Ce document a été supprimé et ne peut donc pas être ouvert.",
    411: "Les documents vides ne sont pas autorisés."
};

export const reviewNoteCategories = [{
        value: reviewNoteRoutes.path.all.id,
        path: reviewNoteRoutes.path.all.path,
        label: "Toutes les notes"
    },
    {
        value: reviewNoteRoutes.path.document.id,
        path: reviewNoteRoutes.path.document.path,
        label: "Notes de document"
    },
    {
        value: reviewNoteRoutes.path.task.id,
        path: reviewNoteRoutes.path.task.path,
        label: "Notes de tâches"
    },
    {
        value: reviewNoteRoutes.path.form.id,
        path: reviewNoteRoutes.path.form.path,
        label: "Commentaires du formulaire Canvas"
    }
];

export const reviewNoteStatus = [{
        value: '1',
        label: "Ouverte"
    },
    {
        value: '2',
        label: "Réglée"
    },
    {
        value: '3',
        label: "Fermée"
    }
];

/* RNH Review note hub */
export const reviewNoteTypes = [{
        id: 1,
        type: 'document',
        label: "Note de document"
    },
    {
        id: 2,
        type: 'task',
        label: "Note de tâche"
    }
];

export const accountConclusionTabs = {
    details: "Détails",
    conclusions: "Conclusions"
};


export const rnhFilterType = [{
        id: 0,
        filterType: rnhFilterTypeQuery.annotationStatusIds,
        name: "Code de l’état de la note",
        inDropDown: false
    },
    {
        id: 1,
        filterType: rnhFilterTypeQuery.authoredBy,
        name: "Rédigée par",
        inDropDown: true
    },
    {
        id: 2,
        filterType: rnhFilterTypeQuery.assignedTo,
        name: "Attribuée à",
        inDropDown: true
    },
    {
        id: 3,
        filterType: rnhFilterTypeQuery.priority,
        name: "Priorité",
        inDropDown: true,
        filterOptions: [{
            id: "1",
            label: "Faible"
        }, {
            id: "2",
            label: "Moyenne"
        }, {
            id: "3",
            label: "Élevée"
        }, {
            id: "4",
            label: "Critique"
        }]
    },
    {
        id: 4,
        filterType: rnhFilterTypeQuery.dueBefore,
        name: "Échéant le ou avant le",
        inDropDown: true,
        isDateTime: true
    },
    {
        id: 5,
        filterType: rnhFilterTypeQuery.dueAfter,
        name: "Échéant le ou après le",
        inDropDown: true,
        isDateTime: true
    }
];

export const rnhSortingOptions = [{
        id: 'Number',
        label: '#'
    },
    {
        id: 'DueDate',
        label: "Échéance"
    },
    {
        id: 'Priority',
        label: "Priorité"
    },
    {
        id: 'Status',
        label: "État"
    }
];

export const userConfidentiality = [{
        id: 1,
        value: "Général"
    },
    {
        id: 2,
        value: "Faible"
    },
    {
        id: 3,
        value: "Moyenne"
    },
    {
        id: 4,
        value: "Élevée"
    },
    {
        id: 5,
        value: "Restreinte"
    },
    {
        id: 6,
        value: "Confidentielle"
    }
];

export const externalUserStatus = {
    active: "Active",
    inactive: "Inactive"
};

export const engagementStatus = {
    1: "Active",
    2: "En attente",
    3: "Rejetée",
    4: "Inactive",
    13: "Planifiée - Inactive"
};

export const copyRequestStatus = {
    0: "Échue",
    1: "Prête",
    2: "Envoyée",
    3: "Reçue",
    4: "Exportation en cours",
    5: "Exportation réussie",
    6: "Erreur d’exportation",
    7: "Importation en cours",
    8: "Importation réussie",
    9: "Erreur d’importation",
    10: "Refusée",
    11: "Copie en cours",
    13: "Ébauche",
    14: "Envoi en cours",
    15: "Transmission en cours",
    16: "Erreur de transmission"
}

export const copyObjectGrouptype = {
    21: "Mission",
    22: "Comptes",
    23: "Catégories d’opérations importantes",
    20: "Éléments probants",
    24: "Récupérer d’un projet existant",
    25: "Gabarit",
    26: "Exportation en bloc",
    27: "Document externe",
    28: "Flux de travail guidés",
    29: "Mission par entité"
}

export const independenceStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.overriden,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const independenceStatusFilterOptions = [{
        value: 3,
        label: labels.matteridentifiedpendingaction
    },
    {
        value: 4,
        label: labels.matterresolveddeniedaccess
    },
    {
        value: 5,
        label: labels.matterresolvedgrantedaccess
    },
    {
        value: 8,
        label: labels.override
    },
    {
        value: 1,
        label: labels.incomplete
    },
    {
        value: 2,
        label: labels.nomattersidentified
    },
    {
        value: 7,
        label: labels.restored
    },
    {
        value: 6,
        label: labels.notapplicable
    }
];

export const independenceConfirmationStatus = {
    0: labels.undefined,
    1: labels.incomplete,
    2: labels.nomattersidentified,
    3: labels.matteridentifiedpendingaction,
    4: labels.matterresolveddeniedaccess,
    5: labels.matterresolvedgrantedaccess,
    6: labels.notapplicable,
    7: labels.restored,
    8: labels.override,
    9: labels.priornomattersidentified,
    10: labels.priormatteridentifiedpendingaction,
    11: labels.priormatterresolvedgrantedaccess,
    12: labels.priormatterresolveddeniedaccess
};

export const timePhaseTypes = {
    1: "Étendue",
    2: "Stratégie",
    3: "Tests de cheminement",
    4: "Tests des contrôles intermédiaires",
    5: "Tests de corroboration intermédiaires",
    6: "Tests de cheminement (processus de fin d’exercice)",
    7: "Test des contrôles de fin d’exercice",
    8: "Tests de corroboration de fin d’exercice",
    9: "Conclusion",
    10: "S. O.",
    11: "Exécution",
    12: "Activités axées sur la qualité en lien avec l’étendue et la stratégie",
    13: "Autres activités de l’étape Étendue et stratégie",
    14: "EGR",
    15: "Évaluation des risques et caractère significatif",
    16: "Finaliser l’étendue et la stratégie",
    17: "Activités de gestion de projet post-intermédiaires"
};

export const engagementMetricsComingDueOptions = [{
        value: 1,
        label: "Demain"
    },
    {
        value: 3,
        label: "Dans les 3 prochains jours"
    },
    {
        value: 5,
        label: "Dans les 5 prochains jours",
        isDefault: true
    },
    {
        value: 10,
        label: "Dans les 10 prochains jours"
    },
    {
        value: 30,
        label: "Dans les 30 prochains jours",
        isMax: true
    }
];

export const engagementMetricsWhatsNewOptions = [{
        value: 1,
        label: "Hier"
    },
    {
        value: 3,
        label: "3 derniers jours"
    },
    {
        value: 5,
        label: "5 derniers jours",
        isDefault: true
    },
    {
        value: 10,
        label: "10 derniers jours",
        isMax: true
    }
];

export const engagementMetricsDisplayedAttributes = {
    preparer: "À préparer",
    forMyReview: "À passer en revue",
    upcomingReview: "Revue à venir",
    reviewNotesAssigned: "Notes pour moi",
    reviewNotesAuthored: "Notes par moi",
    partnerTasks: "Tâches de l’associé",
    eqrTasks: "Tâches du Responsable de la revue de la qualité de la mission",
    timephases: "Périodes",
    groupTasks: "Tâches pour le groupe",
    groupDeliverables: "Livrables du groupe ",
    automation: "Automatisation",
    requests: "Demandes"
};

export const quickLinks = {
    linkAccountSummary: "Synthèse des comptes",
    linkScotSummary: "Synthèse des catégories importantes d’opérations",
    linkITSummary: "Synthèse TI",
    linkCRASummary: "Synthèse de l’EGR",
    linkGAStructureSummary: "Synthèse de la structure du groupe",
    linkGAInstrcutionSummary: "Synthèse des instructions du groupe",
    linkSEM: "Matrice d’évaluation des procédures de corroboration",
    linkAuditPlan: "Plan de mission",
    linkWorkPlan: "Plan de travail",
    linkITProcessEvaluation: "Évaluations des TI",

    linkGeneral: "Général",
    linkScots: "Catégories importantes d’opérations",
    linkITSO: "TI/SS",
    linkAccounts: "Comptes",
    linkResponseTask: "Tâches Réponse ",
    linkWrapupEngagement: "Clôture de la mission",
    linkArchive: "Liste de contrôle de l’archivage"
};

export const customKeyEvents = {
    reportDate: "Date du rapport",
    endDatePeriodCovered: "Date de fin de la période visée",
    archiveDeadlineDate: "Date limite d’archivage"
};

export const filterReviewNoteStatus = [{
        value: filters.reviewNoteStatus.open,
        label: "Ouverte"
    },
    {
        value: filters.reviewNoteStatus.cleared,
        label: "Réglée"
    },
    {
        value: filters.reviewNoteStatus.closed,
        label: "Fermée"
    }
];

export const filterFileExtension = [{
        value: filters.fileExtension.canvasForm,
        label: "Formulaire Canvas"
    },
    {
        value: filters.fileExtension.email,
        label: "Adresse courriel"
    },
    {
        value: filters.fileExtension.excel,
        label: "Excel"
    },
    {
        value: filters.fileExtension.paperProfile,
        label: "Profil papier"
    },
    {
        value: filters.fileExtension.pdf,
        label: "PDF"
    },
    {
        value: filters.fileExtension.powerPoint,
        label: 'PowerPoint'
    },
    {
        value: filters.fileExtension.smartAutomation,
		label: "Automatisation intelligente"
    },
    {
        value: filters.fileExtension.visio,
        label: "Visio"
    },
    {
        value: filters.fileExtension.word,
        label: "Word"
    },
    {
        value: filters.fileExtension.zip,
        label: "Zip"
    },
    {
        value: filters.fileExtension.other,
        label: "Autre"
    }
];

export const filterDocumentContent = [{
        value: filters.documentContent.trackedChanges,
        label: "En suivi des modifications"
    },
    {
        value: filters.documentContent.comments,
        label: "Commentaires"
    },
    {
        value: filters.documentContent.formulaError,
        label: "Erreurs de formules (fichiers Excel seulement)"
    },
    {
        value: filters.documentContent.highlightsWordFilesOnly,
        label: "Surbrillance (fichiers Word seulement)"
    },
    {
        value: filters.documentContent.hiddenSheets,
        label: "Feuilles masquées"
    },
    {
        value: filters.documentContent.embeddedFiles,
        label: "Fichiers incorporés"
    },
    {
        value: filters.documentContent.ProtectedFiles,
        label: "Protégé"
    },
    {
        value: filters.documentContent.DocumentContentNotAvailable,
        label: "Contenu du document non disponible"
    },
    {
        value: filters.documentContent.DocumentsInCollaborationMode,
        label: "Documents en mode édition multiutilisateur"
    }
];

export const filterSharedEvidence = [{
        value: filters.sharedEvidence.source,
        label: "Source"
    },
    {
        value: filters.sharedEvidence.target,
        label: "Cible"
    }
];

export const filterFindings = [{
        value: filters.findings.misstatement,
        label: "Anomalie"
    },
    {
        value: filters.findings.deficiency,
        label: "Déficience"
    }
];

export const filterSignoffRequirements = [{
        value: filters.signoffRequirements.picMandatory,
        label: "Approbation de l’associé responsable obligatoire"
    },
    {
        value: filters.signoffRequirements.picTeamAssigned,
        label: "Attribué à l'équipe de l’associé responsable"
    },
    {
        value: filters.signoffRequirements.eqrMandatory,
        label: "Approbation du responsable de la revue de la qualité de la mission obligatoire"
    },
    {
        value: filters.signoffRequirements.eqrTeamAssigned,
        label: "Attribués à l'équipe du responsable de la revue de la qualité de la mission"
    }
];

export const filterResponsiveToRisks = [{
        value: filters.responsiveToRisk.responsiveToSignificantRisk,
        label: "Risques importants"
    },
    {
        value: filters.responsiveToRisk.responsiveToFraudRisk,
        label: "Risques de fraude"
    },
    {
        value: filters.responsiveToRisk.responsiveToHigherInherentRisk,
        label: "Risques inhérents élevés"
    }
];

export const filterMissingRelatedTask = [{
        value: filters.missingRelatedTask.picSignoffRequired,
        label: "Approbation de l’associé responsable requise"
    },
    {
        value: filters.missingRelatedTask.eqrSignoffRequired,
        label: "Approbation du responsable de la revue de la qualité de la mission requise"
    }
];

export const filterCanvasForms = [{
        value: filters.canvasForms.incompleteResponses,
        label: "Réponses incomplètes "
    },
    {
        value: filters.canvasForms.unresolvedComments,
        label: "Commentaires non résolus"
    }
];

export const documentChangeTypes = {
    0: "Aucune raison justifiant la modification n’a été sélectionnée",
    1: "Modification de nature non administrative",
    2: "Accepter les révisions lorsque le mode de suivi des modifications a été utilisé ",
    3: "Ajouter des renvois à des éléments probants existants",
    4: "Ajouter une lettre de confirmation originale reçue précédemment par télécopie ou par courriel",
    5: "Modification superficielle",
    6: "Formulaire AP et évaluation des rôles importants en cours",
    7: "Supprimer les documents remplacés par d’autres",
    8: "Préparer la lettre d’affirmation de la direction",
    9: "Approuver les listes de contrôle relatives au processus d’archivage ",
    10: "Classer et collationner les feuilles de travail définitives et y ajouter des références croisées",
    11: "Lorsqu’elle est réglée au fuseau horaire local, la modification est effectuée au plus tard à la date du rapport (Amériques seulement)."
};

export const documentChangeTypesOptions = [{
        value: 1,
        label: "Changement autre que de nature administrative "
    },
    {
        value: 2,
        label: "Accepter les révisions/commentaires s’il y a lieu"
    },
    {
        value: 3,
        label: "Ajouter des renvois à des éléments probants existants"
    },
    {
        value: 4,
        label: "Ajouter une lettre de confirmation originale reçue précédemment par télécopie ou par courriel"
    },
    {
        value: 5,
        label: "Modification superficielle"
    },
    {
        value: 6,
        label: "Formulaire AP et évaluation des rôles importants en cours"
    },
    {
        value: 7,
        label: "Supprimer ou éliminer toute documentation qui ne constitue pas un élément probant"
    },
    {
        value: 8,
        label: "Préparer ou ajouter des documents qui n’étayent pas notre opinion"
    },
    {
        value: 9,
        label: "Approuver les listes de contrôle relatives au processus d’archivage "
    },
    {
        value: 10,
        label: "Classer et collationner les feuilles de travail définitives et y ajouter des références croisées"
    },
    {
        value: 12,
        label: "Entités multiples-même équipe seulement : Modification des éléments probants associés aux entités dont la date de rapport est postérieure à la date de rapport dans EY Canvas"
    },
    {
        value: 11,
        label: "Lorsqu’elle est réglée au fuseau horaire local, la modification est effectuée au plus tard à la date du rapport (Amériques seulement)."
    }
];

export const FourFortyFilterTypes = [{
        id: 0,
        filterType: 'QuickFilter',
        name: "Filtres rapides",
        hasChild: false
    },
    {
        id: 1,
        filterType: 'TaskStatus',
        name: "État de la tâche",
        hasChild: false
    },
    {
        id: 2,
        filterType: 'TaskType',
        name: "Type de tâche",
        hasChild: false
    },
    {
        id: 3,
        filterType: 'AssignedTo',
        name: "Attribuée à",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 4,
        filterType: 'OpenAssignment',
        name: "Affectations ouvertes",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 5,
        filterType: 'AssignmentsUsersEngagementRoles',
        name: "Affectations ouvertes",
        hideDisplay: true,
        loadOptionsFromServer: true
    },
    {
        id: 6,
        filterType: 'ReviewNotesStatus',
        name: "État des notes de revue",
        hasChild: false
    },
    {
        id: 7,
        filterType: 'ReviewNotesAssignedTo',
        name: "Notes de revue attribuées à",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 8,
        filterType: 'ReviewNotesCreatedBy',
        name: "Notes de revue créées par",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 9,
        filterType: 'TimePhase',
        name: "Période",
        hasChild: false,
        loadOptionsFromServer: true
    },
    {
        id: 10,
        filterType: 'Milestone',
        name: "Jalon",
        hasChild: false
    },
    {
        id: 11,
        filterType: 'AuditPhase',
        name: "Phase de l’audit",
        altName: "Phase de la mission",
        hasChild: false
    },
    {
        id: 12,
        filterType: 'DocumentConflict',
        name: "Conflit lié au document",
        hasChild: false
    },
    {
        id: 13,
        filterType: 'Findings',
        name: "Constatations",
        hasChild: false,
        hideForNonAudit: true
    },
    {
        id: 14,
        filterType: 'Entity',
        name: "Entité",
        hasChild: false,
        loadOptionsFromServer: true,
        hideForNonMest: true
    },
    {
        id: 15,
        filterType: 'IsBookmarked',
        name: "Téléchargée pour le travail hors ligne",
        hasChild: false
    }
];

/* Arc Timeline */
export const arcValidationGroups = [{
        id: 1,
        label: "Étape de production 29 ???"
    },
    {
        id: 2,
        label: "Étape de production 30 ???"
    },
    {
        id: 3,
        label: "'SEM (Evaluation Matrix) ???'"
    },
    {
        id: ArcTimelineGroups.FinalizeEvidence,
        label: "Finalisation des éléments probants"
    },
    {
        id: ArcTimelineGroups.CompleteRemainingTasks,
        label: "Terminer les tâches restantes"
    },
    {
        id: ArcTimelineGroups.ResolveValidations,
        label: "Régler les demandes de validation restantes"
    },
    {
        id: 7,
        label: "Préparer pour l’archivage"
    },
    {
        id: 8,
        label: "Tableau de bord de la mission"
    },
    {
        id: 9,
        label: "Formulaire Canvas (individuel)"
    },
    {
        id: 10,
        label: "Formulaire Canvas (tous)"
    }
];

export const checkListTypes = [{
        id: 7,
        label: "Finaliser les fichiers et les dossiers sur support papier"
    },
    {
        id: 13,
        label: "Confirmer l’exactitude des dates des missions clés"
    },
    {
        id: 14,
        label: "Confirmer l’exactitude des codes mission"
    },
    {
        id: 15,
        label: "Confirmer l’exactitude du code client"
    },
    {
        id: 10,
        label: "Détacher cette mission du groupe"
    },
    {
        id: 16,
        label: "Approuver le type de rapport"
    },
    {
        id: 17,
        label: "Passer en revue les fichiers temporaires pour trouver ceux ayant été modifiés après la date de délivrance du rapport"
    },
    {
        id: 18,
        label: "Passer en revue les fichiers supprimés pour trouver ceux ayant été modifiés après la date de délivrance du rapport"
    },
    {
        id: 19,
        label: "Vérifier que les modifications apportées au profil de la mission ont bien été envoyées. "
    },
    {
        id: 20,
        label: "Passer en revue les documents protégés"
    },
    {
        id: 95,
        label: "Désigner le responsable général"
    }
];

export const arcValidationTypes = [{
        id: ArcTimeLineValidationTypes.DocumentConflict,
        label: "Régler les conflits liés au document restants"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsInMultiUserEditMode,
        label: "Documents en mode édition multiutilisateur"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentsWithIsProtected,
        label: "Passer en revue les documents protégés"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentIsNotFinalized,
        label: "Contenu du document non disponible"
    },
    {
        id: ArcTimeLineValidationTypes.AddressAllOpenReviewNotes,
        label: "Fermer toutes les notes de revue non résolues"
    },
    {
        id: ArcTimeLineValidationTypes.RemoveTrackedChangesFromEvidence,
        label: "Supprimer le suivi des modifications des éléments probants"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeSmartAutomationEvidenceFiles,
        label: "Finaliser les éléments probants provenant du Centre d’automatisation intelligente"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllPICSignoffRequirements,
        label: "Remplir toutes les exigences d’approbation de l’associé responsable"
    },
    {
        id: ArcTimeLineValidationTypes.FinalizeCompleteAllEQRSignoffRequirements,
        label: "Remplir toutes les exigences d’approbation du responsable de la revue de la qualité de la mission"
    },
    {
        id: ArcTimeLineValidationTypes.PICEvidenceWithoutAtLeastOneRelatedPICTask,
        label: "Associer les documents nécessitant l’approbation de l’associé responsable aux tâches de l’associé responsable"
    },
    {
        id: ArcTimeLineValidationTypes.EQREvidenceWithoutAtLeastOneRelatedEQRTask,
        label: "Associer les documents nécessitant l’approbation du responsable de la revue de la qualité de la mission aux tâches du responsable de la revue de la qualité de la mission"
    },
    {
        id: ArcTimeLineValidationTypes.EvidencemissingSignoffs,
        label: "Approuver tous les éléments probants"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormComment,
        label: "Résoudre les commentaires du formulaire Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkedSharedEvidence,
        label: "Éléments probants partagés détachés"
    },
    {
        id: ArcTimeLineValidationTypes.TaskswithoutEvidence,
        label: "Ajouter des éléments probants aux tâches ouvertes"
    },
    {
        id: ArcTimeLineValidationTypes.PICTaskWithoutAtLeastOneRelatedPICEvidence,
        label: "Vérifier toutes les tâches de l’associé responsable contenant des documents pour lesquels son approbation est requise"
    },
    {
        id: ArcTimeLineValidationTypes.EQRTaskWithoutAtLeastOneRelatedEQREvidence,
        label: "Vérifier toutes les tâches du responsable de la revue de la qualité de la mission contenant des documents pour lesquels son approbation est requise"
    },
    {
        id: ArcTimeLineValidationTypes.RelateEvidenceToEntityTask,
        label: "Associer les éléments probants à la tâche de l’entité"
    },
    {
        id: ArcTimeLineValidationTypes.MarkTasksComplete,
        label: "Indiquer que les tâches sont terminées"
    },
    {
        id: ArcTimeLineValidationTypes.AccountsSummary,
        label: "Synthèse des comptes"
    },
    {
        id: ArcTimeLineValidationTypes.ScotSummary,
        label: "Synthèse des catégories importantes d’opérations"
    },
    {
        id: ArcTimeLineValidationTypes.CraSummary,
        label: "Synthèse de l’EGR"
    },
    {
        id: ArcTimeLineValidationTypes.ITSummary,
        label: "Synthèse TI"
    },
    {
        id: ArcTimeLineValidationTypes.ConfirmAccuracyOfAuditorReport,
        label: "Confirmer l’exactitude des données du rapport de l’auditeur"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveForm,
        label: "Remplir le formulaire d’archivage"
    },
    {
        id: ArcTimeLineValidationTypes.CompleteArchiveTask,
        label: "Terminer la tâche d’archivage"
    },
    {
        id: ArcTimeLineValidationTypes.UnlinkGroupSharedEvidence,
        label: "Détacher le groupe d’éléments probants partagés"
    },
    {
        id: ArcTimeLineValidationTypes.AuditPlan,
        label: "Plan de mission"
    },
    {
        id: ArcTimeLineValidationTypes.UnassociateFinding,
        label: "Constatations non associées"
    },
    {
        id: ArcTimeLineValidationTypes.IndependenceCompliance,
        label: "Conformité aux règles d’indépendance"
    },
    {
        id: ArcTimeLineValidationTypes.IncompleteCanvasFormResponses,
        label: "Finaliser les réponses incomplètes dans le formulaire Canvas"
    },
    {
        id: ArcTimeLineValidationTypes.WCGWwithNoRelatedsubstantivetask,
        label: "Matrice d’évaluation des procédures de corroboration"
    },
    {
        id: ArcTimeLineValidationTypes.ITEvaluation,
        label: "Évaluations des TI"
    },
    {
        id: ArcTimeLineValidationTypes.DocumentModifiedAfterReportReleaseDate,
        label: "Documents modifiés après la date de délivrance du rapport"
    },
    {
        id: ArcTimeLineValidationTypes.DuplicateFileNames,
        label: "Renommer les fichiers d’éléments probants dont le nom existe en double"
    },
    {
        id: ArcTimeLineValidationTypes.ITFlowCanvasForm,
        label: "Flux TI"
    },
    {
        id: ArcTimeLineValidationTypes.AdjustmentsModule,
        label: "Ajustements"
    },
    {
        id: ArcTimeLineValidationTypes.CanvasFormsWithNoContent,
        label: "Passer en revue les formulaires Canvas sans contenu"
    },
    {
        id: ArcTimeLineValidationTypes.PersonInCharge,
        label: "Responsable"
    },
    {
        id: ArcTimeLineValidationTypes.EstimateAccountWithoutEstimatePSPindex,
        label: ''
    },
    {
        id: ArcTimeLineValidationTypes.TempFilesWithPreparerAndReviewerSignoffsError,
        label: "Passer en revue les fichiers temporaires qui ont été approuvés par le préparateur et le responsable de la revue pour les ajouter en tant qu’éléments probants ou les supprimer"
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFilesWithPICRequirementUserOrKnowledge,
        label: "Passer en revue les fichiers temporaires pour lesquels l’approbation de l’associé responsable est requise et les ajouter à titre d’éléments probants ou en supprimer l’exigence d’approbation par l’associé responsable."
    },
    {
        id: ArcTimeLineValidationTypes.TemporaryFileWithEQRRequirementUserOrKnowledge,
        label: "Passer en revue les fichiers temporaires pour lesquels l’approbation du responsable de la revue de la qualité de la mission est requise et les ajouter à titre d’éléments probants ou en supprimer l’exigence d’approbation par le responsable de la revue de la qualité de la mission."
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithPICRequirementUserOnly,
        label: "Passer en revue les fichiers supprimés pour lesquels l’approbation de l’associé responsable est requise et les ajouter à titre d’éléments probants ou en supprimer l’exigence d’approbation par l’associé responsable."
    },
    {
        id: ArcTimeLineValidationTypes.DeletedFilesWithEQRRequirementUserOnly,
        label: "Passer en revue les fichiers supprimés pour lesquels l’approbation du responsable de la revue de la qualité de la mission est requise et les ajouter à titre d’éléments probants ou en supprimer l’exigence d’approbation par le responsable de la revue de la qualité de la mission."
    },
    {
        id: ArcTimeLineValidationTypes.DocumentAssociatedToInvalidObject,
        label: "Documents associés à des objets qui ne sont plus disponibles dans la mission."
    }
];

export const ArchiveErrors = {
    32204: "Il existe une tâche sans éléments probants pour cette mission.",
    32209: "Il existe un formulaire Canvas qui contient des réponses incomplètes pour cette mission.",
    32210: "Il existe des notes de revue ouvertes pour cette mission.",
    32212: "Il existe une tâche incomplète pour cette mission.",

    32402: "L’identifiant de l’archive est nul ou vide.",
    32403: "L’identifiant global unique (GUID) du fichier est nul ou vide.",
    32404: "Le champ Hôte de stockage de fichiers d’archive est nul ou vide. ",
    32424: "Code mission principal manquant ou invalide.",
    32425: "La date de délivrance du rapport ne peut pas être une date future.",
    32426: "La date de délivrance du rapport doit être postérieure à la date de fin de la mission.",
    32427: "Un associé doit être invité à la mission.",
    32428: "Données manquantes sur le type de document de travail pour le Centre d’archivage.",
    32429: "Une réponse est requise pour le type de rapport dans le formulaire d’archivage.",
    32430: "Une réponse est requise pour les rapports avec réserve dans le formulaire d’archivage.",
    32431: "Une erreur s’est produite pendant le processus d’archivage en raison de l’intégration avec le Centre des archives. Veuillez communiquer avec le Service de dépannage pour signaler cette erreur. "
};

export const validationTypes = [{
        id: 1,
        label: "Conformité aux règles d’indépendance à confirmer",
        altLabel: "Incomplete form",
        errorLabel: "Conformité aux règles d’indépendance à confirmer"
    },
    {
        id: 2,
        label: "Version du formulaire relatif à l’indépendance non à jour",
        altLabel: "Out of date form",
        errorLabel: "Version du formulaire relatif à l’indépendance non à jour"
    },
    {
        id: 3,
        label: "Accès accordé par un rôle non admissible",
        altLabel: "Not approved by PPEDD",
        errorLabel: "Accès accordé par un rôle non admissible"
    },
    {
        id: 4,
        label: "Remplacement par un rôle non admissible",
        altLabel: "Not overridden by PPEDD",
        errorLabel: "Remplacement par un rôle non admissible"
    },
    {
        id: 5,
        label: "Catégories importantes d’opérations non associées (sans compte)",
        errorLabel: "Catégories d’opérations importantes non associées"
    },
    {
        id: 6,
        label: "Contrôles non associés (sans erreur possible)",
        errorLabel: "Contrôles non associés"
    },
    {
        id: 7,
        label: "Stratégie axée sur les contrôles sélectionnée sans erreur possible associée",
        errorLabel: "Stratégie axée sur les contrôles sélectionnée sans erreur possible associée"
    },
    {
        id: 8,
        label: "Stratégie axée sur les contrôles sélectionnée sans contrôle associé",
        errorLabel: "Stratégie axée sur les contrôles sélectionnée sans contrôle associé"
    },
    {
        id: 9,
        label: "Stratégie axée sur les contrôles sélectionnée sans contrôle associé sélectionné aux fins de tests",
        errorLabel: "Stratégie axée sur les contrôles sélectionnée sans contrôle associé sélectionné aux fins des tests"
    },
    {
        id: 10,
        label: "Stratégie axée sur les contrôles sélectionnée et erreur possible sans contrôle associé sélectionné aux fins de tests",
        errorLabel: "Stratégie axée sur les contrôles sélectionnée et erreur possible sans contrôle associé sélectionné aux fins des tests"
    },
    {
        id: 11,
        label: "Risques non associés",
        errorLabel: "Risques non associés"
    },
    {
        id: 12,
        label: "Remplir l’EGR pour cette assertion",
        errorLabel: "Remplir l’EGR pour cette assertion"
    },
    {
        id: 13,
        label: "Erreurs possibles non associées",
        errorLabel: "Erreurs possibles non associées"
    },
    {
        id: 14,
        label: "Aucune catégorie importante d’opérations n’est associée à un compte important",
        errorLabel: "Aucune catégorie d’opérations importante n’est associée au compte important"
    },
    {
        id: 15,
        label: "Stratégie avec appui sélectionnée sans erreur possible associée",
        errorLabel: "Stratégie avec appui sélectionnée sans erreur possible associée"
    },
    {
        id: 16,
        label: "Stratégie avec appui sélectionnée sans contrôle associé",
        errorLabel: "Stratégie avec appui sélectionnée sans contrôle associé"
    },
    {
        id: 17,
        label: "Stratégie avec appui sélectionnée sans contrôle associé sélectionné aux fins de tests",
        errorLabel: "Stratégie avec appui sélectionnée sans contrôle associé sélectionné aux fins des tests"
    },
    {
        id: 18,
        label: "Stratégie avec appui sélectionnée et erreur possible sans contrôle sélectionné aux fins de tests",
        errorLabel: "Stratégie avec appui sélectionnée et erreur possible sans contrôle associé sélectionné aux fins des tests"
    },
    {
        id: 19,
        label: "TI/SS non associées",
        errorLabel: "application informatique/SS non associée"
    },
    {
        id: 20,
        label: "Contrôles / procédures de corroboration liée aux TI non associées",
        errorLabel: "Contrôles/procédures de corroboration liées aux TI non associés"
    },
    {
        id: 21,
        label: "Aucune TI/SS associée",
        errorLabel: "Aucune application informatique/SS associée"
    },
    {
        id: 22,
        label: "Aucun risque associé",
        errorLabel: "Aucun risque associé"
    },
    {
        id: 23,
        label: "Aucun contrôle / aucune procédure de corroboration liée aux TI associé",
        errorLabel: "Aucun contrôle / aucune procédure de corroboration liée aux TI associé"
    },
    {
        id: 24,
        label: "Aucun contrôle / aucune procédure de corroboration liée aux TI associé n’a été sélectionné aux fins de tests",
        errorLabel: "Aucun contrôle / aucune procédure de corroboration liée aux TI associé n’a été sélectionné aux fins des tests"
    },
    {
        id: 25,
        label: "Il existe un risque pour lequel aucun contrôle / aucune procédure de corroboration liée aux TI associé n’a été sélectionné aux fins de tests",
        errorLabel: "Il existe un risque pour lequel aucun contrôle / aucune procédure de corroboration liée aux TI associé n’a été sélectionné aux fins des tests"
    },
    {
        id: 26,
        label: "Aucune tâche Corroboration n’est associée au compte présentant un risque limité",
        errorLabel: "Aucune tâche de corroboration n’est associée au compte présentant un risque limité"
    },
    {
        id: 27,
        label: "Aucune tâche Corroboration n’est associée à l’assertion",
        errorLabel: "Aucune tâche de corroboration n’est associée à l’assertion"
    },
    {
        id: 28,
        label: "TDC non associé",
        errorLabel: "TDC non associé"
    },
    {
        id: 29,
        label: "Test de cheminement non associé",
        errorLabel: "Test de cheminement non associé"
    },
    {
        id: 30,
        label: "Aucune tâche Test de cheminement n’est associée à la catégorie importante d’opérations",
        errorLabel: "Aucune tâche Test de cheminement n’est associée à la catégorie d’opérations importante "
    },
    {
        id: 31,
        label: "Aucune tâche Contrôle n’est associée à un contrôle sélectionné aux fins de tests",
        errorLabel: "Aucune tâche Contrôle n’est associée à un contrôle sélectionné aux fins des tests"
    },
    {
        id: 32,
        label: "Test de cheminement TI/SS non associé",
        errorLabel: "Test de cheminement TI/SS non associé"
    },
    {
        id: 33,
        label: "TDC TI/SS non associé",
        errorLabel: "TDC TI/SS non associé"
    },
    {
        id: 34,
        label: "APC TI/SS non associée",
        errorLabel: "APC TI/SS non associée"
    },
    {
        id: 35,
        label: "Aucune tâche Test de cheminement n’est associée au processus TI/SS",
        errorLabel: "Aucune tâche Test de cheminement n’est associée au processus TI/SS"
    },
    {
        id: 36,
        label: "Aucun TDC n’est associé au contrôle",
        errorLabel: "Aucun TDC n’est associé au contrôle"
    },
    {
        id: 37,
        label: "Aucune APC n’est associée à la procédure de corroboration liée aux TI",
        errorLabel: "Aucune APC n’est associée à la procédure de corroboration liée aux TI"
    },
    {
        id: 38,
        label: "Conflit lié au document",
        errorLabel: "Conflits non résolus"
    },
    {
        id: 39,
        label: "Conflit de synchronisation - Éléments probants partagés - Ne s’affichent pas dans le compteur de validation de Canvas",
        errorLabel: "Éléments probants partagés − Conflit de synchronisation  "
    },
    {
        id: 40,
        label: "Éléments probants sans approbations",
        errorLabel: "Approuver tous les éléments probants"
    },
    {
        id: 41,
        label: "Tâches sans éléments probants",
        errorLabel: "Ajouter des éléments probants aux tâches ouvertes"
    },
    {
        id: 42,
        label: "Code mission non valide",
        errorLabel: "Code mission invalide"
    },
    {
        id: 43,
        label: "Code client non valide",
        errorLabel: "Code client invalide"
    },
    {
        id: 44,
        label: "Dupliquer les noms des fichiers",
        errorLabel: "Dupliquer les noms des fichiers"
    },
    {
        id: 45,
        label: "Évaluation des TI incohérente",
        errorLabel: "Évaluation des processus informatiques incomplète"
    },
    {
        id: 46,
        label: "Évaluation des processus informatiques incomplète",
        errorLabel: "Évaluation des processus informatiques incomplète"
    },
    {
        id: 47,
        label: "Évaluation globale des TI incomplète",
        errorLabel: "Évaluation globale des TI incomplète"
    },
    {
        id: 48,
        label: "Réponse incomplète",
        errorLabel: "Justification incomplète"
    },
    {
        id: 49,
        label: "Anomalie non associée",
        errorLabel: "Anomalies non associées"
    },
    {
        id: 50,
        label: "Déficience non associée",
        errorLabel: "Déficiences non associées"
    },
    {
        id: 51,
        label: "Aucune tâche de corroboration n’est associée à l’erreur possible",
        errorLabel: "Aucune tâche de corroboration n’est associée à l’erreur possible"
    },
    {
        id: 52,
        label: "Aucune erreur possible n’est associée au risque",
        errorLabel: "Aucune erreur possible n’est associée à ce risque "
    },
    {
        id: 53,
        label: "Aucune référence PCB n’est associée à l’estimation",
        errorLabel: "Aucune référence PCB n’est associée à l’estimation"
    },
    {
        id: 54,
        label: "Aucune catégorie importante d’opérations d’estimation n’est associée à la catégorie importante d’opérations d’estimation",
        errorLabel: "Aucune catégorie d’opérations importante d’estimation n’est associée à l’estimation"
    },
    {
        id: 55,
        label: "Aucune estimation n’est associée à la catégorie importante d’opérations d’estimation",
        errorLabel: "Aucune estimation n’est associée à la catégorie d’opérations d’estimation importante"
    },
    {
        id: 56,
        label: "Aucun TDC ne correspond à l’assertion dont le risque lié au contrôle est «Appui»",
        errorLabel: "Aucun TDC ne correspond à l’assertion dont le risque lié au contrôle est « Appui »"
    },
    {
        id: 57,
        label: "Au moins un TDC doit être associé à l’assertion avec «Appui» comme niveau de risque lié au contrôle, et il doit porter sur un contrôle conçu efficacement dont le risque est autre que faible et qui est adapté au risque.",
        errorLabel: "Au moins un TDC doit être associé à l’assertion avec « Appui » comme niveau de risque lié au contrôle, et il doit porter sur un contrôle conçu efficacement dont le risque est autre que faible et qui est adapté au risque."
    },
    {
        id: 58,
        label: "Aucune tâche Corroboration ne correspond à l’assertion",
        errorLabel: "Aucune tâche Corroboration ne correspond à l’assertion"
    },
    {
        id: 59,
        label: "Aucun contrôle ne correspond à l’assertion",
        errorLabel: "Aucun contrôle ne correspond à l’assertion"
    },
    {
        id: 60,
        label: "Commentaire du formulaire Canvas",
        errorLabel: "Commentaire du formulaire Canvas"
    },
    {
        id: 61,
        label: "Réponses incomplètes dans le formulaire Canvas",
        errorLabel: "Réponses incomplètes dans le formulaire Canvas"
    },
    {
        id: 62,
        label: "Notes de revue ouvertes ou réglées qui devraient être fermées ou supprimées",
        errorLabel: "Notes de revue ouvertes ou réglées qui devraient être fermées ou supprimées"
    },
    {
        id: 63,
        label: "Éléments probants avec suivi des modifications",
        errorLabel: "Éléments probants avec suivi des modifications"
    },
    {
        id: 64,
        label: "Tâches non inscrites comme terminées",
        errorLabel: "Indiquer que les tâches sont terminées"
    },
    {
        id: 65,
        label: "Éléments probants non dissociés",
        errorLabel: "Éléments probants partagés détachés"
    },
    {
        id: 66,
        label: "Documents sans type de modification sélectionné",
        errorLabel: "Documents sans type de modification sélectionné"
    },
    {
        id: 67,
        label: "Changements autres que de nature administrative sans raison pour les justifier (explication)",
        errorLabel: "Changements autres que de nature administrative sans raison pour les justifier (explication)"
    },
    {
        id: 68,
        label: "Modifications non approuvées liées à des changements autres que de nature administrative par rôle approprié",
        errorLabel: "Modifications non approuvées liées à des changements autres que de nature administrative par rôle approprié"
    },
    {
        id: 69,
        label: "Information manquante : approbation du formulaire 440GL par le cadre responsable de la revue",
        errorLabel: "Information manquante : approbation du formulaire 440GL par le cadre responsable de la revue"
    },
    {
        id: 70,
        label: "Mission d’audit de groupe qui n’a pas été dissociée",
        errorLabel: "Détacher cette mission du groupe"
    },
    {
        id: 71,
        label: "Formulaire Canvas sans en-tête",
        altLabel: "Formulaire Canvas sans en-tête",
        errorLabel: "Formulaire Canvas sans en-tête"
    },
    {
        id: 72,
        label: "Information manquante : document de synthèse des composantes du groupe",
        errorLabel: "Information manquante : document de synthèse des composantes du groupe"
    },
    {
        id: 73,
        label: "Réponses incomplètes dans le formulaire Canvas indépendamment de l’approbation ",
        errorLabel: "Formulaire Canvas incomplet"
    },
    {
        id: 74,
        label: "Modification au profil V2 non envoyée",
        errorLabel: "Modification au profil non envoyée"
    },
    {
        id: 75,
        label: "Fichiers électroniques de 0 octet",
        errorLabel: "Fichiers électroniques de 0 octet"
    },
    {
        id: 76,
        label: "Formulaire relatif à l’indépendance modifié après sa transmission.",
        altLabel: "Formulaire non transmis",
        errorLabel: "Formulaire relatif à l’indépendance modifié après sa transmission."
    },
    {
        id: 77,
        label: "Gabarit sur l’indépendance différent du gabarit sur l’indépendance individuelle",
        altLabel: "Gabarit sur l’indépendance différent du gabarit sur l’indépendance individuelle",
        errorLabel: "Gabarit sur l’indépendance différent du gabarit sur l’indépendance individuelle"
    },
    {
        id: 78,
        label: "Application informatique (aucune SS) sans au moins un processus informatique associé",
        errorLabel: "Application informatique non associée"
    },
    {
        id: 79,
        label: "Lorsque HasNoITGC = 1, aucun risque lié aux TI associé au CGI ou un risque lié aux TI associé au CGI",
        errorLabel: "CGI non associé"
    },
    {
        id: 80,
        label: "Il n’existe aucun risque lié aux TI pour cette procédure de corroboration liée aux TI",
        errorLabel: "Procédure de corroboration liée aux TI non associée"
    },
    {
        id: 81,
        label: "Aucune application informatique n’est associée au processus informatique",
        errorLabel: "Processus informatique non associé"
    },
    {
        id: 82,
        label: "Aucun risque lié aux TI associé au processus informatique lorsqu’un contrôle des applications informatiques ou un contrôle de détection manuel lié aux TI (sans exception) est associé à partir de l’application informatique ",
        errorLabel: "Risque lié aux TI manquant"
    },
    {
        id: 83,
        label: "Aucun CGI associé au risque lié aux TI (HasNoITGC = 0)",
        errorLabel: "CGI manquant ou « Aucun » indiqué"
    },
    {
        id: 84,
        label: "Aucune application informatique n’est associée au contrôle manuel lié aux TI/contrôle des applications informatiques",
        errorLabel: "Contrôle des applications/manuel lié aux TI sans application informatique"
    },
    {
        id: 85,
        label: "Procédure de corroboration liée aux TI non supprimée lorsque le corps du texte correspondant n’est pas affiché",
        errorLabel: "Procédure de corroboration liée aux TI à supprimer"
    },
    {
        id: 86,
        label: "CGI non supprimé lorsque le corps du texte correspondant n’est pas affiché",
        errorLabel: "CGI à supprimer"
    },
    {
        id: 87,
        label: "Risque lié aux TI non supprimé lorsque le corps du texte correspondant n’est pas affiché",
        errorLabel: "Risque lié aux TI à supprimer"
    },
    {
        id: 88,
        label: "CGI avec HasITControlTesting = 1 alors que le corps du texte correspondant n’est pas affiché",
        errorLabel: "Stratégie de test associée au CGI invalide"
    },
    {
        id: 89,
        label: "Efficacité de la conception non sélectionnée pour le CGI",
        errorLabel: "Évaluation de la conception du CGI manquante"
    },
    {
        id: 90,
        label: "Efficacité de la conception non sélectionnée pour le contrôle",
        errorLabel: "Efficacité de la conception non sélectionnée pour le contrôle"
    },
    {
        id: 91,
        label: "Aucune application informatique associée à la catégorie d’opérations importante alors que HasNoITApplication = 0",
        errorLabel: "Catégorie d’opérations importante non associée"
    },
    {
        id: 92,
        label: "Procédures de corroboration et tests des contrôles qui répondent à un risque important, mais non à l’erreur possible associée au risque",
        errorLabel: "Inconsistent RiskTaskRelation vs Risk > WCGW > Task relationship"
    },
    {
        id: 93,
        label: "Réponse incohérente pour les tests des contrôles",
        errorLabel: "Réponse incohérente pour les tests des contrôles"
    },
    {
        id: 94,
        label: "Contrôle des applications/manuel lié aux TI associé à la catégorie d’opérations importante lorsque HasNoITApplication = 0",
        errorLabel: "Application informatique manquante pour la catégorie d’opérations importante"
    },
    {
        id: 95,
        label: "Aucun membre de l’équipe ne s’est vu attribuer la responsabilité globale.",
        altLabel: "Aucun membre de l’équipe ne s’est vu attribuer la responsabilité globale.",
        errorLabel: "Aucun membre de l’équipe ne s’est vu attribuer la responsabilité globale."
    },
    {
        id: 96,
        label: "Facteurs de risque non associés à un risque ou ne portant pas la mention « Il ne s’agit pas d’un risque d’anomalies significatives »",
        errorLabel: "Facteurs de risque non associés à un risque ou ne portant pas la mention « Il ne s’agit pas d’un risque d’anomalies significatives »"
    },
    {
        id: 97,
        label: "Risks unrelated to an Assertion",
        errorLabel: "Risks unrelated to an Assertion"
    },
    {
        id: 98,
        label: "Montant prévu pour la base de mesure incomplet",
        errorLabel: "Montant prévu pour la base de mesure incomplet"
    },
    {
        id: 99,
        label: "Justification du montant prévu pour la base de mesure incomplète",
        errorLabel: "Justification du montant prévu pour la base de mesure incomplète"
    },
    {
        id: 100,
        label: "Montant ajusté pour la base de mesure incomplet",
        errorLabel: "Montant ajusté pour la base de mesure incomplet"
    },
    {
        id: 101,
        label: "Seuil de signification initial incomplet",
        errorLabel: "Seuil de signification initial incomplet"
    },
    {
        id: 102,
        label: "Seuil de signification initial supérieur au montant maximal",
        errorLabel: "Seuil de signification initial supérieur au montant maximal"
    },
    {
        id: 103,
        label: "Justification pour le seuil de signification initial incomplète",
        errorLabel: "Justification pour le seuil de signification initial incomplète"
    },
    {
        id: 104,
        label: "Erreur acceptable incomplète",
        errorLabel: "Erreur acceptable incomplète"
    },
    {
        id: 105,
        label: "EA se situant à l’extérieur de la fourchette des valeurs autorisées",
        errorLabel: "EA se situant à l’extérieur de la fourchette des valeurs autorisées"
    },
    {
        id: 106,
        label: "Justification relative à l’EA incomplète",
        errorLabel: "Justification relative à l’EA incomplète"
    },
    {
        id: 107,
        label: "Seuil minimal de report des anomalies incomplet",
        errorLabel: "Seuil minimal de report des anomalies incomplet"
    },
    {
        id: 108,
        label: "Seuil minimal de report des anomalies supérieur à la valeur maximale",
        errorLabel: "Seuil minimal de report des anomalies supérieur à la valeur maximale"
    },
    {
        id: 109,
        label: "Justification relative au seuil minimal de report des anomalies incomplète",
        errorLabel: "Justification relative au seuil minimal de report des anomalies incomplète"
    },
    {
        id: 110,
        label: "Sélection PACE incomplète",
        errorLabel: "Sélection PACE incomplète"
    },
    {
        id: 111,
        label: "Aucun document associé",
        errorLabel: "Aucun document associé"
    },
    {
        id: 112,
        label: "Tâche de l’associé responsable sans au moins un élément probant connexe lié à l’associé responsable",
        errorLabel: "Tâche de l’associé responsable sans au moins un élément probant connexe lié à l’associé responsable"
    },
    {
        id: 113,
        label: "Tâche du RRQM sans au moins un élément probant connexe lié au RRQM",
        errorLabel: "Tâche du RRQM sans au moins un élément probant connexe lié au RRQM"
    },
    {
        id: 114,
        label: "Élément probant lié à l’associé responsable sans au moins une tâche connexe de l’associé responsable ",
        errorLabel: "Élément probant lié à l’associé responsable sans au moins une tâche connexe de l’associé responsable "
    },
    {
        id: 115,
        label: "Élément probant lié au RRQM sans au moins une tâche connexe du RRQM",
        errorLabel: "Élément probant lié au RRQM sans au moins une tâche connexe du RRQM"
    },
    {
        id: 116,
        label: "Élément probant lié à l’associé responsable sans au moins une approbation de l’associé responsable ",
        errorLabel: "Élément probant lié à l’associé responsable sans au moins une approbation de l’associé responsable "
    },
    {
        id: 117,
        label: "Élément probant lié au RRQM sans au moins une approbation du RRQM",
        errorLabel: "Élément probant lié au RRQM sans au moins une approbation du RRQM"
    },
    {
        id: 118,
        label: "Il y a encore des éléments probants qui ne doivent pas être archivés ",
        errorLabel: "Il y a encore des éléments probants qui ne doivent pas être archivés "
    },
    {
        id: 119,
        label: "Fichiers temporaires approuvés par le préparateur et le responsable de la revue",
        errorLabel: "Fichiers temporaires approuvés par le préparateur et le responsable de la revue"
    },
    {
        id: 120,
        label: "Tous les commentaires ouverts ou réglés du formulaire Canvas",
        errorLabel: "Tous les commentaires ouverts ou réglés du formulaire Canvas"
    },
    {
        id: 121,
        label: "Fichiers temporaires pour lesquels l’approbation de l’associé responsable est requise",
        errorLabel: "Fichiers temporaires pour lesquels l’approbation de l’associé responsable est requise"
    },
    {
        id: 122,
        label: "Fichier temporaire pour lequel l’approbation du RRQM est requise",
        errorLabel: "Fichier temporaire pour lequel l’approbation du RRQM est requise"
    },
    {
        id: 123,
        label: "Fichiers supprimés pour lesquels l’approbation de l’associé responsable est requise",
        errorLabel: "Fichiers supprimés pour lesquels l’approbation de l’associé responsable est requise"
    },
    {
        id: 124,
        label: "Fichiers supprimés pour lesquels l’approbation du RRQM est requise",
        errorLabel: "Fichiers supprimés pour lesquels l’approbation du RRQM est requise"
    },
    {
        id: 125,
        label: "Passer en revue les documents protégés",
        errorLabel: "Passer en revue les documents protégés"
    },
    {
        id: 126,
        label: "Contenu du document non disponible",
        errorLabel: "Contenu du document non disponible"
    },
    {
        id: 127,
        label: "Corps de l’état des résultats sans données",
        errorLabel: "Corps de l’état des résultats sans données"
    },
    {
        id: 128,
        label: "Corps du bilan sans données",
        errorLabel: "Corps du bilan sans données"
    },
    {
        id: 129,
        label: "Entités multiples - La mission entités multiples n’est pas liée à toutes les PCB ou tâches Conclusion sur le compte associées au(x) compte(s).",
        errorLabel: "Entités multiples - La mission entités multiples n’est pas liée à toutes les PCB ou tâches Conclusion sur le compte associées au(x) compte(s)."
    },
    {
        id: 130,
        label: "Compte sans formulaire d’évaluation des risques individuel",
        errorLabel: "Compte sans formulaire d’évaluation des risques individuel"
    },
    {
        id: 131,
        label: "Estimation sans documentation correspondante",
        errorLabel: "Estimation sans documentation correspondante"
    },
    {
        id: 132,
        label: "Compte sans formulaire d’analyse individuel",
        errorLabel: "Compte sans formulaire d’analyse individuel"
    },
    {
        id: 133,
        label: "Mission entités multiples sans formulaire de profil individuel",
        errorLabel: "Mission entités multiples sans formulaire de profil individuel"
    },
    {
        id: 134,
        label: "Account - AccountTypeID does not match Action",
        errorLabel: "Account - AccountTypeID does not match Action"
    },
    {
        id: 135,
        label: "Account - HasEstimate does not match Action",
        errorLabel: "Account - HasEstimate does not match Action"
    },
    {
        id: 136,
        label: "Account - Account FormOption Has Related Risks Not Associated To Account",
        errorLabel: "Account - Account FormOption Has Related Risks Not Associated To Account"
    },
    {
        id: 137,
        label: "Compte - Assertion présentant un risque inhérent élevé sans risque élevé associé",
        errorLabel: "Compte - Assertion présentant un risque inhérent élevé sans risque élevé associé"
    },
    {
        id: 138,
        label: "Mission entités multiples - Mission entités multiples sans procédures de corroboration connexes pour un ou plusieurs comptes connexes",
        errorLabel: "Mission entités multiples - Mission entités multiples sans procédures de corroboration connexes pour un ou plusieurs comptes connexes"
    },
    {
        id: 139,
        label: "Composante sans formulaire relatif à la participation à un audit de groupe (exclusion faite des composantes désignées comme Référence seulement)",
        errorLabel: "Composante sans formulaire relatif à la participation à un audit de groupe (exclusion faite des composantes désignées comme Référence seulement)"
    },
    {
        id: 140,
        label: "Composante (audit complet/spécifique) sans instructions relatives à l’évaluation des risques au niveau du groupe connexe (exclusion faite des composantes désignées comme Référence seulement)",
        errorLabel: "Composante (audit complet/spécifique) sans instructions relatives à l’évaluation des risques au niveau du groupe connexe (exclusion faite des composantes désignées comme Référence seulement)"
    },
    {
        id: 141,
        label: "Mission entités multiples − Compte sans mission entités multiples associée",
        errorLabel: "Mission entités multiples − Compte sans mission entités multiples associée"
    },
    {
        id: 142,
        label: "Document.SmartEvidenceSourceID associated to an invalid object",
        errorLabel: "Document.SmartEvidenceSourceID associated to an invalid object"
    },
    {
        id: 143,
        label: "Compte - Assertion présentant un risque inhérent élevé sans risque élevé associé",
        errorLabel: "Compte - Assertion présentant un risque inhérent élevé sans risque élevé associé"
    },
    {
        id: 144,
        label: "Groupe ‒ Comptes (exécutés dans d’autres missions) sans composante associée",
        errorLabel: "Groupe ‒ Comptes (exécutés dans d’autres missions) sans composante associée"
    },
    {
        id: 145,
        label: "Compte ‒ Aucune référence PCB n’est associée à l’estimation",
        errorLabel: "Compte ‒ Aucune référence PCB n’est associée à l’estimation"
    },
    {
        id: 146,
        label: "Mission entités multiples − Modification au profil individuel de la mission entités multiples non envoyée (document individuel)",
        errorLabel: "Mission entités multiples − Modification au profil individuel de la mission entités multiples non envoyée (document individuel)"
    },
    {
        id: 147,
        label: "Mission entités multiples − Modification au profil individuel de la mission entités multiples non envoyée (document individuel)",
        errorLabel: "Mission entités multiples − Modification au profil individuel de la mission entités multiples non envoyée (document individuel)"
    },
    {
        id: 148,
        label: "Compte ‒ Propriétés du compte invalides ou incomplètes",
        errorLabel: "Compte ‒ Propriétés du compte invalides ou incomplètes"
    },
    {
        id: 149,
        label: "Téléversement de documents ‒ Approbations requises de l’associé responsable / du RRQM manquantes",
        errorLabel: "Téléversement de documents ‒ Approbations requises de l’associé responsable / du RRQM manquantes"
    },
    {
        id: 150,
        label: "Téléversement de documents ‒  Exigences d’approbation de l’associé responsable / du RRQM manquantes ",
        errorLabel: "Téléversement de documents ‒  Exigences d’approbation de l’associé responsable / du RRQM manquantes "
    },
    {
        id: 151,
        label: "Compte ‒ Compte important / information à fournir importante sans assertion associée ",
        errorLabel: "Compte ‒ Compte important / information à fournir importante sans assertion associée "
    },
    {
        id: 152,
        label: "Téléversement de documents ‒ Approbations du préparateur ou du responsable de la revue manquantes",
        errorLabel: "Téléversement de documents ‒ Approbations du préparateur ou du responsable de la revue manquantes"
    },
    {
        id: 153,
        label: "Ajustement sans éléments probants",
        errorLabel: "Ajustement sans éléments probants"
    },
    {
        id: 154,
        label: "Estimation sans compte associé",
        errorLabel: "Estimation sans compte associé"
    },
    {
        id: 155,
        label: "Estimation présentant un risque élevé/faible associée à un compte qui n’est pas une estimation",
        errorLabel: "Estimation présentant un risque élevé/faible associée à un compte qui n’est pas une estimation"
    },
    {
        id: 156,
        label: "Réponse relative à la catégorie d’estimation non alignée sur la désignation dans « Modifier l’estimation »",
        errorLabel: "Réponse relative à la catégorie d’estimation non alignée sur la désignation dans « Modifier l’estimation »"
    },
    {
        id: 157,
        label: "Estimation sans catégorie d’opérations importante valide",
        errorLabel: "Estimation sans catégorie d’opérations importante valide"
    },
    {
        id: 158,
        label: "Account without valid estimate",
        errorLabel: "Account without valid estimate"
    },
    {
        id: 159,
        label: "Compte Estimation sans estimation présentant un risque élevé ou faible",
        errorLabel: "Compte Estimation sans estimation présentant un risque élevé ou faible"
    },
    {
        id: 160,
        label: "Catégorie d’opérations d’estimation importante sans estimation présentant un risque élevé ou faible",
        errorLabel: "Catégorie d’opérations d’estimation importante sans estimation présentant un risque élevé ou faible"
    },
    {
        id: 161,
        label: "Ajustements non compensés",
        errorLabel: "Ajustements non compensés"
    },
    {
        id: 162,
        label: "Estimation présentant un risque élevé sans risque valide associé",
        errorLabel: "Estimation présentant un risque élevé sans risque valide associé"
    },
    {
        id: 163,
        label: "Document – Document extrait ou en cours d’extraction pour collaboration",
        errorLabel: "Document – Document extrait ou en cours d’extraction pour collaboration"
    },
    {
        id: 164,
        label: "Éléments probants manquants pour les tâches qui ne s’appliquent pas à l’ensemble de la mission",
        errorLabel: "Éléments probants manquants pour les tâches qui ne s’appliquent pas à l’ensemble de la mission"
    },
    {
        id: 165,
        label: "La réponse ne correspond pas aux exigences d’approbation de l’associé responsable de la mission ou du RRQM.",
        errorLabel: "La réponse ne correspond pas aux exigences d’approbation de l’associé responsable de la mission ou du RRQM."
    },
    {
        id: 166,
        label: "Risque important/risque de fraude associé à une estimation qui ne présente pas un risque élevé",
        errorLabel: "Risque important/risque de fraude associé à une estimation qui ne présente pas un risque élevé"
    }
];

export const contentType = {
    1: "Tâches standards de base (TSB)",
    2: "Référence des procédures de corroboration de base (référence PCB)",
    3: "Procédures de corroboration de base (PCB)",
    4: "Instructions pour l’audit du groupe",
    5: "Formulaires Canvas requis par méthode",
    6: "Formulaires Canvas créés par les utilisateurs (p. ex., formulaire sur les catégories importantes d’opérations)",
    7: "Indépendance",
    9: "Profil",
    10: "Schémas Canvas"
};

export const contentTypeByName = {
    'PST': "Tâches standards de base (TSB)",
    'PSPIndex': "Référence Procédures de corroboration de base (référence PCB)",
    'PSP': "Procédures de corroboration de base (PCB)",
    'GAInstructions': "Instructions relatives à l’audit de groupe",
    'CanvasFormKnowledge': "Formulaires Canvas de la base de connaissances",
    'CanvasFormUserAdded': "Formulaires Canvas créés par les utilisateurs (p. ex., formulaire sur les catégories importantes d’opérations)",
    'IndependenceForm': "Indépendance",
    'Profile': "Profil",
    'Maps': "Schémas Canvas"
};

export const reportTypes = {
    1: "Opinion avec réserve – avec paragraphe d’observations",
    2: "Sans réserve – sans paragraphe d’observations",
    3: "Avec réserve – avec paragraphe d’observations",
    4: "Avec réserve – sans paragraphe d’observations",
    5: "Opinion défavorable – avec paragraphe d’observations",
    6: "Opinion défavorable – sans paragraphe d’observations",
    7: "Impossibilité d’exprimer une opinion – avec paragraphe d’observations",
    8: "Impossibilité d’exprimer une opinion – sans paragraphe d’observations",
    100: "Non",
    101: "S. O.",
    102: "Pas encore sélectionné"
};

export const internalUserRoles = [{
        roleKey: 3,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Archiver la mission",
        displayName: "Archiver la mission",
        roleDisplayOrder: 2,
        tooltipText: "Possibilité d’archiver la mission"
    },
    {
        roleKey: 4,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Gérer la mission",
        displayName: "Gérer la mission",
        roleDisplayOrder: 1,
        tooltipText: "Possibilité d’inviter des membres internes et externes et d’affecter les autorisations aux membres internes"
    },
    {
        roleKey: 5,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Mettre à jour le contenu",
        displayName: "Mettre à jour le contenu",
        roleDisplayOrder: 6,
        tooltipText: "Possibilité de modifier le profil et d’accepter une mise à jour de contenu"
    },
    {
        roleKey: 7,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Créer une demande de service",
        displayName: "Gérer les demandes de services",
        roleDisplayOrder: 4,
        tooltipText: "Possibilité de créer une demande de service et de marquer les demandes de service comme étant terminées."
    },
    {
        roleKey: 8,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Gérer le groupe",
        displayName: "Gérer le groupe",
        roleDisplayOrder: 5,
        tooltipText: "Accepter ou rejeter les instructions pour l’audit de groupe reçues de l’équipe principale ou de l’équipe zonale."
    },
    {
        roleKey: 9,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Copier, récupérer et restaurer des missions",
        displayName: "Copier, récupérer et restaurer des missions",
        roleDisplayOrder: 3,
        tooltipText: "Permet de copier une mission ainsi que de récupérer et restaurer l’archive qui y est associée.",
    },
    {
        roleKey: 0,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidentialité",
        roleNameUI: "Par défaut",
        displayName: "Aucun (par défaut)",
        roleDisplayOrder: 1,
        tooltipText: "Rôle donnant accès aux documents de niveau de confidentialité par défaut"
    },
    {
        roleKey: 10,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidentialité",
        roleNameUI: "Faible",
        displayName: "Faible",
        roleDisplayOrder: 8,
        tooltipText: "Rôle donnant accès aux documents de niveau de confidentialité faible"
    },
    {
        roleKey: 11,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidentialité",
        roleNameUI: "Élevée",
        displayName: "Élevée",
        roleDisplayOrder: 10,
        tooltipText: "Rôle donnant accès aux documents de niveau de confidentialité élevé"
    },
    {
        roleKey: 12,
        sectionId: 1,
        groupDisplayOrder: 200,
        groupName: "Confidentialité",
        roleNameUI: "Modérée",
        displayName: "Modérée",
        roleDisplayOrder: 9,
        tooltipText: "Rôle donnant accès aux documents de niveau de confidentialité modéré"
    },
    // {
    // roleKey: 13,
    // sectionId:1,
    // groupDisplayOrder: 200,
    // groupName: "Confidentialité",
    // roleNameUI: "Confidentiel",
    // displayName: "Confidentiel",
    // roleDisplayOrder: 11,
    // tooltipText: "Rôle donnant accès aux documents strictement confidentiels"
    // },
    {
        roleKey: 14,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restrictions",
        roleNameUI: "Lecture seule",
        displayName: "Lecture seule",
        roleDisplayOrder: 12,
        tooltipText: "Cette fonction ne doit être utilisée que pour donner accès à cette mission EY Canvas à des réviseurs tiers. Les approbations et les autorisations appropriées doivent être obtenues auprès des Services professionnels."
    },
    {
        roleKey: 16,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restrictions",
        roleNameUI: "Revue seule",
        displayName: "Revue seule",
        roleDisplayOrder: 13,
        tooltipText: "L’accès Revue seule permet à l’utilisateur de voir l’information d’une mission dans EY Canvas, de l’approuver et d’utiliser la fonctionnalité Note de revue. Ce mode d’accès ne devrait être utilisé que lorsque d’autres utilisateurs d’EY doivent passer en revue la mission sans pouvoir effectuer de modifications."
    },
  {
        roleKey: 37,
        sectionId: 3,
        groupDisplayOrder: 100,
        groupName: "Restrictions",
        roleNameUI: "Indépendance seulement",
        displayName: "Indépendance seulement",
        roleDisplayOrder: 14,
        tooltipText: "La restriction Indépendance seulement permet à cet utilisateur de remplir le formulaire sur l’indépendance pour la mission, mais il n’aura pas un accès complet à la mission EY Canvas. Cette restriction ne doit être utilisée que lorsqu’un utilisateur a réalisé des travaux dans le cadre de la mission, mais qu’il n’a pas besoin d’avoir accès à EY Canvas.",
    },
    {
        roleKey: 6,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Annuler les modifications",
        displayName: " Restaurer /supprimer en bloc le document",
        roleDisplayOrder: 7,
        tooltipText: "Possibilité de reconstituer les documents lorsque des modifications ont été apportées par erreur après la date de délivrance du rapport et de les supprimer du formulaire 440 d’EY Canvas."
    },
    {
        roleKey: 35,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Gérer le partage de l’outil FIT d’EY Canvas",
        displayName: "Gérer les flux de travail guidés",
        roleDisplayOrder: 14,
        tooltipText: "Permet de partager les flux de travail guidés entre les missions EY Canvas"
    },
    {
        roleKey: 36,
        sectionId: 2,
        groupDisplayOrder: 150,
        groupName: "Autorisations",
        roleNameUI: "Importer des données d’EY Helix",
        displayName: "Importer des données d’EY Helix",
        roleDisplayOrder: 15,
        tooltipText: "Permet d’importer des données d’EY Helix"
    }
];

export const ValidationSubGroups = [{
        id: 9008,
        label: "Conformité aux règles d’indépendance"
    },
    {
        id: 9001,
        label: "Synthèse des comptes"
    },
    {
        id: 9002,
        label: "Synthèse des catégories importantes d’opérations"
    },
    {
        id: 9004,
        label: "Synthèse TI"
    },
    {
        id: 9003,
        label: "Synthèse de l’EGR"
    },
    {
        id: 9005,
        label: "Plan de mission"
    },
    {
        id: 9011,
        label: "Matrice d’évaluation des procédures de corroboration"
    },
    {
        id: 9012,
        label: "Validations par formulaire Canvas"
    },
    {
        id: 9009,
        label: "Évaluation des TI"
    },
    {
        id: 49,
        label: "Anomalies non associées"
    },
    {
        id: 50,
        label: "Déficiences non associées"
    },
    {
        id: 44,
        label: "Dupliquer les noms des fichiers"
    },
    {
        id: 38,
        label: "Conflits non résolus"
    },
    {
        id: 9013,
        label: "Modifications apportées après la date de délivrance du rapport"
    },
    {
        id: 9014,
        label: "Flux TI"
    },
    {
        id: 9015,
        label: "Outil FIT d’EY Canvas"
    },
    {
        id: 71,
        label: "Formulaires sans contenu"
    },
    {
        id: 9016,
        label: 'Incomplete canvas form response'
    },
    {
        id: 9017,
        label: 'Adjustment module'
    },
];

export const engagementIndustry = {
    116: "Aucun secteur précis",
    61: "Aérospatiale et défense – Fabrication aérospatiale",
    112: "Aérospatiale et défense – Fabrication en sous-traitance pour le secteur de la défense",
    59: "Compagnies aériennes – Transport aérien",
    92: "Gestion d’actifs – Fonds communs de marchandises",
    57: "Gestion d’actifs – Autres fonds",
    43: "Gestion d’actifs – Capital-investissement / capital risque",
    85: "Gestion d’actifs – Fonds agréés / cotés",
    53: "Gestion d’actifs – Produits structurés",
    60: "Gestion d’actifs – Fonds de couverture non réglementés",
    10: "Gestion d’actifs – Comptes distincts non réglementés",
    90: "Audit de systèmes de gestion de la conformité",
    51: "Automobile – Concessionnaires d’automobiles et réparations",
    101: "Automobile – Construction de véhicules automobiles",
    5: "Automobile – Fournisseurs du secteur de l’automobile",
    71: "Secteur bancaire et marchés financiers – Banques",
    89: "Secteur bancaire et marchés financiers – Courtiers",
    27: "Secteur bancaire et marchés financiers – Coopératives de crédit",
    54: "Secteur bancaire et marchés financiers – Services diversifiés et autres institutions financières",
    32: "Secteur bancaire et marchés financiers – Financement de sociétés",
    4: "Biotechnologie – Biotech – Marchés émergents",
    109: "Biotechnologie – Recherches en santé et essais cliniques",
    66: "Produits chimiques – Fabrication de produits chimiques",
    41: "Technologies Propres",
    37: "Consolidations",
    130: "Construction – Services de génie et d’architecture",
    68: "Construction – Construction de routes et construction lourde",
    65: "Construction – Entrepreneurs spécialisés",
    82: "Produits de consommation – Fabrication de produits de consommation non durables",
    17: "Produits de consommation – Fabrication d’aliments et de boissons",
    35: "Produits de consommation – Culture vivrière, bétail, pêche",
    33: "Produits de consommation – Fabrication d’appareils ménagers et de matériel électronique",
    75: "Produits de consommation – Fabrication d’autres biens de consommation durables",
    39: "Produits de consommation – Textile et fabrication de vêtements",
    21: "Produits industriels diversifiés – Fabrication de produits métalliques",
    31: "Produits industriels diversifiés – Foresterie, pâtes et papiers",
    29: "Produits industriels diversifiés – Fabrication d’instruments industriels",
    40: "Produits industriels diversifiés – Fabrication de machines industrielles",
    26: "Produits industriels diversifiés – Emballage industriel",
    42: "Produits industriels diversifiés – Bois de construction et fabrication de produits du bois",
    105: "Produits industriels diversifiés – Autres produits industriels",
    100: "Produits industriels diversifiés – Métaux primaires",
    45: "Produits industriels diversifiés – Impression",
    1: "Produits industriels diversifiés – Fabrication pour l’industrie du caoutchouc et du plastique",
    118: "Produits industriels diversifiés – Fabrication de produits en pierre, argile et verre",
    76: "Général",
    79: "Gouvernement et secteur public – Éducation",
    78: "Gouvernement et secteur public – Gouvernements fédéraux, nationaux et internationaux",
    131: "Gouvernement et secteur public – Commissaire à la santé",
    132: "Gouvernement et secteur public – Prestataire de soins de santé",
    97: "Gouvernement et secteur public – Gouvernement local, y compris le gouvernement étatique ou autres paliers sous le gouvernement national",
    2: "Soins de santé – Centres médicaux universitaires",
    72: "Soins de santé – Hôpitaux gouvernementaux",
    74: "Soins de santé – Soins de santé gérés",
    8: "Soins de santé – Réseaux d’hôpitaux",
    128: "Soins de santé – Hôpitaux hors système",
    94: "Soins de santé – Autres prestataires de soins de santé",
    73: "Soins de santé – Groupes de médecins",
    121: "Soins de santé – Soins postactifs",
    58: "Soins de santé – Hôpitaux spécialisés",
    16: "Tourisme d’accueil et loisirs – Jeux de hasard et d’argent",
    7: "Tourisme d’accueil et loisirs – Hôtels, motels et hébergement",
    126: "Tourisme d’accueil – Restaurants / Restaurants et bars",
    84: "IFRS",
    55: "Assurance – Assurance maladie",
    111: "Assurance – Agents et courtiers d’assurance",
    69: "Assurance – Sociétés d’assurance vie",
    96: "Assurance  – Autres secteurs de l’assurance",
    11: "Assurance – Assureurs de dommages",
    117: "Assurance – Réassureurs",
    23: "Sciences de la vie – Technologie médicale",
    48: "Médias et divertissement – Publicité",
    14: "Médias et divertissement – Diffusion, réseau câblé, vidéo en ligne",
    18: "Médias et divertissement – Câblodistributeur, satellite, MVPD",
    86: "Médias et divertissement – Cinéma",
    46: "Médias et divertissement – Services intégrés de médias et de divertissement",
    15: "Médias et divertissement – Secteur de la musique",
    25: "Médias et divertissement – Autres",
    20: "Médias et divertissement – Édition",
    30: "Médias et divertissement – Sports",
    28: "Mines – Exploitation minière",
    3: "PME non complexes",
    120: "Organismes sans but lucratif – Fondations et fiducies de bienfaisance",
    107: "Organismes sans but lucratif – Autres organismes sans but lucratif",
    70: "Pétrole et gaz – Commerce de l’énergie",
    22: "Pétrole et gaz – Exploration et production",
    67: "Pétrole et gaz – Raffinage",
    113: "Autres secteurs du transport – Transport local et urbain",
    38: "Autres secteurs du transport – Autres secteurs du transport",
    83: "Autres secteurs du transport – Transport ferroviaire",
    88: "Autres secteurs du transport – Transport routier et entreposage",
    6: "Autres services du transport – Transport maritime",
    87: "Fonds de retraite / régimes d’avantages sociaux",
    95: "Pharmaceutique – Fabrication d’appareils médicaux",
    123: "Pharmaceutique – Fabrication de produits pharmaceutiques et commerce de gros",
    115: "Énergie et services publics – Électricité",
    119: "Énergie et services publics – Gaz naturel",
    110: "Énergie et services publics – Autres services publics",
    102: "Énergie et services publics – Déchets et eaux",
    125: "Sociétés et services professionnels – Services d’affaires",
    34: "Sociétés et services professionnels – Autres services",
    47: "Sociétés et services professionnels – Services personnels",
    124: "Sociétés et services professionnels – Sociétés de services professionnels",
    127: "Sociétés et services professionnels – Services de location et de crédit-bail",
    108: "Sociétés et services professionnels – Services de voyages",
    49: "Immobilier – Propriétaires/promoteurs de biens immobiliers commerciaux",
    56: "Immobilier – Autres propriétaires/promoteurs immobiliers",
    62: "Immobilier – Fiducies de placement immobilier",
    122: "Immobilier – Investisseurs immobiliers",
    12: "Immobilier – Sociétés de services immobiliers",
    91: "Immobilier – Propriétaires / promoteurs de biens immobiliers résidentiels",
    24: "Commerce de détail et de gros – Grands magasins",
    93: "Commerce de détail et de gros – Commandes par Internet et par la poste, commerce de détail",
    80: "Commerce de détail et de gros – Grandes surfaces / magasins de rabais",
    9: "Commerce de détail et de gros – Autres détaillants spécialisés",
    77: "Commerce de détail et de gros – Magasins de vêtements et d’accessoires, commerce de détail",
    114: "Commerce de détail et de gros – Supermarchés, épiceries et dépanneurs",
    36: "Commerce de détail et de gros – Biens durables, commerce de gros",
    64: "Commerce de détail et de gros – Biens non durables, commerce de gros",
    104: "Développement durable",
    63: "Technologie – Équipement de communication et de réseaux",
    52: "Technologie – Ordinateurs et produits électroniques",
    138: "Technologie – Commerce électronique et social",
    103: "Technologie – Services de TI",
    19: "Technologie – Autre technologie",
    98: "Technologie – Semi-conducteurs",
    13: "Technologie – Logiciel / Logiciels-services / Applications",
    81: "Télécommunications – Services de communication par câble",
    106: "Télécommunications – Prestataires de services de communication intégrés",
    129: "Télécommunications – Fournisseurs de services Internet",
    99: "Télécommunications – Services de communication mobiles sans fil ",
    50: "Télécommunications – Autres services de communication",
    44: "Télécommunications – Services de communications par satellites"
};

export const rnhQuickFilterLabel = [{
        id: rnhQuickFilter.all,
        label: "Afficher tout"
    },
    {
        id: rnhQuickFilter.assigned,
        filterType: rnhFilterTypeQuery.assignedTo,
        label: "Attribuées à moi"
    },
    {
        id: rnhQuickFilter.authored,
        filterType: rnhFilterTypeQuery.authoredBy,
        label: "Rédigées par moi"
    }
];

export const relatedItemStatus = [{
        id: 1,
        label: "Projet"
    },
    {
        id: 2,
        label: "Aucun client"
    },
    {
        id: 3,
        label: "Envoyé"
    },
    {
        id: 4,
        label: "Erreur système"
    },
    {
        id: 5,
        label: "Client invalide"
    },
    {
        id: 6,
        label: "En attente d’une réponse"
    },
    {
        id: 7,
        label: "Reçu"
    },
    {
        id: 8,
        label: "Accepté"
    },
    {
        id: 9,
        label: "Retourné"
    },
    {
        id: 10,
        label: "Retiré"
    },
    {
        id: 11,
        label: "Envoi en cours"
    },
    {
        id: 12,
        label: "Acceptation en cours"
    },
    {
        id: 13,
        label: "Retrait en cours"
    },
    {
        id: 14,
        label: "Suppression en cours"
    },
    {
        id: 15,
        label: "Retour en cours"
    },
    {
        id: 16,
        label: "Réponse en cours"
    },
    {
        id: 17,
        label: "Supprimé"
    },
    {
        id: 18,
        label: "Client invalide retourné"
    },
    {
        id: 19,
        label: "Rappel en cours"
    },
    {
        id: 20,
        label: "Rappelé"
    },
    {
        id: 21,
        label: "Traitement en cours"
    },
    {
        id: 22,
        label: "Rappel en cours"
    }
];

export const GroupDocuments = [{
        id: 33,
        label: "Group instructions sent by the primary team"
    },
    {
        id: 37,
        label: "Documents returned from the primary team"
    }
];

export const engagementUserStatus = {
    1: "Actif",
    2: "En attente",
    3: "Rejeté",
    4: "Désactivé",
    5: "Demande d’accès aux archives",
    6: "Rejet de la demande d’accès aux archives",
    7: "Copie de la mission – Inactif",
    8: "Détaché – Inactif",
    9: "Gabarit – Inactif",
    10: "Récupération – Inactif",
    11: "Localisé dans un centre de données universel",
    12: "Invitation en cours",
    13: "Planifié – Inactif"
};
export const CGTTaskSendStatus = [{
        id: 1,
        label: "Non envoyée"
    },
    {
        id: 2,
        label: "Document en transit"
    },
    {
        id: 3,
        label: "Version projet envoyée"
    },
    {
        id: 4,
        label: "Retournée"
    },
    {
        id: 5,
        label: "En cours de revue"
    },
    {
        id: 6,
        label: "Terminée"
    },
    {
        id: 7,
        label: "Rejetée"
    },
    {
        id: 8,
        label: "Rejet en transit"
    },
    {
        id: 9,
        label: "Version finale envoyée"
    },
    {
        id: 999,
        label: "Échec de l’envoi"
    }
];

export const ServiceRequestStatus = [{
        id: 11,
        cssClass: 'accepted-text',
        statusLabel: "Acceptée"
    },
    {
        id: 12,
        cssClass: 'pending-text',
        statusLabel: "Envoyée"
    },
    {
        id: 13,
        cssClass: 'rejected-text',
        statusLabel: "Annulée"
    },
    {
        id: 14,
        statusLabel: "Projet"
    },
    {
        id: 15,
        cssClass: 'completed-text',
        statusLabel: "Terminée"
    },
    {
        id: 16,
        statusLabel: "Terminées au cours de la période précédente"
    },
    {
        id: 17,
        statusLabel: "Erreur de l’envoi"
    },
    {
        id: 22,
        statusLabel: "s. o."
    },
    {
        id: 24,
        statusLabel: "Action requise"
    }
];

export const assignmentsSectionLabels = [{
        id: bulkAssignment.assign,
        label: "Affectations"
    },
    {
        id: bulkAssignment.timephase,
        label: "Périodes"
    },
    {
        id: bulkAssignment.tag,
        label: "Balises"
    }
];

export const assignmentsSectionLabelsNew = [{
        id: bulkAssignment.assign,
        label: "Affectations"
    },
    {
        id: bulkAssignment.timephase,
        label: "Périodes"
    }
];

export const assignmentTypeLabels = [{
        id: assignmentTypes.preparer,
        label: "Préparateur"
    },
    {
        id: assignmentTypes.detailReviewer,
        label: "Responsable de la revue détaillée"
    },
    {
        id: assignmentTypes.generalReviewer,
        label: "Responsable de la revue générale"
    },
    {
        id: assignmentTypes.partner,
        label: "Associé"
    },
    {
        id: assignmentTypes.eqr,
        label: "RRQM"
    },
    {
        id: assignmentTypes.other,
        label: "Autre"
    }
];

export const assignmentActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "Ajouter"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "Supprimer"
    },
    {
        id: bulkAssignmentConstants.actionIds.replace,
        label: "Remplacer"
    },
    {
        id: bulkAssignmentConstants.actionIds.updateDueDays,
        label: "Mettre à jour le nombre de jours avant l’échéance"
    }
];

export const tagActionsLabels = [{
        id: bulkAssignmentConstants.actionIds.add,
        label: "Ajouter"
    },
    {
        id: bulkAssignmentConstants.actionIds.remove,
        label: "Retirer"
    }
];

export const manageAssigmentsActionTypeLabel = [{
        id: actionTypes.edit,
        label: "Modifier"
    },
    {
        id: actionTypes.delete,
        label: "Supprimer"
    }
];

export const confidentialityLevels = {
    [confidentialityTypes.DEFAULT]: "Par défaut",
    [confidentialityTypes.LOW]: "Faible",
    [confidentialityTypes.MODERATE]: "Modéré",
    [confidentialityTypes.HIGH]: "Élevé"
};

export const milestoneTaskLabels = [{
        id: milestoneBuildTaskIds.accounts,
        label: "Tâches du flux pour les comptes"
    },
    {
        id: milestoneBuildTaskIds.scots,
        label: "Tâches du flux pour les catégories importantes d’opérations"
    },
    {
        id: milestoneBuildTaskIds.itso,
        label: "Tâches du flux pour les TI/SS"
    },
    {
        id: milestoneBuildTaskIds.cra,
        label: "Tâches du flux pour l’EGR"
    },
    {
        id: milestoneBuildTaskIds.auditPlan,
        label: "Tâches du flux pour le plan de mission"
    },
    {
        id: milestoneBuildTaskIds.groupStructure,
        label: "Tâches du flux pour la structure du groupe"
    },
    {
        id: milestoneBuildTaskIds.groupInstructions,
        label: "Tâches du flux pour les instructions du groupe"
    },
    {
        id: milestoneBuildTaskIds.review,
        label: "Tâche du flux pour la revue"
    }
];

//Filters for RegionComponentEvidence
export const gaDocFilters = {
    scope: "Étendue",
    teamName: "Nom de l’équipe",
    groupStructure: "Structure du groupe",
    region: "Zone",
    component: "Composante"
};

export const filterSourceOfForm = [{
        value: '1',
        label: "Personnalisé"
    },
    {
        value: '2',
        label: "Connaissances"
    },
    {
        value: '3',
        label: "Indépendance"
    }
];

export const independenceActions = [{
        id: independenceActionIds.createIndependenceForm,
        label: "Créer un formulaire relatif à l’indépendance "
    },
    {
        id: independenceActionIds.removeTeamMember,
        label: "Retirer le membre de l’équipe"
    },
    {
        id: independenceActionIds.removeOverride,
        label: "Retirer l’écrasement"
    }
];


export const reviewNoteModalLabels = {
    /*Review Notes*/
    commentThread: "Fil de la note",
    singleNoteInstructionalText: "Afficher le commentaire sélectionné ci-après et y répondre.",
    emptyNoteDetailsMessage: "Sélectionnez une note pour afficher les détails. Pour activer les contrôles en bloc, appuyez sur la touche Ctrl ou Maj et sélectionnez plusieurs commentaires de revue. Si vous souhaitez travailler sur un seul commentaire, vous devez le sélectionner dans la liste.",
    documentReviewNotesLabel: "Notes de document",
    addNewReviewNoteButtonText: "Nouvelle note",
    noNotesAssociatedWithDocumentLabel: "Veuillez laisser une note en utilisant les données ci-après. Attribuez la note à un utilisateur et indiquez la priorité ainsi que la date d’échéance.",
    noNotesFound: "Aucune note trouvée",
    noNotesAssociatedWithTaskLabel: "Aucune note {0} n’est associée à la tâche.",
    allNotesLabel: "Toutes les notes",
    charactersLabel: "caractères",
    myNotesLabel: "Mes notes",
    showClearedLabel: "Afficher les éléments réglés",
    showClosedLabel: "Afficher les éléments fermés",
    assignedToLabel: "Attribuée à",

    ofLabel: "de",
    enterNoteText: "Entrer une note",
    addNewNoteModalClose: "Fermer",
    addNewNoteModalTitleLabel: "Ajouter une nouvelle note",
    editNoteModalTitleLabel: "Modifier la note",
    deleteIconHoverText: "Supprimer",
    deleteIconModalAcceptText: "Supprimer",
    deleteIconModalConfirmMessage: "Voulez-vous vraiment supprimer votre réponse à ce commentaire?",
    deleteIconModalConfirmMessageParent: "Voulez-vous vraiment supprimer le commentaire sélectionné?",
    deleteIconModalTitleLabel: "Supprimer la note",
    deleteReplyIconModalTitle: "Supprimer la réponse",
    emptyRepliesMessage: "Aucune réponse pour l’instant",
    replyInputPlaceholder: "Répondre à cette note",
    replyInputPlaceholderEdit: "Modifier la réponse à la note de revue",
    noteInputPlaceholderEdit: "Modifier la note de revue",
    replyText: "Texte de réponse",
    editReplyModelTitle: "Modifier la réponse",
    editReplyPlaceholder: "Saisir la réponse",
    noteDueDateLabel: "Échéance",

    priorityLabel: "Priorité",
    dueDateLabel: "Date d'échéance",
    dueLabel: "Échéance",
    status: "État",
    noteModifiedDateLabel: "Modifiée",
    cancelLabel: "Annuler",
    saveLabel: "Enregistrer",
    clearedBy: "Effacée par",
    closedBy: "Fermée par",
    reopenedBy: "Rouverte par",
    reply: "Répondre",
    editIconHoverTextLabel: "Modifier",
    required: "Requis",
    closeTitle: "Fermer",
    otherEngagementNotes: "Autres notes relatives à la mission",
    closeLabel: "Fermer",
    showMore: "Afficher plus",
    showLess: "Afficher moins",
    showMoreEllipsis: "Afficher plus…",
    showLessEllipsis: "Afficher moins…",
    noResultFound: "Aucun résultat",
    engagementNameLabel: "Nom de la mission :",
    taskReviewNotesLabel: "Notes de tâche",
    fromUserLabel: labels.fromUserLabel,
    toUserLabel: labels.toUserLabel
};

//Copyhub create package
export const createPackageLabels = {
    packageType: "Type de paquet",
    categories: "Catégories",
    itemsToCopy: "Éléments à copier",
    createPackage: "Créer un paquet",
    selectPackageType: "Sélectionner le type de paquet",
    selectPackageTypeTitle: "Sélectionner le type de paquet",
    selectCategoriesTitle: "Sélectionner des catégories",
    selectEntitiesTitle: "Sélectionner des entités",
    relateCanvasFormsTitle: "Associer les documents",
    relateAnObjectTitle: "Associer un objet",
    step1InstructionalText: "Sélectionnez le type de paquet, nommez-le et choisissez le destinataire. Assurez-vous de vous conformer aux lois, aux règlements et aux directives d’EY applicables concernant la confidentialité des données, le transfert des données entre pays et la protection des renseignements confidentiels avant de créer ou d’envoyer un paquet de données pour copie.",
    packageTypes: [{
        value: 21,
        text: "Mission"
    }, {
        value: 20,
        text: "Éléments probants"
    }, {
        value: 24,
        text: "Récupérer d’un projet existant"
    }, {
        value: 22,
        text: "Comptes"
    }, {
        value: 23,
        text: "Catégories d’opérations importantes"
    }, {
        value: 26,
        text: "Exportation en bloc"
    }, {
        value: 25,
        text: "Gabarit"
    }, {
        value: 27,
        text: "Documents externes"
    }, {
        value: 28,
        text: "Flux de travail guidés"
    }, {
        value: 29,
        text: "Mission par entité"
    }],

    packageName: "Nom du paquet",
    packageDetailsText: "Renseignements sur le paquet",
    required: "Requis",
    sendTo: "Envoyer à",
    nameOrEmail: "Nom ou courriel",
    sendToName: "Nom",
    sendToEmail: "Courriel",
    clearAllValues: "Effacer toutes les valeurs",
    engagementIdErrorMessage: "L’identifiant de la mission n’est pas précisé.",
    emptyCategoriesStep2Text: '...',
    insufficientPermissionsMessage: "Vous ne disposez pas des autorisations requises pour créer un paquet de données pour copie. Veuillez communiquer avec l’administrateur de la mission et demander l’autorisation de créer un paquet de données pour copie.",
    CopyHubCanvasFormTooltip: "Pour les formulaires EY Canvas seulement",
    CopyEngagementInProgress: "Vous ne pouvez traiter qu’une seule copie de la mission à la fois. ",

    //Step 3 labels
    step3Header: "Sélectionner {0} pour copier",
    selectAllText: "Tout sélectionner",
    delectAllText: "Tout désélectionner",
    documentsSelectedText: "documents sélectionnés",
    scotsSelectedText: "Catégories importantes d’opérations sélectionnées",
    accountsSelectedText: "Comptes sélectionnés ",
    entitiesSelectedText: "entités sélectionnées",
    step3InstructionText: "Assurez-vous de vous conformer aux lois, aux règlements et aux directives d’EY applicables concernant la confidentialité des données, le transfert des données entre pays et la protection des renseignements confidentiels avant de créer ou d’envoyer un paquet de données.",
    step3InstructionTextEvidence: "Assurez-vous de vous conformer aux lois, aux règlements et aux directives d’EY applicables concernant la confidentialité des données, le transfert des données entre pays et la protection des renseignements confidentiels avant d’envoyer les données d’une mission.",
    step3InstructionTextWarning: "Les formulaires EY Canvas n’incluront pas les objets associés (p. ex., catégories d’opérations importantes, contrôles).",
    step3InstructionTextWarningFIT: "Les copies des flux de travail guidés peuvent inclure les situations et événements pertinents relevés et leurs descriptions connexes. Elles n’incluront pas les autres objets associés (p. ex. comptes, risques).",
    availableCanvasFormsColumnName: "Documents disponibles",
    availableFITDocuments: "Flux de travail guidés disponibles",
    availableAccountsColumnName: "Comptes disponibles",
    availableSCOTsColumnName: "Catégories importantes d’opérations disponibles",
    availableExternalDocumentsColumnName: "Documents externes disponibles",
    step3NoItemeSelectedError: "Sélectionnez au moins un élément pour continuer",
    searchPackagePlaceholder: "Rechercher",
    searchPackageClearHoverText: "Effacer",

    //step2:
    step2Header: "Sélectionner les catégories pour le paquet {0} ",
    step2AccountsHdr: "Sélectionner les catégories à inclure dans le paquet de données pour copie. Le paquet de base inclut toutes les assertions, les PCB et les APC associées.",
    step2scotshdr: "Sélectionner les catégories à inclure dans le paquet de données pour copie. Le paquet de base inclut toutes les erreurs possibles connexes, les contrôles et les tâches associés. ",
    step2canformhdr: "Sélectionner les catégories à inclure dans le paquet de données pour copie.",
    step2InstructionTextEngagementByEntity: "Sélectionner les entités à inclure dans le paquet de données pour copie.",
    availableEntitiesColumnName: "Entités disponibles",
    step2HeaderEntities: "Sélectionner {0} pour le paquet de la mission.",
    entitiesLabel: "Entités",

    scots: "Catégories importantes d’opérations",
    itso: "Application informatique / Société de services",
    evidence: "Éléments probants",
    realtedevidence: "Éléments probants associés",
    signoffs: "Approbations",
    tempfiles: "Fichiers temporaires",
    priorperiodevidence: "Éléments probants de la période précédente",
    recentlydeletedfiles: "Fichiers récemment supprimés",
    historyfiles: "Fichiers historiques",
    extgrp: "Groupes externes et membres de l’équipe externe",
    eydocument: "Documents EY",
    extdoc: "Documents externes",
    totalfilesize: "La taille totale de tous les fichiers sélectionnés est de",
    requestandexernaltasks: "Demandes et tâches externes",
    rollForwardFromExisting: "Récupérer d’un projet existant",
    template: "Gabarit",
    bulkExport: "Exportation en bloc",

    fileSizeWaring: "Les catégories sélectionnées comprennent des fichiers qui {0}. EY Canvas ne prend pas en charge les paquets de données pour copie dont la taille dépasse cette limite.",
    fileSizeWarningline2: "Songez à éliminer des catégories de documents pour réduire la taille de fichier du paquet de données pour copie.",
    coloredExceedLable: "dépassent {0} Go",
    step2EngHdr: "Sélectionner les catégories à inclure dans le paquet de données pour copie. Le paquet de base comprend le profil de la mission, tous les documents de la base de connaissances, les tâches standards de base, les autres tâches standards, les périodes; les comptes / les informations à fournir, les assertions et les tâches qui leur sont associées; les catégories d’opérations importantes, les erreurs possibles, les contrôles et les tâches connexes; les applications informatiques / sociétés de services, les risques, les contrôles généraux informatiques / procédures de corroboration liés aux TI et les tâches associées. S’il s’agit d’une mission d’audit de groupe, le paquet comprendra également les données d’audit de groupe.",
    step2EngByEntityHdr: "Sélectionner les catégories à inclure dans le paquet de données pour copie. Le paquet de base comprend le profil de la mission, tous les documents de la base de connaissances, les tâches standards de base, les autres tâches standards, les périodes; les comptes / informations à fournir, les assertions et les tâches qui leur sont associées; les catégories d’opérations importantes, les erreurs possibles, les contrôles et les tâches connexes; les applications informatiques / sociétés de services, les risques, les contrôles généraux informatiques / procédures de corroboration liés aux TI et les tâches associées; les schémas. S’il s’agit d’une mission d’audit de groupe, le paquet comprendra également les données d’audit de groupe.",
    step2BulkExpHdr: "Sélectionner les catégories de documents à exporter.",
    gb: "Go",
    step2And: "et",
    step2Files: "document(s)",
    lessThanMinGB: "moins de 0,01 Go",
    CategoryFileSizeCount: " {0} Go et {0} document(s)",

    cancelLabel: "Annuler",
    showSelected: "Afficher la sélection",
    showSelectedDocuments: "Afficher {0} document(s) sélectionné(s)",
    showSelectedEntities: "Afficher {0} entité(s) sélectionnée(s)",
    showSelectedGuidedWorflows: "Afficher {0} flux de travail guidé(s) sélectionné(s)",
    showSelectedAccounts: "Afficher {0} compte(s) sélectionné(s)",
    showSelectedSCOTs: "Afficher {0} catégorie(s) d’opérations importante(s) sélectionnée(s)",
    noDataFoundLabel: "Aucune donnée trouvée",
    copyPackageSuccessMessage: "{0} exportation de données a été lancée.",
    copyPackageWarningLabel: "Avertissement : L’envoi du paquet aux membres ci-dessous a échoué en raison d’une information invalide :- {0}",
    noResultFound: "Aucun résultat trouvé",
    canvasForms: "Formulaires EY Canvas",
    canvasFormsInformationText: "Les formulaires EY Canvas peuvent être exportés seulement comme éléments probants et/ou fichiers temporaires.<br/>Veuillez sélectionner l’une de ces options pour permettre le téléchargement des formulaires EY Canvas.",
    coEditSelectAllWarningMessage: "Certains documents sont actuellement en mode édition multiutilisateur et ne peuvent donc pas être inclus dans le paquet pour copie.",
    coEditDocumentTooltip: "Le document est actuellement en mode édition multiutilisateur et ne peut donc pas être copié. Veuillez archiver le document afin de pouvoir l’inclure à ce paquet.",
    coEditCopyWarningMessage: "{0} documents sont actuellement en mode édition multiutilisateur dans la ou les catégories {1}. Veuillez archiver tous les documents dans chaque catégorie pour les inclure dans ce paquet."
};

export const documentTypes = [{
        id: 1,
        label: "Éléments probants"
    },
    {
        id: 2,
        label: "Temporaire"
    },
    {
        id: 3,
        label: "Éléments probants de l’exercice précédent"
    },
    {
        id: 4,
        label: "Dossiers clients"
    },
    {
        id: 5,
        label: "Instantané"
    },
    {
        id: 6,
        label: "Formulaire dynamique"
    },
    {
        id: 29,
        label: "Profil papier"
    },
    {
        id: 47,
        label: "Exportation des documents en bloc"
    },
    {
        id: 48,
        label: "Formulaire Canvas"
    },
    {
        id: 51,
        label: "Centre d’automatisation"
    },
    {
        id: 59,
        label: "Paquets de données"
    },
    {
        id: 72,
        label: "Feuille de travail dynamique"
    }
];

export const activityTypes = [{
        id: activityType.primaryLinkAccept,
        label: "Demande de lien acceptée par {0}"
    },
    {
        id: activityType.primaryLinkReject,
        label: "Demande de lien rejetée par {0}"
    },
    {
        id: activityType.primaryUnlink,
        label: "Mission dissociée du groupe par {0}"
    },
    {
        id: activityType.primaryComponentUnlink,
        label: "Mission dissociée du groupe par {0}"
    },
    {
        id: activityType.componentPrimaryUnlink,
        label: "Mission dissociée du groupe par {0}"
    },
    {
        id: activityType.primarySendLink,
        label: "Demande de lien envoyée par {0} à {1}"
    },
    {
        id: activityType.documentsReceived,
        label: "Documents reçus par {0}"
    },
    {
        id: activityType.primarySendInstruction,
        label: "Instructions envoyées par {0} à {1}"
    },
    {
        id: activityType.primaryRejectInstruction,
        label: "Instructions retournées par {0}"
    },
    {
        id: activityType.primaryAcceptInstruction,
        label: "Instructions acceptées par {0}"
    },
    {
        id: activityType.componentReceivedInstruction,
        label: "Instructions reçues"
    },
    {
        id: activityType.componentAcceptInstruction,
        label: "Instructions acceptées par {0}"
    },
    {
        id: activityType.componentRejectInstruction,
        label: "Instructions retournées par {0}"
    },
    {
        id: activityType.componentAcceptUpdatetInstruction,
        label: "Instructions acceptées par {0}"
    },
    {
        id: activityType.componentRejectUpdateInstruction,
        label: "Instructions retournées par {0}"
    },
    {
        id: activityType.primaryEvidenceReceived,
        label: "Version reçue par {0}"
    },
    {
        id: activityType.documentVersionConflictResolved,
        label: "Conflit résolu par {0}"
    },
    {
        id: activityType.documentOverwrite,
        label: "Contenu du document écrasé par {0}"
    },

    {
        id: activityType.primaryAssignComponent,
        label: "Document attribué à {0}"
    },
    {
        id: activityType.componentUnassigned,
        label: "Document retiré à {0}"
    },
    {
        id: activityType.clearDocumentReturnedtoComponent,
        label: "Version terminée par {0}"
    },
    {
        id: activityType.componentClearReturnedDocument,
        label: "Version résolue par {0}"
    },
    {
        id: activityType.primaryReturnEvidence,
        label: "Version retournée par {0}"
    },
    {
        id: activityType.componentEvidenceSent,
        label: "Version envoyée par {0}"
    },
    {
        id: activityType.componentReturnEvidence,
        label: "Version retournée par {0}"
    },
    {
        id: activityType.createReviewNote,
        label: "Note consultée par {0}"
    },
    {
        id: activityType.openReviewNote,
        label: "Note consultée par {0}"
    },
    {
        id: activityType.clearReviewNote,
        label: "Note réglée par {0}"
    },
    {
        id: activityType.closeReviewNote,
        label: "Note fermée par {0}"
    },
    {
        id: activityType.reviewerSignOff,
        label: "Approuvée par {0}"
    },
    {
        id: activityType.preparerSignOff,
        label: "Approuvée par {0}"
    },
    {
        id: activityType.canvasSendClientRequest,
        label: labels.sent
    },
    {
        id: activityType.clientRespondToClientRequest,
        label: "Réponse reçue"
    },
    {
        id: activityType.canvasRejectClientRequest,
        label: labels.rejected
    },
    {
        id: activityType.canvasWithdrawClientRequest,
        label: labels.WithdrawLabel
    },
    {
        id: activityType.canvasDeleteClientRequest,
        label: "Supprimée"
    },
    {
        id: activityType.canvasAcceptClientRequest,
        label: labels.accepted
    },
    {
        id: activityType.CEARecallClientRequest,
        label: "Rappelée"
    },
    {
        id: activityType.canvasCompleteClientRequest,
        label: labels.completed
    }
];


export const gaLinkStatus = [{
        id: GALinkStatus.Undefined,
        label: "Non définie"
    },
    {
        id: GALinkStatus.NoPointOfContact,
        label: "Aucun contact"
    },
    {
        id: GALinkStatus.Pending,
        label: "En attente"
    },
    {
        id: GALinkStatus.Accepted,
        label: "Acceptée"
    },
    {
        id: GALinkStatus.Rejected,
        label: "Rejetée"
    },
    {
        id: GALinkStatus.Expired,
        label: "Échue"
    },
    {
        id: GALinkStatus.Unlinked,
        label: "Détachée"
    },
    {
        id: GALinkStatus.Delegated,
        label: "Déléguée"
    },
    {
        id: GALinkStatus.SystemError,
        label: "Erreur système"
    },
    {
        id: GALinkStatus.Sent,
        label: "Envoyée"
    },
    {
        id: GALinkStatus.InvalidPointOfContact,
        label: "Contact non valide"
    },
    {
        id: GALinkStatus.ComponentNotUsingCanvas,
        label: "Composante n’utilisant pas Canvas"
    }
];

export const gaInstructionStatus = [{
        id: 0,
        label: labels.notApplicable
    },
    {
        id: instructionStatus.notSent,
        label: "Non envoyée"
    },
    {
        id: instructionStatus.pending,
        label: "En attente"
    },
    {
        id: instructionStatus.accepted,
        label: "Acceptée"
    },
    {
        id: instructionStatus.rejected,
        label: "Retournée"
    },
    {
        id: instructionStatus.systemError,
        label: "Erreur système"
    },
    {
        id: instructionStatus.expired,
        label: "Échue"
    },
    {
        id: instructionStatus.sent,
        label: "Envoyée"
    },
    {
        id: instructionStatus.unlinked,
        label: "Détachée"
    },
    {
        id: instructionStatus.queued,
        label: "En file d’attente"
    }
];

export const gsSnapshotComparisonStatus = [{
        id: snapshotComparisonIds.noChange,
        value: "Aucun changement"
    },
    {
        id: snapshotComparisonIds.new,
        value: "Nouveau"
    },
    {
        id: snapshotComparisonIds.added,
        value: "Ajouté"
    },
    {
        id: snapshotComparisonIds.modified,
        value: "Modifié"
    },
    {
        id: snapshotComparisonIds.updated,
        value: "Mis à jour"
    },
    {
        id: snapshotComparisonIds.removed,
        value: "Retiré"
    },
    {
        id: snapshotComparisonIds.itemsRemoved,
        value: "Éléments retirés"
    },
]

export const gaRoleType = [{
        id: GARoleTypeId.Primary,
        label: "Principale"
    },
    {
        id: GARoleTypeId.Region,
        label: "Zone"
    },
    {
        id: GARoleTypeId.Component,
        label: "Composante"
    }
];

export const linkRequestTypes = [{
        id: linkType.sent,
        label: "Envoyée"
    },
    {
        id: linkType.unlinked,
        label: "Détachée"
    },
    {
        id: linkType.accepted,
        label: "Acceptée"
    }
];

export const instructionTypes = [{
        id: instructionType.sent,
        label: "Envoyée"
    },
    {
        id: instructionType.rejected,
        label: "Retournée"
    },
    {
        id: instructionType.received,
        label: "Reçue"
    },
    {
        id: instructionType.accepted,
        label: "Acceptée"
    }
];

export const syncStatusLabels = [{
        id: syncStatus.notSynchronized,
        label: "Non synchronisé"
    },
    {
        id: syncStatus.syncInTransit,
        label: "Synchronisation en transit"
    },
    {
        id: syncStatus.syncInProcess,
        label: "Synchronisation en cours"
    },
    {
        id: syncStatus.synchronized,
        label: "Synchronisation terminée"
    },
    {
        id: syncStatus.deleteInTransit,
        label: "Suppression en transit"
    },
    {
        id: syncStatus.deleteInProcess,
        label: "Suppression en cours"
    },
    {
        id: syncStatus.deleted,
        label: "Supprimé"
    },
    {
        id: syncStatus.noHostEngagement,
        label: "Aucune mission hôte"
    },
    {
        id: syncStatus.syncError,
        label: "Erreur de synchronisation"
    }
];

export const colorOptionsLabels = {
    Red: "Rouge",
    Orange: "Orange",
    Teal: "Sarcelle",
    Blue: "Bleu",
    Purple: "Mauve",
    Green: "Vert",
    Yellow: "Jaune",
    Gray: "Gris"
};

export const todoListTimeFrameLabels = [{
        id: todoListTimeframeOptions.byDay,
        label: "Par jour"
    },
    {
        id: todoListTimeframeOptions.byWeek,
        label: "Par semaine"
    },
    {
        id: todoListTimeframeOptions.byMonth,
        label: "Par mois"
    },
    {
        id: todoListTimeframeOptions.all,
        label: "Toutes"
    },
    {
        id: todoListTimeframeOptions.overdue,
        label: "En retard"
    }
];

export const clientRequestsStatusFilter = [{
        value: 'Draft',
        label: "Projet"
    },
    {
        value: 'Pending',
        label: "En attente d’une réponse"
    },
    {
        value: 'Received',
        label: "Reçue"
    },
    {
        value: 'Accepted',
        label: "Acceptée"
    }
];

export const clientRequestsTypeFilter = [{
        value: 'Required',
        label: "Approbation requise"
    },
    {
        value: 'NotRequired',
        label: "Approbation non requise"
    }
];

export const clientRequestsPriorityFilter = [{
        value: 'Normal',
        label: "Normale"
    },
    {
        value: 'High',
        label: "Élevée"
    },
    {
        value: 'Critical',
        label: "Critique"
    }
];

export const clientRequestsAttachmentsFilter = [{
        value: 'Analytics',
        label: "Analyses"
    },
    {
        value: 'ExternalAttachments',
        label: "Pièces jointes externes"
    },
    {
        value: 'EyAttachments',
        label: "Pièces jointes EY "
    },
    {
        value: 'None',
        label: "Aucune "
    }
];

export const clientRequestsCreatedByFilter = [{
        value: 'Client',
        label: "Client"
    },
    {
        value: 'EY',
        label: "EY"
    }
];

export const filterTimePhase = [{
    value: -1,
    label: "Aucune période"
}];

export const clientRequestsBooleanFilters = [{
        value: 1,
        label: "Oui"
    },
    {
        value: 0,
        label: "Non"
    }
]

export const bulkClientRequestsNoRelatedTaskFilter = [{
        value: false,
        label: "Oui"
    },
    {
        value: true,
        label: "Non"
    }
]

export const controlsTestingFilters = [{
        value: 'true',
        label: "Oui"
    },
    {
        value: 'false',
        label: "Non"
    },
    {
        value: 'null',
        label: "Non sélectionné"
    }
];

export const controlsDesignEffectivenessFilters = [{
        value: '1',
        label: "Efficace"
    },
    {
        value: '2',
        label: "Inefficace"
    },
    {
        value: '0',
        label: "Non sélectionné"
    }
];

export const clientRequestAnnotationTabs = [{
        id: clientRequestNoteTab.comments,
        label: "Commentaires"
    },
    {
        id: clientRequestNoteTab.history,
        label: "Historique"
    }
];

export const riskTypeOptions = [{
        id: 1,
        name: "Risques importants"
    },
    {
        id: 2,
        name: "Risques de fraude"
    },
    {
        id: 3,
        name: "Risque d’anomalies significatives"
    }
];

export const months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
export const longDays = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
export const shortDays = ['dim.', 'lun.', 'mar.', 'mer.', 'jeu.', 'ven.', 'sam.'];

// GA Scopes
export const gaScopesResource = [{
        id: gaScopes.full,
        label: "Audit complet"
    },
    {
        id: gaScopes.specific,
        label: "Audit spécifique"
    },
    {
        id: gaScopes.specificAuditProcedures,
        label: "Procédures d’audit spécifiées"
    },
    {
        id: gaScopes.review,
        label: "Revue"
    }
]

// GA Instructions
export const gaRecommendationTypeResource = [{
        id: gaRecommendationType.required,
        label: "Requises"
    },
    {
        id: gaRecommendationType.optional,
        label: "Facultatives"
    },
    {
        id: gaRecommendationType.notApplicable,
        label: "Sans objet"
    }
]

// GS Group Summary
export const gsTabsResource = [{
        id: groupSummaryTabs.assignedTeams,
        label: "Équipes affectées"
    },
    {
        id: groupSummaryTabs.instructions,
        label: "Instructions"
    },
    {
        id: groupSummaryTabs.tasks,
        label: "Tâches"
    }
]

export const receiveInstructionsTypeResource = {
    true: {
        title: "Nouvelle",
        instructional: "une nouvelle"
    },
    false: {
        title: "Mise à jour de la {version} ",
        instructional: "une {version} mise à jour"
    }
}

export const clientRequestSystemGeneratedMessages = {
    sent: "Demande envoyée à ",
    accepted: "Demande acceptée",
    received: "Demande reçue",
    returned: "Demande retournée",
    withdrawn: "Demande retirée",
    complete: "Demande traitée par EY",
    recalled: "Demande rappelée",
    notification_submit: "Demande soumise aux fins d’automatisation",
    notification_success: "La demande a bien été soumise aux fins d’automatisation",
    notification_error: "Une erreur s’est produite lors de la soumission de la demande aux fins d’automatisation. Cliquez sur Soumettre aux fins d’automatisation pour réessayer.",
    restore_document: "Document restauré - ",
    delete_document: "Document supprimé - ",
    assignedto: "Élément réaffecté à",
    editrequest: "Demande modifiée",
    prioritychange: "Priorité de la demande mise à jour et passée à"
};

export const externalTaskSystemGeneratedMessages = {
    sent: "Tâche externe envoyée à ",
    accepted: "Tâche externe acceptée",
    received: "Réponse reçue",
    returned: "Tâche externe retournée",
    withdrawn: "Tâche externe retirée",
    complete: "La tâche externe a été effectuée à partir d’EY Canvas.",
    recalled: "Tâche externe rappelée",
    restore_document: "Document restauré - ",
    delete_document: "Document supprimé - ",
    assignedto: "Élément réaffecté à",
    editrequest: "Tâche externe modifiée",
    prioritychange: "Priorité de la tâche externe mise à jour pour le"
};

export const ipInputLabels = [{
        id: ipInputType.ipAddress,
        label: "Adresse IP"
    },
    {
        id: ipInputType.ipRange,
        label: "Plage d’adresses IP"
    },
    {
        id: ipInputType.cidrBlock,
        label: "Bloc CIDR"
    }
];

export const ipFilterTypeLabels = {
    [ipFilterType.ipAddress]: "Adresse IP",
    [ipFilterType.ipRange]: "Plage d’adresses IP",
    [ipFilterType.cidrBlock]: "Bloc CIDR"
};

export const gaLinkStatusObj = {
    [GALinkStatus.Undefined]: "Non défini",
    [GALinkStatus.NoPointOfContact]: "Aucune personne-ressource",
    [GALinkStatus.NotSent]: "Non envoyé",
    [GALinkStatus.Pending]: "Demande de lien en attente",
    [GALinkStatus.Accepted]: "Demande de lien acceptée",
    [GALinkStatus.Rejected]: "Rejeté",
    [GALinkStatus.Expired]: "Échu",
    [GALinkStatus.Unlinked]: "Dissociée",
    [GALinkStatus.Delegated]: "Déléguée",
    [GALinkStatus.SystemError]: "Erreur système",
    [GALinkStatus.Sent]: "Envoyée",
    [GALinkStatus.InvalidPointOfContact]: "Contact non valide",
    [GALinkStatus.ComponentNotUsingCanvas]: "N’utilisant pas EY Canvas",
    [GALinkStatus.ComponentReferenceOnly]: "Référence seulement"
};

export const epTasksObj = [{
        value: '3',
        label: "Aucun document approuvé"
    },
    {
        value: '2',
        label: "Quelques documents approuvés"
    },
    {
        value: '1',
        label: "Tous les documents approuvés"
    }
];

export const eqrTasksObj = [{
        value: '6',
        label: "Aucun document approuvé"
    },
    {
        value: '5',
        label: "Quelques documents approuvés"
    },
    {
        value: '4',
        label: "Tous les documents approuvés"
    }
];

export const groupsFilterEntity = [{
        id: 1,
        label: "Tâches"
    },
    {
        id: 2,
        label: "Documents"
    }
];

export const scopesFilterEntity = [{
        id: 1,
        label: "Audit complet"
    },
    {
        id: 2,
        label: "Audit spécifique"
    },
    {
        id: 3,
        label: "Procédures d’audit spécifiées"
    },
    {
        id: 4,
        label: "Examen"
    }
];

export const notesFilterLabels = [{
        id: notesFilter.allNotes,
        label: "Toutes les notes"
    },
    {
        id: notesFilter.myNotes,
        label: "Mes notes"
    },
    {
        id: notesFilter.authoredByMeNotes,
        label: "Attribués à moi "
    }
];

//Client Request Advanvce Search
export const advancedSearchValues = [{
        id: 1,
        value: labels.advancedSearchTitleCheck
    },
    {
        id: 2,
        value: labels.advancedSearchRefereceNumberCheck
    },
    {
        id: 3,
        value: labels.advancedSearchDocumentsCheck
    },
    {
        id: 4,
        value: labels.advancedSearchCommentsCheck
    }
];


export const TaskTypeLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy]
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs]
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs]
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts]
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution]
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion]
    }
];

export const TaskCategoryLabels = [{
        id: TaskListTypes.ScopeAndStrategy,
        label: taskNavigation[TaskListTypes.ScopeAndStrategy],
        displayOrder: 1
    },
    {
        id: TaskListTypes.Risks,
        label: taskNavigation[TaskListTypes.Risks],
        displayOrder: 2
    },
    {
        id: TaskListTypes.SCOTs,
        label: taskNavigation[TaskListTypes.SCOTs],
        displayOrder: 3
    },
    {
        id: TaskListTypes.ITSOs,
        label: taskNavigation[TaskListTypes.ITSOs],
        displayOrder: 4
    },
    {
        id: TaskListTypes.Accounts,
        label: taskNavigation[TaskListTypes.Accounts],
        displayOrder: 5
    },
    {
        id: TaskListTypes.GeneralExecution,
        label: taskNavigation[TaskListTypes.GeneralExecution],
        displayOrder: 6
    },
    {
        id: TaskListTypes.Conclusion,
        label: taskNavigation[TaskListTypes.Conclusion],
        displayOrder: 7
    },
];

export const kendoLabels = {
    alignLeft: "Aligner le texte à gauche",
    alignRight: "Aligner le texte à droite",
    alignCenter: "Centrer le texte",
    alignFull: "Justifier le texte",
    addComment: "Ajouter un commentaire",
    addColumnBefore: "Ajouter une colonne à gauche",
    addColumnAfter: "Ajouter une colonne à droite",
    addRowAbove: "Ajouter une ligne au-dessus",
    addRowBelow: "Ajouter une ligne en dessous",
    bulletList: "Insérer une liste non triée",
    bold: "Gras",
    backColor: "Surbrillance",
    createLink: "Insérer un hyperlien",
    createTable: "Créer un tableau",
    cleanFormatting: "Effacer la mise en forme",
    deleteRow: "Supprimer la ligne",
    deleteColumn: "Supprimer la colonne",
    deleteTable: "Supprimer le tableau",
    fontSizeInherit: "Taille de la police",
    foreColor: "Couleur",
    format: "Format",
    fontSize: "Taille de la police",
    hyperlink: "Insérer une adresse URL ",
    italic: "Italique",
    indent: "Retrait",
    insertTableHint: "Créer un tableau {0} par {1} ",
    'hyperlink-dialog-content-address': "Adresse de la page Web",
    "hyperlink-dialog-title": "Insérer un lien hypertexte",
    "hyperlink-dialog-content-title": "Titre",
    "hyperlink-dialog-content-newwindow": "Ouvrir le lien dans une nouvelle fenêtre",
    "hyperlink-dialog-cancel": "Annuler",
    "hyperlink-dialog-insert": "Insérer",
    outdent: "Retrait négatif",
    orderedList: "Insérer une liste triée",
    print: "Imprimer",
    pdf: "exporter en PDF",
    redo: "recommencer",
    strikethrough: "Barré",
    subscript: "Indice",
    superscript: "Exposant",
    underline: "Souligné",
    undo: "Annuler"
};

export const kendoFormatOptions = [{
        text: "Paragraphe",
        value: "p"
    },
    {
        text: "En-tête 1",
        value: "h1"
    },
    {
        text: "En-tête 2",
        value: "h2"
    },
    {
        text: "En-tête 3",
        value: "h3"
    },
    {
        text: "En-tête 4",
        value: "h4"
    },
    {
        text: "En-tête 5",
        value: "h5"
    },
    {
        text: "En-tête 6",
        value: "h6"
    }
];

export const kendoFontSize = [{
        text: '8',
        value: '8px'
    },
    {
        text: '9',
        value: '9px'
    },
    {
        text: '10',
        value: '10px'
    },
    {
        text: '11',
        value: '11px'
    },
    {
        text: '12',
        value: '12px'
    },
    {
        text: '14',
        value: '14px'
    },
    {
        text: '16',
        value: '16px'
    },
    {
        text: '18',
        value: '18px'
    },
    {
        text: '20',
        value: '20px'
    },
    {
        text: '22',
        value: '22px'
    },
    {
        text: '24',
        value: '24px'
    },
    {
        text: '26',
        value: '26px'
    },
    {
        text: '28',
        value: '28px'
    },
    {
        text: '36',
        value: '36px'
    },
    {
        text: '48',
        value: '48px'
    },
    {
        text: '72',
        value: '72px'
    }
];

export const monthsList = [
	"Janvier",
	"Février",
	"Mars",
	"Avril",
	"Mai",
	"Juin",
	"Juillet",
	"Août",
	"Septembre",
	"Octobre",
	"Novembre",
	"Décembre"
];

export const pspContentStatus = {
    1: "Mise à jour requise",
    2: "Mise à jour en cours",
    3: "Mise à jour terminée",
    4: "Erreur de mise à jour"
}

export const handOffLabels = {
    handoff: "Transmettre",
    handOffTitleTip: "Transmettre pour revue",
    markCompleteTitleTip: "Inscrire comme terminée",
    handoffModalTitle: "Transmettre au prochain membre de l’équipe",
    handoffConfirmButtonText: "Transmettre",
    return: "Retourner",
    handModalDescription: "Pour approuver un élément probant, sélectionnez une option parmi les suivantes.",
    markCompleteTextLine1: "Transmettre cette tâche au prochain membre de l’équipe.",
    markCompleteTextLine2: "Pour approuver un élément probant, sélectionnez une option parmi les suivantes. Si vous avez terminé la tâche qui vous a été attribuée, cliquez sur <b>Oui</b> pour la fermer. Si cette tâche nécessite l’approbation de l’associé responsable ou du responsable de la revue de la qualité de la mission, sélectionnez l’une des options suivantes.",
    closeLabel: "Fermer",
    handoffto: "Transmettre à ",
    missingToUserError: "Obligatoire",
    markCompleteConfirm: "Inscrire comme terminée",
    markCompleteModalHeaderTextPart1: "La tâche sera inscrite comme terminée.",
    markCompleteModalHeaderTextPart2: "Pour approuver un élément probant, sélectionnez une option parmi les suivantes. Si vous avez terminé la tâche qui vous a été attribuée, cliquez sur <b>Oui</b> pour la fermer. Si cette tâche nécessite l’approbation de l’associé responsable ou du responsable de la revue de la qualité de la mission, sélectionnez l’une des options suivantes.",
    signOffOnAllAs: "Tout approuver à titre de ",
    preparer: "Préparateur",
    reviewer: "Responsable de la revue",
    none: "Aucune  ",
    noSignOffsByMe: "Aucune approbation par moi",
    myPreparerSignOffs: "Approbations du préparateur qui me sont attribuées",
    myReviewerSignOffs: "Approbations du responsable de la revue qui me sont attribuées",
    myPreparerAndReviewerSignOffs: "Approbations de mon préparateur et de mon responsable de la revue",
    preparerTitle: "Approbations des préparateurs",
    reviewerTitle: "Approbations des responsables de la revue",
    autoAssignmentMessage: "Aucune tâche n’a été attribuée à ce membre de l’équipe. Une tâche avec une date d’échéance au {1} sera affectée à {0}. Pour modifier cette affectation, {2}.",
    clickHere: "cliquez ici",
    noTaskEvidencesHandoffModal: "Aucun élément probant n’est associé à cette tâche.",
    // Create Assignment
    createAssignment: "Créer une affectation",
    create: "Créer  ",
    cancelLabel: "Annuler",
    createassignmentheader1: "Cette tâche n’a pas été attribuée au membre de l’équipe sélectionné.",
    createassignmentheader2: "Créer une affectation ici.",
    dueDate: "Date d’échéance",
    teamMemberAssigmentLabel: "Membre de l’équipe",
    daysPriorToEndDate: "Nombre de jours avant la date de fin",
    // Add Assignment
    addAssignmentTitle: "Ajouter le nom de l’affectation",
    confirmButtonLabel: "Ajouter",
    cancelButtonLabel: "Annuler",
    assignmentTypeInstructionalText: "Sélectionnez le type d’affectation et indiquez un nom ci-après. Cliquez sur <b>Ajouter</b> lorsque vous avez terminé.",
    assignmentType: "Type d’affectation",
    required: "Requis",
    clearHoverText: "Effacer",
    unmarkcomplete: "Supprimer la mention « Terminée »",
    markCompleteErrorMessage: "La tâche ne peut pas être marquée comme étant terminée. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    // Assignment Dropdown
    noResultFound: "Aucun résultat",
    addTaskGroupLabel: "Ajouter un groupe de tâches",
    addAssignmentName: "Ajouter le nom de l’affectation",
    assignmentName: "Nom de l’affectation",
    additionalSignOff: "Autres approbations requises",
    signoffRequirementsModalPICLabel: "PIC",
    signoffRequirementsModalEQRLabel: "RRQM",
    closeMyAssignment: "Fermer mon affectation",
    filterYes: "Oui",
    filterNo: "Non",
    assignmentTypeLabels: [{
            id: assignmentTypes.preparer,
            label: "Préparateur"
        },
        {
            id: assignmentTypes.detailReviewer,
            label: "Responsable de la revue détaillée"
        },
        {
            id: assignmentTypes.generalReviewer,
            label: "Responsable de la revue générale"
        },
        {
            id: assignmentTypes.partner,
            label: "Associé"
        },
        {
            id: assignmentTypes.eqr,
            label: "RRQM"
        },
        {
            id: assignmentTypes.other,
            label: "Autre"
        }
    ]
};

export const displayedOn = {
    "Account": "Compte",
    "SCOT": "Catégorie d’opérations importante",
    "IT/SO": "TI/SS",
    "Scope & Strategy": "Étendue et stratégie",
    "Execution": "Exécution",
    "Conclusion": "Conclusion"
}

export const auditPlanReportLabels = {
    adc: "Objet associé",
    secondaryObject: "Objet associé secondaire",
    taskTypeColumn: "Type de tâche",
    taskNamePrefix: "Préfixe de la tâche",
    taskName: "Titre de la tâche",
    taskNameSuffix: "Suffixe de la tâche",
    taskDescription: "Description de la tâche",
    auditTaskStatus: "État de la tâche",
    rationaleForRejection: "Raison du rejet",
    knowledgeTaskTitle: "Titre de la tâche de la base de connaissances",
    knowledgeTaskDescription: "Description de la tâche de la base de connaissances",
    assignedTo: "Attribuée à",
    engagementTagGroupName: "Groupe de balises",
    engagementTagName: "Balises",
    prioritized: "Priorisée",
    viewDisplayedOn: "Affichage de la vue",
    engagementPhase: "Phase de la mission",
    milestone: "Jalon",
    periodName: "Période",
    riskTypeAbbr: "Type de risque associé",
    riskName: "Nom du risque associé",
    relatedMESTEntityName: "Entités MEST associées",
    scheduledNextWaveservices: "Services centralisés",
    taskID: "Identifiant de la tâche",
    timephaseID: "Identifiant de la période",
    taskTypeID: "Identifiant du type de tâche",
    timephaseTypeID: "Identifiant du type de période"
}

export const reportingTaskAll = {
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    taskAssignedTo: labels.taskassignedto,
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    knowledge_Task_Title: "Titre de la tâche de la base de connaissances",
    knowledge_Task_Description: "Description de la tâche de la base de connaissances",
    rejected: labels.rejected,
    rationale_for_Rejection: "Raison du rejet",
    audit_Phase: labels.auditPhasesLabel,
    milestonename: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    timephasestartdateinutc: "Date de début de la période (UTC)",
    timephaseduedateinutc: "Date d’échéance de la période (UTC)",
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    lastTaskChangeDateInUTC: "Date de la dernière modification apportée à l’état de la tâche (UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    mesT_Entity_Name: "Entités MEST associées",
    multiEntityType: "Type de mission entités multiples",
    taskID: "Identifiant de la tâche",
    taskTypeID: "Identifiant du type de tâche",
    taskStatusID: "Identifiant de l’état de la tâche",
    auditPhaseID: "Identifiant de la phase de l’audit",
    timephaseTypeID: "Identifiant du jalon",
    taskSourceTypeID: "Identifiant de la source de la tâche",
    taskNatureTypeID: "Identifiant de la nature de la tâche",
    cgTaskID: "KnowledgeTaskID",
    knowledgeContentID: "KnowledgeContentID"
}

export const reportTaskAssignments = {
    taskNamePrefix: labels.taskPrefix,
    taskName: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    taskTypeName: labels.taskType,
    taskSourceType: labels.repTaskSource,
    taskNatureType: labels.repTaskNature,
    auditPhaseName: labels.engagementPhase,
    milestones: labels.filterMilestoneLabel,
    periodName: labels.timephase,
    PICSignoffRequired: "Approbation de l’associé responsable requise",
    EQRSignoffRequired: "Approbation du Responsable de la revue de la qualité de la mission requise",
    taskStatusName: labels.taskStatusLabel,
    taskDueDateInUTC: "Date d’échéance de la tâche (UTC)",
    engagementTagGroupName: labels.manageTagGroupName,
    engagementTagName: labels.tagsLabel,
    completedAssignment: labels.completedAssignments,
    totalAssignment: "Total des affectations",
    closedTaskAssignmentPercent: "% de tâches attribuées fermées",
    assignmentOrder: "Ordre d’attribution",
    firstNameVal: "Prénom du membre de l’équipe pour la tâche attribuée",
    lastNameVal: "Nom du membre de l’équipe pour la tâche attribuée",
    assignmentName: labels.assignmentName,
    assignmentTypeName: labels.filterAssignmentTypeLabel,
    roleName: "Rôle de l’utilisateur dans la mission",
    assignmentStatusVal: "État de la tâche attribuée",
    dueDays: "Nombre de jours avant l’échéance",
    completedDateInUTC: "Date à laquelle la tâche a été terminée (UTC)",
    assignmentDueDateInUTC: "Date d’échéance de l’affectation (UTC)",
    daysCompleteBeforeDueDate: "Nombre de jours restants avant la date d’échéance de la tâche attribuée",
    daysCompleteAfterDueDate: "Nombre de jours de retard après la date d’échéance de la tâche attribuée",
    closedEarlyOrLate: "Fermée trop tôt / tard",
    closedDaysEarly: "Fermée avec des jours d’avance",
    closedDaysLate: "Fermée avec des jours de retard",
    oldTaskName: "Titre de l’ancienne tâche",
    oldTaskDetail: "Description de l’ancienne tâche",
    taskID: "Identifiant de la tâche",
    assignmentID: "Identifiant de l’affectation",
    roleID: "Identifiant du rôle",
    userID: "Identifiant de l’utilisateur"
}

export const reportingMultiEntityTask = {
    engagementID: "EngagementId",
    taskID: "TaskId",
    taskNamePrefix: labels.taskPrefix,
    task_Name: labels.repTaskTitle,
    taskNameSuffix: labels.taskSuffix,
    taskDescription: labels.repTaskDescription,
    mesT_Entity_Name: "Entité associée",
    multiEntityType: "MultiEntityType",
    taskTypeID: "TaskTypeID",
    taskStatusID: "TaskStatusID"
}

export const reportingManageteamInternal = {
        firstName: labels.firstnameLabel,
        lastName: labels.lastnameLabel,
        userInitials: labels.initialsLabel,
        emailAddress: labels.editExternalEmailLabel,
        gui: "Identifiant global unique (GUI)",
        engagementRole: labels.engagementrole,
        hasOverallResponsability: "Assume la responsabilité globale",
        userStatus: "Statut",
        independenceStatus: "Statut d’indépendance",
        grantedAccess: "Accès obtenu après l’archivage",
        primaryOffice: "Bureau principal",
        preferredContactPhone: "Numéro de téléphone",
        engagementUserStatusID: "Identifiant de l’état de l’utilisateur de la mission",
        engagementRoleID: "Identifiant du rôle dans la mission",
        independenceStatusID: "Identifiant du statut d’indépendance"
    }

export const reportingManageteamExternal = {
    clientGroupName: "Nom du groupe",
    firstName: labels.firstnameLabel,
    lastName: labels.lastnameLabel,
    userInitials: labels.initialsLabel,
    emailAddress: labels.editExternalEmailLabel,
    domain: "Domaine de l’utilisateur",
    validDomainWithinGroup: "Domaine valide dans le groupe",
    userStatus: "État de l’utilisateur",
    preferredContactPhone: "Numéro de téléphone principal"
};

export const controlDesignEffectivenessType = {
    1: "Efficace",
    2: "Inefficace"
};

export const itAppSOSummaryReportLabels = {
    itApplicationName: "Application informatique / société de services",
    strategyTypeName: "Stratégie informatique",
    typeName: "Type",
    itProcessName: "Processus informatique",
    itRiskName: "Risque lié aux TI",
    itControlName: "CGI / procédures de corroboration liées aux TI",
    natureOfTest: "Nature du test",
    controlFrequencyTypeNameColumn: "Fréquence",
    testing: "Test",
    designEffectiveness: "Efficacité de la conception",
    evaluation: "Évaluation du processus informatique"
};

export const ArchiveReportLabels = {
    engagementDescription: "Description de la mission",
    archiveReportQualifiedNameSection: "Rapport avec réserve",
    archiveReportQualifiedTypeNameSection: "Type de rapport avec réserve",
    archiveFolderDescription: "Description du dossier d’archive",
    archiveFolderTypeNameSection: "Type de dossier",
    location: "Emplacement",
    archiveComments: "Archiver les commentaires",
    engagementID: "Identifiant de la mission",
    archiveCountryOfficeRegionID: "Identifiant de la zone du bureau dans le pays de l’archive",
    archiveReportQualifiedID: "Identifiant du rapport avec réserve de l’archive",
    archiveReportQualifiedTypeID: "Identifiant du type de rapport avec réserve de l’archive"
};

export const canvasFormRelatedCommentsLabels = {
    canvasFormName: "Nom du formulaire Canvas",
    order1: "HeaderOrder",
    formHeaderName: "En-tête",
    order2: "SectionOrder",
    order3: "BodyOrder",
    formBodyResponseValue: "Réponse",
    commentNumber: "Numéro du commentaire",
    author: "Auteur",
    assignedTo: "Attribué à ",
    createDateSection: "Date de création",
    commentStatusSection: "État",
    commentText: "Commentaire",
    commentVoiceNote: "Comporte une note vocale",
    reply: "Répondre",
    replyVoiceNote: "Comporte une note vocale"
};

export const canvasFormRelatedObjectsLabels = {
    canvasFormName: "Nom du formulaire Canvas",
    order1: "HeaderOrder",
    formHeaderName: "En-tête",
    formHeaderID: "FormHeaderID",
    order2: "SectionOrder",
    formSectionID: "FormSectionID",
    formSectionName: "Section",
    firstLevelEntityColumn: "Entité de premier niveau",
    firstLevelRelatedObject: "Objet associé de premier niveau",
    secondLevelEntityColumn: "Entité de deuxième niveau",
    secondLevelRelatedObject: "Objet associé de deuxième niveau"
};

export const canvasFormResponseLabels = {
    canvasFormName: "Nom du formulaire Canvas",
    order1: "HeaderOrder",
    formHeaderName: "En-tête",
    knowledgeFormHeaderID: "Header KnowledgeID",
    headerKnowledgeContentID: "Header KnowledgeContentID",
    order2: "SectionOrder",
    formSectionName: "Section",
    knowledgeFormSectionID: "Section KnowledgeID",
    sectionKnowledgeContentID: "Section KnowledgeContentID",
    order3: "BodyOrder",
    formBody: "Corps de texte",
    knowledgeFormBodyID: "Body KnowledgeID",
    bodyKnowledgeContentID: "Body KnowledgeContentID",
    formBodyResponse_Value: "Réponse"
};

export const CanvasFormsIncompleteLabels = {
    canvasFormName: "Nom du formulaire Canvas",
    header: "En-tête",
    headerOrder: "HeaderOrder",
    sectionOrder: "SectionOrder",
    bodyOrder: "BodyOrder",
    body: "Corps de texte",
    formHeaderID: "FormHeaderID",
    formSectionID: "FormSectionID",
    formBodyID: "FormBodyID"
};

export const controlFormResponseLabels = {
    controlName: "Contrôle",
    documentName: "Document",
    engagementDescription: "Description de la mission",
    formHeader: "En-tête",
    headerKnowledgeDisplayOrder: "HeaderKnowledgeDisplayOrder",
    formSection: "Section",
    sectionKnowledgeDisplayOrder: "SectionKnowledgeDisplayOrder",
    formBodyVal: "Corps de texte",
    bodyKnowledgeDisplayOrder: "BodyKnowledgeDisplayOrder",
    ControlTesting: "Test des contrôles",
    controlFrequencyType: "Fréquence du contrôle",
    Effective: "Est efficace",
    formBodyOptionVal: "Valeur de l’option de corps de texte du formulaire",
    controlType: "Type de contrôle",
    controlDesignEffectivenessType: "Type d’efficacité de la conception du contrôle "
};

export const itProcessSummaryLabels = {
    itProcessName: "Processus informatique",
    itProcessEvaluation: "Évaluation du processus informatique",
    itProcesSupportingRationale: "Justification",
    itRiskName: "Risque lié aux TI",
    itControlName: "CGI / procédures de corroboration liées aux TI",
    natureOfTest: "Nature du test",
    controlFrequencyTypeId: "Fréquence",
    testing: "Test",
    designEffectiveness: "Efficacité de la conception",
    operatingEffectiveness: "Efficacité du fonctionnement"
}

export const itProcessScotControlsLabels = {
    itProcessName: "Processus informatique",
    scotName: "Catégorie d’opérations importante",
    controlName: "Contrôle",
    controlDesignEffectivenessTypeName: "Efficacité de la conception",
    testing: "Test",
    operatingEffectiveness: "Efficacité du fonctionnement",
    controlTypeName: "Type de contrôle",
    isIPEManuallyTestedName: "Les IPE ont-elles été testées manuellement?",
    itApplicationName: "Application informatique  ",
    aggregateITEvaluationTypeName: "Évaluation globale des TI"
};

export const scotsControlsReportLabels = {
    scotName: "Catégorie d’opérations importante",
    controlName: "Contrôle",
    operatingEffectiveness: "Efficacité de la conception",
    itApplicationName: "Application informatique  ",
    aggregateITEvaluation: "Évaluation globale des TI",
    supportingRationaleControlLabel: "Justification"
}

export const sCOTSummaryReportHeaderLabels = {
    scotName: "Catégorie d’opérations importante",
    scotTypeName: "Type d’opération",
    strategyTypeName: "Stratégie axée sur la catégorie d’opérations importante ",
    itApplicationName: "TI/SS associée à la catégorie d’opérations importante ",
    wcgwName: labels.wcgw,
    controlName: labels.control,
    controlFrequencyTypeName: labels.frequencyLabel,
    controlTypeName: "Type de contrôle",
    testing: "Test",
    operatingEffectiveness: "Efficacité du fonctionnement",
    controlITApplication: "TI/SS associée au contrôle",
    aggregateITEvaluationTypeName: "Évaluation globale des TI",
    supportingRationale: "Justification",
    scotId: "Identifiant de la catégorie d’opérations importante",
    strategyTypeID: "Identifiant du type de stratégie",
    scotTypeID: "Identifiant du type de catégorie d’opérations importante",
    wcgwid: "Identifiant de l’erreur possible",
    controlID: "Identifiant du contrôle",
    controlFrequencyTypeID: "Identifiant du type de fréquence du contrôle",
    controlTypeID: "Identifiant du type de contrôle",
    aggregateITEvaluationTypeID: "Identifiant du type d’évaluation globale des TI"
};

export const findingsDeficiencyHeaderLabels = {
    description: "Description de la déficience",
    controls: "Contrôles",
    controlsIsEffective: "Efficacité du fonctionnement des contrôles",
    type: "Type de déficience",
    magnitude: "Ampleur",
    responseText: "Texte de la réponse",
    remediatedAtYearEnd: "Corrigée à la fin de l’exercice",
    mitigatingControls: "Contrôle compensatoire",
    mitigatingControlsIsEffective: "Efficacité du fonctionnement du contrôle compensatoire",
    mitigatingTasks: "Tâches d’atténuation",
    foundIn: "Dans le document",
    accountsAndAssertions: "Comptes et assertions",
    scoTs: "Catégories d’opérations importantes",
    deficiencyID: "Identifiant de la déficience ",
    controlID: "Identifiant du contrôle",
    mitigatedControlID: "Identifiant du contrôle d’atténuation ",
    mitigatedTaskID: "Identifiant de la tâche d’atténuation ",
    documentID: "Identifiant du document",
    accountID: "Identifiant du compte",
    scotID: "Identifiant de la catégorie d’opérations importante"
};

export const findingsMisstatementHeaderLabels = {
    description: "Description de l’anomalie",
    type: "Type d’anomalie",
    trialBalance: "Balance des comptes",
    period: "Période",
    accountNumber: "Numéro de compte",
    accountName: "Nom du compte",
    accountType: "Type de compte",
    debit: "Débit ",
    credit: "Crédit",
    responseText: "Texte de la réponse",
    correctedUncorrected: "Corrigée/Non corrigée",
    mitigatingTasks: "Tâches d’atténuation",
    foundInDocument: "Dans le document",
    accountsAndAssertions: "Comptes et assertions",
    misstatementID: "Identifiant de l’anomalie ",
    trialBalanceID: "Identifiant de la balance des comptes",
    misstatementAdjustmentID: "Identifiant d’ajustement de l’anomalie"
};

export const findingsDeficiencyITHeaderLabels = {
    itApplicationName: "Nom de l’application informatique",
    itProcessName: "Nom du processus informatique",
    itControlName: "Nom du contrôle informatique",
    itApproachTypeName: "Type d’approche informatique",
    isEffective: "Efficacité du contrôle",
    referenceNumber: "Numéro de référence",
    description: "Description de la déficience",
    deficiencyMagnitudeName: "Ampleur de la déficience",
    deficiencyTypeName: "Type de déficience"
};

export const auditPlanRelatedEvidenceReportHeaderLabels = {
    adc: "Objet associé",
    secondaryObject: "Contrôle / procédure de corroboration associé",
    taskName: "Titre de la tâche",
    taskDescription: "Description de la tâche",
    taskTypeColumn: "Type de tâche",
    taskStatusValue: "État de la tâche",
    rationaleForRejection: "Raison du rejet",
    engagementPhase: "Phase de la mission",
    milestone: "Jalon ",
    periodName: "Période",
    assignedTo: "Attribuée à",
    engagementTagGroupName: "Groupe de balises",
    engagementTagName: "Balises",
    displayedOn: "Affichage de la vue",
    documentName: "Nom du document",
    preparersValue: "Préparateurs (date selon l’UTC)",
    reviewersValue: "Responsables de la revue (date selon l’UTC)",
    openReviewNotes: "Notes de revue ouvertes",
    closedReviewNotes: "Notes de revue réglées",
    trackChangesValue: "Suivi des modifications",
    lastModifiedBy: "Dernière modification par",
    lastModifiedDateValue: "Date de la dernière modification (UTC)",
    taskID: "Identifiant de la tâche",
    timephaseID: "Identifiant de la période",
    taskTypeID: "Identifiant du type de tâche",
    documentTypeID: "Identifiant du type de document",
    parentDocumentTypeID: "Identifiant du type de document de l’entité parent",
    timePhaseTypeID: "Identifiant du type de période"
};

// group instruction summary
export const groupInstructionSummaryReportHeaderLabels = {
    sectionName: "Section",
    gaInstructionName: "Titre de l’instruction",
    gaInstructionDescription: "Description de l’instruction",
    documents: "Nom du document",
    knowledgeInstructionName: "Titre de l’instruction de la base des connaissances",
    knowledgeInstructionDescription: "Description de l’instruction de la base de connaissances",
    gaScopeName: "Étendues / Sous-étendues connexes",
    componentOnly: "Étendue / Instruction de la composante individuelle",
    shortName: "Nom de la zone/composante",
    cSection: "Section personnalisée",
    customInstruction: "Instruction personnalisée",
    gAinstructionID: "Identifiant de l’instruction pour l’audit de groupe"
};

// GIS last publish and send
export const gIsLastPublishAndSendReportHeaderLabels = {
    primaryEngagementID: "Identifiant de la mission",
    gaScopeID: "Identifiant de l’étendue de l’audit de groupe",
    gaScopeName: "Étendue",
    gaComponentID: "Identifiant de la composante de l’audit de groupe",
    shortName: "Nom de la composante",
    lastPublishedDateInUTC: "Date de la dernière publication",
    lastSentDateInUTC: "Date du dernier envoi",
    gaLinkStatusId: "État du lien",
    gaInstructionStatusId: "État de l’instruction"
};

// Group Activity
export const groupActivityReportHeaderLabels = {
    engagementID: "Identifiant de la mission",
    gaScopeID: "Identifiant de l’étendue de l’audit de groupe",
    gaScopeName: "Étendue",
    gaComponentID: "Identifiant de la composante de l’audit de groupe",
    shortName: "Nom de la composante",
    gaLinkStatusId: "État du lien",
    accountID: "Identifiant du compte",
    accountName: "Nom du compte",
    accountType: "Désignation du compte",
    activityTypeID: "Identifiant du type d’activité",
    activityTypeText: "Type d’activité",
    modifyDateInUTC: "Modifier la date",
    modifyUser: "Modifier l’utilisateur",
};

export const AccountDisclosuresReportHeadeLabels = {
    engagementID: "Identifiant de la mission",
    accountID: "Identifiant du compte",
    accountName: "Nom du compte",
    accountTypeID: "Identifiant du type de compte",
    accountTypeId: "Désignation du compte",
    knowledgeAssertionId: "Abréviation de l’assertion",
    inherentRiskTypeId: "Évaluation du risque inhérent",
    controlRiskTypeId: "Évaluation du risque lié au contrôle",
    craValue: "EGR",
    riskID: "Identifiant du risque",
    riskTypeID: "Identifiant du type de risque",
    riskType: "Type de risque",
    riskName: "Nom du risque",
    isHigherRiskValue: "Présente un risque élevé",
};

// CRA summary
export const craSummaryReportHeaderLabels = {
    accountName: "Compte ",
    accountTypeName: "Type de compte",
    rationale: "Justification",
    pspIndex: "Référence PCB",
    conclusionStatement: "Énoncé de conclusion à l’égard du compte",
    scotName: "Catégories d’opérations importantes",
    transactionType: "Type d’opération",
    strategyTypeName: "Stratégie axée sur la catégorie d’opérations importante ",
    wcgwName: "Erreur possible",
    controlName: "Contrôle",
    controlFrequencyTypeName: "Fréquence",
    controlTypeName: "Type de contrôle",
    testing: "Test",
    operatingEffectiveness: "Efficacité du fonctionnement",
    itApplicationName: "TI/SS associée à la catégorie d’opérations importante",
    controlITApplication: "TI/SS associée au contrôle"
};

export const craSummaryAssertionReportHeaderLabels = {
    accountName: "Compte ",
    accountTypeName: "Type de compte",
    rationale: "Justification",
    pspIndex: "Référence PCB",
    assertionAbbreviation: "Assertion",
    riskName: "Risque",
    inherentRiskTypeName: "Évaluation du risque inhérent",
    controlRiskTypeName: "Évaluation du risque lié au contrôle",
    craValue: "EGR",
    wcgwName: "Erreur possible",
    controlName: "Contrôle",
    controLFrequencyTypeName: "Fréquence",
    controlTypeName: "Type de contrôle",
    testing: "Test",
    isLowerR: "Est un risque faible",
    operatingEffectiveness: "Efficacité du fonctionnement",
    itApplicationName: "TI/SS"
};

export const craSummaryDataReportHeaderLabels = {
    wcgwName: "Erreur possible",
    controlName: "Contrôle",
    controLFrequencyTypeName: "Fréquence du contrôle",
    controlTypeName: "Type de contrôle",
    itApplicationName: "Application informatique",
    assertionName: "Assertion",
    statementTypeName: "Type d’état",
    accountTypeName: "Type de compte",
    assertionAbbreviation: "Abréviation de l’assertion",
    inherentRiskTypeName: "Risque inhérent",
    controlRiskTypeName: "Risque lié au contrôle",
    craValue: "EGR",
    riskTypeAbbreviation: "Abréviation du risque",
    frequency: "Fréquence  ",
    accountName: "Compte",
    riskName: "Risque",
    pspIndex: "Référence PCB",
    testing: "Test",
    operatingEffectiveness: "Efficacité du fonctionnement",
    isLowerRiskColumn: "Risque faible",
    scotName: "Catégorie d’opérations importante",
    controlitApplicationName: "Contrôle des applications informatiques",
    rationale: "Justification",
    accountID: "Identifiant du compte",
    riskID: "Identifiant du risque ",
    scotid: "Identifiant de la catégorie d’opérations importante",
    wcgwid: "Identifiant de l’erreur possible",
    controlID: "Identifiant du contrôle",
    itApplicationID: "Identifiant de l’application informatique ",
    knowledgeAssertionID: "Identifiant de l’assertion de la base de connaissances",
    controlTypeID: "Identifiant du type de contrôle",
    controlFrequencyTypeID: "Identifiant du type de fréquence du contrôle",
    accountTypeID: "Identifiant du type de compte",
    riskTypeID: "Identifiant du type de risque",
    inherentRiskTypeID: "Identifiant du type de risque inhérent",
    controlRiskTypeID: "Identifiant du type de risque lié au contrôle",
    statementTypeID: "Identifiant du type d’état",
    conclusionStatement: "Énoncé de conclusion à l’égard du compte"
};

export const reportingRequestsAndTasks = {
    requestTitle: "Titre de la demande/tâche",
    request_Description: "Description de la demande/tâche",
    type: "Type",
    tasks: "Titre de la tâche",
    engagementTagName: "Balises",
    eyAssigned: "Utilisateur désigné EY",
    clientGroupName: "Groupe externe",
    externalAssignedUser: "Utilisateur désigné externe",
    periodName: "Période",
    dueDateInUTC: "Date d’échéance (UTC)",
    requestStatus: "État de la demande/tâche",
    documentType: "Type de document",
    documentName: "Nom du document de l’exercice considéré",
    priorYearDocumentName: "Nom du document de l’exercice précédent",
    externalDocumentSignOffInUTC: "Approbations des documents externes (UTC)",
    clientRequestReferenceNumber: "Numéro de référence de la demande au client"
};

export const reportingRequestComment = {
    requestTitle: "Titre de la demande/tâche",
    request_Description: "Description de la demande/tâche",
    type: "Type",
    tasks: "Titre de la tâche",
    engagementTagName: "Balises",
    eyAssigned: "Utilisateur désigné EY",
    clientGroupName: "Groupe externe",
    externalAssignedUser: "Utilisateur désigné externe",
    periodName: "Période",
    dueDateInUTC: "Date d’échéance (UTC)",
    requestStatus: "État de la demande/tâche",
    externalDocumentSignOffInUTC: "Approbations des documents externes (UTC)",
    annotationTextData: "Commentaires",
    createDateInUTC: "Date des commentaires (UTC)",
    annotationUserInitials: "Commentaire formulé par "
};

export const reportingAllDocuments = {
    documentName: "Nom du document",
    fileExt: "Extension de fichier",
    canvasFormType: "Type de formulaire Canvas",
    docType: "Type de document",
    confidentiality: "Confidentialité",
    docFileSize: "Taille du fichier (Ko)",
    preparers: "Préparateurs (UTC)",
    reviewers: "Responsables de la revue (UTC)",
    relatedTask: "Tâches associées",
    openReviewNote: "Notes de revue ouvertes",
    clearedReviewNote: "Notes de revue réglées",
    trackChanges: "Suivi des modifications",
    hiddenSheets: "Feuilles masquées",
    comments: "Commentaires",
    highlighted: "Texte en surbrillance",
    conflicted: "Conflits",
    docModifyUser: "Dernière modification par",
    docModifyDateInUTC: "Date de la dernière modification (UTC)",
    documentID: "Identifiant du document"
};

export const signOffDocuments = {
    documentName: "Nom du document",
    fileExt: "Extension de fichier",
    canvasFormType: "Type de formulaire Canvas",
    docType: "Type de document",
    confidentiality: "Confidentialité",
    docFileSize: "Taille du fichier (Ko)",
    docModifyUser: "Dernière modification par",
    docModifyDateInUTC: "Date de la dernière modification (UTC)",
    signOffDate: "Date d’approbation (UTC)",
    signedOffBy: "Approuvé par",
    role: "Rôle",
    preparerReviewer: "Préparateur/Responsable de la revue"
};

export const reportingDocumentsModified = {
    documentName: "Nom du document",
    lastModifiedDateInUTC: "Date de la dernière modification (UTC)",
    lastModifiedUser: "Dernière modification par",
    reason: "Raison",
    documentChangeComment: "Justification",
    preparersInUTC: "Préparateurs (UTC)",
    reviewersInUTC: "Responsables de la revue (UTC)",
    approver: "Approbations (UTC)"
};

export const reportingDeletedTaskReport = {
    taskNamePrefix: labels.taskPrefix,
    taskName: "Titre de la tâche",
    taskNameSuffix: labels.taskSuffix,
    taskDescription: "Description de la tâche",
    taskTypeAbbreviation: "Type de tâche",
    taskSourceType: "Source de la tâche",
    taskNatureType: "Nature de la tâche",
    last_Modified_By: "Dernière modification par",
    modifyDateInUTC: "Date de la dernière modification (UTC) ",
    oldTaskName: "Titre de l’ancienne tâche",
    oldTaskDetail: "Description de l’ancienne tâche"
};

export const SEMReportHeaderLabel = {
    accountAssertion: "Compte/assertion",
    craValue: "EGR",
    riskOfMaterialMisstatements: labels.riskOfMaterialMisstatement,
    relatedRisks: "Risques associés",
    taskType: "Type de tâche",
    taskTitle: "Titre de la tâche",
    taskSource: labels.source,
    taskNature: labels.nature,
    taskTypeID: "Identifiant du type de tâche",
    taskSourceTypeID: "Identifiant du type de la source de la tâche",
    taskNatureTypeID: "Identifiant du type de la nature de la tâche"
}

export const MilestonesReportHeaderLabels = {
    taskName: labels.repTaskTitle,
    taskType: labels.taskType,
    taskStatus: labels.taskStatusLabel,
    auditPhase: labels.auditPhasesLabel,
    periodName: labels.timephase,
    timephase: "Jalon actuel",
    correctTimephase: "Jalon approprié"
}

export const MilestonesReportHeader = {
    milestone: "Jalon",
    status: "État du jalon",
    taskStatus: "État de la tâche",
    taskTitle: "Titre de la tâche",
    taskTypeAbbreviationColumn: "Abréviation du type de tâche",
    taskType: "Type de tâche",
    timePhase: "Période",
    assignedTo: "Attribuée à ",
    taskName: "Nom de la tâche",
    task_Detail: "Détail de la tâche",
    due_Date: "Date d’échéance",
    documentName: "Nom du document",
    preparers: "Préparateurs",
    reviewers: "Responsables de la revue",
    tagGroup: "Groupe de balises",
    tags: "Balises",
    engagementID: "Identifiant de la mission",
    taskID: "Identifiant de la tâche",
    taskTypeID: "Identifiant du type de tâche",
    taskStatusID: "Identifiant de l’état de la tâche",
    timephaseID: "Identifiant de la période",
    timephaseTypeID: "Identifiant du type de période",
    documentID: "Identifiant du document"
}

export const groupStructureSummaryReportHeaderLabels = {
    gaScopeName: "Description de l’étendue des travaux",
    gaScopeDescription: "Nom de l’étendue ou de la sous-étendue",
    shortName: "Nom de la zone/composante",
    legalName: "Nom légal",
    gaRoleTypeName: "Rôle dans le groupe",
    relatedRegion: "Zone associée",
    pocText: "Personne-ressource",
    gaLinkStatusName: "État du lien",
    gaInstructionStatusName: "État de l’instruction",
    engagementID: "Identifiant de la mission",
    gaRoleTypeID: "Identifiant du type de rôle relatif à l’audit de groupe",
    gaLinkStatusID: "Identifiant de l’état du lien relatif à l’audit de groupe",
    gaInstructionStatusID: "Identifiant de l’état de l’instruction relative à l’audit de groupe"
}

export const collaborationSummary = {
    clientRequestID: "Numéro de la demande",
    requestTitle: "Titre ",
    requestType: "Type",
    engagementTagName: "Balises",
    clientUser: "Attribuée à",
    clientEmail: "Courriel du client",
    clientStatusName: "État",
    isOverDue: "En retard",
    dueDateInUTC: "Date d’échéance (UTC)",
    eySentDateInUTC: "Date d’envoi par EY (UTC)",
    eyReceivedDateInUTC: "Date de réception (UTC)",
    deliveredLate: "Livrée en retard",
    daysLate: "Jours de retard",
    timesReturned: "Nombre de retours"
}

export const collaborationActivity = {
    clientRequestID: "Numéro de la demande",
    requestTitle: "Titre ",
    requestType: "Type",
    engagementTagName: "Balises",
    clientUser: "Attribuée à",
    clientEmail: "Courriel du client",
    clientStatusName: "État",
    isOverDue: "En retard",
    dueDateInUTC: "Date d’échéance (UTC)",
    eySentDateInUTC: "Date d’envoi par EY (UTC)",
    eyReceivedDateInUTC: "Date de réception (UTC)",
    deliveredLate: "Livrée en retard",
    daysLate: "Jours de retard",
    timesReturned: "Nombre de retours",
    activity: "Activité",
    activityDateInUTC: "Date de l’activité (UTC)",
    historicalDueDateInUTC: "Ancienne date d’échéance (UTC)"
}

export const groupReportHeaderLabels = {
    gaInstructionName: "Nom de l’instruction",
    gascopeTypeIDName: labels.scope,
    componentName: "Nom de la composante",
    pointOfContact: labels.pointOfContact,
    dueDateValue: "Date d’échéance (UTC)",
    overdueValue: labels.overdueLabel,
    gaStatusIdName: labels.status,
    documentName: labels.documents,
    createDateValue: "Date d’approbation (UTC)",
    signoffBy: labels.signedOffBy,
    engagementRoleIDName: labels.role,
    isPreparerText: "Préparateur/Responsable de la revue",
    documentID: "Identifiant de document",
    gaStatusID: "Identifiant de l’état de l’audit de groupe",
    engagementRoleID: "Identifiant du rôle dans la mission"
}

export const wcgwSummaryHeaders = {
    wcgwName: "Erreur possible",
    scotName: "Catégorie d’opérations importante",
    controlName: "Contrôles connexes",
    itApplications: "TI/SS",
    testing: "Sélection aux fins des tests",
    isLowerR: "Est un risque faible",
    controlFrequencyTypeName: "Fréquence du contrôle ",
    controlTypeName: "Type de contrôle",
    wcgwCount: "Nombre d’autres erreurs possibles associées"
}

export const allControlsHeaders = {
    engagementID: "Identifiant de la mission",
    scotid: "Identifiant de la catégorie d’opérations importante",
    controlID: "Identifiant du contrôle",
    scotName: "Nom de la catégorie d’opérations importante",
    controlName: "Description du contrôle",
    hasControlTesting: "Sélection aux fins des tests",
    isLowerRisk: "Risque faible",
    controlTypeID: "Type de contrôle",
    relatedITApplicationNames: "TI/SS associée",
    responsiveToSR: "Réponse à un risque important",
    IPE: "IPE"
}


export const qualityChecksHeaders = {
    itemID: "Identifiant de l’élément",
    itemName: "Nom de l’élément",
    qualityChecks: "Contrôle qualité",
    validationDescription: "Description de la validation",
    buildGroup: "Tâche de production ‒ Audit de groupe",
    impactedItem: "Élément concerné",
    type: "Type"
}

export const statisticsHeaders = {
    scotname: "Catégorie d’opérations importante",
    strategyTypeId: "Stratégie pour la catégorie d’opérations importante",
    wcgwName: "Erreur possible",
    controlName: "Contrôle",
    operatingEvaluation: "Évaluation du fonctionnement",
    itApplicationName: "TI/SS associé",
    assertions: "Assertions",
    controlTypeId: "Type de contrôle",
    testingSelection: "Sélection aux fins des tests",
    controlFrequencyTypeId: "Fréquence",
    itApplications: "Applications informatiques",
    scotTypeId: "Type de catégorie d’opérations importante",
    itType: "Type d’application informatique",
    isLowerR: "Risque faible",
    engagementID: "Identifiant de la mission",
    workspaceID: "Identifiant de l’espace de travail",
    scotID: "Identifiant de la catégorie d’opérations importante",
    scotTypeID: "Identifiant du type de catégorie d’opérations importante",
    wcgwid: "Identifiant de l’erreur possible",
    controlID: "Identifiant du contrôle"
}

export const CRTAssertionCountSummaryHeaders = {
    accountName: "Compte",
    assertion: "Assertion",
    controlName: "Contrôle",
    ControlTypeName: "Type de contrôle",
    ControlFrequencyTypeName: "Fréquence",
    Testing: "Test",
    OperatingEvaluation: "Évaluation du fonctionnement",
    assertionControlCount: "Nombre de contrôles pour l’assertion",
    assertionAbbreviation: "Abréviation de l’assertion",
    wcgwName: "Erreur possible",
    engagementID: "Identifiant de la mission",
    workspaceID: "Identifiant de l’espace de travail",
    assertionID: "Identifiant de l’assertion ",
    wcgwid: "Identifiant de l’erreur possible",
    controlID: "Identifiant du contrôle"
}

export const crtlistcontrolTypeName = {
    'IT Application Control': "Contrôle d’applications informatiques",
    'IT Dependent Manual Control': "Contrôle manuel lié aux TI",
    'Manual Prevent': "Contrôle manuel de prévention",
    'Manual Detect': "Contrôle manuel de détection"
}

export const controlFrequencyNameTypes = {
    'Many times per day': "Plusieurs fois par jour",
    'Daily': "Une fois par jour",
    'Weekly': "Une fois par semaine",
    'Monthly': "Une fois par mois",
    'Quarterly': "Une fois par trimestre",
    'Annually': "Une fois par année",
    'IT Application Control': "Contrôle d’applications informatiques",
    'Other': "Autre"
};

// Folder types
export const archiveFolderTypeNameTypes = {
    'Working Papers': "Documents de travail",
    'Perm File Active': "Dossier permanent actif",
    'Perm File Superseded': "Dossier permanent remplacé",
    'Working Papers - CD/DVD': "Documents de travail - CD/DVD",
    'Perm File Active - CD/DVD': "Dossier permanent actif - CD/DVD",
    'Perm File Superseded - CD/DVD': "Dossier permanent remplacé - CD/DVD",
    'Data Storage Devices': "Dispositifs de stockage de données"
};

export const operatingEvaluationType = {
    'Effective': "Efficace",
    'Ineffective': "Inefficace",
    'Not Selected': "Non sélectionné"
};

export const CRTSCOTCountSummaryHeaders = {
    scotname: "Catégorie d’opérations importante",
    strategyTypeName: "Stratégie pour la catégorie d’opérations importante",
    wcgwName: "Erreurs possibles associées",
    controlName: "Contrôles connexes",
    operatingEvaluation: "Évaluation du fonctionnement",
    itApplicationName: "TI/SS associée",
    assertions: "Assertions",
    controlTypeName: "Type de contrôle",
    testing: "Sélection aux fins des tests",
    controlFrequencyTypeName: "Fréquence",
    itApplications: "Applications informatiques",
    itAppType: "Type d’application informatique",
    scotTypeName: "Type de catégorie d’opérations importante",
    soctisLowerRisk: "Risque faible",
    engagementID: "Identifiant de la mission",
    workspaceID: "Identifiant de l’espace de travail",
    scotID: "Identifiant de la catégorie d’opérations importante",
    scottypeid: "Identifiant du type de catégorie d’opérations importante",
    wcgwid: "Identifiant de l’erreur possible",
    controlID: "Identifiant du contrôle"
};

export const projectInsightCanvasFormExportHeaders = {
    EngagementID: "Identifiant de la mission",
    DocumentID: "Identifiant du document",
    ControlID: "Identifiant du contrôle"
};

export const projectInsightSCOTToWCGWToControlHeaders = {
    engagementID: "Identifiant de la mission",
    scotName: "Nom de la catégorie d’opérations importante",
    strategyTypeName: "Nom du type de stratégie",
    wcgwName: "Nom de l’erreur possible",
    controlID: "Identifiant du contrôle",
    controlName: "Nom du contrôle",
    controlFrequencyTypeName: "Nom du type de fréquence du contrôle",
    controlTypeName: "Nom du type de contrôle",
    isLowerRiskHeader: "Est un risque faible",
    hasControlTestingHeader: "Test des contrôles",
    operativeEffectiveness: "Efficacité du fonctionnement"
};

export const ComponentTeamGroupAccountInfoControlHeaders = {
    engagementId: "Identifiant de la mission",
    accountId: "Identifiant du compte",
    accountName: "Nom du compte",
    accountTypeId: "Identifiant du type de compte",
    accountDesignation: "Désignation du compte",
    pspIndexTitle: "Référence PCB",
    knowledgeAssertion: "Abréviation de l’assertion",
    inherentRiskType: "Évaluation du risque inhérent",
    controlRiskType: "Évaluation du risque lié au contrôle",
    craValue: "EGR",
    riskId: "Identifiant du risque",
    riskTypeId: "Identifiant du type de risque",
    riskTypeEnum: "Type de risque",
    riskName: "Nom du risque",
    isHigherRiskText: "Présente un risque élevé",
    rejectedTaskId: "Identifiant de la tâche",
    rejectedTaskName: "PCB rejetée",
    rejectedTaskRationale: "Raison du rejet de la PCB "
};

export const projectInsightControlToITApplicationHeaders = {
    engagementID: "Identifiant de la mission",
    controlID: "Identifiant du contrôle",
    itApplicationID: "Identifiant de l’application informatique",
    controlITApplication: "Contrôle des applications informatiques"
};

export const projectInsightControlToAssertionHeaders = {
    engagementID: "Identifiant de la mission",
    controlID: "Identifiant du contrôle",
    Accountname: "Nom du compte",
    AssertionAbbreviation: "Abréviation de l’assertion"
};

export const projectInsightRisksToWCGWsHeaders = {
    engagementId: "Identifiant de la mission",
    accountName: "Nom du compte",
    accountId: "Identifiant du compte",
    knowledgeAssertion: "Assertion",
    CRA: "EGR",
    RelatedRisk: "Risque associé",
    riskId: "Identifiant du risque",
    riskType: "Type de risque",
    WCGW: "Erreur possible",
    wcgwId: "Identifiant de l’erreur possible",
    RelatedSCOT: "Catégorie d’opérations importante associée",
    scotId: "Identifiant de la catégorie d’opérations importante"
};

export const ipeControlsHeaders = {
    EngagementID: "Identifiant de la mission",
    DocumentID: "Identifiant du document"
};

export const ipeSubstantiveHeaders = {
    EngagementID: "Identifiant de la mission",
    DocumentID: "Identifiant du document"
};

export const ipeITGCHeaders = {
    EngagementID: "Identifiant de la mission",
    DocumentID: "Identifiant du document"
};

export const iTAppSOReport = {
    relatedITSO: "TI/SS associée",
    iTAppType: "Type d’application informatique",
    iTAppControl: "Contrôle de l’application informatique ",
    testingSelection: "Sélection aux fins des tests",
    relatedSCOTs: "Catégories d’opérations importantes associées",
    relatedSCOTStrategy: "Stratégie pour la catégorie d’opérations importante associée",
    itdm: "Contrôle manuel lié aux TI",
    manualPrevent: "Contrôle manuel de prévention",
    manualDetect: "Contrôle manuel de détection",
    noRelatedControls: "Aucun contrôle associé",
    controlsStatistics: "Contrôles par type",
    relatedSCOTType: "Type de catégorie d’opérations importante associée",
    controlType: "Type de contrôle",
    grandTotal: "Total  ",
    yes: "Oui",
    no: "Non  ",
    notSelected: "Non sélectionnée ",
    controls: "Contrôles",
    substantive: "Corroboration",
    routine: "Courante ",
    nonRoutine: "Non courante",
    estimation: "Estimation"
};

export const IndependenceSummaryReport = {
    id: "Identifiant",
    userName: "Nom de l’utilisateur",
    order: "Ordre",
    questionFormatted: "Question",
    answer: "Réponse",
    actionTypeID: "Identifiant du type d’action",
    independenceStatusID: "Identifiant du statut d’indépendance",
    EngagementUserStatusName: "État de l’utilisateur de la mission",
    engagementUserStatusID: "Identifiant de l’état de l’utilisateur de la mission",
    IndependenceStatusName: "Statut d’indépendance",
    requiresExecutiveClearance: "Autorisation d’un cadre requise"
};

export const additionalInfoBasedOnValidationTypeId = {
    1: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    2: "L’équipe n’utilise pas la version la plus récente du formulaire 109 sur l’indépendance des membres de l’équipe.",
    3: "Un membre de l’équipe a modifié son rôle (auparavant associé (délégué)/directeur) après avoir accordé l’accès à un autre membre de l’équipe pour lequel une question relative à l’indépendance a été relevée.",
    4: "Un membre de l’équipe a modifié son rôle (auparavant associé (délégué)/directeur) après avoir contourné le statut d'un autre membre de l’équipe pour lequel une question relative à l’indépendance a été relevée.",
    5: "Cliquer sur le lien de validation, identifier la catégorie d’opérations importante sans matricule numérique accolé. Associer la catégorie d’opérations importante à un compte",
    6: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    7: "Identifier la catégorie d’opérations importante pour laquelle le champ du nombre d’erreurs possibles est vide. Naviguer jusqu’à la tâche de production correspondante. Développer la catégorie d’opérations importante et ajouter les erreurs possibles, s’il y a lieu.",
    8: "Identifier la catégorie d’opérations importante pour laquelle le champ du nombre de contrôles est vide. Naviguer jusqu’à la tâche de production correspondante. Développer la catégorie d’opérations importante et ajouter un contrôle aux erreurs possibles.",
    9: "Identifier la catégorie d’opérations importante à valider, développer la catégorie d’opérations importante pour en afficher les détails et vérifier que Oui est coché sous tests pour au moins un contrôle par erreur possible. ",
    10: "Identifier la catégorie d’opérations importante à valider, développer la catégorie d’opérations importante pour en afficher les détails et vérifier que Oui est coché sous tests pour au moins un contrôle par erreur possible ",
    11: "Cliquer sur le lien de validation, identifier le risque sans matricule numérique accolé. Associer l’assertion appropriée au risque.",
    12: "Identifier l’assertion sans risque inhérent et/ou risque lié au contrôle. Remplir le champ vide.",
    13: "Cliquer sur le lien de validation et ouvrir le menu déroulant Ajouter une erreur possible. Sélectionner une catégorie d’opérations importante à la fois et identifier l’erreur possible sans matricule numérique accolé. Associer l’erreur possible à l’assertion appropriée.",
    14: "Identifier le compte sans matricule numérique accolé. Naviguer jusqu’au flux de production des catégories d’opérations importantes et associer la catégorie d’opérations importante à un compte.",
    15: "Identifier le compte/l’assertion à valider, cliquer sur le bouton Ajouter les erreurs possibles et associer l’erreur possible à l’assertion.",
    16: "Ce contrôle de validation permet de vérifier que toutes les erreurs possibles associées à une assertion assortie d’une stratégie axée sur les contrôles sont visées par un contrôle qui sera testé. Identifier l’assertion à valider, cliquer sur le bouton Ajouter des erreurs possibles et associer l’erreur possible à l’assertion.",
    17: "Passer en revue chaque erreur possible liée à une assertion et vérifier qu’elle est visée par au moins un contrôle assorti d’une stratégie de test (Oui est coché). ",
    18: "Toutes les erreurs possibles pour une assertion dont la stratégie est « avec appui » doivent être visées par un contrôle pour lequel on a indiqué « oui » dans le champ test.",
    19: "Une application informatique/société de services accompagnée d’une stratégie « avec appui » n’est ni supprimée ni associée à un processus TI/SS.",
    20: "Aucun contrôle / aucune procédure de corroboration liée aux TI pour une application information/société de services ne sont associés à un risque TI/SS.",
    21: "Une modification a été apportée à la stratégie, la faisant passer de « avec appui » à « pas d’appui » après la création du processus TI/SS.",
    22: "Aucun risque n’est associé à une assertion.",
    23: "Aucun contrôle / aucune procédure de corroboration liée aux TI pour l’application informatique / société de services ne sont associés à un risque TI/SS.",
    24: "Aucun contrôle / aucune procédure de corroboration pour une application informatique/société de services ne sont sélectionnés aux fins des tests.",
    25: "Aucun contrôle / aucune procédure de corroboration liée aux TI pour une application informatique/société de services ne sont associés à un risque TI/SS.",
    26: "Identifier le compte présentant un risque limité sans Tâches. Ajouter une ou plusieurs APC.",
    27: "Vérifiez si vous avez importé des PCB. Si des PCB n’ont pas été importées, cliquez sur Importer des PCB. S’il n’y a aucune PCB pour l’assertion, créez une APC.",
    28: "Naviguer jusqu’au flux de production des catégories d’opérations importantes, ouvrir le menu déroulant Ajouter un test des contrôles, identifier la tâche TDC sans matricule numérique accolé. Associer la tâche TDC au contrôle.",
    29: "La mission comporte au moins une tâche Test de cheminement qui n’a pas encore été associée à une catégorie d’opérations importante. ",
    30: "Une catégorie d’opérations importante n’est pas associée à au moins une tâche Test de cheminement. ",
    31: "Naviguer jusqu’au flux de production des catégories d’opérations importantes, ouvrir le menu déroulant Ajouter un test des contrôles, identifier la tâche TDC sans matricule numérique accolé. Associer la tâche TDC au contrôle.",
    32: "Un test de cheminement TI/SS n’est pas associé à au moins un processus TI/SS.",
    33: "Un test des contrôles TI/SS n’est pas associé à au moins un contrôle / une procédure de corroboration TI/SS pour lesquels on a indiqué « oui » dans le champ test.",
    34: "Une autre procédure de corroboration TI/SS n’est pas associée à au moins un contrôle / une procédure de corroboration TI/SS pour lesquels on a indiqué « oui » dans le champ test.",
    35: "Un processus TI/SS n’est pas associé à au moins une tâche Test de cheminement.",
    36: "Un contrôle pour lequel on a indiqué « oui » dans le champ test n’est pas associé à une tâche Test des contrôles. ",
    37: "Une autre procédure de corroboration TI/SS n’est pas associée à au moins un contrôle / une procédure de corroboration TI/SS pour lesquels on a indiqué « oui » dans le champ test.",
    38: "Cliquer sur le lien de validation, dans la liste Éléments probants, cliquer sur l’icône de conflit pour régler le conflit.",
    39: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    40: "Cliquer sur le lien de validation, dans la liste Éléments probants, approuver les documents pour lesquels il manque l’approbation d’un préparateur ou d’un responsable de la revue. N’approuvez que les fichiers que vous avez préparés ou passés en revue.",
    41: "Cliquer sur le lien de validation, dans la liste de tâches filtrées, passer en revue chaque tâche et associer les fichiers d’éléments probants appropriés.",
    42: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    43: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    44: "Cliquer sur le lien de validation, dans la liste d’éléments probants, renommer les documents dont les noms sont identiques.",
    45: "L’évaluation du processus informatique n’a pas été sélectionnée ou n’est pas cohérente avec les évaluations sur l’efficacité du fonctionnement des CGI/procédures de corroboration liées aux TI.",
    46: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    47: "L’évaluation globale des TI n’a pas été sélectionnée pour un ou plusieurs contrôles des applications / manuels liés aux TI. ",
    48: "Au moins un champ du formulaire Canvas n’est pas rempli.",
    49: "Cliquer sur le lien de validation puis cliquer sur Ajouter une assertion pour associer l’assertion ou le compte présentant un risque limité.",
    50: "Tâche à laquelle aucune assertion ou aucun compte présentant un risque limité ne sont associés. Cliquer sur Ajouter une assertion pour associer une assertion ou un compte présentant un risque limité.",
    51: "Aucune erreur possible n’a été associée à une tâche de corroboration.",
    52: "La mission comporte au moins un risque inhérent, risque important ou risque de fraude qui n’est pas associé à au moins une erreur possible.",
    53: "Un compte d’estimation n’est pas accompagné de la référence EST (Accounting Estimates). L’ajouter à partir de la liste de référence des PCB.",
    54: "Identifier le ou les comptes présentant des estimations et ouvrir chacun d’entre eux pour voir si une catégorie d’opérations importante d’estimation y est associée. Si ce n’est pas le cas, vous devez associer la catégorie d’opérations importante d’estimation au compte.",
    55: "Identifier la catégorie d’opérations importante d’estimation qui n’est pas liée à un compte d’estimation. Associer ensuite la catégorie d’opérations importante d’estimation au compte d’estimation.",
    56: "Un risque important ou un risque de fraude doit comporter au moins une procédure de corroboration, un contrôle et une tâche Test des contrôles (s’il y a lieu).",
    57: "Un risque important ou un risque de fraude doit comporter au moins une procédure de corroboration, un contrôle et une tâche Test des contrôles (s’il y a lieu).",
    58: "Cliquer sur le risque à valider et développer l’assertion. Vérifier que Oui est coché pour au moins une tâche.",
    59: "Cliquer sur le risque à valider et développer l’assertion. Vérifier que Oui est coché pour au moins un contrôle. L’efficacité de la conception du contrôle doit également être vérifiée.",
    60: "Cliquer sur le lien de validation Résoudre les commentaires du formulaire Canvas. Ouvrir chaque formulaire Canvas et sélectionner les commentaires non résolus. Tous les commentaires doivent être réglés ou fermés.",
    61: "Cliquer sur le lien de validation Finaliser les réponses incomplètes du formulaire Canvas. Ouvrir chaque formulaire Canvas et sélectionner Afficher les réponses incomplètes. Aucune question du formulaire Canvas ne doit rester sans réponse.",
    62: "Cliquer sur le lien de validation, passer en revue les commentaires ouverts et les régler ou les fermer.",
    63: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    64: "Cliquer sur le lien de validation, dans la liste de tâches filtrées, passer en revue chaque tâche et marquer les tâches ouvertes comme étant terminées.",
    65: "Cliquer sur le bouton Dissocier tous pour détacher tous les éléments probants partagés.",
    66: "Le formulaire 440 comporte au moins un document pour lequel aucune raison justifiant la modification n’a été sélectionnée.",
    67: "Le formulaire 440 comporte au moins un document pour lequel un changement autre que de nature administrative a été sélectionné sans que la raison n’ait été donnée.",
    68: "Le formulaire 440 comporte au moins un document pour lequel un changement autre que de nature administrative a été sélectionné qui n’a pas été approuvé par un chef d’équipe ou une personne d’un échelon supérieur.",
    69: "Le formulaire 440 n’a pas été approuvé par l’associé responsable.",
    70: "Cliquer sur le bouton Dissocier du groupe dans la liste de contrôle de l’archivage.",
    71: "Un formulaire Canvas n’a ni en-tête ni contenu standard.",
    72: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    73: "Cliquer sur l’icône du contrôle de validation dans le formulaire Canvas pour afficher le nombre de réponses incomplètes. ",
    74: "Cliquer sur le lien et envoyer la version actualisée du profil de la mission.",
    75: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    76: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    77: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    78: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    79: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    80: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    81: "Relever les processus informatiques et les associer aux applications informatiques.",
    82: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    83: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    84: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    85: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    86: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    87: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    88: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    89: "L’évaluation du processus informatique n’a pas été sélectionnée ou n’est pas cohérente avec les évaluations de l’efficacité du fonctionnement des CGI/procédures de corroboration liées aux TI.",
    90: "Efficacité de la conception non sélectionnée pour le contrôle.",
    91: "Afficher les catégories d’opérations importantes et les applications informatiques connexes qui sont pertinentes pour l’audit.",
    92: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    93: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    94: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    95: "Aucun membre de l’équipe en particulier n’a été désigné comme responsable à la page Gérer l’équipe.",
    96: "Un facteur de risque n’est pas associé à un risque ou ne porte pas la mention « Il ne s’agit pas d’un risque d’anomalie significative ».",
    97: "Un risque n’est pas associé à une assertion.",
    98: "Un montant doit être indiqué comme montant prévu pour la base de mesure.",
    99: "Une justification doit être donnée pour le montant prévu pour la base de mesure.",
    100: "Un montant doit être indiqué comme montant ajusté pour la base de mesure.",
    101: "Le pourcentage du seuil de signification initial n’a pas été sélectionné.",
    102: "Le pourcentage du seuil de signification initial se situe à l’extérieur de la fourchette permise.",
    103: "Une justification doit être saisie pour le pourcentage du seuil de signification initial sélectionné.",
    104: "L’erreur acceptable n’a pas été saisie.",
    105: "Le pourcentage de l’erreur acceptable se situe à l’extérieur de la fourchette permise.",
    106: "Une justification doit être saisie pour le pourcentage de l’erreur acceptable sélectionné.",
    107: "Le pourcentage de seuil minimal de report des anomalies n’a pas été sélectionné.",
    108: "Le pourcentage de seuil minimal de report des anomalies se situe à l’extérieur de la fourchette permise.",
    109: "Une justification doit être saisie pour le pourcentage de seuil minimal de report des anomalies sélectionné.",
    110: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    111: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    112: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    113: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    114: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    115: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    116: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    117: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    118: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    119: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    120: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    121: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    122: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    123: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    124: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    125: "Les documents protégés ne doivent pas être conservés dans les dossiers de mission, sauf si cela est nécessaire.",
    126: "Supprimer le document et le téléverser à nouveau.",
    127: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    128: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    129: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    130: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    131: "Accédez au formulaire Liste des estimations et utilisez l’option Créer un document.",
    132: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    133: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    134: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    135: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    136: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    137: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    138: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    139: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    140: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    141: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    142: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    143: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    144: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    145: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    146: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    147: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    148: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    149: "Cliquer sur le lien de validation Finaliser les réponses incomplètes du formulaire Canvas. Ouvrir chaque formulaire Canvas et vérifier que tous les documents requis associés aux exigences comportent l’approbation correspondante de l’associé responsable / du RRQM. N’approuvez que les fichiers que vous avez préparés et passés en revue.",
    150: "Cliquer sur le lien de validation Finaliser les réponses incomplètes du formulaire Canvas. Ouvrir chaque formulaire Canvas et vérifier que tous les documents requis associés aux exigences comportent l’exigence d’approbation correspondante de l’associé responsable / du RRQM.",
    151: "Veuillez vérifier que tous les comptes importants et toutes les informations à fournir importantes sont associés à au moins une assertion. ",
    152: "Ouvrir chaque formulaire Canvas et vérifier que tous les documents requis associés aux exigences comportent l’approbation correspondante du préparateur et du responsable de la revue. N’approuvez que les fichiers que vous avez préparés et passés en revue.",
    153: "Accédez à l’ajustement et utilisez l’option Ajouter des éléments probants pour associer les éléments probants appropriés.",
    154: "Accédez au document sur l’estimation et vérifiez que les estimations présentant un risque élevé/faible sont associées à un compte Estimation. Les estimations présentant un risque très faible doivent être associées à au moins un compte.",
    155: "Accédez au document sur l’estimation et vérifiez les comptes qui sont associés. À partir de la documentation de l’audit, vous devez dissocier le compte s’il n’est pas une estimation ou en faire un compte Estimation.",
    156: "Accédez au document sur l’estimation et vérifiez les réponses.",
    157: "Accédez au document sur l’estimation et vérifiez que les estimations présentant un risque élevé/faible sont associées à une catégorie d’opérations d’estimation importante. Les estimations présentant un risque très faible doivent être associées à au moins une catégorie d’opérations importante.",
    158: "Accédez au document sur le compte et vérifiez qu’au moins une estimation présentant un risque élevé ou faible est associée.",
    159: "Accédez au document sur le compte et vérifiez qu’au moins une estimation présentant un risque élevé ou faible est associée.",
    160: "Accédez à la feuille maîtresse des estimations pour identifier les catégories d’opérations d’estimation importantes auxquelles aucune estimation n’est associée. À partir de la documentation de l’audit, vous devez modifier ces catégories d’opérations importantes pour qu’elles ne soient pas des estimations ou associer des estimations à ces catégories d’opérations importantes.",
    161: "Accédez à l’ajustement et vérifiez que la somme des écritures de débit correspond à la somme des écritures de crédit.",
    162: "Accédez au document sur l’estimation et vérifiez qu’au moins un risque important ou un risque de fraude est associé.",
    163: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    164: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    165: "Suivre les instructions étape par étape du document d’appui How to clear validation checks in EY Canvas pour résoudre cet élément de validation.",
    166: "Accédez au document sur l’estimation et vérifiez les risques associés. À partir de la documentation de l’audit, vous devez dissocier le risque important ou le risque de fraude ou modifier la catégorie d’estimation pour estimation présentant un risque élevé."
};

export const validationChecksReportHeaderLabels = {
    validationType: "Type de validation",
    validationDescription: "Description de la validation",
    itemName: "Nom de l’élément",
    auditPhase: "Phase de l’audit",
    additionalInformation: "Informations additionnelles",
    localization: "Localisation",
    itemType: "Type d’élément",
    location: labels.location,
    count: "Nombre",
    validationCount: "Nombre de validations",
    itemID: "Identifiant de l’élément",
    validationTypeID: "Identifiant du type de validation",
    category: "Catégorie",
    auditPhaseID: "Identifiant de la phase de l’audit",
    entity: labels.filterEntitiesLabel
};


export const ReviewNotesReportHeaderLabel = {
    annotationID: "Identifiant de l’annotation ",
    assignToUserID: "Attribué à Identifiant de l’utilisateur",
    assignedtoUser: labels.assignedTo,
    createUserID: "Identifiant de l’auteur",
    createdBy: "Auteur",
    createdDate: "Créé le",
    dueDateLabel: "Date d’échéance",
    relatedEvidence: "Éléments probants associés",
    reviewNote: labels.reviewNotesLabel,
    lastModifiedBy: "Dernière modification par",
    modifyUserID: "Modifié par Identifiant de l’utilisateur",
    lastModifiedOnLabel: "Dernière modification le",
    priorityType: labels.priorityLabel,
    annotationParentID: "Identifiant de l’annotation de l’entité parent",
    referenceNumber: "Référence",
    relatedTasks: "Tâche associée",
    replies: labels.reply,
    reviewNoteStatus: labels.status,
    statusChangedByUserID: "État modifié par Identifiant de l’utilisateur",
    statusChangedBy: "État modifié par",
    statusChangedDateLabel: "État modifié par",
    startDateLabel: "Créées pour la première fois (UTC) ",
    clearedDateLabel: "Réglées pour la dernière fois (UTC)",
    closedDateLabel: "Fermées pour la dernière fois (UTC)",
    documentTypeID: "Date de modification de l’état",
    childAnnotationID: "Identifiant du type de document"
};

export const taskDueDateCategoryIdLabels = {
    0: "Dernières semaines",
    1: "Semaine courante",
    2: "Semaine prochaine",
    3: "Semaines à venir"
};

export const taskSummaryReportHeaderLabels = {
    engagementID: "Identifiant de la mission",
    taskID: "Identifiant de la tâche",
    displayedTaskName: labels.TaskName,
    taskNamePrefix: "Préfixe de la tâche",
    taskNameSuffix: "Suffixe de la tâche",
    dueDateColumn: labels.taskDueDateHeader,
    dueDateWeek: labels.dueLabel,
    assignmentType: labels.assignmentType,
    assignmentTypeID: "Identifiant du type d’affectation",
    assignmentName: labels.assignmentName,
    assignmentStatus: labels.taskAssigmentStatusHeader,
    reviewNoteAssignedOpen: "Notes de revue ouvertes attribuées",
    reviewNoteAssignedCleared: "Notes de revue réglées attribuées",
    reviewNoteAuthoredOpen: "Notes de revue ouvertes rédigées",
    reviewNoteAuthoredCleared: "Notes de revue réglées rédigées",
    taskStatus: labels.taskStatusLabel,
    taskStatusID: "Identifiant de l’état de la tâche",
    taskType: labels.taskType,
    taskTypeID: "Identifiant du type de tâche",
    milestone: labels.filterMilestoneLabel,
    milestoneID: "Identifiant du jalon",
    isOverdueColumn: labels.Overdue,
    timephaseName: labels.timephase,
    relatedObjectName: "Objet associé",
    relatedEntityID: "Identifiant de l’objet associé ",
    openAssignmentsOverdue: "Affectations ouvertes ‒ En retard",
    openAssignmentsThisWeek: "Affectations ouvertes ‒ Cette semaine",
    openAssignmentsNextWeek: "Affectations ouvertes ‒ Semaine prochaine",
    openAssignmentsTotal: "Affectations ouvertes ‒ Total",
    inProgressAssignmentsOverdue: "Affectations en cours ‒ En retard",
    inProgressAssignmentsThisWeek: "Affectations en cours ‒ Cette semaine",
    inProgressAssignmentsNextWeek: "Affectations en cours ‒ Semaine prochaine",
    inProgressAssignmentsTotal: "Affectations en cours ‒ Total"
};

export const crtControlSummaryReportHeaderLabels = {
    scotID: "Identifiant de la catégorie d’opérations importante",
    scotName: "Catégorie d’opérations importante",
    strategyTypeName: "Type de stratégie",
    wcgwID: "Identifiant de l’erreur possible",
    wcgwName: "Erreur possible",
    controlID: "Identifiant du contrôle",
    controlName: "Contrôle",
    operatingEvaluation: "Évaluation du fonctionnement",
    assertions: "Assertions",
    controlTypeName: "Type de contrôle ",
    testingFormatted: "Sélection aux fins des tests",
    scotStrategy: "Stratégie axée sur la catégorie d’opérations importante",
    itApplicationName: "TI/SS associée",
    controlFrequencyTypeName: "Fréquence",
    scotTypeID: "Identifiant du type de catégorie d’opérations importante",
    scotTypeName: "Type de catégorie d’opérations importante",
    itAppType: "Application TI/SS",
    lowerRiskControl: "Contrôle présentant un risque faible"
};

export const trialBalanceReportHeaderLabels = {
    engagementID: "Identifiant de la mission",
    trialBalanceID: "Identifiant de la balance des comptes",
    trialBalanceTypeID: "Identifiant du type de balance des comptes",
    trialBalanceTypeName: "Nom du type de balance des comptes",
    financialStatementID: "Identifiant de l’état financier",
    financialStatementName: "Nom de l’état financier",
    financialStatementTypeID: "Identifiant du type d’état financier",
    financialStatementTypeName: "Nom du type du type d’état financier",
    financialStatementSubTypeID: "Identifiant du sous-type d’état financier",
    financialStatementSubTypeName: "Nom du sous-type d’état financier",
    analysisPeriodBalance: "Solde à la date de l’analyse",
    comparativePeriodBalance: "Solde à la date de comparaison",
    analysisComparativeBalanceChange: "Variation du solde entre la période de comparaison et la période visée par l’analyse",
    analysisComparativeBalanceChangePercent: "Variation en pourcentage du solde entre la période de comparaison et la période visée par l’analyse",
    secondComparativePeriodBalance: "Solde à la deuxième date de comparaison",
    analysisSecondComparativeBalanceChange: "Variation du solde entre la deuxième période de comparaison et la période visée par l’analyse",
    analysisSecondComparativeBalanceChangePercent: "Variation en pourcentage du solde entre la deuxième période de comparaison et la période visée par l’analyse",
    parentFinancialStatementID: "Identifiant de l’état financier de la société mère",
    displayOrder: "Ordre d’affichage",
    eyCanvasAccountName: "Nom de compte EY Canvas",
    relatedEntities: "Entités associées"
};

export const taskSourceTypes = {
    1: labels.internal,
    2: labels.external
};

export const taskNatureTypes = {
    1: labels.testOfDetail,
    2: labels.substantiveAnalyticalProcedure,
    3: labels.testOfControl
};

export const priorityTypesCollaboration = [{
        value: 1,
        label: "Normale"
    },
    {
        value: 3,
        label: "Élevée"
    },
    {
        value: 4,
        label: "Critique"
    }
];

export const StatementType = [{
    id: 1,
    value: "État des résultats"
}, {
    id: 2,
    value: "Bilan"
}, {
    id: 3,
    value: "Les deux"
}];

export const AccountTypes = [{
        id: 1,
        accountTypeName: "Important"
    },
    {
        id: 2,
        accountTypeName: "Risque limité"
    },
    {
        id: 3,
        accountTypeName: "Négligeable"
    },
    {
        id: 4,
        accountTypeName: "Autre"
    },
    {
        id: 5,
        accountTypeName: "Informations à fournir "
    }
];

export const ITAppSOAttributes = [{
    id: 1,
    value: "Sélection aux fins des tests"
}, {
    id: 2,
    value: "TI/SS associée"
}, {
    id: 3,
    value: "Catégorie d’opérations importante associée"
}, {
    id: 4,
    value: "Stratégie pour la catégorie d’opérations importante associée"
}, {
    id: 5,
    value: "Type de catégorie d’opérations importante associée"
}];

export const notesEditorLabels = {
    addNoteButtonLabel: reviewNoteModalLabels?.addNewReviewNoteButtonText,
    saveNoteButtonLabel: labels.saveLabel,
    messagePlaceholder: labels.addNewNoteModalTitle,
    messagePlaceholderReply: reviewNoteModalLabels?.replyInputPlaceholder,
    messagePlaceholderEdit: reviewNoteModalLabels?.noteInputPlaceholderEdit,
    messagePlaceholderReplyEdit: reviewNoteModalLabels?.replyInputPlaceholderEdit,
    addReplyButtonLabel: reviewNoteModalLabels?.reply,
    characters: labels.characters,
    of: labels.of,
    formRequired: labels.required,
    formMaxLength: labels.formMaxLength,
    toFieldLabel: labels.assignedTo,
    priorityFieldLabel: labels.rnhPriority,
    dueDateFieldLabel: labels.dueDate,
    voiceNoteButtonLabel: labels.voiceNoteButtonLabel,
    stopRecordingButtonLabel: labels.stopRecordingButtonLabel,
    cancelButtonLabel: labels.cancelButtonLabel,
    noResultsFound: labels.noResultsFound,
    microphoneBlockedMessage: labels.microphoneBlockedMessage,
    microphoneBlockedOnVideoMessage: labels.microphoneBlockedOnVideoMessage,
    notInMainWindowVoice: labels.notInMainWindowVoice,
    notInMainWindowScreen: labels.notInMainWindowScreen,
    voiceNoteNotAvailable: "La note vocale et l’enregistrement d’écran ne sont pas disponibles dans le tiroir. Passez en mode plein écran pour utiliser ces fonctionnalités.",
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel,
    screenRecord: labels.screenRecord,
    playbackReview: labels.playbackReview,
    close: labels.reviewNotesModalClose
};


export const noteModalLabels = {
    ...notesEditorLabels,
    closeButton: labels.reviewNotesModalClose,
    closed: labels.closed,
    open: labels.open,
    cleared: labels.cleared,
    allNotes: labels.allNotes,
    myNotes: labels.myNotes,
    assignedToMe: labels.assignedToMe,
    noNotesFound: reviewNoteModalLabels?.noNotesFound,
    noNotesFoundInstructional: reviewNoteModalLabels?.noNotesAssociatedWithDocumentLabel,
    assignedTo: labels.assignedTo,
    dueDate: labels.dueDate,
    edit: labels.edit,
    delete: labels.delete,
    clear: labels.clear,
    reopen: labels.reopen,
    close: labels.closeTitle,
    reply: labels.reply,
    confirm: labels.confirm,
    cancel: labels.cancelButtonLabel,
    deleteModalHeaderNote: reviewNoteModalLabels?.deleteIconModalTitleLabel,
    deleteModalHeaderReply: reviewNoteModalLabels?.deleteReplyIconModalTitle,
    deleteModalTextNote: reviewNoteModalLabels?.deleteIconModalConfirmMessageParent,
    deleteModalTextReply: reviewNoteModalLabels?.deleteIconModalConfirmMessage,
    showMore: reviewNoteModalLabels?.showMore,
    showLess: reviewNoteModalLabels?.showLess,
    view: labels.view,
    notSelected: labels.notSelectedText,
    deleteButtonTitle: labels.voiceNoteCommentDeleteLabel,
    playButtonTitle: labels.voiceNoteCommentPlayLabel,
    pauseButtonTitle: labels.voiceNoteCommentStopLabel
};

export const EntitiesLabels = {
    close: "Fermer",
    cancel: "Annuler",
    repNoRecordMessage: "Aucun résultat trouvé",
    edit: "Modifier",
    delete: "Supprimer",
    actions: "Actions ",
    show: "Afficher",
    first: "Première page",
    last: "Dernière page",
    prev: "Page précédente",
    next: "Page suivante",

    [Entity.Account]: {
        manageEntity: "Gérer les comptes et les informations à fournir",
        searchEntity: "Rechercher des comptes",
        createEntity: "Nouveau compte",
        entityName: "compte",
        entityNameCaps: "Compte",
        entityNamePlural: "Comptes",
        placeholderText: "Créez de nouveaux comptes et informations à fournir ou modifiez et supprimez des comptes et informations à fournir existants ci-après.",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer ce compte? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.Estimate]: {
        manageEntity: "Gérer les estimations",
        searchEntity: "Rechercher une estimation",
        createEntity: "Nouvelle estimation",
        entityName: "estimation",
        entityNameCaps: "Estimation",
        entityNamePlural: "Estimations",
        placeholderText: "Créer de nouvelles estimations ou modifier/supprimer les estimations existantes ci-après.",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer cette estimation? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.Risk]: {
        manageEntity: "Gérer les risques",
        searchEntity: "Rechercher des risques",
        createEntity: "Nouveau risque",
        entityName: "risque",
        entityNameCaps: "Risque",
        entityNamePlural: "Risques",
        placeholderText: "Créer de nouveaux risques ou modifier/supprimer les risques existants ci-après.",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer ce risque? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.STEntity]: {
        manageEntity: "Gérer les entités",
        searchEntity: "Rechercher des entités",
        createEntity: "Nouvelle entité",
        entityName: "entité",
        entityNameCaps: "Entité",
        entityNamePlural: "Entités",
        placeholderText: "Créer de nouvelles entités ou modifier et supprimer des entités existantes ci-après.",
        deleteEntity: "Supprimer l’entité",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer cette entité? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.Control]: {
        manageEntity: "Gérer les contrôles",
        searchEntity: "Rechercher des contrôles",
        createEntity: "Nouveau contrôle",
        entityName: "contrôle",
        entityNameCaps: "Contrôle",
        entityNamePlural: "Contrôles ",
        placeholderText: "Créer de nouveaux contrôles ou modifier et supprimer des contrôles existants ci-après.",
        deleteEntity: "Supprimer le contrôle",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer ce contrôle? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.SCOT]: {
        manageEntity: "Gérer les catégories d’opérations importantes",
        searchEntity: "Rechercher des catégories d’opérations importantes",
        createEntity: "Nouvelle catégorie d’opérations importante",
        entityName: "Catégorie d’opérations importante ",
        entityNameCaps: "Catégorie d’opérations importante ",
        entityNamePlural: "Catégories d’opérations importantes ",
        placeholderText: "Créer de nouvelles catégories d’opérations importantes ou modifier et supprimer les catégories d’opérations importantes ci-après.",
        deleteEntity: "Supprimer la catégorie d’opérations importante",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer cette catégorie d’opérations importante? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.ITApplication]: {
        manageEntity: "Gérer les applications informatiques",
        searchEntity: "Rechercher",
        createEntity: "Nouvelle application informatique",
        entityName: "Application informatique",
        entityNameCaps: "Application informatique",
        entityNamePlural: "Applications informatiques",
        placeholderText: "Créer de nouvelles applications informatiques ou modifier/supprimer des applications informatiques existantes ci-après.",
        deleteEntity: "Supprimer l’application informatique",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer cette application informatique? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.TaskSection]: {
        manageEntity: "Gérer les groupes de tâches",
        searchEntity: "Rechercher dans le groupe de tâches",
        createEntity: "Nouveau groupe de tâches",
        entityName: "groupe de tâches",
        entityNameCaps: "Groupe de tâches",
        entityNamePlural: "Groupes de tâches",
        placeholderText: "Créer un nouveau groupe de tâches ou modifier/supprimer un groupe de tâches existant ci-après.",
        deleteEntity: "Supprimer le groupe de tâches",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer l’ajustement sélectionné? Cette action ne peut pas être annulée."
    },
    [Entity.WCGW]: {
        manageEntity: "Gérer les erreurs possibles",
        searchEntity: "Rechercher des erreurs possibles",
        createEntity: "Nouvelles erreurs possibles",
        entityName: "Erreur possible",
        entityNameCaps: "Erreur possible",
        entityNamePlural: "Erreurs possibles",
        placeholderText: "Créer une nouvelle erreur possible ou modifier/supprimer des erreurs possibles existantes ci-après.",
        deleteEntity: "Supprimer l’erreur possible",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer cette erreur possible? Toutes les relations existantes seront retirées. Cette action ne peut pas être annulée."
    },
    [Entity.Misstatement]: {
        manageEntity: "Gérer les ajustements",
        searchEntity: "Rechercher des ajustements",
        createEntity: "Nouvel ajustement",
        entityName: "ajustement",
        entityNameCaps: "Ajustement",
        entityNamePlural: "Ajustements",
        placeholderText: "Créer de nouveaux ajustements ou modifier/supprimer des ajustements existants ci-après.",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer l’ajustement sélectionné? Cette action ne peut pas être annulée."
    },
    [Entity.AdjustmentValidation]: {
        manageEntity: "Gérer les ajustements avec des contrôles de validation",
        searchEntity: "Rechercher",
        entityName: "ajustements",
        entityNameCaps: "Ajustements",
        entityNamePlural: "Ajustements",
        placeholderText: "Chaque ajustement doit avoir au moins un élément probant associé et pour chaque ajustement, la somme des écritures de débit doit correspondre à la somme des écritures de crédit. Le ou les ajustements suivants présentent une ou plusieurs erreurs de validation. Cliquez sur <b>« Modifier »</b> pour les régler.",
        deleteConfirmLabel: "Voulez-vous vraiment supprimer l’ajustement sélectionné? Cette action ne peut pas être annulée.",
        adjustmentHeader: "Ajustement",
        validationTyeHeader: "Type de validation",
        validationTypeAmtMissmatch: "La somme des écritures de débit ne correspond pas à la somme des écritures de crédit.",
        validationTypeNoEvidence: "Aucun élément probant associé"
    },
    [Entity.SampleItem]: {
        manageEntity: "Gérer les balises d’échantillon",
        searchEntity: "Rechercher des balises",
        createEntity: "Nouvelle balise",
        createManageTagEntity: "Gérer les groupes de balises",
        entityName: "Balise",
        entityNamePlural: "Balises",
        entityNameForTagGroupPlural: "Groupes de balises",
        placeholderText: "Créer de nouvelles balises ou modifier/supprimer des balises existantes ci-après."
    },
    [Entity.SampleTagGroups]: {
        manageEntity: "Gérer les groupes de balises d’échantillon",
        searchEntity: "Rechercher",
        createEntity: "Nouveau groupe de balises",
        entityName: "Groupe de balises",
        entityNameCaps: "Groupe de balises",
        entityNamePlural: "Groupes de balises",
        placeholderText: "Créer de nouveaux groupes de balises d’échantillon ou modifier/supprimer des groupes de balises d’échantillon existants ci-après.",
    }
};

export const executionType = [{
        id: 1,
        label: '',
        toolTip: '',
        value: "Dans cette mission"
    },
    {
        id: 2,
        label: 'CT',
        toolTip: "Procédures dans d’autres missions [équipe principale seulement]",
        value: "Dans d’autres missions [équipe principale seulement]"
    },
    {
        id: 3,
        label: 'PT/CT',
        toolTip: "Procédures dans cette mission et dans d’autres missions [équipe principale seulement]",
        value: "Dans cette mission et dans d’autres missions [équipe principale seulement]"
    }
];

export const AccountType = [{
        id: 1,
        accounttypename: "Compte important"
    },
    {
        id: 2,
        accounttypename: "Compte présentant un risque limité"
    },
    {
        id: 3,
        accounttypename: "Compte négligeable"
    },
    {
        id: 4,
        accounttypename: "Autre compte"
    },
    {
        id: 5,
        accounttypename: "Information à fournir importante"
    }
];

export const statementTypes = [{
        id: 1,
        name: "État des résultats"
    },
    {
        id: 2,
        name: "Bilan"
    },
    {
        id: 3,
        name: "Les deux"
    }
];

export const CreateEditAccountLabels = {
    createModalDescription: "Entrez les détails relatifs au nouveau compte et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer un autre compte, sélectionnez ’<b>{1}</b>’.",
    editModalDescription: "Modifier les détails du compte ci-dessous et sélectionner ’<b>{0}</b>’ pour terminer.",
    close: "Fermer",
    cancel: "Annuler",
    yes: "Oui",
    no: "Non",
    createAccount: "Nouveau compte",
    editAccount: "Modifier le compte",
    delete: "Supprimer",
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer un autre compte",
    accountNameLabel: "Nom du compte (obligatoire)",
    accountDesignationLabel: "Désignation",
    accountExecutionTypeLabel: "Dans quelle mission Canvas les procédures pour ce compte seront-elles mises en œuvre et documentées?",
    accountEstimateLabel: "Une estimation a-t-elle une incidence sur ce compte?",
    accountStatementTypeLabel: "Type d’état",
    pspIndexDropdownLabel: "Référence PCB (obligatoire, maximum 5)",
    removePSPIndexLabel: "Supprimer la référence PCB",
    assertionsLabel: "Sélectionner les assertions pertinentes",
    assertionOptions: assertions,
    executionTypeOptions: executionType,
    accountTypeOptions: AccountType,
    statementTypeOptions: statementTypes,
    confirm: "Confirmer",
    pspIndexErrorMsg: "Obligatoire",
    assertionWarningMessage: "Vous ne pouvez pas modifier les assertions qui sont associées à un risque important, un risque de fraude, un risque d’anomalies significatives ou une estimation. Vous devez d’abord supprimer ces relations.",
    confirmChanges: "Confirmer les modifications",
    executionTypeWarningMessage: "Les modifications que vous vous apprêtez à enregistrer pour ce compte auront une incidence sur les assertions et les PCB existantes : les liens seront brisés. Voulez-vous vraiment continuer? Cette action ne peut pas être annulée.",
    contentUpdateToastMessage: "Mise à jour de contenu disponible pour {0}. Veuillez lancer la mise à jour du contenu à partir de la page Mise à jour du contenu.",
    assertionsRequired: "Au moins une assertion doit être sélectionnée",
    pspIndexDisabledLabel: "Sélectionner jusqu’à cinq références PCB. Désélectionner une ou plusieurs options pour continuer.",
    newSignificantDisclosure: "Nouvelle information à fournir importante",
    noOptionsMessage: "Aucun résultat trouvé",
    accountNameErrorMsg: "Obligatoire"
};

export const CreateMestLabels = {
    createModalTitle: "Nouvelle entité",
    createModalDescription: "Indiquer l’entité ci-dessous et sélectionner ’<b>{0}</b>’ pour terminer. Pour créer une autre entité, sélectionner ’<b>{1}</b>’. Notre stratégie d’audit est axée sur les entités, qui pourraient ne  pas être des entités juridiques, mais des unités fonctionnelles ou d’autres regroupements.",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer une autre entité",
    entityNameLabel: "Nom de l’entité",
    entityStandardIndexLabel: "Référence standard de l’entité",
    entityDescriptionLabel: "Description de l’entité (facultatif)",
    entityNameErrorMsg: "Obligatoire",
    entityStandardIndexErrorMsg: "Obligatoire"
}

export const CreateEditSCOTLabels = {
    createModalTitle: "Nouvelle catégorie d’opérations importante ",
    editModalTitle: "Modifier la catégorie d’opérations importante",
    createModalDescription: "Entrez les détails relatifs à la nouvelle catégorie d’opérations importante ci-dessous et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer une autre catégorie d’opérations importante, sélectionnez ’<b>{1}</b>’.",
    editModalDescription: "Modifiez les détails relatifs à la catégorie d’opérations importante ci-dessous et sélectionnez '<b>{0}</b>' pour terminer.",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer une autre catégorie d’opérations importante",
    scotNameLabel: "Nom de la catégorie d’opérations importante (obligatoire)",
    scotStrategyLabel: "Stratégie axée sur la catégorie d’opérations importante",
    scotTypeLabel: "Type de catégorie d’opérations importante",
    scotTypeOptions: scotTypes,
    hasEstimateLabel: "Une estimation a-t-elle une incidence sur cette catégorie d’opérations importante?",
    itAPPUsedLabel: "Aucune application informatique utilisée",
    routine: "Courante",
    nonRoutine: "Non courante",
    controls: "Contrôles",
    substantive: "Corroboration",
    yes: "Oui",
    scotNameErrorMsg: "Obligatoire",
    remove: "Retirer",
    noOptionsMessage: "Aucun résultat",
    wtDetailPrefix: "<p>Nous confirmons notre compréhension de toutes les catégories d’opérations importantes courantes et non courantes et de tous les processus liés aux informations à fournir importantes à chaque période au moyen de tests de cheminement. De plus, dans le cas des audits réalisés selon les normes du PCAOB, nous effectuons des tests de cheminement des catégories d’opérations importantes d’estimation.<br/>Dans le cas de toutes les catégories d’opérations importantes où nous recourons à une stratégie axée sur les contrôles et dans le cas des contrôles qui répondent à des risques importants, nous confirmons que les contrôles pertinents ont été conçus et mis en place de façon appropriée. Nous confirmons que notre décision de recourir à une stratégie axée sur les contrôles convient toujours.<br/><br/>Nous concluons que notre documentation décrit avec exactitude le fonctionnement de la catégorie d’opérations importante et que nous avons relevé toutes les erreurs possibles pertinentes, y compris celles qui découlent du recours à l’informatique, et les contrôles connexes (le cas échéant).<br/><br/> Nous devons déterminer si notre compréhension des catégories d’opérations importantes d’estimation qui font l’objet d’une stratégie corroborative est appropriée à la lumière de nos procédures de corroboration.</p>",
    disabledTabTooltipMessage: "Désélectionner « Aucune application informatique utilisée » pour associer les applications informatiques",
    itAppLabels: {
        tabLabel: "Applications informatiques",
        dropdownLabel: "Associer les applications informatiques",
        noRelatedItems: "Aucune application informatique associée",
        itApplications: "Applications informatiques"
    },
    soLabels: {
        tabLabel: "SS",
        dropdownLabel: "Associer des sociétés de services ",
        noRelatedItems: "Aucune société de services associée",
        serviceOrganizations: "Sociétés de services"
    }
};

export const CreateEditWCGWLabels = {
    wcgwName: "Nom de l’erreur possible (obligatoire)",
    editWCGW: "Modifier l’erreur possible",
    editTheWCGW: "Modifiez les détails relatifs à l’erreur possible ci-dessous et sélectionnez ’<b>{0}</b>’ pour terminer.",
    createNewWCGW: "Entrez les détails relatifs à la nouvelle erreur possible ci-dessous et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer une autre erreur possible, sélectionnez ’<b>{1}</b>’.",
    createEditWCGWModelScot: "Catégorie d’opérations importante",
    newWCGWTitel: "New WCGW",
    editWCGWSave: "Enregistrer",
    editWCGWClose: "Annuler",
    closeTitle: "Fermer",
    wcgwNameIsRequired: "Obligatoire",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer une autre entité"
};

export const controlFrequencyTypes = [{
        value: 1,
        label: "Plusieurs fois par jour"
    },
    {
        value: 2,
        label: "Une fois par jour"
    },
    {
        value: 3,
        label: "Une fois par semaine"
    },
    {
        value: 4,
        label: "Une fois par mois"
    },
    {
        value: 5,
        label: "Une fois par trimestre"
    },
    {
        value: 6,
        label: "Une fois par année"
    },
    {
        value: 8,
        label: "Autre"
    }
];

export const controlTypes = [{
        value: 1,
        label: "Contrôles des applications informatiques"
    },
    {
        value: 2,
        label: "Contrôle manuel lié aux TI"
    },
    {
        value: 3,
        label: "Contrôle manuel de prévention"
    },
    {
        value: 4,
        label: "Contrôle manuel de détection"
    }
];

export const CreateEditControlLabels = {
    createModalTitle: "Nouveau contrôle",
    editModalTitle: "Modifier le contrôle",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer un autre contrôle",
    controlNameLabel: "Nom du contrôle (obligatoire)",
    frequency: "Fréquence",
    controlType: "Type de contrôle",
    frequencyTypeOptions: controlFrequencyTypes,
    controlTypeOptions: controlTypes,
    designEffectiveness: "Efficacité de la conception",
    operatingEffectiveness: "Efficacité du fonctionnement",
    testingLabel: "Test",
    lowerRiskLabel: "Le risque lié au contrôle est-il faible?",
    ITDMControlSubstantiveTestingOptionLabel: "La partie automatisée de ce contrôle manuel lié aux TI ne consiste qu’en l’utilisation de rapports générés par le système qui font l’objet de tests de corroboration",
    effective: "Efficace",
    ineffective: "Inefficace",
    yes: "Oui",
    no: "Non  ",
    required: "Obligatoire",
    remove: "Retirer",
    noOptionsMessage: "Aucun résultat trouvé",
    disabledTabTooltipMessage: "Sélectionner « Contrôle des applications informatiques » ou « Contrôle manuel lié aux TI » comme « Type de contrôle » pour associer les applications informatiques ",
    itAppLabels: {
        tabLabel: "Applications informatiques",
        dropdownLabel: "Associer les applications informatiques",
        noRelatedItems: "Aucune application informatique associée",
        itApplications: "Applications informatiques"
    },
    soLabels: {
        tabLabel: "SS",
        dropdownLabel: "Associer des sociétés de services ",
        noRelatedItems: "Aucune société de services associée",
        serviceOrganizations: "Sociétés de services"
    },
    controlNameErrorMsg: "Obligatoire",
    createModalDescriptionLabel: "Entrez les détails relatifs au nouveau contrôle ci-dessous et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer un autre contrôle, sélectionnez ’<b>{1}</b>’.",
    editModalDescriptionLabel: "Modifiez les détails relatifs au contrôle ci-dessous et sélectionnez '<b>{0}</b>' pour terminer.",
    wcgwLabel: "Erreur possible"
};

export const CreateEditITApplicationLabels = {
    close: "Fermer",
    cancel: "Annuler",
    yes: "Oui",
    no: "Non",
    delete: "Supprimer",
    save: "Enregistrer",
    closeTitle: "Fermer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer une autre application informatique",
    iTApplicationNameLabel: "Nom de l’application informatique (obligatoire)",
    iTSOApplicationNameLabel: "Nom de la société de services",
    newITApplicationLabel: "Nouvelle application informatique",
    newITSOApplicationLabel: "Nouvelle société de services",
    editITApplicationLabel: "Modifier l’application informatique",
    confirm: "Confirmer  ",
    confirmChanges: "Confirmer les modifications",
    noOptionsMessage: "Aucun résultat",
    iTAppNameErrorMsg: "Obligatoire",
    iTSOAppNameErrorMsg: "Obligatoire",
    controls: "Contrôles",
    substantive: "Corroboration",
    remove: "Retirer",
    iTApplicationStrategyLabel: "Stratégie liée à l’application informatique",
    SCOTsLabel: "Nom de la catégorie d’opérations informatique",
    StrategyLabel: "Stratégie",
    ControlsLabel: "Noms des contrôles",
    ControlTypeLabel: "Type",
    addDescriptionLabel: "Entrez les détails relatifs à la nouvelle application informatique ci-dessous et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer une autre application informatique, sélectionnez ’<b>{1}</b>’.",

    editDescriptionLabel: "Modifiez les détails relatifs à l’application informatique ci-dessous et sélectionnez '<b>{0}</b>' pour terminer.",

    addSODescriptionLabel: "Entrez les détails relatifs à la nouvelle société de services ci-dessous et sélectionnez ’<b>Enregistrer et fermer</b>’ pour terminer. Pour créer une autre société de services, sélectionnez ’<b>Enregister et créer/b>’.",

    scotErrorMessage: "La catégorie d’opérations importante ne peut pas être dissociée de l’application informatique, car des contrôles sont associés.",
    SCOTsLabels: {
        tabLabel: "Catégories d’opérations importantes ",
        dropdownLabel: "Associer des catégories d’opérations importantes  ",
        noRelatedItems: "Aucune catégorie d’opérations importante associée"
    },
    ControlsLabels: {
        tabLabel: "Contrôles",
        dropdownLabel: "Associer les contrôles",
        noRelatedItems: "Aucun contrôle associé"
    },
    strategyType: {
        1: "Contrôles",
        2: "Corroboration",
        3: "Appui",
        4: "Pas d’appui"
    },
    controlType: {
        1: "Contrôle des applications informatiques",
        2: "Contrôle manuel lié aux TI",
        3: "Contrôle manuel de prévention",
        4: "Contrôle manuel de détection"
    }
};

export const groupComponentAccountReportHeaderLabels = {
    primaryEngagementId: "Identifiant de la mission",
    gaScopeName: "Étendue",
    gaComponentId: "Identifiant de la composante de l’audit de groupe",
    shortName: "Nom de la composante",
    pocText: "Personne-ressource",
    accountId: "Identifiant du compte",
    accountName: "Nom du compte",
    accountType: "Désignation du compte",
    knowledgeAssertion: "Assertion",
    inherentRiskType: "Risque inhérent",
    riskId: "Identifiant du risque",
    riskType: "Type de risque",
    riskName: "Nom du risque",
    isHigherRiskText: "Présente un risque élevé"
};

export const AccountTypeIDs = {
    1: "Compte important",
    2: "Compte présentant un risque limité",
    3: "Compte négligeable",
    4: "Compte − Autre",
    5: "Information à fournir importante"
};

export const InherentRiskTypeIDs = {
    1: "Élevé",
    2: "Faible",
    3: "Très faible"
};

export const riskTypeIDs = {
    1: "Risques importants",
    2: "Risques de fraude",
    3: "Risques d’anomalies significatives"
};

export const riskTypeIDsShortForm = {
    1: "RI",
    2: "RF",
    3: "Risque d’anomalies significatives"
};

export const ControlRiskTypeIDs = {
    1: "Appui",
    2: "Pas d’appui",
    3: "Tester les procédures de la direction"
};

export const knowledgeAssertions = {
    1: "Exhaustivité",
    2: "Existence",
    3: "Évaluation",
    4: "Droits et obligations",
    5: "Présentation et informations fournies",
    6: "Exhaustivité",
    7: "Réalité",
    8: "Mesure",
    9: "Présentation et informations fournies",
    10: "Exhaustivité",
    11: "Existence/Réalité",
    12: "Mesure/Évaluation",
    13: "Droits et obligations",
    14: "Présentation et informations fournies"
};

export const gaInstructionStatuslabels = {
    0: "Non définies",
    [instructionStatus.notSent]: "Non envoyées",
    [instructionStatus.pending]: "En attente",
    [instructionStatus.accepted]: "Acceptées",
    [instructionStatus.rejected]: "Retournées",
    [instructionStatus.systemError]: "Erreur système",
    [instructionStatus.expired]: "Expirées",
    [instructionStatus.sent]: "Envoyées",
    [instructionStatus.unlinked]: "Dissociées",
    [instructionStatus.queued]: "Mises en file d’attente"
};

export const financialStatementTypeLabels = {
    [financialStatementType.Asset]: "Actif",
    [financialStatementType.CurrentAsset]: "Actif courant",
    [financialStatementType.NonCurrentAsset]: "Actif non courant",
    [financialStatementType.Liability]: "Passif",
    [financialStatementType.CurrentLiability]: "Passif courant",
    [financialStatementType.NonCurrentLiability]: "Passif non courant",
    [financialStatementType.Equity]: "Capitaux propres",
    [financialStatementType.Revenue]: "Produits",
    [financialStatementType.Expense]: "Charges",
    [financialStatementType.NonOperatingIncome]: "Résultat hors exploitation",
    [financialStatementType.OtherComprehensiveIncome]: "Autres éléments du résultat global",
    [financialStatementType.Other]: "Autre",
    [financialStatementType.AccountType]: "Type de compte",
    [financialStatementType.AccountSubType]: "Sous-type de compte",
    [financialStatementType.AccountClass]: "Catégorie de compte",
    [financialStatementType.AccountSubClass]: "Sous-catégorie de compte",
    [financialStatementType.NetIncomeExpense]: "Résultat net",
    18: "Compte GL"
};

export const trialBalanceTypeLabels = {
    [trialBalanceType.Planning]: "Planification"
};

export const createEditRiskModalLabels = {
    createModalDescription: "Entrez les détails relatifs au nouveau risque ci-dessous et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer un autre risque, sélectionnez ’<b>{1}</b>’.",
    editModalDescription: "Modifier les détails relatifs au risque ci-dessous et sélectionner <b>{0}</b> pour terminer.",
    close: "Fermer",
    cancel: "Annuler",
    createRisk: "Nouveau risque",
    editRisk: "Modifier le risque",
    riskType: "Type de risque (obligatoire)",

    riskTypeOptions: [{
            value: 1,
            label: "Risque"
        },
        {
            value: 2,
            label: "Risque de fraude"
        },
        {
            value: 3,
            label: "Risque d’anomalies significatives"
        }
    ],
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer un autre risque",
    riskNameLabel: "Nom du risque (obligatoire)",
    relatedAccountsAssertionsLabel: "Comptes et assertions connexes (facultatif)",
    relateAccounts: "Associer des comptes et des assertions (facultatif)",
    assertionsLabel: "Sélectionner les assertions pertinentes ",
    riskNameErrorMsg: "Obligatoire",
    riskTypeErrorMsg: "Obligatoire",
    assertionOptions: assertions,
    removeAccountLabel: "Retirer le compte",
    required: "Obligatoire",
    assertionsRequired: "Au moins une assertion doit être sélectionnée"
};

export const activityTypeLabels = {
    104: "Ajouté",
    105: "Retiré"
};

export const superModalNavigationLabels = {
    identifyAccountsAndDisclosures: "Identifier les comptes et les informations à fournir",
    identifySCOTs: "Identifier les catégories d’opérations importantes et les associer à des comptes",
    determineSCOTStrategy: "Déterminer la stratégie pour la catégorie d’opérations importante",
    identifyWCGWAndControls: "Identifier les erreurs possibles et les contrôles",
    selectControlToTest: "Sélectionner les contrôles à tester",
    identifyRisks: "Identifier les risques ",
    relateWCGWsToAssertions: "Associer les erreurs possibles aux assertions ",
    relateRisksToWCGWs: "Associer les risques aux erreurs possibles",
    determineCRA: "Établir l’EGR",
    timephase: "Période",
    SCOTWT: "Créer une tâche Test de cheminement",
    controlTOC: "Créer une tâche TDC",
    ITProcessUDP: "Créer une tâche Comprendre le processus  ",
    ITGC_ITSP_TOC_OSP: "Créer une tâche TDC TI/APC",
    accountPSP: "Créer une tâche PCB",
    accountOSP: "Créer une tâche APC",
    relateWCGWTo: "Associer l’erreur possible à l’élément suivant : ",
    relatedWCGWToTask: "Associer l’erreur possible à la tâche",
    respondToSignificant_fraudRisks: "Répondre aux risques importants / risques de fraude",
    OST: "ATS",
    accountSummary: "Synthèse des comptes",
    SCOTSummary: "Synthèse des catégories d’opérations importantes",
    ITSummary: "Synthèse TI",
    understandITProcesses: "Comprendre les processus informatiques",
    evaluateIT: "Évaluer les processus informatiques",
    CRASummary: "Synthèse de l’EGR",
    auditPlan: "Plan de mission",
    workplanSummary: "Synthèse du plan de travail",
    buildSteps: "Étapes de production ",
    ITApplicationsAndITProcesses: "Applications informatiques et processus informatiques ",
    workPlan: "Plan de travail",
    accounts: "Comptes",
    scots: "Catégories importantes d’opérations",
    cra: "EGR",
    openInNewTab: "Ouvrir dans un nouvel onglet"
}

export const auditPlanITProcessLabels = {
    itProcess: "Processus informatique",
    itProcesses: "Processus informatiques",
    tasks: "Tâches",
    sectionHeading: "Processus informatique et tâches Comprendre le processus associées",
    subHeader: "Comprendre le processus informatique",
    visualDistinctMessage: "Chaque processus informatique doit être associé à au moins une tâche Comprendre le processus. Créer une tâche {0} ou {1}.",
    addUdp: "Nouvelle tâche Comprendre le processus ",
    relatedUdp: "Associer les tâches Comprendre le processus ",
    toggleFilter: "Afficher seulement les processus informatiques auxquels aucune tâche Comprendre le processus n’est associée",
    noResultsFound: "Aucun résultat",
    taskTitle: "Comprendre et consigner le processus informatique : {0}",
	taskDescription: "Consigner notre compréhension du processus informatique. Joindre le formulaire pertinent pour étayer notre compréhension du processus informatique. Lorsque des CGI sont affichés dans la section Attributs de la tâche, exécuter des procédures de test de cheminement pour confirmer notre compréhension des CGI et en évaluer la conception et la mise en œuvre. 	Joindre les éléments probants à l’appui de nos procédures.",
    noRecordsAvailable: "Aucun processus informatique disponible ",
    unrelatedLabel: "Afficher les tâches Comprendre le processus non associées",
    unrelatedModalHeader: "Tâches Comprendre le processus non associées",
    noUnrelatedTaskPlaceholder: "Aucune tâche Comprendre le processus non associée disponible",
    noTaskselectedLabel: "Au moins une tâche doit être sélectionnée pour suppression",
    relateITProcessTaskTitle: "Associer les tâches Comprendre le processus au processus informatique",
    understandITProcesses: "Comprendre les processus informatiques",
    unrelatedTasksMustBeAssociated: "Les tâches non associées doivent être associées à un processus informatique ou supprimées."
}

export const noEvidenceReferencedReasonsLabels = {
    immaterialReason: "Non significatif : Le solde/mouvement n’atteint pas le seuil de sélection des tests – Pas d’investigation plus poussée    ",
    strikethroughMText: "m",
    waivedReason: "Exclu : Montant en deçà du seuil minimal de report des anomalies – Pas d’investigation plus poussée    ",
    strikethroughWText: "w"
}

export const auditPlanScotListLabels = {
    scot: "Catégorie d’opérations importante ",
    scots: "Catégories importantes d’opérations",
    tasks: "Tâches",
    sectionHeading: "Catégories d’opérations importantes et tâches Test de cheminement associées",
    subHeader: "Tâches Test de cheminement",
    visualDistinctMessage: "Chaque catégorie d’opérations importante doit être associée à au moins une tâche Test de cheminement. Créer une tâche {0} ou {1}.",
    newWT: "Nouvelle tâche Test de cheminement",
    relatedWT: "Associer les tâches Test de cheminement ",
    toggleFilter: "Afficher seulement les catégories d’opérations importantes auxquelles aucune tâche Test de cheminement n’est associée",
    noResultsFound: "Aucun résultat",
    noRecordsAvailable: "Aucune catégorie d’opérations importante disponible",
    relateScotTaskTitle: "Associer les tâches Test de cheminement à la catégorie d’opérations importante",
    taskTitle: "Test de cheminement : {0}",
    taskDescription: "<p>Nous confirmons notre compréhension de toutes les catégories d’opérations importantes courantes et non courantes et de tous les processus liés aux informations à fournir importantes à chaque période au moyen de tests de cheminement. De plus, dans le cas des audits réalisés selon les normes du PCAOB, nous effectuons des tests de cheminement des catégories d’opérations importantes d’estimation.<br/>Dans le cas de toutes les catégories d’opérations importantes où nous recourons à une stratégie axée sur les contrôles et dans le cas des contrôles qui répondent à des risques importants, nous confirmons que les contrôles pertinents ont été conçus et mis en place de façon appropriée. Nous confirmons que notre décision de recourir à une stratégie axée sur les contrôles convient toujours.<br/><br/>Nous concluons que notre documentation décrit avec exactitude le fonctionnement de la catégorie d’opérations importante et que nous avons relevé toutes les erreurs possibles pertinentes, y compris celles qui découlent du recours à l’informatique, et les contrôles connexes (le cas échéant).<br/><br/> Nous devons déterminer si notre compréhension des catégories d’opérations importantes d’estimation qui font l’objet d’une stratégie corroborative est appropriée à la lumière de nos procédures de corroboration.</p>",
    unrelatedLabel: "Afficher les tâches Test de cheminement non associées",
    unrelatedModalHeader: "Tâches Test de cheminement non associées ",
    noUnrelatedTaskPlaceholder: "Aucune tâche Test de cheminement non associée disponible",
    noTaskselectedLabel: "Au moins une tâche doit être sélectionnée pour suppression.",
    manageScots: "Gérer les catégories d’opérations importantes",
    unrelatedTasksMustBeAssociated: "Les tâches non associées doivent être associées à une catégorie d’opérations importante ou supprimées."
}

export const auditPlanControlsLabels = {
    control: "Contrôle",
    controls: "Contrôles sélectionnés aux fins des tests",
    tasks: "Tâches",
    sectionHeading: "Contrôles et test des contrôles associé",
    subHeader: "Tâches Test des contrôles",
    visualDistinctMessage: "Chaque contrôle doit être associé à au moins une tâche TDC. Créer une tâche {0} ou {1}.",
    addToc: "Nouvelle tâche TDC",
    relatedToc: "Associer les tâches TDC ",
    toggleFilter: "Afficher seulement les contrôles auxquels aucune tâche TDC n’est associée",
    noResultsFound: "Aucun résultat",
    noRecordsAvailable: "Aucun contrôle sélectionné aux fins des tests",
    unrelatedLabel: "Afficher les TDC non associés ",
    unrelatedModalHeader: "Tâches TDC non associées",
    noUnrelatedTaskPlaceholder: "Aucune tâche TDC non associée disponible",
    noTaskselectedLabel: "Au moins une tâche doit être sélectionnée pour suppression.",
    relateControlTaskTitle: "Associer les tâches TDC au contrôle",
    manageControl: "Gérer les contrôles",
    taskTitleTOC: "Test des contrôles : {0}",
    taskDescriptionTOC: "Déterminer la nature, le calendrier et l’étendue de nos tests des contrôles de manière à obtenir des éléments probants suffisants et appropriés confirmant que les contrôles fonctionnent efficacement comme prévu pour toute la durée de la période d’appui et permettent de prévenir ou de détecter et de corriger les anomalies significatives au niveau des assertions.<br/>Formuler une conclusion sur l’efficacité du fonctionnement des contrôles, en évaluant les résultats de nos tests des contrôles, y compris lorsque nous avons élargi la taille de nos échantillons et mis en œuvre des tests des contrôles compensatoires.",
    manageControls: "Gérer les contrôles",
    unrelatedTasksMustBeAssociated: "Les tâches non associées doivent être associées à un contrôle ou supprimées."
}

export const industrySelectionGroupLabels = {
    1: "Secteurs sélectionnés",
    2: "Autres secteurs"
}

export const knowledgeDataLabels = {
    industry: "Secteur ",
    showSelected: "Afficher seulement les secteurs sélectionnés",
    noContent: "La base de connaissances ne contient pas de contenu pour le secteur sélectionné",
    importFromKnowledge: "Importer de la base de connaissances",
    importAccounts: "Importer des comptes",
    importAccountsAndDisclosures: "Importer des comptes et des informations à fournir",
    accountBuild1: "Étape de production 1 ‒ Compte",
    import: "Importer",
    close: "Fermer",
    cancel: "Annuler",
    selected: "sélectionné(e)s",
    scotTitle: "Étape de production 1 – Catégorie d’opérations importante",
    importScots: "Importer des catégories d’opérations importantes",
    noKnowledgeDataResult: "Aucun contenu n’est disponible pour l’élément sélectionné",
    showOnlySelectedLabel: "Afficher seulement la catégorie d’opérations importante sélectionnée",
    scot: "Catégorie d’opérations importante",
    scotDropdownLabel: "Catégorie d’opérations importante pour le secteur sélectionné",
    importWcgw: "Importer des erreurs possibles",
    importFailedLabel: "Échec de l’importation. Veuillez réessayer.",
    wtDetailPrefix: "<p>Nous confirmons notre compréhension de toutes les catégories d’opérations importantes courantes et non courantes et de tous les processus liés aux informations à fournir importantes à chaque période au moyen de tests de cheminement. De plus, dans le cas des audits réalisés selon les normes du PCAOB, nous effectuons des tests de cheminement des catégories d’opérations importantes d’estimation.<br/>Dans le cas de toutes les catégories d’opérations importantes où nous recourons à une stratégie axée sur les contrôles et dans le cas des contrôles qui répondent à des risques importants, nous confirmons que les contrôles pertinents ont été conçus et mis en place de façon appropriée. Nous confirmons que notre décision de recourir à une stratégie axée sur les contrôles convient toujours.<br/><br/>Nous concluons que notre documentation décrit avec exactitude le fonctionnement de la catégorie d’opérations importante et que nous avons relevé toutes les erreurs possibles pertinentes, y compris celles qui découlent du recours à l’informatique, et les contrôles connexes (le cas échéant).<br/><br/> Nous devons déterminer si notre compréhension des catégories d’opérations importantes d’estimation qui font l’objet d’une stratégie corroborative est appropriée à la lumière de nos procédures de corroboration.</p>",
    importOSP: "Importer des APC",
    auditPlanBuild7: "Étape de production 7 – Plan de mission",
    account: "Compte",
    accountName: "Références PCB",
    wcgwName: "Erreurs possibles",
    selectScot: "Sélectionner une catégorie d’opérations importante",
    wcgwTitle: "Étape de production 3 – Catégorie d’opérations importante",
    noResultFound: "’Aucun résultat",
    importValidationMessage: "Une réponse est requise",
    searchIconHoverLabel: "Rechercher",
    scotsHeader: "Catégories d’opérations importantes",
    controlsHeader: "Contrôles",
    ospsHeader: "APC",
    wcgw: "Erreur possible",
    importControls: "Importer des contrôles",
    accountAssertionsValidationMessage: "Assertions associées à la tâche manquantes",
    accountsAndDisclosures: "Comptes et informations à fournir",
}

export const auditPlanITControlsLabels = {
    itcontrol: "Contrôle informatique",
    itcontrols: "Contrôles informatiques sélectionnés aux fins des tests",
    tasks: "Tâches",
    type: "Type",
    sectionHeading: "CGI/procédures de corroboration liées aux TI et tâches Tests des contrôles et Procédures de corroboration associés",
    subHeader: "Tâches TDC/APC",
    visualTOCDistinctMessage: "Chaque CGI doit être associé à au moins un test des contrôles. Créer un {0} ou {2}.",
    visualOSPDistinctMessage: "Chaque procédure de corroboration liée aux TI doit être associée à au moins une procédure de corroboration. Créer une {1} ou {3}. ",
    addTOC: "Nouvelle tâche TDC",
    addOSP: "Nouvelle tâche APC",
    relatedTOCOSP: "Associer des TDC/APC",
    relatedTOC: "Associer des TDC ",
    relatedOSP: "Associer des APC",
    toggleFilter: "Afficher seulement les contrôles informatiques auxquels aucun TDC/aucune APC ne sont associés’,",
    noResultsFound: "Aucun résultat",
    noRecordsAvailable: "Aucun CGI sélectionné aux fins des tests",
    taskTitleTOC: "Test des contrôles : {0}",
    taskDescriptionTOC: "Mettre en œuvre les tests des CGI que nous avons conçus de manière à obtenir des éléments probants suffisants et appropriés sur l’efficacité de leur fonctionnement pour toute la période d’appui.",
    taskTitleOSP: "Autre procédure de corroboration : {0}",
    taskDescriptionOSP: "Adapter la description de cette tâche en fonction de la nature, du calendrier et de l’étendue des procédures de corroboration liées aux TI de manière à obtenir des éléments probants suffisants et appropriés confirmant que les risques liés aux TI sont traités efficacement pour toute la durée de la période d’appui.<br>Si les procédures de corroboration liées aux TI sont mises en œuvre à une date intermédiaire, concevoir et mettre en œuvre des procédures de manière à obtenir des éléments probants supplémentaires confirmant que les risques liés aux TI sont traités pour la période visée par nos procédures intermédiaires jusqu’à la fin de la période.<br>Nous formulons une conclusion sur les résultats des procédures de corroboration liées aux TI.",
    relateITControlTaskTitle: "Associer des TDC/APC au contrôle informatique",
    relateITControlTOCTaskTitle: "Associer des TDC au CGI",
    relateITControlOSPTaskTitle: "Associer d’APC à la procédure de corroboration liée aux TI",
    unrelatedModalHeader: "Tâches TDC/APC non associées",
    noUnrelatedTaskPlaceholder: "Aucune tâche TDC/APC non associée disponible",
    noTaskselectedLabel: "Au moins une tâche doit être sélectionnée pour suppression.",
    unrelatedLabel: "Afficher les tâches TDC/APC non associées",
    understandITProcesses: "Comprendre les processus informatiques",
    unrelatedTasksMustBeAssociated: "Les tâches non associées doivent être associées à un contrôle informatique ou supprimées."
}

export const generalLabelsForMobile = {
    noRecordsFound: "Aucun résultat dans la catégorie de tâches",
    taskListTitle: "Mes tâches",
    taskEvidenceTitle: "Éléments probants",
    cameraPagesTitle: "Pages ",
    cameraTitle: "Caméra",
    taskDetailsTitle: "Détails de la tâche",
    invalidPage: "Aucune page trouvée",
    combinedTaskLabel: "PIC/EQR",
    picTaskLabel: "PIC",
    eqrTaskLabel: "EQR",
    pageLabel: "Page",
    ofLabel: "de",
    noTasksAvailable: "Aucune tâche disponible",
    searchLabel: "Rechercher...",
    noDescriptionAvailable: 'No description available.',
    knowledge: 'Knowledge',
    description: 'Description',
    knowledgeDescription: 'Knowledge description',
    customized: 'Customized',
    taskDetailsTitle: "Détails de la tâche",
    unassigned: "Non attribuée",
    assignTo: "Attribuée à ",
    signOffLabel: "Approbations",
    evidenceNoteLabel: "Notes sur les éléments probants",
    attributeLabel: "Attributs",
    addNoteLabel: "Nouvelle note",
    addCommentLabel: "Ajouter un commentaire",
    editCommentLabel: "Mettre à jour le commentaire",
    addReplyNoteLabel: "Répondre à cette note",
    replyNoteLabel: "Répondre",
    replyEditNoteLabel: "Modifier la réponse",
    enterReplyPlaceholder: "Saisir la réponse",
    editNoteLabel: "Modifier",
    deleteNoteLabel: "Supprimer",
    reopenNoteLabel: "Rouvrir",
    closeNoteLabel: "Fermer",
    clearNoteLabel: "Régler",
    preparerAbbrv: "P",
    reviewerAbbrv: "R",
    uploadPhoto: "Téléverser une photo",
    noEvidenceFound: "Aucun élément probant associé à la tâche",
    noRegionComponentFound: "Aucun document reçu d’une équipe zonale ou d’une équipe affectée à l’audit d’une composante",
    noEvidenceMessage: "Cliquer sur Téléverser une photo pour téléverser des éléments probants",
    noNotesFound: "Aucune note trouvée",
    noNotesStatement: "Veuillez laisser une note en utilisant les données ci-après. Attribuez la note à un utilisateur et indiquez la priorité ainsi que la date d’échéance.",
    regionComponentEvidence: "Éléments probants associés à une zone ou à une composante",
    documentWarning: "Le document téléchargé s’ouvrira en lecture seule. Veuillez supprimer le fichier lorsque vous aurez terminé. ",
    preparerTitle: "Approbations des préparateurs",
    reviewerTitle: "Approbations des responsables de la revue",
    teamLabel: "Équipe",
    saveEvidenceTitle: "Enregistrer les éléments probants",
    saveButton: "Enregistrer  ",
    cancelButton: "Annuler",
    confirmButtonLabel: "Confirmer",
    previewButton: "Aperçu",
    evidenceLable: "Nom de l’élément probant",
    mergingTitleLable: "images fusionnées au PDF.",
    showErrFileExistMsg: "Le nom de fichier existe déjà. Veuillez renommer le fichier.",
    showErrForNoImgExist: "Aucune image n’est disponible pour la création d’un PDF.",
    showErrBlankFileNameMsg: "Le nom du fichier ne peut pas être vide.",
    showIsCompletedMessage: "Téléversement du fichier réussi.",
    uploadingTitle: "Traitement en cours",
    showErrImgContext: 'useImages must be used within an ImagesProvider',
    PagePreviewTitle: "Page",
    regionComponentEvidenceLabel: "Éléments probants associés à une zone ou à une composante",
    downloadProcessLabel: "Téléchargement en cours...",
    downloadCompleteLabel: "Téléchargement terminé",
    taskNotes: "Notes de tâche",
    documentNotes: "Notes de document",
    dueDateLabel: "Date d’échéance",
    view: "Afficher :",
    documentNotes: "Notes de document",
    newNote: "Ajouter une note",
    editNote: "Modifier la note",
    assignedTo: "Attribuée à",
    priority: "Priorité",
    select: "Sélectionner",
    dueDate: "Date d’échéance",
    addNewNote: "Ajouter une nouvelle note",
    addNote: "Ajouter une note",
    updateNote: "Mettre à jour la note",
    enterDescription: "Entrer une description…",
    allnotes: "Toutes les notes",
    mynotes: "Mes notes",
    assignedToMe: "Attribuées à moi",
    hashValue: "#",
    showLessToggle: "Afficher moins",
    showMoreToggle: "Afficher plus",
    delete: "Supprimer",
    deleteNoteModalTitle: "Supprimer le message",
    deleteReplyModalTitle: "Supprimer la réponse",
    confirmDeleteNoteLabel: "Voulez-vous vraiment supprimer la note sélectionnée?",
    confirmDeleteReplyLabel: "Voulez-vous vraiment supprimer votre réponse à cette note?",
    downloadInfo: "Il n’est pas permis de télécharger un fichier comportant le caractère # ",
	evidenceFileValidationInfo: 'Le nom du fichier ne peut pas contenir les caractères suivants : */ : <>\?| "',
    previewPageTitle: "Aperçu",
    redirecting: "Redirection vers la page d’accueil dans quelques secondes…",
    redirectingToTask: "Redirection vers la page \'Mes tâches\' dans quelques secondes...",
    errorApplyingConstraints: "Erreur d’application des contraintes :",
    zoomIsNotSupported: "Zoom n’est pas pris en charge par cet appareil.",
    errorCheckingCameraCapability: "Erreur de vérification des fonctions de la caméra :",
    previous: "précédente",
    next: "suivante",
    after: "après",
    redirectingToTaskDetails: "Redirection vers les détails de la tâche dans quelques secondes",
    mobileURL: '/mobile'
};

export const RNHNoteMobileStatusOptions = [{
        value: 1,
        label: "Ouverte"
    },
    {
        value: 2,
        label: "Réglée"
    },
    {
        value: 3,
        label: "Fermée"
    }
];

export const auditPhaseTypes = [{
        value: 1,
        label: "Étendue et stratégie"
    },
    {
        value: 2,
        label: "Exécution"
    },
    {
        value: 3,
        label: "Conclusion"
    },
];

export const CreateEditTaskSectionLabels = {
    createModalTitle: "Nouveau groupe de tâches",
    editModalTitle: "Modifier le groupe de tâches",
    createModalDescription: "Entrez les détails relatifs au groupe de tâches ci-dessous et sélectionnez '<b>{0}</b>' pour terminer. Pour créer un autre groupe de tâches, sélectionnez '<b>{1}</b>'.",
    editModalDescription: "Modifiez les détails relatifs au groupe de tâches ci-dessous et sélectionnez '<b>{0}</b>' pour terminer.",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer un autre compte",
    taskSectionNameLabel: "Nom du groupe de tâches (obligatoire)",
    taskSectionNameErrorMsg: "Obligatoire",
    engagementPhaseOptions: auditPhaseTypes,
    engagementPhaseLabel: "Phase de la mission (obligatoire)",
    engagementPhaseErrorMsg: "Obligatoire",
};

export const auditPhaseLabels = {
    1: "Étendue et stratégie",
    2: "Exécution",
    3: "Conclusion",
    4: "Réaliser les activités préliminaires à la planification de la mission",
    5: "Identifier et évaluer les risques",
    6: "Répondre aux risques",
    7: "Conclusion et rapport"
};

export const ITApproachType = {
    1: "CGI",
    2: "Procédure de corroboration liée aux TI"
};

// taskbuildmilestoneid labels
export const taskBuildMilestoneId = [{
        id: 1,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 31,
        label: superModalNavigationLabels.identifyAccountsAndDisclosures
    },
    {
        id: 5,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 32,
        label: superModalNavigationLabels.identifySCOTs
    },
    {
        id: 6,
        label: superModalNavigationLabels.determineSCOTStrategy
    },
    {
        id: 7,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 38,
        label: superModalNavigationLabels.identifyWCGWAndControls
    },
    {
        id: 8,
        label: superModalNavigationLabels.selectControlToTest
    },
    {
        id: 2,
        label: superModalNavigationLabels.identifyRisks
    },
    {
        id: 15,
        label: superModalNavigationLabels.relateWCGWsToAssertions
    },
    {
        id: 30,
        label: superModalNavigationLabels.relateRisksToWCGWs
    },
    {
        id: 3,
        label: superModalNavigationLabels.determineCRA
    },
    {
        id: 18,
        label: superModalNavigationLabels.SCOTWT
    },
    {
        id: 19,
        label: superModalNavigationLabels.controlTOC
    },
    {
        id: 20,
        label: superModalNavigationLabels.ITProcessUDP
    },
    {
        id: 21,
        label: superModalNavigationLabels.ITGC_ITSP_TOC_OSP
    },
    {
        id: 25,
        label: superModalNavigationLabels.accountPSP
    },
    {
        id: 26,
        label: superModalNavigationLabels.accountOSP,
    },
    {
        id: 27,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 56,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 29,
        label: superModalNavigationLabels.relatedWCGWToTask
    },
    {
        id: 39,
        label: superModalNavigationLabels.respondToSignificant_fraudRisks
    },
    {
        id: 50,
        label: superModalNavigationLabels.OST
    }
];

export const noEvidenceReferencedReasons = [{
        id: 1,
        reason: noEvidenceReferencedReasonsLabels.immaterialReason,
        glAccountTypeId: 12,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughMText
    },
    {
        id: 2,
        reason: noEvidenceReferencedReasonsLabels.waivedReason,
        glAccountTypeId: 13,
        strikethroughText: noEvidenceReferencedReasonsLabels.strikethroughWText
    }
];


export const createEditAdjustmentLabels = {
    createModalTitle: "Nouvel ajustement",
    editModalTitle: "Modifier l’ajustement",
    createModalDescription: "Entrez les détails relatifs à l’ajustement et sélectionnez ’<b>{0}</b>’ pour terminer. Pour créer un autre ajustement, sélectionnez ’<b>{1}</b>’.",
    editModalDescription: "Modifiez les détails relatifs à l’ajustement et sélectionnez ’<b>{0}</b>’ pour terminer. Pour supprimer l’ajustement, cliquez sur ’<b>{1}</b>’.",
    close: "Fermer",
    cancel: "Annuler",
    save: "Enregistrer",
    saveAndCloseLabel: "Enregistrer et fermer",
    saveAndCreateLabel: "Enregistrer et créer un autre ajustement",
    delete: "Supprimer",
    adjustmentNameLabel: "Référence de l’ajustement (obligatoire)",
    adjustmentDescriptionLabel: "Description de l’ajustement (obligatoire)",
    adjustmentDescriptionPlaceholder: "Description de l’ajustement (obligatoire)",
    required: "Obligatoire",
    editDescriptionModal: "Modifier la description de l’ajustement",
    descriptionRequired: "La description de l’ajustement est requise",
    uploadDocumentPlaceholder: "L’ajustement doit être enregistré avant de pouvoir être associé à l’élément probant.",
    generalLedgerAccount: "Comptes GL (obligatoires)",
    documentHeader: "Documents (obligatoire)",
    addDocumentButton: "Ajouter des éléments probants",
    glAccountPlaceholder: 'GL account is not available. To add the account click {0}.',
    adjustmentIndex: "Référence de l’ajustement",
    addglaccountbutton: "Ajouter le compte du grand livre général",
    descriptionMaxLengthError: "La réponse dépasse la longueur maximale permise.",
    glaccountTotalError: "Le total des écritures de débit doit correspondre au total des écritures de crédit.",
    glaccountIdDuplicate: "Chaque compte GL ne peut être utilisé qu’une seule fois dans l’ajustement. ",
    placeholderText: 'No related documents. To relate a document click <a>Add evidence<a>',
    editAdjustmentDescriptionHeader: "Modifier la description de l’ajustement",
    editAdjustmentDescriptionSubHead: "Modifier les détails relatifs à la description de l’ajustement ci-dessous et sélectionner \'<b>Enregistrer</b>' pour terminer. "
};

export const addUpdateGlAccountLabels = {
    addGLaccountTitle: "Ajouter un compte GL",
    glaccountDescription: "Entrer les détails relatifs au compte GL ci-dessous et sélectionner '<b>{0}</b>' pour terminer. Pour créer un autre compte GL, sélectionner '<b>{1}</b>'.",
    addAndClose: "Ajouter et fermer",
    addAnother: "Ajouter un autre compte GL",
    accountSubClassPlaceholder: "Sous-catégorie de compte",
    glAccountsPlaceholder: "Sélectionner une sous-catégorie de compte pour afficher les comptes GL disponibles.",
    glAccountListHeaderColumn: "Compte GL",
    amountLabel: "Montant (obligatoire)",
    debitCreditOptions: [{
            id: 1,
            label: "Débit"
        },
        {
            id: 2,
            label: "Crédit"
        }
    ],
    searchPlaceholder: "Rechercher",
    newGlAccount: "Nouveau compte de rapprochement",
    noResultsFound: "Aucun résultat",
    noRecordsPlaceholder: "Aucun compte de rapprochement trouvé pour la sous-catégorie de compte sélectionnée. Sélectionnez une sous-catégorie différente ou cliquez sur {0} pour ajouter le compte de rapprochement à la sous-catégorie de compte sélectionnée.",
    editTitleTip: "Modifier le compte de rapprochement",
    removeTitleTip: "Supprimer le compte de rapprochement",
    custom: "Personnaliser",
    duplicateGLAccount: "Chaque compte GL ne peut être utilisé qu’une seule fois dans l’ajustement. ",
    updateModalTitle: "Mettre à jour le compte de rapprochement",
    updateModalDescription: `Update GL account amount and debit/credit details below and select '<b>{0}</b>' to finish.`,
    accountClassLabel: "Account class",
    glAccountLabel: "GL account",
    updateLabel: "Mettre à jour",
    updateGlAccountModalTitle: "Mettre à jour le compte GL",
}

export const deleteGLAccountLabels = {
    deleteConfirmationModallHeader: "Supprimer le compte de rapprochement",
    deleteConfirmationModalBodyHeader: "Voulez-vous vraiment supprimer le compte de rapprochement sélectionné? Cette action ne peut pas être annulée.",
    deleteConfirmationModalAccountSubClass: "Sous-catégorie de compte :",
    deleteConfirmationModalAccountName: "Nom du compte : ",
    deleteConfirmationModalGLAccountName: "Nom du compte de rapprochement :",
    closeButtonTitle: "Annuler",
    confirmBtnTitle: "Supprimer"
}

export const glAccountListLabel = {
    accountClass: "Catégorie de compte",
    accountSubClass: "Sous-catégorie de compte",
    glAccount: "Compte GL",
    debit: "Débit",
    credit: "Crédit",
    actions: "Actions ",
    editTitleTip: "Modifier le compte GL",
    removeTitleTip: "Supprimer le compte GL"
}

export const EngagementMapLabels = {
    objectivePreviewMessage: 'Hover over a map item to preview',
    noMapAvailableMessage: "Aucun schéma disponible.",
    takeContentUpdateMessage: "Faire une mise à jour du contenu pour obtenir le schéma le plus récent. ",
    noRecordsLabel: "Aucun enregistrement trouvé",
    auditTopic: "Sujet d’audit",
    auditTopicPlaceholder: "Sélectionner un sujet pour l’afficher ",
    numberSelected: "{0} sujets sélectionnés",
    refreshMapTitletip: "Cliquez ici pour lancer la mise à jour du schéma de la mission",
    mapUpdateInProgress: "Mise à jour en cours. Le processus peut prendre jusqu’à 10 minutes.",
    refreshMapsLabel: "Refresh maps"
}

export const createEditGLAccountLabels = {
    createModalTitle: "Nouveau compte de rapprochement",
    editModalTitle: "Modifier le compte de rapprochement",
    createModalDescription: "Entrez les détails relatifs au compte de rapprochement ci-dessous et sélectionnez '<b>{0}</b>' pour terminer. Pour ajouter un autre compte de rapprochement, sélectionnez '<b>{1}</b>'.",
    editModalDescription: "Modifiez les détails relatifs au compte de rapprochement ci-dessous et sélectionnez '<b>{0}</b>' pour terminer.",
    accountSubClass: "Sous-catégorie de compte",
    accountName: "Nom du compte (obligatoire)",
    glAccountName: "Nom du compte de rapprochement (obligatoire)",
    cancelbtn: "Annuler",
    saveAndAddbtn: "Enregistrer et ajouter un autre compte GL",
    saveAndClosebtn: "Enregistrer et fermer",
    save: "Enregistrer",
    required: "Obligatoire",
}

//Receive instructions switcher
export const receiveInstructionSwitcherLabels = {

    [receiveInstructionSwitcherIds.groupInstructions]: "Instructions relatives à l’audit de groupe",
    [receiveInstructionSwitcherIds.groupRiskAssessment]: "Évaluation des risques au niveau du groupe",
    [receiveInstructionSwitcherIds.documents]: "Documents"
};

export const misstatementEvidenceLabels = {
    placeholderText: "Aucun élément probant associé. Au moins un élément probant doit être associé. Pour associer un élément probant, cliquez sur {0}.",
    addEvidenceBtn: "Ajouter un élément probant",
};

export const misstatementTempLabels = {
    placeholderText: "Aucun document temporaire associé. Pour associer un document temporaire, cliquez sur {0}.",
    addEvidenceBtn: "Ajouter un fichier temporaire",
};

export const inherentRiskFactorTypes = [{
        id: 1,
        label: "Complexité",
        displayOrder: 1
    },
    {
        id: 2,
        label: "Incertitude liée au degré de subjectivité",
        displayOrder: 2
    },
    {
        id: 3,
        label: "Fraude ou erreur",
        displayOrder: 3
    },
    {
        id: 4,
        label: "Changement",
        displayOrder: 4
    },
    {
        id: 5,
        label: "Nature du compte",
        displayOrder: 5
    },
    {
        id: 6,
        label: "Parties liées",
        displayOrder: 6
    }
];

export const helixSettingsStepLabels = {
    title: "Définir les paramètres de connexion",
    subTitle: "Sélectionnez les paramètres de connexion de votre analyseur.",
    connectionNameLabel: "Nom de la connexion",
    connectionNamePlaceholder: "Nom de la connexion (obligatoire)",
    connetionTypesLabel: "Types de connexion",
    connectionTypeScopeAndStrategy: "Étendue et stratégie",
    connectionTypeFinancionStatement: "États financiers",
    includeAllBusinessUnitsField: "Voulez-vous inclure toutes les unités fonctionnelles?",
    yes: "Oui",
    no: "Non",
    businessUnitsLabel: "Unité(s) fonctionnelle(s)",
    businessUnitsPlaceholder: "Unité(s) fonctionnelle(s)",
    analysisPeriodLabel: "Date de l’analyse",
    analysisPeriodPlaceholder: "Date de l’analyse",
    comparativePeriod1Label: "Date de comparaison 1",
    comparativePeriod1Placeholder: "Date de comparaison 1 (facultatif)",
    comparativePeriod2Label: "Date de comparaison 2",
    comparativePeriod2Placeholder: "Date de comparaison 2 (facultatif)",
    currencyTypeField: "Type de monnaie",
    reporting: "Présentation",
    functional: "Fonctionnelle",
    currencyCodeField: "Code de monnaie",
    currencyCodePlaceholder: "Code de monnaie (obligatoire)",
    scopeAndStrategyLabel: "Étendue et stratégie",
    financialStatementLabel: "État financier",

    required: "Obligatoire",
    comparativePeriodError: "Date non valide. Sélectionnez une date antérieure à la date de l’analyse.",

    dataConnectionLink: 'How to manage data connections',
    helixfiscalDropDownLabel: "Date {0} - {1}",

    helixError: 'Could not connect to the selected analyzer. Refresh the page and try again. If the issue persists, contact the Help Desk.',
    businessUnitsSelectedCount: "{0} sélectionnée(s)",
    allBusinessUnitsLabel: "Toutes les unités fonctionnelles"
};

export const importDataModalLabels = ({
    title,
    description,
    buttonLabel
}) => {
    return {
        title: title,
        description: description,
        entity: "Entité",
        trialBalanceName: "Nom de la balance des comptes",
        reporting: "De présentation",
        functional: "Fonctionnelle",
        analysisPeriod: "Date de l’analyse",
        comparativePeriod: "Date de comparaison",
        secondComparativePeriod: "Deuxième date de comparaison (facultatif)",
        includeFinancialStatements: "Inclure les états financiers",
        carryForwardReferencesAndAdjustments: "Reproduire les renvois et les ajustements dans la nouvelle importation?",
        import: buttonLabel,
        businessUnitSelectedCount: "{0} unité fonctionnelle",
        businessUnitsSelectedCount: "{0} unités fonctionnelles",
        allBusinessUnitsLabel: "Toutes les unités fonctionnelles",
        businessUnitsPlaceholder: "Unité(s) fonctionnelle(s)",
        required: "Obligatoire",
        comparativePeriodError: "Date non valide. Sélectionnez une date antérieure à la date de l’analyse.",
        secondComparativePeriodError: "Deuxième date de comparaison postérieure ou égale à la date de comparaison",
        equalComparativePeriodError: "Les dates ne peuvent pas être identiques.",
        analysisDateMustBeLaterError: 'Analysis date must be later than both comparative dates.'
    };
};

export const AnalyzerHelixErrors = {
    400: "Le projet EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, supprimez d’abord toutes les importations associées à la connexion, puis cliquez sur « Déconnecter l’analyseur » dans le menu « Plus ». Veuillez déterminer s’il faut connecter un autre analyseur.",
    403: "Vous n’êtes pas un membre autorisé de l’équipe de l’analyseur connecté. Veuillez communiquer avec l’administrateur de projet EY Helix pour obtenir l’accès.",
    405: "L’analyse n’est pas disponible pour la connexion liée. Veuillez accéder à EY Helix et réaliser les étapes de traitement et d’analyse de données pour continuer.",
    406: "L’analyseur EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, supprimez d’abord toutes les importations associées à la connexion, puis cliquez sur « Déconnecter l’analyseur » dans le menu « Plus ». Veuillez déterminer s’il faut connecter un autre analyseur.",
    408: "Le projet EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, supprimez d’abord toutes les importations associées à la connexion, puis cliquez sur « Déconnecter l’analyseur » dans le menu « Plus ». Veuillez déterminer s’il faut connecter un autre analyseur.",
    411: "L’analyseur sélectionné n’a pas tous les paramètres requis. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus.",
    430: "L’analyseur sélectionné n’a pas tous les paramètres requis. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    800: "Il semblerait que vous n’avez encore jamais accédé à EY Helix. Veuillez accéder à EY Helix, vous connecter et suivre les indications pour créer un compte.",
    801: "Vous n’êtes pas un membre autorisé de l’équipe du projet associé. Veuillez communiquer avec l’administrateur du projet EY Helix pour obtenir l’accès.",
    901: "Le projet EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, cliquez sur « Supprimer » dans le menu « Plus » ci-dessous. Veuillez déterminer s’il faut connecter un autre analyseur.",
    902: "Le projet EY Helix associé à la connexion sélectionnée est marqué pour suppression. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, cliquez sur « Supprimer » dans le menu « Plus » ci-dessous. Veuillez déterminer s’il faut connecter un autre analyseur.",
    903: "Le projet EY Helix associé à la connexion sélectionnée est marqué pour stockage. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, cliquez sur « Supprimer » dans le menu « Plus » ci-dessous. Veuillez déterminer s’il faut connecter un autre analyseur.",
    926: "L’analyseur sélectionné n’est pas disponible dans EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    927: "L’analyse n’est pas disponible pour le projet associé. Veuillez accéder à EY Helix et réaliser les étapes de traitement et d’analyse de données pour continuer.",
    928: "L’analyseur est non valide ou manquant dans EY Helix. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    929: "Une erreur relative au projet EY Helix associé s’est produite. Les données ne peuvent pas être importées."
};

export const validationLabels = {
    viewAdjustmentWithValidations: "Afficher les {0} ajustements avec des validations",
    validationTypeAmtMissmatch: "La somme des écritures de débit ne correspond pas à la somme des écritures de crédit.",
    validationTypeNoEvidence: "Aucun élément probant associé"
};

export const canavsImportErrors = {
    400: "Échec de l’importation. Le projet EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, supprimez d’abord toutes les importations associées à la connexion, puis cliquez sur « Déconnecter l’analyseur » dans le menu « Plus ». Veuillez déterminer s’il faut connecter un autre analyseur.",
    403: "Échec de l’importation. Vous n’êtes pas un membre autorisé de l’équipe de l’analyseur connecté. Veuillez communiquer avec l’administrateur de projet EY Helix pour obtenir l’accès, puis actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    405: "Échec de l’importation. L’analyse n’est pas disponible pour la connexion liée. Veuillez accéder à EY Helix et réaliser les étapes de traitement et d’analyse de données pour continuer, puis actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    406: "Échec de l’importation. L’analyseur EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, supprimez d’abord toutes les importations associées à la connexion, puis cliquez sur « Déconnecter l’analyseur » dans le menu « Plus ». Veuillez déterminer s’il faut connecter un autre analyseur.",
    408: "Échec de l’importation. Le projet EY Helix associé à la connexion sélectionnée n’est plus disponible. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Pour supprimer la connexion de façon permanente, supprimez d’abord toutes les importations associées à la connexion, puis cliquez sur « Déconnecter l’analyseur » dans le menu « Plus ». Veuillez déterminer s’il faut connecter un autre analyseur.",
    411: "Échec de l’importation. L’analyseur sélectionné n’a pas tous les paramètres requis. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus, puis actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    430: "Échec de l’importation. L’analyseur sélectionné n’a pas tous les paramètres requis. Veuillez communiquer avec un administrateur EY Helix pour en savoir plus. Actualisez la page et réessayez. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
    113082: "La période de l’analyse ne doit pas être vide."
};
